/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

const __vue_script__ = {
    name: 'Card',

    props: {
        title: {
            type: Array,
            default: []
        },
        season: {
            type: String,
            default: ''
        },
        attractions: {
            type: Array,
            default: []
        },
    },
}

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      staticStyle: { "enable-background": "new 0 0 2171 1538" },
      attrs: {
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink",
        x: "0px",
        y: "0px",
        width: "2171px",
        height: "1538px",
        viewBox: "0 0 2171 1538",
        "xml:space": "preserve",
      },
    },
    [
      _vm.season == "hiver"
        ? _c("g", { attrs: { id: "hiver" } }, [
            _c("g", { attrs: { id: "water-bg" } }, [
              _c("rect", {
                staticClass: "st0",
                attrs: { width: "2170.15", height: "1537.06" },
              }),
            ]),
            _vm._v(" "),
            _c("g", { attrs: { id: "land" } }, [
              _c("g", [
                _c("path", {
                  staticClass: "st1",
                  attrs: {
                    d: "M2107.3,997.777c-10.98-8.021-18.12-5.91-30.36-6.754c-12.21-0.844-10.98,0-27.4,0\n                c-16.43,0-45.1,2.11-75.46-5.066c-30.36-7.175-50.16-7.175-65.78-8.864c-15.58-1.688-44.25-5.909-63.25-15.157\n                c-18.96-9.287-28.36-1.804-38.03-0.538c0,0-6.95,1.036-13.7-2.839c-6.76-3.914-21.07,2.647-25.6,5.909\n                c-4.53,3.262-17.62,4.643-30.36,2.226c-12.74-2.418-18.96-2.303-26.37,0.959c-7.37,3.262-17.38,2.648-20.34-0.192\n                c-2.95-2.839-17.08-5.065-29.2-2.532c-12.13,2.532-36.58-5.142-44.91-7.522c-8.33-2.379-33.43-3.223-42.25-3.223\n                c-8.83,0-44.48,0.883-59.64,0s-26.1,1.151-33.05,4.95c-6.95,3.799-14.7,6.639-19.3-0.614c-4.57-7.291-0.16-6.178-4.42-10.13\n                c-4.26-3.953-13.12-5.833-27.82-5.68c-14.7,0.154-45.86,4.106-55.5,1.881c0,0-2.57-0.96-0.46-3.377\n                c2.11-2.418,9.9-11.973,10.48-14.813c0.57-2.839,0.96-8.211,1.23-11.128c0.23-2.916-1.58-2.533-2.23-2.302\n                c-0.61,0.23-3.15,4.912-4.41,9.171c-1.27,4.259-4.26,9.478-6.64,11.474c-2.38,1.957-8.14,8.212-9.48,13.047\n                c-1.34,4.835-0.81,9.977-1.96,13.929c-1.19,3.953-3.64,4.989-4.49,6.332c-0.88,1.343-1.57,4.413-1.19,7.828\n                c0.38,3.416-6.72,5.526-10.67,2.61c-3.95-2.917-10.36-5.833-10.67-8.634c-0.3-2.763-2.99-7.982-4.26-11.935\n                c-1.26-3.952,0.39-6.101,0.23-8.135c-0.15-2.072,0.54-6.869-2.84-7.176c-3.41-0.307-15.08,4.567-25.06,9.095\n                c-9.98,4.49-20.23,9.095-28.55,8.788c-8.29-0.307-20.19,1.112-25.14-8.366c-4.95-9.478-6.41-6.216-13.74-5.372\n                c-7.33,0.844-7.1,0-13.74,1.88s-15.81,1.88-21.3,1.995c-5.49,0.116-10.33,0.538-14.43-2.417\n                c-4.11-2.955-17.08-13.392-18.65-14.429c-1.58-1.036-13.28-8.096-24.26,2.955c0,0-10.21,12.011-19.07,12.97\n                c-8.87,0.96-28.37-0.115-36.46-0.422c-8.1-0.307-24.45,5.488-32.47,6.025c-8.02,0.537-7.6-0.115-7.6-0.115l-5.84-77.822\n                l-14.08-169.19c0,0-1.11-23.331-6.33-28.243c0,0,18.34-3.799,45.36-6.024c27.02-2.226,36.04-7.445,42.22-10.131\n                c6.18-2.686,36.99-9.018,57.87-10.591c0,0,6.18-0.806,13.13-4.758c0,0,3.49-1.881-2-13.93c-5.45-12.011-9.02-17.614-11.4-19.763\n                c-2.37-2.148-5.6-4.106-5.6-4.106s-3.07-1.88-1.42,2.994c1.65,4.911,1.27,6.331,3.15,10.514c1.88,4.183,1.96,5.756,1.8,8.941\n                c-0.15,3.147,1.04,8.634-6.48,1.113c0,0-3.5-2.533-6.87-4.183c-3.42-1.65-10.14-5.526-13.05-11.474\n                c-2.92-5.909-5.22-12.318-5.07-19.992c0.15-7.675,1.5-23.715-8.79-28.55c-10.28-4.835-20.38-6.102-22.3-6.178\n                c-1.88-0.077-12.97-1.113-23.56-18.957c-10.59-17.844-26.48-20.07-37.46-22.372s-22.6-3.876-31.55-9.785\n                c-8.939-5.91-13.352-4.682-21.028-2.917c-7.676,1.727-16.35,4.106-24.409-7.598c-8.06-11.704-16.849-8.135-18.883-8.71\n                c-2.072-0.538-14.929-4.759-25.676-17.537c-10.746-12.817-32.161-20.07-34.694-22.219c-2.533-2.149-19.996-14.39-28.631-22.678\n                c-8.635-8.289-27.288-12.664-39.07-18.036c-11.782-5.372-31.624-20.146-36.115-27.361c-4.49-7.175-11.552-11.857-17.846-19.762\n                c-6.333-7.905-10.746-20.223-46.017-26.401c-35.27-6.178-47.897-18.189-54.69-28.627c-6.793-10.438-18.345-26.401-34.464-31.773\n                c-16.12-5.373-37.612-6.486-55.497-21.988c-2.686-2.341-7.1-4.567-12.665-6.716l-30.204-24.943c0,0-22.145-26.977-36.192-31.505\n                c-14.085-4.528-29.091-6.293-35.654-16.846c-6.563-10.552-20.609-16.692-29.859-21.105c-9.249-4.413-11.015-17.575-23.334-24.636\n                c-12.32-7.023-20.226-11.435-23.296-14.966C377.165,111.728,342.355,60,342.355,60H60c0,0,68.737,114.469,87.811,132.811\n                c19.113,18.305,22.222,41.175,29.015,46.471c6.793,5.257,7.676,9.67,16.465,25.518c8.789,15.81,14.891,26.171,21.07,31.544\n                c6.179,5.372,20.264,13.315,26.405,17.69c6.14,4.375,29.897,11.973,33.658,16.693c4.337,5.103,8.021,10.437,10.478,16.04\n                c13.931,31.62,20.878,28.473,28.477,44.245c7.599,15.81,22.145,21.489,34.772,39.831c12.665,18.343,28.438,15.81,41.756,27.207\n                c13.279,11.397,15.812,17.691,22.759,24.022c6.946,6.332,22.145,15.158,31.624,18.343c9.48,3.147,28.439,13.93,28.439,13.93\n                s9.173,4.413,33.428,1.458c24.256-2.955,28.478-1.573,31.51-2.648c3.07-1.036,4.337-0.422,4.337-0.422s-1.689,6.946,9.364,14.121\n                c11.053,7.176,26.136,9.479,45.748,11.167c19.612,1.689,34.349,10.745,50.814,19.609c16.426,8.865,27.825,12.971,45.863,17.69\n                c18.038,4.759,29.091,15.158,38.264,18.957c9.173,3.799,10.439,0.959,20.571,6.025c10.132,5.065,28.785,8.519,37.305,11.051\n                c8.52,2.533,17.078,5.373,36.038,9.786c18.959,4.413,34.464,9.171,42.063,14.85c7.599,5.68,19.612,12.011,30.972,17.384\n                c11.399,5.372,31.625,9.785,44.597,9.478c12.972-0.307,13.586,2.84,24.332,7.291c10.746,4.413,16.772,6.946,24.026,7.598\n                c0,0,2.149,0.307,3.646,0.806c0,0,4.493,6.638,5.223,16.616c0.73,9.977,13.51,162.013,13.51,162.013s0.3,1.305-13.09-2.456\n                c-13.396-3.799-20.458,0.538-33.2-1.573c-12.742-2.11-21.607,0.23-26.443-2.302c-4.836-2.533-17.27-8.634-20.571-13.086\n                c-3.262-4.413-8.751-11.819-22.03-12.318c-13.279-0.537-24.255,8.212-35.001,10.745c-10.747,2.533-29.514,2.724-53.962,0.537\n                c-24.447-2.226-34.694-1.88-40.49-2.417c-5.795-0.538-16.004-1.574-22.029-2.725c-6.026-1.151-11.821-1.995-19.075-1.688\n                c-7.253,0.307-22.643-1.152-28.784-3.262c-6.102-2.111-16.772-0.192-28.899,2.11c-12.128,2.303-9.173,0.845-17.194,2.533\n                c-8.022,1.689-8.751,0.422-12.435,0.959c-3.685,0.538-13.087-0.614-12.972-10.744c0.115-10.131,12.972-7.598,14.238-7.79\n                c1.267-0.23,5.68,1.88,11.706,0s7.676-7.176,13.471-9.709c5.795-2.532,10.439-5.372,14.968-10.629\n                c4.529-5.257,12.665-11.167,22.452-11.704c9.786-0.537,17.078,1.573,31.202-0.307c14.124-1.88,21.185-5.181,31.509-4.221\n                c10.324,0.959,26.443,5.794,34.043,6.869c7.599,1.036,19.726,1.266,22.989-6.217c3.262-7.483-7.062-8.02-16.657-11.704\n                c-9.595-3.684-26.558-11.051-31.394-14.313s-17.386-5.181-29.398-7.598c-12.013-2.418-7.293-3.147-15.506-6.524\n                c-8.213-3.377-15.812-12.855-27.21-17.268c-11.399-4.413-3.148-8.864-21.723-13.699c-18.537-4.835-16.848-8.443-27.633-8.212\n                c-10.746,0.23-17.079-3.799-22.145-5.488c-5.066-1.688-19.381-10.322-40.682-10.975c-21.3-0.614-40.912-3.568-49.317-14.313\n                c-8.443-10.745-8.443-15.158-32.046-22.756c-23.604-7.598-23.412-22.755-34.772-29.509\n                c-11.399-6.754-17.271-13.085-44.481-11.397c0,0-9.71,1.036-23.412-6.524c-13.701-7.597-27.402-3.568-34.579-2.724\n                s-15.582,2.533-17.923-8.02c-2.303-10.553-6.525-15.81-15.39-18.957c-8.866-3.146-22.337-2.532-33.083-2.11\n                s-17.271,0.614-26.136-5.066c-8.866-5.679-13.548-6.446-17.808-6.753s-9.71,1.189-15.736,2.417\n                c-6.025,1.228-9.863,1.42-11.513-4.106c-1.612-5.526-5.565-9.555-8.943-9.133c-3.377,0.422-1.88,3.07-4.951,2.725\n                c-3.07-0.307-6.639,0.23-10.861-1.574c-4.222-1.803-7.791-4.106-13.394-4.528c-5.604-0.422-5.373-0.422-6.026,1.881\n                c-0.614,2.302,0.96,2.302-3.262,0.614c-4.222-1.689-4.836-3.262-8.098-3.915c-3.262-0.613-9.441-2.302-14.546-4.221\n                c0,0-12.012-6.945-18.115,3.377c-6.102,10.323-3.377,15.273,0,21.912c3.378,6.638,8.022,10.859,10.324,13.699\n                c2.303,2.84,4.951,10.016,5.373,15.58c0.423,5.602,6.755,12.011,10.133,17.191c3.377,5.181,6.025,12.126,7.714,16.424\n                c1.688,4.298,12.665,12.855,26.021,12.855c13.356,0,31.624,0.192,44.366,15.58c0,0,10.861,9.9,18.959,15.58\n                c0,0,2.226,1.727,11.629,9.862c9.403,8.135,9.403,11.205,17.156,18.496c7.752,7.253,14.545,13.277,16.426,19.455\n                c1.881,6.179,3.646,11.704,3.339,17.691c-0.307,6.024,2.379,16.193,5.22,21.873c2.84,5.679,10.324,20.453,16.349,27.936\n                c6.026,7.483,19.919,23.523,23.91,28.55c3.992,5.065,14.738,20.031,19.19,27.706c4.413,7.713,17.539,26.708,24.831,48.849\n                c7.254,22.142,7.1,22.602,9.787,32.234c2.686,9.632,21.339,45.051,26.251,52.649c4.913,7.598,8.904,41.331,9.557,51.231\n                c0.614,9.9-1.267,10.13,5.68,31.39c6.946,21.29,8.443,39.41,7.177,51.65c-1.267,12.24-2.534,35.61,6.524,49.73\n                c9.057,14.12,36.997,61.67,37.957,71.15c0.959,9.47,4.414,25.28,31.624,30.35c27.211,5.06,40.145,8.86,61.023,41.75\n                s23.411,27.82,37.305,62.59c13.931,34.76,38.878,72.72,85.048,95.16c46.17,22.45,130.604,24.99,202.68,14.85\n                c72.074-10.13,82.514-19.91,100.554-27.2c18.04-7.25,56.61-30.36,74.95-30.97c18.35-0.61,43.95-2.53,53.12-2.23\n                c9.17,0.31,33.85,0.62,46.48-4.41c12.66-5.06,11.55-1.57,20.72-2.53l9.18-0.96c0,0,25.59-2.07,40.95-3.8\n                c15.35-1.73,70.19-6.18,103.7-12.82c33.5-6.63,75.56-12.97,112.56-25.13c37-12.17,68.47-25.6,85.86-29.89\n                c17.38-4.26,38.41-20.07,43.63-24.33s26.87-15.35,31.32-16.93c4.41-1.57,9.79-4.75,14.09-10.13\n                c4.26-5.37,62.82-24.13,77.14-27.28c14.31-3.15,59.64-16.12,69.04-17.81c9.37-1.68,33.43-12.66,46.29-19.6\n                c12.85-6.95,23.72-14.86,30.55-27.4c6.87-12.55,19.3-35.31,35-43.1c0,0,19.11-10.2,29.55-16.38c10.44-6.18,39.99-26.1,55.34-34\n                c15.36-7.91,46.17-33.35,50.43-38.11s17.7-26.7,26.56-32.5c8.87-5.79,31.63-18.03,20.65-26.017L2107.3,997.777z M987.202,941.252\n                c-7.907-0.153-22.606-7.099-31.318-13.277c-8.712-6.178-9.172-8.519-14.853-12.817c-5.68-4.259-15.159-12.164-17.232-13.124\n                c-2.072-0.959-12.473-7.598-8.52-16.616c3.953-9.017,9.326-9.977,19.919-9.977c10.592,0,24.332-0.307,35.731,1.574\n                c11.398,1.88,16.771,2.225,23.718,2.839c6.943,0.614,18.343,0.461,21.183,1.573l5.84,67.346c0,0-26.562-7.444-34.468-7.598\n                V941.252z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st1",
                  attrs: {
                    d: "M1114.66,730.964c0,0-19.38,7.253-22.15,19.801c-2.72,12.548-6.21,16.002-1.15,24.674\n                c5.07,8.634,11.06,14.966,31.32,15.388c20.23,0.422,35.73-1.573,47.63,2.302c11.9,3.915,19.07,9.786,25.83,16.539\n                c6.75,6.754,12.12,17.077,45.63,18.535c33.5,1.458,37.3,1.804,43.94,2.725c6.64,0.959,13.59,3.261,15.93,8.442\n                c2.3,5.18,3.38,11.166,10.63,11.166c7.26,0,8.64-3.069,10.86-3.799c2.23-0.729,6.45-1.995,9.91,1.881\n                c3.49,3.914,4.95,6.101,21.91,3.146c0,0,6.64-0.614,11.59,2.303c0,0,3.57,3.07,10.98,0c0,0,1.26,0.115,1.57-3.569\n                c0.31-3.684,2.3-8.02,12.55-5.487c10.21,2.532,19.38,3.683,29.63,3.146c10.21-0.537,16.96,0.115,29.51,0\n                c12.55-0.115,25.95-0.23,25.41-7.483c-0.54-7.291-4.41-7.674-16.43-12.011c-12.01-4.336-18.11-6.101-28.55-8.941\n                c-10.44-2.839-23.18-7.905-27.52-10.437c-4.34-2.533-21.49-10.438-28.36-12.126c-6.87-1.689-13.09-7.598-16-6.869\n                c-2.96,0.729-12.86,0.959-15.7,0.192c-2.84-0.73-12.32-4.106-16.77-5.258c-4.42-1.151-15.7-8.442-19.19-10.974\n                c-3.5-2.533-20.65-14.659-21.8-15.503c-1.15-0.845-3.8-5.603-22.88-3.991c0,0-8.44,0.115-17.8-16.539\n                c-9.37-16.655-42.91-30.776-51.55-31.083c-8.63-0.307-29.63-1.036-54.27,11.819c-24.67,12.855-11.82,4.758-24.67,11.896\n                L1114.66,730.964z",
                  },
                }),
              ]),
            ]),
            _vm._v(" "),
            _c("g", { attrs: { id: "beach" } }, [
              _c("path", {
                staticClass: "st2",
                attrs: {
                  d: "M568.445,1262.5c0,0,52.081,23.01,69.16,36.28c17.078,13.27,14.392,8.74,37.611,18.48\n            c19.42,8.17,19.305,11.54,25.599,26.08c6.333,14.53,27.211,48.97,34.157,54.64c6.947,5.68,26.559,15.15,37.305,18.33\n            c10.746,3.15,9.48,5.68,22.145,11.39c12.665,5.68,80.941,5.07,101.167,3.8s37.957-0.61,58.797-3.14\n            c20.878-2.54,25.944-3.15,43.637-5.07c17.697-1.88,28.517-1.88,49.667-5.06c21.14-3.14,21.79-7.59,38.87-10.12\n            c17.08-2.53,31.63-3.8,31.63-3.8s76.33,4.07,86.54,1.27c0,0,10.14,0.42-19.49,4.83c-29.63,4.41-46.14-1.46-72.81,2.34\n            c-26.37,3.76-33.96,7.02-39.95,11.04c-5.99,4.03-52.62,28.38-80.521,34.9c-27.902,6.48-77.986,20.51-138.05,18.1\n            c-57.376-2.3-125.691,1.99-180.957-63.54c-55.266-65.5-17.731-41.23-55.42-94.38C579.614,1265.38,606.479,1293.26,568.445,1262.5z\n            ",
                },
              }),
            ]),
            _vm._v(" "),
            _c("g", { attrs: { id: "text-riviere-st-maurice" } }, [
              _c("g", [
                _c("path", {
                  staticClass: "st1",
                  attrs: {
                    d: "M175.942,815.638v11.082h-5.45v-27.878h9.096c2.763,0,4.913,0.728,6.486,2.186\n                c1.574,1.457,2.341,3.451,2.341,6.059c0,1.457-0.307,2.722-0.959,3.758c-0.653,1.035-1.612,1.879-2.84,2.531\n                c1.42,0.498,2.456,1.303,3.108,2.415c0.614,1.112,0.96,2.531,0.96,4.219v1.955c0,0.767,0.077,1.573,0.269,2.455\n                c0.191,0.882,0.498,1.495,0.959,1.917v0.383h-5.642c-0.46-0.421-0.729-1.073-0.844-1.994c-0.115-0.92-0.154-1.84-0.154-2.799\n                v-1.879c0-1.381-0.268-2.454-0.844-3.221c-0.576-0.767-1.382-1.151-2.456-1.151h-3.953L175.942,815.638z M175.942,811.305h3.646\n                c1.113,0,1.957-0.345,2.533-0.997c0.576-0.691,0.844-1.649,0.844-2.876s-0.307-2.301-0.844-3.03\n                c-0.576-0.767-1.42-1.112-2.495-1.112h-3.646v8.091L175.942,811.305z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st1",
                  attrs: { d: "M198.47,826.72h-5.411v-27.878h5.411V826.72z" },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st1",
                  attrs: {
                    d: "M211.402,819.588l0.23,1.074h0.116l0.23-0.997l4.644-20.823h5.718l-7.791,27.878h-5.68l-7.791-27.878h5.719\n                l4.605,20.784V819.588z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st1",
                  attrs: { d: "M230.365,826.72h-5.412v-27.878h5.412V826.72z" },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st1",
                  attrs: {
                    d: "M249.704,814.488h-9.364v7.899h11.015v4.333h-16.503v-27.878h16.464v4.333H240.34v6.941h9.364v4.333V814.488\n                z M245.406,796.848h-4.414l-4.72-4.985v-0.115h5.756l3.339,5.1H245.406z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st1",
                  attrs: {
                    d: "M259.684,815.638v11.082h-5.45v-27.878h9.096c2.764,0,4.913,0.728,6.486,2.186\n                c1.574,1.457,2.341,3.451,2.341,6.059c0,1.457-0.307,2.722-0.959,3.758c-0.652,1.035-1.612,1.879-2.84,2.531\n                c1.42,0.498,2.456,1.303,3.109,2.415c0.614,1.112,0.959,2.531,0.959,4.219v1.955c0,0.767,0.077,1.573,0.269,2.455\n                c0.192,0.882,0.499,1.495,0.959,1.917v0.383h-5.642c-0.46-0.421-0.729-1.073-0.844-1.994c-0.115-0.92-0.153-1.84-0.153-2.799\n                v-1.879c0-1.381-0.269-2.454-0.845-3.221c-0.575-0.767-1.381-1.151-2.456-1.151h-3.953L259.684,815.638z M259.684,811.305h3.646\n                c1.113,0,1.958-0.345,2.533-0.997c0.576-0.691,0.845-1.649,0.845-2.876s-0.307-2.301-0.845-3.03\n                c-0.575-0.767-1.42-1.112-2.494-1.112h-3.646v8.091L259.684,811.305z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st1",
                  attrs: {
                    d: "M291.31,814.488h-9.365v7.899h11.015v4.333h-16.503v-27.878h16.465v4.333h-10.977v6.941h9.365v4.333V814.488\n                z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st1",
                  attrs: {
                    d: "M120.138,866.525c0-1.074-0.269-1.956-0.844-2.569c-0.576-0.614-1.536-1.266-2.956-1.879\n                c-2.916-0.997-5.066-2.148-6.524-3.452c-1.459-1.265-2.188-3.067-2.188-5.407c0-2.339,0.845-4.141,2.533-5.598\n                c1.689-1.419,3.838-2.148,6.448-2.148s4.836,0.805,6.486,2.416c1.65,1.611,2.456,3.643,2.418,6.059v0.115h-5.335\n                c0-1.265-0.307-2.301-0.959-3.106c-0.653-0.805-1.535-1.189-2.725-1.189c-1.075,0-1.919,0.345-2.533,0.997\n                c-0.614,0.652-0.921,1.496-0.921,2.493c0,0.92,0.345,1.687,0.998,2.262c0.652,0.575,1.842,1.266,3.53,1.994\n                c2.649,0.882,4.644,2.033,5.988,3.413c1.343,1.381,1.995,3.221,1.995,5.561c0,2.339-0.806,4.295-2.418,5.675\n                c-1.612,1.381-3.761,2.032-6.409,2.032s-4.951-0.766-6.908-2.339c-1.957-1.572-2.879-3.758-2.84-6.672v-0.115h5.335\n                c0,1.725,0.383,2.953,1.113,3.719c0.729,0.767,1.842,1.113,3.3,1.113c1.151,0,1.996-0.307,2.572-0.921\n                c0.537-0.613,0.844-1.457,0.844-2.492V866.525z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st1",
                  attrs: {
                    d: "M141.553,867.829h-7.369l-1.497,5.944h-5.488l7.868-27.879h5.68l7.829,27.879h-5.488l-1.497-5.944H141.553z\n                M135.297,863.496h5.143l-2.533-9.856h-0.115L135.297,863.496z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st1",
                  attrs: {
                    d: "M156.443,873.811h-5.412v-27.878h5.412V873.811z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st1",
                  attrs: {
                    d: "M180.508,873.811h-5.411l-8.52-17.831h-0.115v17.831h-5.45v-27.878h5.45l8.52,17.831h0.115v-17.831h5.411\n                V873.811z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st1",
                  attrs: {
                    d: "M200.656,850.266h-6.294v23.545h-5.45v-23.545h-6.256v-4.333h18V850.266z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st1",
                  attrs: { d: "M208.526,863.994h-9.518v-4.333h9.518V863.994z" },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st1",
                  attrs: {
                    d: "M220.156,845.894l4.989,20.478h0.115l5.066-20.478h7.1v27.879h-5.411v-8.091l0.46-10.853h-0.115\n                l-5.335,18.944h-3.607l-5.258-18.829h-0.115l0.46,10.699v8.092h-5.411v-27.879h7.062V845.894z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st1",
                  attrs: {
                    d: "M254.463,867.829h-7.369l-1.496,5.944h-5.489l7.868-27.879h5.68l7.83,27.879h-5.489l-1.496-5.944H254.463z\n                M248.207,863.496h5.143l-2.533-9.856h-0.115L248.207,863.496z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st1",
                  attrs: {
                    d: "M281.944,845.894v18.982c0,2.991-0.883,5.254-2.61,6.903c-1.766,1.61-4.03,2.416-6.87,2.416\n                s-5.104-0.806-6.87-2.416c-1.727-1.611-2.61-3.912-2.61-6.865v-18.982h5.45v18.982c0,1.688,0.346,2.953,1.036,3.758\n                c0.691,0.806,1.689,1.189,2.956,1.189c1.266,0,2.302-0.383,2.993-1.15c0.691-0.767,1.036-2.033,1.036-3.797v-18.982h5.412\n                L281.944,845.894z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st1",
                  attrs: {
                    d: "M291.309,862.69v11.083h-5.45v-27.879h9.096c2.764,0,4.913,0.729,6.486,2.186\n                c1.574,1.457,2.341,3.451,2.341,6.059c0,1.457-0.307,2.722-0.959,3.758c-0.652,1.035-1.612,1.879-2.84,2.531\n                c1.42,0.498,2.456,1.304,3.109,2.416c0.614,1.112,0.959,2.531,0.959,4.218v1.956c0,0.767,0.077,1.572,0.269,2.454\n                c0.192,0.882,0.499,1.495,0.959,1.917v0.384h-5.641c-0.461-0.422-0.73-1.074-0.845-1.994c-0.115-0.921-0.153-1.841-0.153-2.8\n                V867.1c0-1.38-0.269-2.454-0.845-3.221c-0.575-0.767-1.381-1.15-2.456-1.15h-3.953L291.309,862.69z M291.309,858.357h3.646\n                c1.113,0,1.958-0.345,2.533-0.997c0.576-0.69,0.845-1.649,0.845-2.876s-0.307-2.301-0.845-3.03\n                c-0.575-0.767-1.42-1.112-2.494-1.112h-3.646v8.092L291.309,858.357z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st1",
                  attrs: {
                    d: "M313.837,873.811h-5.411v-27.878h5.411V873.811z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st1",
                  attrs: {
                    d: "M335.868,864.8v0.115c0.077,3.067-0.652,5.368-2.111,6.941c-1.496,1.572-3.684,2.339-6.563,2.339\n                c-2.878,0-5.181-0.882-6.908-2.646c-1.727-1.764-2.571-4.257-2.571-7.516v-8.322c0-3.221,0.844-5.752,2.494-7.516\n                c1.651-1.764,3.915-2.684,6.717-2.684c2.955,0,5.219,0.805,6.716,2.377c1.497,1.573,2.303,3.912,2.341,7.018v0.115h-5.296\n                c0.077-1.841-0.154-3.145-0.729-3.95c-0.576-0.805-1.574-1.227-2.994-1.227c-1.228,0-2.149,0.46-2.801,1.457\n                c-0.653,0.997-0.96,2.416-0.96,4.333v8.399c0,1.955,0.345,3.451,1.036,4.41c0.691,0.958,1.727,1.418,3.071,1.418\n                c1.343,0,2.226-0.383,2.763-1.15s0.729-2.071,0.691-3.911h5.258H335.868z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st1",
                  attrs: {
                    d: "M354.06,861.54h-9.365v7.899h11.015v4.334h-16.503v-27.879h16.465v4.333h-10.977v6.941h9.365v4.334V861.54z",
                  },
                }),
              ]),
            ]),
            _vm._v(" "),
            _c("g", { attrs: { id: "buildings" } }, [
              _c("g", [
                _c("path", {
                  staticClass: "st3",
                  attrs: {
                    d: "M1498.95,1254.68l9.94,18.02l-24.18,2.69l-13.59-20.71H1498.95z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st3",
                  attrs: {
                    d: "M1818.92,1081.81l35,10.35l6.1-20.44l21.53,5.68l-4.22,15.8l12.43,2.3l-1.07,14.15l-9.06-1.27l-4.22,11.58\n                l-26.98-6.75l-0.88,2.73l-36.43-9.47L1818.92,1081.81z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st4",
                  attrs: {
                    d: "M1031.53,1238.71l-12.16,56.45l29.26,6.3l12.17-56.46L1031.53,1238.71z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st4",
                  attrs: {
                    d: "M1019.32,1277.11c0,8.09-6.56,14.61-14.62,14.61c-8.059,0-14.622-6.55-14.622-14.61\n                c0-8.05,6.563-14.61,14.622-14.61C1012.76,1262.5,1019.32,1269.06,1019.32,1277.11z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st3",
                  attrs: {
                    d: "M983.553,1303.48l-7.612,28.88l63.619,16.74l7.61-28.89L983.553,1303.48z",
                  },
                }),
              ]),
            ]),
            _vm._v(" "),
            _c("g", { attrs: { id: "roads" } }, [
              _c("g", [
                _c("path", {
                  staticClass: "st5",
                  attrs: {
                    d: "M1240.54,1389.16c-13.13,0-26.94-0.19-41.07-0.38c-22.79-0.31-46.4-0.65-68.23-0.15\n                c-3.61,0-6.68-2.8-6.76-6.45c-0.07-3.64,2.8-6.67,6.45-6.74c22.07-0.5,45.79-0.16,68.7,0.15c40.03,0.54,77.83,1.07,102.32-2.69\n                c62.36-9.58,256.22-52.61,284.89-71.05c6.83-4.41,13.66-9.01,20.87-13.89c24.8-16.75,50.43-34.05,79.14-44.48\n                c11.9-4.33,30.55-8.59,52.16-13.57c41.45-9.51,98.25-22.55,113.79-39.85c6.26-6.98,12.71-14.72,18.92-22.24\n                c18.85-22.74,38.34-46.24,59.34-55.79c3.3-1.54,7.21-0.04,8.75,3.26c1.5,3.29,0.04,7.21-3.26,8.74\n                c-18.23,8.28-36.73,30.6-54.66,52.19c-6.29,7.59-12.81,15.45-19.26,22.63c-18.35,20.4-72.69,32.86-120.67,43.86\n                c-21.18,4.87-39.45,9.05-50.62,13.12c-27.17,9.86-52.12,26.69-76.22,42.99c-7.29,4.94-14.2,9.58-21.15,14.07\n                c-31.74,20.4-226.51,63.24-290.03,72.98c-16.65,2.57-38.8,3.22-63.44,3.22L1240.54,1389.16z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st5",
                  attrs: {
                    d: "M1794.93,1033.45c-0.35,0-0.65,0-1-0.07c-4.11-0.62-8.44-1.31-13.05-2.04\n                c-27.52-4.29-65.2-10.16-114.48-14.53c-55.15-4.87-255.68-8.94-326.19-9.74c-14.77-0.15-35.42-0.23-58.6-0.31\n                c-76.84-0.27-172.44-0.57-190.9-4.41c-7.79-1.61-18.54-4.139-30.97-7.092c-26.1-6.135-58.57-13.805-90.346-19.519\n                c-61.867-11.082-107.539-17.218-128.609-17.218c-28.4,0-54.92-22.395-56.033-23.353c-2.764-2.378-3.109-6.52-0.73-9.281\n                c2.38-2.761,6.525-3.106,9.288-0.728c0.23,0.192,24.026,20.209,47.475,20.209c27.94,0,86.622,9.472,130.95,17.41\n                c32.125,5.752,66.165,13.767,91.035,19.634c12.36,2.914,23.03,5.407,30.63,7.017c17.15,3.567,120.12,3.912,188.28,4.142\n                c23.22,0.077,43.87,0.153,58.69,0.307c70.65,0.805,271.68,4.87,327.18,9.782c49.7,4.41,87.66,10.31,115.37,14.65\n                c4.6,0.72,8.94,1.38,13.01,2.03c3.6,0.53,6.06,3.91,5.52,7.51C1800.95,1031.11,1798.15,1033.45,1794.93,1033.45z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st6",
                  attrs: {
                    d: "M1080.39,1225.3c-75.99,1.19-88.966-13.23-89.12-13.34l-2.993,2.3l-3.109,2.19\n                c1.228,1.76,13.701,16.52,86.472,16.52c2.87,0,5.83,0,8.9-0.07l-0.11-7.6H1080.39z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st6",
                  attrs: {
                    d: "M1085.99,1139.94c-75.99,1.19-88.965-13.23-89.118-13.34l-2.994,2.3l-3.108,2.18\n                c1.228,1.77,13.7,16.53,86.47,16.53c2.88,0,5.83,0,8.9-0.07l-0.11-7.6H1085.99z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st7",
                  attrs: {
                    d: "M725.491,902.764l-0.729,8.973c0,0,5.718,0.46,11.437,0.882c5.718,0.422,11.475,0.844,11.475,0.844\n                l0.614-8.974c0,0-5.718-0.422-11.398-0.843C731.171,903.185,725.491,902.764,725.491,902.764z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st7",
                  attrs: {
                    d: "M758.849,907.448l-3.625,8.24c0,0,5.253,2.306,10.518,4.576c5.266,2.27,10.568,4.553,10.568,4.553\n                l3.516-8.278c0,0-5.265-2.27-10.494-4.528C764.079,909.705,758.849,907.448,758.849,907.448z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st7",
                  attrs: {
                    d: "M691.563,899.811l-0.844,8.935c0,0,5.718,0.537,11.437,1.035c5.718,0.499,11.437,0.997,11.437,0.997\n                l0.767-8.935c0,0-5.718-0.498-11.398-0.997C697.282,900.31,691.563,899.811,691.563,899.811z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st7",
                  attrs: {
                    d: "M657.753,896.13l-1.151,8.896c0,0,5.718,0.767,11.437,1.381c2.878,0.307,5.718,0.614,7.867,0.844\n                c2.149,0.23,3.57,0.383,3.57,0.383l0.921-8.935c0,0-1.42-0.153-3.531-0.383c-2.111-0.23-4.951-0.537-7.791-0.844\n                C663.395,896.858,657.753,896.13,657.753,896.13z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st7",
                  attrs: {
                    d: "M624.862,889.687l-2.264,8.705c3.991,1.035,7.791,1.841,11.552,2.799c1.842,0.499,3.723,0.844,5.603,1.266\n                c1.881,0.383,3.761,0.652,5.604,0.997l1.458-8.859c-1.766-0.306-3.531-0.575-5.296-0.92c-1.727-0.383-3.493-0.728-5.182-1.189\n                c-3.914-0.997-7.829-1.802-11.475-2.761V889.687z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st7",
                  attrs: {
                    d: "M609.777,869.478l-9.019,0.345v0.231c0,0,0,0.421,0,0.728c0.038,0.652,0,1.572,0.153,2.761\n                c0.154,2.339,0.538,5.484,1.612,8.743c0.499,1.611,1.228,3.222,2.073,4.717c0.882,1.457,1.842,2.761,2.801,3.758\n                c0.96,0.997,1.843,1.726,2.457,2.186c0.307,0.23,0.575,0.422,0.729,0.537c0.192,0.115,0.269,0.192,0.269,0.192l4.989-7.478\n                c0,0-0.039,0-0.154-0.115c-0.115-0.077-0.268-0.154-0.422-0.307c-0.384-0.268-0.844-0.69-1.382-1.227\n                c-0.537-0.537-1.036-1.227-1.535-2.071c-0.46-0.844-0.959-1.802-1.266-2.953c-0.729-2.185-1.075-4.716-1.19-6.672\n                c-0.115-0.959-0.077-1.841-0.115-2.416c0-0.307,0-0.537,0-0.729c0-0.191,0-0.268,0-0.268V869.478z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st7",
                  attrs: {
                    d: "M608.817,834.275l-8.751,2.838c0,0,0.269,1.342,0.614,3.374c0.231,0.997,0.308,2.225,0.461,3.49\n                c0.077,0.652,0.154,1.304,0.23,1.994c0.077,0.69,0.154,1.342,0.154,2.033c0.077,2.761,0.23,5.522,0,7.592\n                c-0.115,2.071-0.192,3.452-0.192,3.452l9.019-1.189c0,0,0.077-1.496,0.192-3.72c0.192-2.224,0-5.177-0.077-8.168\n                c0-0.728-0.115-1.495-0.192-2.186c-0.076-0.728-0.153-1.457-0.23-2.147c-0.192-1.381-0.269-2.684-0.499-3.758\n                c-0.422-2.186-0.691-3.643-0.691-3.643L608.817,834.275z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st7",
                  attrs: {
                    d: "M594.925,802.025l-7.714,5.1c0,0,0.768,1.151,1.881,2.876c0.575,0.844,1.189,1.918,1.803,3.03\n                c0.614,1.15,1.382,2.301,1.919,3.566c0.614,1.227,1.228,2.493,1.766,3.643c0.499,1.189,0.959,2.301,1.343,3.26\n                c0.384,0.958,0.729,1.764,0.921,2.339s0.307,0.882,0.307,0.882l8.482-3.605c0,0-0.115-0.345-0.345-0.959\n                c-0.192-0.613-0.576-1.457-0.998-2.492c-0.423-1.036-0.921-2.224-1.459-3.528c-0.614-1.266-1.266-2.569-1.919-3.912\n                c-0.614-1.342-1.42-2.607-2.072-3.834c-0.691-1.228-1.305-2.34-1.958-3.26c-1.228-1.879-2.034-3.106-2.034-3.106H594.925z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st7",
                  attrs: {
                    d: "M568.791,778.863l-6.025,6.787c0,0,1.189,0.691,2.993,1.726c0.921,0.498,1.958,1.112,3.071,1.764\n                c0.575,0.307,1.151,0.652,1.727,0.997c0.575,0.383,1.113,0.767,1.688,1.189l0.845,0.575c0.268,0.23,0.537,0.422,0.806,0.652\n                c0.537,0.422,1.036,0.843,1.535,1.265c0.998,0.844,1.842,1.688,2.61,2.378c0.767,0.69,1.343,1.342,1.765,1.802\n                c0.422,0.46,0.652,0.69,0.652,0.69l7.216-5.752c0,0-0.269-0.268-0.691-0.767c-0.461-0.46-1.036-1.188-1.881-1.917\n                c-0.806-0.767-1.727-1.687-2.801-2.608c-0.538-0.46-1.075-0.92-1.651-1.38c-0.268-0.23-0.575-0.46-0.844-0.69l-0.921-0.652\n                c-0.614-0.422-1.228-0.844-1.804-1.266c-0.614-0.383-1.266-0.728-1.842-1.073c-1.19-0.691-2.341-1.343-3.301-1.88\n                c-1.919-1.112-3.224-1.84-3.224-1.84H568.791z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st7",
                  attrs: {
                    d: "M538.316,761.377l-4.414,7.822c0,0,1.267,0.691,3.109,1.726c1.919,1.074,4.26,2.416,6.678,3.796\n                c4.797,2.761,9.633,5.484,9.633,5.484l5.373-7.209c0,0-5.143-2.953-10.285-5.906c-2.572-1.457-5.182-2.991-7.024-4.026\n                c-1.88-1.036-3.147-1.764-3.147-1.764L538.316,761.377z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st7",
                  attrs: {
                    d: "M508.532,744.812l-4.38,7.834l20.003,11.165l4.38-7.834L508.532,744.812z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st7",
                  attrs: {
                    d: "M478.645,728.087l-4.364,7.843l20.026,11.124l4.364-7.843L478.645,728.087z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st7",
                  attrs: {
                    d: "M448.811,711.637l-4.358,7.846l20.034,11.11l4.358-7.846L448.811,711.637z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st7",
                  attrs: {
                    d: "M418.92,695.006l-4.35,7.851l20.046,11.088l4.35-7.85L418.92,695.006z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st7",
                  attrs: {
                    d: "M389.751,677.855l-4.759,7.632l14.507,9.05l5.297,2.914l4.375-7.861l-5.104-2.8L389.751,677.855z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st7",
                  attrs: {
                    d: "M360.624,659.947l-4.683,7.67l19.535,11.964l4.721-7.631L360.624,659.947z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st7",
                  attrs: {
                    d: "M331.34,642.308l-4.606,7.746c0,0,4.913,2.914,9.825,5.867c4.913,2.953,9.787,5.905,9.787,5.905l4.644-7.669\n                c0,0-4.913-2.953-9.825-5.944c-4.913-2.953-9.863-5.905-9.863-5.905H331.34z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st7",
                  attrs: {
                    d: "M301.48,625.281l-4.183,7.938c0,0,1.228,0.652,3.109,1.649c1.88,0.997,4.336,2.416,6.831,3.796\n                c4.951,2.838,9.902,5.676,9.902,5.676l4.529-7.746c0,0-4.99-2.877-9.979-5.753c-2.533-1.418-5.028-2.837-6.947-3.873\n                c-1.919-1.035-3.223-1.725-3.223-1.725L301.48,625.281z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st7",
                  attrs: {
                    d: "M271.008,609.942l-4.145,7.976c0,0,5.105,2.646,10.209,5.292c2.572,1.304,5.143,2.608,7.062,3.566\n                c1.957,0.959,3.262,1.611,3.262,1.611l3.915-8.091c0,0-1.267-0.614-3.147-1.573c-1.919-0.958-4.452-2.224-6.985-3.528\n                c-5.066-2.607-10.132-5.253-10.132-5.253H271.008z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st7",
                  attrs: {
                    d: "M240.877,593.951l-4.26,7.9c0,0,5.066,2.722,10.132,5.407c5.066,2.684,10.132,5.368,10.132,5.368\n                l4.222-7.938l-20.187-10.775L240.877,593.951z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st7",
                  attrs: {
                    d: "M210.981,577.615l-4.376,7.861c0,0,5.028,2.761,10.056,5.522c5.027,2.761,10.055,5.484,10.055,5.484\n                l4.299-7.9c0,0-5.028-2.722-10.056-5.483c-5.027-2.761-10.017-5.522-10.017-5.522L210.981,577.615z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st7",
                  attrs: {
                    d: "M181.43,560.819l-4.606,7.708c0,0,4.99,2.952,9.979,5.79c4.989,2.838,10.017,5.676,10.017,5.676l4.413-7.823\n                c0,0-4.951-2.8-9.94-5.637c-4.951-2.838-9.825-5.714-9.825-5.714H181.43z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st7",
                  attrs: {
                    d: "M1381.51,1289.31c-30.67,33.28-74.65,44.63-99.18,51c-4.33,1.11-8.09,2.07-11.05,2.99\n                c-8.83,2.72-31.05,7.36-54.57,12.31c-30.32,6.37-64.71,13.61-81.75,18.98c-25.37,8.02-42.87,3.72-61.41-0.8\n                c-2.11-0.5-4.22-1.04-6.37-1.54c-2.07-0.5-4.57-1.11-7.37-1.84c1.65-5.86,5.18-18.33,8.18-28.53\n                c4.18-14.26,16.92-81.64,19.8-103.19c0.19-1.42,0.35-3.03,0.5-4.72h-12.7c-0.12,1.08-0.23,2.07-0.35,3.03\n                c-2.76,20.67-15.43,87.78-19.42,101.32c-3.03,10.31-6.6,22.85-8.25,28.76c-28.29-8.06-70.158-21.36-80.175-26.5\n                c-1.573-0.81-3.492-1.61-5.641-2.46c1.496-3.79,4.145-10.5,8.635-21.82c7.292-18.48,18.192-82.37,23.45-113.08\n                c0.844-4.91,1.535-8.94,1.995-11.62c2.802-15.88,3.339-52.42,3.685-76.58c0.077-5.41,0.153-10.05,0.23-13.39\n                c0.341-14.34-0.537-43.56-0.883-55.02c4.874-0.96,8.064-2.31,9.514-3c7.22-2.03,17.47-8.78,24.49-14.03\n                c-2-3.68-4.07-7.29-6.98-10.58c-6.61,4.98-15.93,11.15-21.34,12.53c-0.54,0.12-1.12,0.39-1.58,0.66\n                c-0.19,0.11-18.649,9.89-56.683-7.02c-41.872-18.64-93.914-37.658-94.413-37.85c-0.23-0.076-0.422-0.153-0.652-0.192\n                c-2.111-0.536-52.426-12.616-118.553-5.407c-13.932,1.496-25.254,2.877-35.271,4.065c-36.038,4.295-48.166,5.752-70.963,1.304\n                c-8.673-1.687-17.386-3.835-26.558-6.135c-22.183-5.484-45.134-11.16-67.509-10.009c-24.448,1.265-47.398,11.197-49.931,74.624\n                c-1.843,46.06,8.75,100.39,101.129,154.5c17.347,10.16,30.127,17.6,39.799,23.2c19.624,11.4,33.403,20.2,41.334,26.39\n                c3.531,2.76,8.098,6.32,14.699,11.31l5.642,4.29c33.927,25.77,58.413,44.37,93.875,56.07c29.821,9.85,60.102,11.23,84.396,12.35\n                c6.179,0.26,11.975,0.53,17.348,0.92c26.059,1.84,68.468,10.92,81.056,17.33c14.584,7.44,81.905,27.88,102.625,32.75\n                c2.11,0.5,4.18,0.99,6.26,1.53c11.47,2.8,23.14,5.68,36.73,5.68c9.4,0,19.72-1.38,31.51-5.1c16.42-5.18,50.5-12.35,80.55-18.64\n                c24.87-5.22,46.33-9.74,55.69-12.62c2.69-0.84,6.33-1.76,10.52-2.83c26.36-6.83,74.03-19.18,107.27-56.87\n                c-3.73-2.42-6.91-5.33-10.71-6.98c-0.19,0.19-0.35,0.42-0.54,0.61L1381.51,1289.31z M958.645,1311.63\n                c-4.759,12.11-7.484,18.94-8.904,22.54c-20.264-5.79-49.317-10.96-68.238-12.31c-5.527-0.38-11.437-0.65-17.693-0.95\n                c-23.565-1.08-52.848-2.42-81.018-11.7c-33.467-11.04-57.262-29.11-90.191-54.15l-5.68-4.29c-6.525-4.95-11.053-8.48-14.546-11.2\n                c-12.55-9.78-13.126-10.12-42.754-27.34c-9.672-5.6-22.414-13.04-39.761-23.16c-86.66-50.74-96.6-100.82-94.912-143.12\n                c2.034-50.73,15.467-61.314,37.957-62.503c20.533-1.074,42.524,4.372,63.825,9.625c8.942,2.225,18.191,4.487,27.172,6.251\n                c24.755,4.827,38.418,3.217,74.916-1.15c9.979-1.189,21.262-2.531,35.156-4.027c61.099-6.672,109.495,4.027,113.87,5.062\n                c4.606,1.692,53.578,19.792,93.262,37.432c19.036,8.47,34.08,10.96,45.134,11c0.383,11.85,1.189,40.07,0.882,53.61\n                c-0.076,3.41-0.153,8.05-0.23,13.54c-0.307,22.32-0.844,59.67-3.492,74.55c-0.499,2.72-1.152,6.74-2.035,11.69\n                C976.606,1228.95,965.438,1294.33,958.645,1311.63z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", { staticClass: "st8" }, [
                _c("path", {
                  staticClass: "st1",
                  attrs: {
                    d: "M1899.24,1127.21c-2.53,0-5.06-0.84-7.17-2.57c-4.88-3.95-5.61-11.12-1.62-15.99\n                c0.31-0.38,7.41-9.09,22.76-25c1.42-1.5,3.8-4.3,3.49-6.29c-0.3-2.07-3.1-8.05-22.75-19.25c-18.43-10.47-26.87-8.4-26.98-8.36\n                c0.53-0.15-4.61,1.34-4.61,1.34l-11.17-19.71c2.8-1.23,25.49-9.28,54,6.94c15.54,8.86,31.74,20.02,34,35.74\n                c1.27,8.82-1.95,17.34-9.59,25.31c-14.58,15.19-21.45,23.55-21.53,23.66C1905.8,1125.79,1902.54,1127.21,1899.24,1127.21z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st7",
                  attrs: {
                    d: "M1862.32,1037.75c-3.3-4.34-8.67-6.41-13.51-7.37c-8.56-2.56-37.46-7.59-57.26-10.92\n                c-1.96,4.44-4.3,8.43-5.76,13.03c16.62,6.02,18.62,15.73,21.65,23.05l0.54,1.3c0.99,2.42,2.26,4.57,3.57,6.45\n                c-24.18,33.9-61.49,85.55-75.92,102.42c-19.42,22.7-69.5,18.06-72.73,17.76c-3.22-0.54-43.83-7.48-76.45-12.31\n                c-32.31-4.8-66.82-14.27-69.27-14.96l-93.49-30.94c-1.12-0.35-110.65-35.82-133.83-42.99c-5.45-1.69-11.63-3.99-18.16-6.41\n                c-21.45-7.9-48.05-17.75-76.48-17.29c-32.97,0.61-66.44-6.1-69.78-6.75c-3.53-1.07-40.8-12.81-63.75-26.77\n                c-21.22-12.88-20.11-34.931-20.07-35.851c0-0.307,0-0.613,0-0.92l-1.92-24.543c-0.19-2.416-19.46-241.436-20.38-257.005\n                c-0.96-15.837-5.41-29.988-14.39-45.864c-8.365-14.725-26.979-25.692-28.975-26.843l-39.991-25.232l-142.003-88.008\n                c-1.228-0.767-123.312-79.111-282.125-177.818c-30.473-21.819-223.52-160.561-259.366-191.469\n                C214.59,118.863,184.193,64.563,183.771,60h-12.626c0.959,10.392,36.268,68.949,73.38,100.931\n                c36.96,31.867,231.618,171.682,260.863,192.658l-0.153,0.23c1.113,0.69,2.226,1.38,3.3,2.071\n                c0.077,0.038,0.154,0.115,0.192,0.153c157.009,97.633,277.251,174.75,278.518,175.555l142.041,88.008l40.068,25.271\n                c0,0,0.153,0.115,0.268,0.153c0.192,0.115,17.425,9.97,24.333,22.165c8.025,14.073,11.935,26.536,12.785,40.341\n                c0.95,15.723,19.61,247.419,20.41,257.274l1.88,24.159c-0.07,2.454-0.11,12.311,4.84,23.281c-2.53,2.18-4.3,3.79-8.1,6.67\n                c2.92,3.3,4.99,6.9,6.99,10.58c3.72-2.76,5.33-4.22,7.75-6.29c3.64,4.57,8.37,8.98,14.62,12.77c3.57,2.15,7.41,4.26,11.4,6.29\n                c0.31,8.71,1.27,30.56,3.61,50.05c2.76,22.93,4.79,51.23,5.03,70.4c0,0.08,0,0.16,0,0.27c0,0.5,2.53,48.85,0.38,70.98h12.7\n                c2-23.24-0.27-68.14-0.46-71.52c-0.23-19.55-2.3-48.35-5.1-71.63c-1.81-15.03-2.8-31.98-3.26-42.49\n                c20.87,9.13,41.37,15.45,42.56,15.8c0.19,0.04,0.34,0.12,0.53,0.12c1.5,0.3,36.85,7.74,72.89,7.09\n                c25.9-0.5,51.42,8.93,71.88,16.49c6.68,2.45,13.01,4.79,18.81,6.59c23.1,7.18,132.6,42.61,133.63,42.95l5.57,1.84\n                c0,0.54,0,1-0.04,1.58c-0.96,28.68-3.19,95.9-36.08,139.39c-2.26,2.99-4.68,5.83-7.14,8.55c3.8,1.65,6.99,4.56,10.71,6.98\n                c1.46-1.65,2.92-3.37,4.34-5.1l19.15,11.08l38,20.29c4.37,2.18,10.78,4.26,17.23,4.26c6.79,0,13.58-2.31,18.07-9.21\n                c4.34-6.67,5.53-13.3,3.5-19.75c-3.07-9.89-13.63-18.4-32.24-26.07c-20.88-8.59-34.7-19.25-40.07-23.78\n                c14.43-39,16.27-81.37,17.04-104.07l75.53,25c0,0,0.19,0.04,0.27,0.08c0.38,0.11,36.84,10.27,71,15.33\n                c33.7,4.99,75.95,12.24,76.38,12.31c0.11,0,0.23,0,0.34,0.04c0.77,0.08,6.76,0.73,15.47,0.73c19.3,0,51.69-3.18,68.47-22.82\n                c14.66-17.14,51.12-67.6,75.41-101.62c1.88,1.31,3.38,2.11,4.07,2.42c11.82,6.86,23.22,5.64,31.24-3.41\n                c8.37-9.44,11.59-26.69,6.29-33.6L1862.32,1037.75z M1456.04,1282.83c18.31,7.51,23.68,14.03,24.98,18.13\n                c0.54,1.73,0.93,4.57-2.03,9.13c-4.72,7.29-18.88,0.61-18.92,0.61l-37.65-20.13l-17.89-10.31c4.3-6.56,8.03-13.5,11.25-20.63\n                C1423.15,1265.45,1436.77,1274.89,1456.04,1282.83z M1819.68,1052.01l-0.54-1.26c-1.72-4.18-4.03-9.71-8.48-15.19\n                c6.6,1.19,12.86,2.34,18.27,3.38C1826.55,1042.27,1823.4,1046.72,1819.68,1052.01z M1845.2,1064.32c-2.34,2-6.37,4.1-14.23-0.54\n                c-0.2-0.11-0.43-0.23-0.62-0.3c0,0-0.96-0.46-2.3-1.38c6.41-9.05,11.4-16.07,14.01-19.79c1.42,0.08,2.95,0.27,4.37,0.58\n                c0,0,0.08,0,0.12,0c2.38,0.49,4.49,1.26,5.49,2.33C1852.84,1048.02,1851.34,1059.07,1845.2,1064.32z",
                  },
                }),
              ]),
            ]),
            _vm._v(" "),
            _c("g", { attrs: { id: "text" } }, [
              _c("g", [
                _c("path", {
                  staticClass: "st5",
                  attrs: {
                    d: "M385.299,358.114l-3.608-2.225l11.437-18.521l3.608,2.224L385.299,358.114z M400.497,339.17l-0.192,0.268\n                l-2.84-1.725l-0.384-2.608l-2.494,0.805l-2.764-1.687l0.192-0.307l5.028-1.035l2.034,1.265l1.382,5.062L400.497,339.17z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st5",
                  attrs: {
                    d: "M393.704,359.341l6.755,4.18l-1.765,2.876l-10.401-6.404l11.437-18.522l3.608,2.224l-9.672,15.607\n                L393.704,359.341z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st5",
                  attrs: {
                    d: "M415.35,365.476l-6.218-3.835l-3.224,5.254l7.331,4.525l-1.766,2.876l-10.938-6.749l11.437-18.522\n                l10.9,6.749l-1.766,2.876l-7.292-4.487l-2.84,4.602l6.218,3.835l-1.766,2.876H415.35z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st5",
                  attrs: {
                    d: "M430.24,379.205c0.461-0.729,0.614-1.419,0.499-2.071c-0.115-0.652-0.499-1.457-1.189-2.454\n                c-1.497-1.841-2.495-3.528-2.917-4.947c-0.422-1.457-0.192-2.953,0.767-4.487c0.921-1.534,2.265-2.416,3.992-2.684\n                c1.727-0.268,3.415,0.153,5.181,1.227c1.765,1.074,2.878,2.493,3.301,4.257c0.46,1.764,0.153,3.413-0.883,5.023l-0.077,0.077\n                l-3.492-2.186c0.537-0.844,0.729-1.649,0.652-2.454c-0.115-0.805-0.537-1.419-1.305-1.879c-0.729-0.46-1.42-0.575-2.072-0.384\n                c-0.691,0.192-1.228,0.614-1.612,1.266c-0.384,0.613-0.461,1.265-0.269,1.917c0.192,0.652,0.729,1.572,1.535,2.761\n                c1.382,1.688,2.226,3.26,2.572,4.717c0.307,1.457,0,2.953-0.96,4.525c-0.998,1.611-2.303,2.531-3.915,2.761\n                c-1.611,0.23-3.339-0.192-5.104-1.265c-1.765-1.074-2.955-2.531-3.646-4.372c-0.652-1.841-0.384-3.681,0.844-5.599l0.077-0.077\n                l3.531,2.186c-0.691,1.151-0.959,2.109-0.806,2.915c0.192,0.805,0.768,1.495,1.727,2.109c0.768,0.46,1.459,0.613,2.073,0.422\n                c0.614-0.192,1.151-0.614,1.573-1.304H430.24z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st5",
                  attrs: {
                    d: "M443.904,388.868l-4.874-3.029l-3.454,3.336l-3.646-2.263l16.656-15.3l3.761,2.339l-6.255,21.705\n                l-3.646-2.263l1.458-4.563V388.868z M441.524,383.423l3.416,2.109l2.38-7.593h-0.077L441.524,383.423z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st5",
                  attrs: {
                    d: "M451.35,398.915l-3.608-2.224l11.437-18.522l3.608,2.225L451.35,398.915z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st5",
                  attrs: {
                    d: "M467.317,408.771l-3.608-2.224l1.65-15.339h-0.077l-7.292,11.772l-3.607-2.224l11.437-18.522l3.607,2.225\n                l-1.65,15.3h0.077l7.292-11.772l3.608,2.224l-11.437,18.522V408.771z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st5",
                  attrs: {
                    d: "M490.341,401.408l-4.183-2.569l-9.671,15.607l-3.608-2.224l9.671-15.607l-4.145-2.57l1.766-2.876\n                l11.936,7.363L490.341,401.408z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st5",
                  attrs: {
                    d: "M489.958,413.756l-6.333-3.912l1.765-2.876l6.333,3.912L489.958,413.756z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st5",
                  attrs: {
                    d: "M504.275,423.381v0.115c-1.266,2.033-2.686,3.298-4.298,3.72s-3.378,0.038-5.297-1.151\n                c-1.919-1.188-3.07-2.722-3.492-4.601s0-3.912,1.381-6.059l3.416-5.522c1.343-2.148,2.917-3.452,4.759-3.95\n                c1.842-0.499,3.685-0.192,5.527,0.959c1.957,1.227,3.147,2.646,3.492,4.333c0.346,1.687-0.076,3.566-1.343,5.637h-0.077\n                l-3.492-2.109c0.806-1.189,1.19-2.148,1.113-2.953c-0.039-0.767-0.538-1.457-1.497-2.032c-0.806-0.499-1.612-0.576-2.456-0.192\n                c-0.845,0.383-1.651,1.189-2.418,2.493l-3.454,5.56c-0.806,1.304-1.19,2.416-1.113,3.336c0.076,0.921,0.537,1.649,1.458,2.224\n                c0.883,0.537,1.65,0.652,2.303,0.384c0.652-0.307,1.343-1.074,2.072-2.301l3.493,2.147L504.275,423.381z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st5",
                  attrs: {
                    d: "M515.828,438.72l-3.608-2.224l4.759-7.67l-5.757-3.566l-4.759,7.67l-3.608-2.225l11.437-18.521l3.608,2.224\n                l-4.912,7.976l5.756,3.566l4.913-7.976l3.608,2.224L515.828,438.72z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st5",
                  attrs: {
                    d: "M526.804,435.345l-4.567,7.363l-3.608-2.224L530.066,422l6.025,3.72c1.843,1.112,2.956,2.493,3.416,4.103\n                c0.461,1.611,0.154,3.26-0.921,4.986c-0.614,0.958-1.343,1.649-2.188,2.109c-0.844,0.422-1.842,0.613-2.916,0.498\n                c0.767,0.921,1.113,1.879,1.074,2.876c0,0.997-0.422,2.071-1.113,3.183l-0.806,1.304c-0.307,0.498-0.614,1.074-0.844,1.764\n                c-0.23,0.652-0.307,1.189-0.154,1.649l-0.153,0.268l-3.723-2.301c-0.115-0.46-0.038-0.997,0.269-1.687\n                c0.307-0.69,0.652-1.304,1.036-1.956l0.768-1.265c0.575-0.92,0.806-1.764,0.767-2.493c-0.077-0.728-0.46-1.342-1.151-1.764\n                l-2.61-1.61L526.804,435.345z M528.569,432.469l2.418,1.496c0.729,0.46,1.42,0.575,2.111,0.345\n                c0.691-0.23,1.228-0.729,1.765-1.572c0.538-0.844,0.768-1.649,0.691-2.378c-0.077-0.728-0.46-1.342-1.19-1.764l-2.418-1.495\n                l-3.3,5.368H528.569z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st5",
                  attrs: {
                    d: "M537.205,451.912l-3.607-2.225l11.437-18.521l3.607,2.224L537.205,451.912z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st5",
                  attrs: {
                    d: "M551.404,454.021c0.46-0.729,0.614-1.419,0.499-2.071c-0.115-0.652-0.499-1.457-1.19-2.454\n                c-1.497-1.841-2.495-3.528-2.917-4.947c-0.422-1.457-0.192-2.953,0.768-4.487c0.921-1.534,2.264-2.416,3.953-2.684\n                c1.727-0.269,3.415,0.153,5.181,1.227c1.765,1.074,2.878,2.493,3.301,4.257c0.46,1.725,0.153,3.413-0.883,5.023l-0.077,0.077\n                l-3.492-2.186c0.537-0.844,0.729-1.649,0.652-2.454c-0.115-0.806-0.537-1.419-1.305-1.879c-0.729-0.46-1.42-0.575-2.072-0.384\n                c-0.691,0.192-1.228,0.614-1.612,1.266c-0.384,0.613-0.461,1.265-0.269,1.917c0.192,0.652,0.729,1.572,1.535,2.761\n                c1.382,1.687,2.226,3.26,2.572,4.717c0.307,1.457,0,2.953-0.96,4.525c-0.998,1.61-2.303,2.531-3.915,2.761\n                c-1.611,0.23-3.339-0.192-5.104-1.266c-1.765-1.073-2.955-2.531-3.646-4.371c-0.652-1.841-0.384-3.682,0.844-5.599l0.077-0.077\n                l3.531,2.186c-0.691,1.151-0.959,2.109-0.806,2.915c0.192,0.805,0.729,1.495,1.727,2.109c0.768,0.46,1.459,0.613,2.073,0.422\n                c0.614-0.192,1.151-0.614,1.573-1.304H551.404z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st5",
                  attrs: {
                    d: "M574.892,453.599l-4.183-2.569l-9.672,15.607l-3.607-2.224l9.671-15.607l-4.145-2.57l1.766-2.876\n                l11.936,7.363L574.892,453.599z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st5",
                  attrs: {
                    d: "M583.182,471.124c-1.344,2.186-2.994,3.49-4.913,3.988c-1.919,0.499-3.876,0.115-5.833-1.074\n                c-1.958-1.227-3.148-2.799-3.57-4.716c-0.422-1.956,0.039-3.988,1.382-6.174l3.224-5.177c1.343-2.148,2.955-3.49,4.912-3.988\n                c1.919-0.499,3.877-0.154,5.834,1.035c1.957,1.189,3.147,2.799,3.569,4.755c0.422,1.956,0,4.027-1.381,6.174L583.182,471.124z\n                M582.798,463.685c0.806-1.343,1.19-2.493,1.113-3.452c-0.077-0.997-0.576-1.764-1.535-2.339c-0.96-0.575-1.881-0.69-2.764-0.307\n                c-0.882,0.384-1.765,1.227-2.571,2.57l-3.224,5.215c-0.844,1.342-1.228,2.492-1.151,3.451c0.077,0.959,0.576,1.764,1.497,2.339\n                c0.921,0.576,1.842,0.691,2.763,0.307c0.921-0.383,1.765-1.227,2.61-2.569l3.224-5.215H582.798z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st5",
                  attrs: {
                    d: "M589.167,474.843l-4.106,6.634l-3.608-2.224l11.437-18.522l6.448,3.989c1.842,1.15,2.955,2.607,3.377,4.333\n                c0.384,1.764,0.039,3.528-1.036,5.292c-1.113,1.764-2.533,2.876-4.26,3.298c-1.766,0.422-3.531,0.076-5.373-1.074l-2.802-1.726\n                H589.167z M590.933,471.967l2.801,1.726c0.768,0.46,1.536,0.575,2.303,0.23c0.768-0.307,1.42-0.92,1.958-1.802\n                c0.537-0.882,0.806-1.726,0.767-2.57c-0.038-0.843-0.46-1.495-1.228-1.955l-2.802-1.726l-3.761,6.097H590.933z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st5",
                  attrs: {
                    d: "M609.164,496.356l-3.608-2.224l4.759-7.669l-5.757-3.567l-4.759,7.67l-3.608-2.224l11.437-18.522\n                l3.608,2.224l-4.912,7.976l5.756,3.567l4.913-7.977l3.608,2.224L609.164,496.356z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st5",
                  attrs: {
                    d: "M626.818,496.05l-6.217-3.835l-3.224,5.254l7.33,4.525l-1.765,2.876l-10.938-6.75l11.437-18.521l10.9,6.749\n                l-1.766,2.876l-7.292-4.487l-2.84,4.602l6.217,3.835l-1.803,2.876H626.818z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st5",
                  attrs: {
                    d: "M1172.53,765.94l-3.95-1.496l7.67-20.362l3.96,1.495L1172.53,765.94z M1183.81,744.427l-0.11,0.307\n                l-3.11-1.189l-0.88-2.493l-2.27,1.266l-3.03-1.151l0.12-0.345l4.76-1.994l2.22,0.844l2.3,4.717V744.427z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st5",
                  attrs: {
                    d: "M1181.01,765.518l7.45,2.799l-1.19,3.183l-11.44-4.295l7.68-20.362l3.99,1.495L1181.01,765.518z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st5",
                  attrs: {
                    d: "M1203.47,767.397l-6.84-2.569l-2.18,5.752l8.06,3.029l-1.19,3.183l-12.05-4.525l7.67-20.362l12.01,4.525\n                l-1.19,3.183l-8.02-3.03l-1.92,5.062l6.84,2.569L1203.47,767.397z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st5",
                  attrs: {
                    d: "M1209.64,779.937l7.68-20.363l5.99,2.263c2.11,0.805,3.57,1.879,4.37,3.259\n                c0.85,1.381,0.88,2.991,0.19,4.832c-0.34,0.959-0.92,1.764-1.61,2.339c-0.69,0.575-1.57,0.921-2.57,0.959\n                c0.96,0.652,1.57,1.495,1.77,2.531c0.19,1.035,0.07,2.109-0.35,3.259c-0.73,1.956-1.84,3.222-3.34,3.797s-3.3,0.498-5.37-0.307\n                l-6.79-2.569H1209.64z M1217.01,772.459l-2.19,5.79l2.81,1.074c0.84,0.307,1.57,0.307,2.15,0c0.57-0.307,1.07-0.92,1.42-1.84\n                c0.38-0.959,0.46-1.764,0.3-2.455c-0.15-0.652-0.61-1.112-1.42-1.419L1217.01,772.459z M1218.05,769.66l2.19,0.843\n                c0.8,0.269,1.53,0.269,2.15,0c0.61-0.307,1.07-0.843,1.38-1.725c0.34-0.959,0.38-1.726,0.11-2.34\n                c-0.27-0.613-0.88-1.073-1.76-1.418l-2.04-0.767L1218.05,769.66z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st5",
                  attrs: {
                    d: "M1230.71,784.27l7.45,2.799l-1.19,3.183l-11.44-4.295l7.68-20.362l3.99,1.495L1230.71,784.27z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st5",
                  attrs: {
                    d: "M1254.51,788.527c-0.92,2.377-2.26,3.988-4.07,4.87c-1.8,0.843-3.8,0.882-5.95,0.076\n                c-2.15-0.805-3.6-2.147-4.41-3.949c-0.77-1.841-0.73-3.95,0.19-6.328l2.15-5.714c0.88-2.377,2.23-3.988,4.03-4.87\n                c1.8-0.882,3.76-0.882,5.91-0.076c2.15,0.805,3.61,2.147,4.41,3.988c0.81,1.84,0.73,3.95-0.15,6.327l-2.15,5.714L1254.51,788.527\n                z M1252.71,781.279c0.53-1.457,0.69-2.646,0.42-3.605c-0.27-0.958-0.92-1.61-1.96-1.994c-1.04-0.383-1.96-0.307-2.76,0.23\n                c-0.81,0.537-1.5,1.534-2.04,3.03l-2.18,5.752c-0.58,1.457-0.73,2.684-0.46,3.604c0.26,0.921,0.88,1.611,1.91,1.995\n                c1.04,0.383,1.96,0.306,2.77-0.231c0.8-0.536,1.49-1.533,2.07-3.029l2.19-5.752H1252.71z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st5",
                  attrs: {
                    d: "M1268.59,802.178l-3.95-1.496l-1.3-15.377h-0.08l-4.91,13l-3.99-1.496l7.67-20.362l3.99,1.495l1.31,15.339\n                h0.11l4.92-12.961l3.95,1.495l-7.68,20.363H1268.59z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st5",
                  attrs: {
                    d: "M1279.84,800.453l-0.15,0.843h0.07l0.43-0.652l9.13-13.92l4.18,1.572l-13.39,18.215l-4.15-1.572l2-22.51\n                l4.18,1.572l-2.34,16.413L1279.84,800.453z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st5",
                  attrs: {
                    d: "M1291.7,810.883l-3.95-1.496l7.67-20.362l3.95,1.495L1291.7,810.883z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st5",
                  attrs: {
                    d: "M1300.18,810.461l7.45,2.8l-1.19,3.183l-11.44-4.295l7.68-20.363l3.99,1.496L1300.18,810.461z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st5",
                  attrs: {
                    d: "M1313.58,815.523l7.44,2.8l-1.19,3.183l-11.44-4.295l7.68-20.363l3.99,1.496L1313.58,815.523z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st5",
                  attrs: {
                    d: "M1336.02,817.402l-6.83-2.569l-2.18,5.752l8.06,3.029l-1.19,3.183l-12.06-4.525l7.68-20.362l12.01,4.525\n                l-1.19,3.183l-8.02-3.03l-1.92,5.062l6.83,2.569L1336.02,817.402z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", { attrs: { id: "text-fleuve" } }, [
                _c("defs", [
                  _c("rect", {
                    attrs: {
                      id: "SVGID_1_",
                      x: "1294.44",
                      y: "1433.58",
                      width: "390",
                      height: "29.979",
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("clipPath", { attrs: { id: "SVGID_2_" } }, [
                  _c("use", {
                    staticStyle: { overflow: "visible" },
                    attrs: { "xlink:href": "#SVGID_1_" },
                  }),
                ]),
                _vm._v(" "),
                _c("g", { staticClass: "st9" }, [
                  _c("g", [
                    _c("path", {
                      staticClass: "st1",
                      attrs: {
                        d: "M1309.81,1451.05h-9.76v12.11h-5.61v-29.18h17.11v4.53h-11.5v7.94h9.76v4.52V1451.05z",
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("g", [
                    _c("path", {
                      staticClass: "st1",
                      attrs: {
                        d: "M1320.13,1458.59h10.51v4.53h-16.13v-29.14h5.62V1458.59z",
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("g", [
                    _c("path", {
                      staticClass: "st1",
                      attrs: {
                        d: "M1348.7,1450.37h-9.64v8.26h11.34v4.53h-16.99v-29.18h16.95v4.53h-11.3v7.25h9.64v4.53V1450.37z",
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("g", [
                    _c("path", {
                      staticClass: "st1",
                      attrs: {
                        d: "M1372.53,1433.98v19.84c0,3.13-0.91,5.53-2.69,7.21c-1.81,1.69-4.15,2.53-7.07,2.53\n                        c-2.92,0-5.26-0.84-7.07-2.53c-1.78-1.68-2.69-4.08-2.69-7.17v-19.88h5.61v19.84c0,1.76,0.36,3.09,1.07,3.93\n                        c0.71,0.84,1.74,1.24,3.04,1.24c1.3,0,2.37-0.4,3.08-1.2c0.71-0.8,1.07-2.13,1.07-3.97v-19.84h5.57H1372.53z",
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("g", [
                    _c("path", {
                      staticClass: "st1",
                      attrs: {
                        d: "M1385.22,1455.7l0.24,1.13h0.12l0.23-1.09l4.75-21.76h5.88l-8.02,29.14h-5.85l-8.02-29.14h5.89l4.74,21.72\n                        H1385.22z",
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("g", [
                    _c("path", {
                      staticClass: "st1",
                      attrs: {
                        d: "M1414.11,1450.37h-9.64v8.26h11.34v4.53h-17v-29.18h16.96v4.53h-11.3v7.25h9.64v4.53V1450.37z",
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("g", [
                    _c("path", {
                      staticClass: "st1",
                      attrs: {
                        d: "M1440.39,1455.54c0-1.12-0.28-2.04-0.87-2.68s-1.58-1.32-3.04-1.97c-3.01-1.04-5.22-2.24-6.72-3.6\n                        c-1.5-1.33-2.25-3.21-2.25-5.65c0-2.45,0.87-4.33,2.61-5.86c1.73-1.48,3.95-2.24,6.64-2.24c2.68,0,4.97,0.84,6.67,2.53\n                        c1.7,1.68,2.53,3.76,2.49,6.33v0.12h-5.49c0-1.32-0.32-2.41-0.99-3.25c-0.67-0.84-1.58-1.24-2.8-1.24\n                        c-1.11,0-1.98,0.32-2.61,1.04c-0.63,0.72-0.95,1.56-0.95,2.61c0,0.96,0.36,1.76,1.03,2.36c0.71,0.6,1.89,1.32,3.63,2.09\n                        c2.73,0.92,4.79,2.12,6.17,3.56c1.38,1.44,2.05,3.37,2.05,5.81c0,2.45-0.83,4.49-2.49,5.94c-1.66,1.44-3.87,2.12-6.6,2.12\n                        c-2.72,0-5.09-0.8-7.11-2.45c-2.02-1.64-2.96-3.96-2.92-6.97v-0.12h5.49c0,1.8,0.39,3.09,1.14,3.89c0.76,0.8,1.9,1.16,3.4,1.16\n                        c1.19,0,2.06-0.32,2.65-0.96c0.55-0.64,0.87-1.52,0.87-2.61V1455.54z",
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("g", [
                    _c("path", {
                      staticClass: "st1",
                      attrs: {
                        d: "M1462.4,1456.91h-7.58l-1.55,6.21h-5.65l8.11-29.14h5.84l8.07,29.14h-5.65l-1.55-6.21H1462.4z\n                        M1455.96,1452.38h5.3l-2.61-10.3h-0.12L1455.96,1452.38z",
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("g", [
                    _c("path", {
                      staticClass: "st1",
                      attrs: {
                        d: "M1477.78,1463.16h-5.57v-29.18h5.57v29.14V1463.16z",
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("g", [
                    _c("path", {
                      staticClass: "st1",
                      attrs: {
                        d: "M1502.56,1463.16h-5.57l-8.78-18.64h-0.12v18.64h-5.61v-29.18h5.61l8.78,18.64h0.12v-18.64h5.57v29.14\n                        V1463.16z",
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("g", [
                    _c("path", {
                      staticClass: "st1",
                      attrs: {
                        d: "M1523.27,1438.55h-6.48v24.61h-5.62v-24.61h-6.44v-4.57h18.54v4.53V1438.55z",
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("g", [
                    _c("path", {
                      staticClass: "st1",
                      attrs: { d: "M1531.41,1452.9h-9.8v-4.53h9.8V1452.9z" },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("g", [
                    _c("path", {
                      staticClass: "st1",
                      attrs: {
                        d: "M1541.8,1458.59h10.52v4.53h-16.13v-29.14h5.61V1458.59z",
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("g", [
                    _c("path", {
                      staticClass: "st1",
                      attrs: {
                        d: "M1568.4,1456.91h-7.59l-1.54,6.21h-5.65l8.1-29.14h5.85l8.06,29.14h-5.65l-1.54-6.21H1568.4z\n                        M1561.96,1452.38h5.3l-2.61-10.3h-0.12L1561.96,1452.38z",
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("g", [
                    _c("path", {
                      staticClass: "st1",
                      attrs: {
                        d: "M1596.7,1433.98v19.84c0,3.13-0.91,5.53-2.69,7.21c-1.82,1.69-4.15,2.53-7.07,2.53\n                        c-2.93,0-5.26-0.84-7.08-2.53c-1.78-1.68-2.68-4.08-2.68-7.17v-19.88h5.61v19.84c0,1.76,0.35,3.09,1.06,3.93\n                        c0.72,0.84,1.74,1.24,3.05,1.24c1.3,0,2.37-0.4,3.08-1.2c0.71-0.8,1.07-2.13,1.07-3.97v-19.84h5.57H1596.7z",
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("g", [
                    _c("path", {
                      staticClass: "st1",
                      attrs: {
                        d: "M1606.38,1451.58v11.58h-5.61v-29.14h9.37c2.84,0,5.05,0.76,6.68,2.29c1.62,1.52,2.41,3.6,2.41,6.33\n                        c0,1.52-0.32,2.84-0.99,3.93c-0.67,1.08-1.66,1.96-2.93,2.64c1.47,0.52,2.53,1.36,3.2,2.53c0.64,1.16,0.99,2.64,0.99,4.4v2.05\n                        c0,0.8,0.08,1.64,0.28,2.56c0.2,0.93,0.51,1.57,0.99,2.01v0.4h-5.81c-0.48-0.44-0.75-1.12-0.87-2.09\n                        c-0.12-0.96-0.16-1.92-0.16-2.92v-1.96c0-1.45-0.28-2.57-0.87-3.37c-0.59-0.8-1.42-1.2-2.53-1.2h-4.07L1606.38,1451.58z\n                        M1606.38,1447.05h3.76c1.14,0,2.01-0.36,2.6-1.05c0.6-0.72,0.87-1.72,0.87-3s-0.31-2.41-0.87-3.17\n                        c-0.59-0.8-1.46-1.16-2.56-1.16h-3.76v8.46L1606.38,1447.05z",
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("g", [
                    _c("path", {
                      staticClass: "st1",
                      attrs: {
                        d: "M1638.95,1450.37h-9.65v8.26h11.35v4.53h-17v-29.18h16.96v4.53h-11.31v7.25h9.65v4.53V1450.37z",
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("g", [
                    _c("path", {
                      staticClass: "st1",
                      attrs: {
                        d: "M1663.69,1463.16h-5.57l-8.78-18.64h-0.12v18.64h-5.61v-29.18h5.61l8.78,18.64h0.12v-18.64h5.57v29.14\n                        V1463.16z",
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("g", [
                    _c("path", {
                      staticClass: "st1",
                      attrs: {
                        d: "M1684.44,1438.55h-6.48v24.61h-5.62v-24.61h-6.44v-4.57h18.54v4.53V1438.55z",
                      },
                    }),
                  ]),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _vm.title.includes(50)
              ? _c("g", { attrs: { id: "hotzone-list" } }, [
                  _c("g", { attrs: { id: "hotzone-1" } }, [
                    _c("g", [
                      _c("path", {
                        staticClass: "st2",
                        attrs: {
                          d: "M1032.44,1157L1032.44,1157c13.255,0,24,10.745,24,24l0,0c0,13.255-10.745,24-24,24l0,0\n                    c-13.255,0-24-10.745-24-24l0,0C1008.44,1167.745,1019.185,1157,1032.44,1157z",
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("g", [
                      _c("path", {
                        staticClass: "st10",
                        attrs: {
                          d: "M1032.5,1188.28c-3.981,0-7.22-3.238-7.22-7.22s3.239-7.221,7.22-7.221c3.976,0,7.21,3.239,7.21,7.221\n                    S1036.476,1188.28,1032.5,1188.28z M1032.5,1174.84c-3.43,0-6.22,2.791-6.22,6.221s2.79,6.22,6.22,6.22\n                    c3.424,0,6.21-2.79,6.21-6.22S1035.924,1174.84,1032.5,1174.84z",
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("g", [
                      _c("path", {
                        staticClass: "st10",
                        attrs: {
                          d: "M1032.5,1170.189c-0.276,0-0.5-0.224-0.5-0.5v-2.069c0-0.276,0.224-0.5,0.5-0.5s0.5,0.224,0.5,0.5v2.069\n                    C1033,1169.966,1032.776,1170.189,1032.5,1170.189z",
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("g", [
                      _c("path", {
                        staticClass: "st10",
                        attrs: {
                          d: "M1032.5,1194.99c-0.276,0-0.5-0.224-0.5-0.5v-2.061c0-0.276,0.224-0.5,0.5-0.5s0.5,0.224,0.5,0.5v2.061\n                    C1033,1194.767,1032.776,1194.99,1032.5,1194.99z",
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("g", [
                      _c("path", {
                        staticClass: "st10",
                        attrs: {
                          d: "M1045.93,1181.561h-2.06c-0.276,0-0.5-0.224-0.5-0.5s0.224-0.5,0.5-0.5h2.06c0.276,0,0.5,0.224,0.5,0.5\n                    S1046.207,1181.561,1045.93,1181.561z",
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("g", [
                      _c("path", {
                        staticClass: "st10",
                        attrs: {
                          d: "M1021.13,1181.561h-2.07c-0.276,0-0.5-0.224-0.5-0.5s0.224-0.5,0.5-0.5h2.07c0.276,0,0.5,0.224,0.5,0.5\n                    S1021.406,1181.561,1021.13,1181.561z",
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("g", [
                      _c("path", {
                        staticClass: "st10",
                        attrs: {
                          d: "M1040.54,1173.52c-0.127,0-0.255-0.049-0.353-0.146c-0.196-0.194-0.197-0.511-0.002-0.707l1.46-1.47\n                    c0.195-0.196,0.511-0.195,0.707-0.002c0.196,0.194,0.197,0.511,0.002,0.707l-1.46,1.47\n                    C1040.797,1173.471,1040.668,1173.52,1040.54,1173.52z",
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("g", [
                      _c("path", {
                        staticClass: "st10",
                        attrs: {
                          d: "M1022.99,1191.07c-0.127,0-0.255-0.049-0.352-0.146c-0.196-0.194-0.197-0.511-0.003-0.707l1.46-1.471\n                    c0.195-0.196,0.512-0.196,0.707-0.002c0.196,0.194,0.197,0.511,0.003,0.707l-1.46,1.471\n                    C1023.248,1191.021,1023.119,1191.07,1022.99,1191.07z",
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("g", [
                      _c("path", {
                        staticClass: "st10",
                        attrs: {
                          d: "M1042,1191.07c-0.128,0-0.257-0.049-0.355-0.147l-1.46-1.471c-0.194-0.196-0.193-0.513,0.003-0.707\n                    c0.194-0.195,0.512-0.195,0.707,0.002l1.46,1.471c0.194,0.196,0.193,0.513-0.003,0.707\n                    C1042.255,1191.021,1042.127,1191.07,1042,1191.07z",
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("g", [
                      _c("path", {
                        staticClass: "st10",
                        attrs: {
                          d: "M1024.45,1173.52c-0.128,0-0.257-0.049-0.354-0.147l-1.46-1.47c-0.195-0.196-0.194-0.513,0.002-0.707\n                    c0.195-0.194,0.512-0.195,0.707,0.002l1.46,1.47c0.195,0.196,0.194,0.513-0.002,0.707\n                    C1024.705,1173.471,1024.578,1173.52,1024.45,1173.52z",
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("g", [
                      _c("g", { staticClass: "st11" }, [
                        _c("rect", {
                          staticClass: "st2",
                          attrs: {
                            x: "1008.44",
                            y: "1157",
                            width: "48",
                            height: "48",
                          },
                        }),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("g", { attrs: { id: "hotzone-2_1_" } }, [
                    _c("g", [
                      _c("path", {
                        staticClass: "st2",
                        attrs: {
                          d: "M1181.06,1301L1181.06,1301c13.255,0,24,10.745,24,24l0,0c0,13.255-10.745,24-24,24l0,0\n                    c-13.255,0-24-10.745-24-24l0,0C1157.06,1311.745,1167.805,1301,1181.06,1301z",
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("g", [
                      _c("path", {
                        staticClass: "st10",
                        attrs: {
                          d: "M1181.12,1332.28c-3.981,0-7.22-3.238-7.22-7.22s3.238-7.221,7.22-7.221c3.976,0,7.21,3.239,7.21,7.221\n                    S1185.096,1332.28,1181.12,1332.28z M1181.12,1318.84c-3.43,0-6.22,2.791-6.22,6.221s2.79,6.22,6.22,6.22\n                    c3.424,0,6.21-2.79,6.21-6.22S1184.544,1318.84,1181.12,1318.84z",
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("g", [
                      _c("path", {
                        staticClass: "st10",
                        attrs: {
                          d: "M1181.12,1314.189c-0.276,0-0.5-0.224-0.5-0.5v-2.069c0-0.276,0.224-0.5,0.5-0.5s0.5,0.224,0.5,0.5v2.069\n                    C1181.62,1313.966,1181.396,1314.189,1181.12,1314.189z",
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("g", [
                      _c("path", {
                        staticClass: "st10",
                        attrs: {
                          d: "M1181.12,1338.99c-0.276,0-0.5-0.224-0.5-0.5v-2.061c0-0.276,0.224-0.5,0.5-0.5s0.5,0.224,0.5,0.5v2.061\n                    C1181.62,1338.767,1181.396,1338.99,1181.12,1338.99z",
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("g", [
                      _c("path", {
                        staticClass: "st10",
                        attrs: {
                          d: "M1194.55,1325.561h-2.06c-0.276,0-0.5-0.224-0.5-0.5s0.224-0.5,0.5-0.5h2.06c0.276,0,0.5,0.224,0.5,0.5\n                    S1194.826,1325.561,1194.55,1325.561z",
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("g", [
                      _c("path", {
                        staticClass: "st10",
                        attrs: {
                          d: "M1169.75,1325.561h-2.07c-0.276,0-0.5-0.224-0.5-0.5s0.224-0.5,0.5-0.5h2.07c0.276,0,0.5,0.224,0.5,0.5\n                    S1170.026,1325.561,1169.75,1325.561z",
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("g", [
                      _c("path", {
                        staticClass: "st10",
                        attrs: {
                          d: "M1189.16,1317.52c-0.127,0-0.255-0.049-0.353-0.146c-0.195-0.194-0.197-0.511-0.002-0.707l1.46-1.47\n                    c0.193-0.196,0.51-0.196,0.707-0.002c0.195,0.194,0.197,0.511,0.002,0.707l-1.46,1.47\n                    C1189.417,1317.471,1189.289,1317.52,1189.16,1317.52z",
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("g", [
                      _c("path", {
                        staticClass: "st10",
                        attrs: {
                          d: "M1171.61,1335.07c-0.127,0-0.255-0.049-0.353-0.146c-0.195-0.194-0.197-0.511-0.002-0.707l1.46-1.471\n                    c0.194-0.195,0.511-0.197,0.707-0.002c0.195,0.194,0.197,0.511,0.002,0.707l-1.46,1.471\n                    C1171.867,1335.021,1171.739,1335.07,1171.61,1335.07z",
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("g", [
                      _c("path", {
                        staticClass: "st10",
                        attrs: {
                          d: "M1190.62,1335.07c-0.129,0-0.257-0.049-0.354-0.147l-1.46-1.471c-0.195-0.196-0.193-0.513,0.002-0.707\n                    c0.196-0.195,0.513-0.193,0.707,0.002l1.46,1.471c0.195,0.196,0.193,0.513-0.002,0.707\n                    C1190.875,1335.021,1190.747,1335.07,1190.62,1335.07z",
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("g", [
                      _c("path", {
                        staticClass: "st10",
                        attrs: {
                          d: "M1173.07,1317.52c-0.129,0-0.257-0.049-0.354-0.147l-1.46-1.47c-0.195-0.196-0.193-0.513,0.002-0.707\n                    c0.197-0.194,0.514-0.194,0.707,0.002l1.46,1.47c0.195,0.196,0.193,0.513-0.002,0.707\n                    C1173.325,1317.471,1173.197,1317.52,1173.07,1317.52z",
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("g", { staticClass: "st11" }, [
                      _c("rect", {
                        staticClass: "st2",
                        attrs: {
                          x: "1157.06",
                          y: "1301",
                          width: "48",
                          height: "48",
                        },
                      }),
                    ]),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.title.includes(51)
              ? _c("g", { attrs: { id: "vestiaire" } }, [
                  _c("g", { attrs: { id: "vestiaire-patin" } }, [
                    _c("path", {
                      staticClass: "st0",
                      attrs: {
                        d: "M1140.06,1222L1140.06,1222c13.255,0,24,10.745,24,24l0,0c0,13.255-10.745,24-24,24l0,0\n                c-13.255,0-24-10.745-24-24l0,0C1116.06,1232.745,1126.805,1222,1140.06,1222z",
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("g", [
                    _c("g", [
                      _c("polygon", {
                        staticClass: "st12",
                        attrs: {
                          points:
                            "1136.124,1243.393 1136.743,1242.575 1135.87,1242.575 1135.251,1243.393 \t\t\t\t",
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("g", [
                      _c("path", {
                        staticClass: "st12",
                        attrs: {
                          d: "M1127.956,1238.939c-0.618-0.312-1.24-0.425-1.602-0.466l-0.243,0.97\n                    c-0.018,0.067-0.364,1.358-0.093,2.373h3.779C1129.702,1240.475,1129.083,1239.507,1127.956,1238.939z",
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("g", [
                      _c("polygon", {
                        staticClass: "st12",
                        attrs: {
                          points:
                            "1127.186,1233.281 1127.125,1234.177 1127.654,1234.115 1127.654,1233.281 \t\t\t\t",
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("g", [
                      _c("polygon", {
                        staticClass: "st12",
                        attrs: {
                          points:
                            "1128.818,1243.393 1129.438,1242.575 1128.565,1242.575 1127.945,1243.393 \t\t\t\t",
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("g", [
                      _c("path", {
                        staticClass: "st12",
                        attrs: {
                          d: "M1151.135,1239.137c0.407-0.399,0.628-0.93,0.628-1.5c0-0.578-0.221-1.111-0.62-1.503\n                    c-0.399-0.4-0.945-0.628-1.5-0.628c-0.561,0-1.11,0.228-1.507,0.624c-0.396,0.396-0.623,0.945-0.623,1.507\n                    c0,0.563,0.222,1.094,0.623,1.496C1148.917,1239.93,1150.355,1239.935,1151.135,1239.137z",
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("g", [
                      _c("path", {
                        staticClass: "st12",
                        attrs: {
                          d: "M1137.914,1238.647c-0.009-0.002-0.019-0.003-0.028-0.005v3.174h3.843\n                    C1141.573,1240.102,1140.324,1239.065,1137.914,1238.647z",
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("g", [
                      _c("path", {
                        staticClass: "st12",
                        attrs: {
                          d: "M1132.738,1235.64l-0.614-1.285l-5.067,0.595l-0.152,1.305c-0.001,0.014-0.004,0.03-0.009,0.048\n                    l-0.356,1.428c0.46,0.062,1.106,0.203,1.759,0.532c0.965,0.485,2.132,1.496,2.26,3.554h6.57l0.001-1.831l-0.001-0.042v-1.56\n                    c-0.462-0.201-1.05-0.517-1.749-0.938l-0.71,0.708c-0.138,0.143-0.395,0.144-0.536,0c-0.147-0.148-0.147-0.389,0.001-0.536\n                    l0.583-0.583c-0.123-0.077-0.242-0.154-0.357-0.229l-0.722,0.72c-0.143,0.144-0.394,0.145-0.536,0\n                    c-0.072-0.071-0.111-0.167-0.111-0.268c0-0.102,0.039-0.197,0.111-0.269l0.612-0.612c-0.455-0.307-0.776-0.534-0.845-0.583\n                    C1132.808,1235.749,1132.766,1235.698,1132.738,1235.64z",
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("g", [
                      _c("path", {
                        staticClass: "st12",
                        attrs: {
                          d: "M1150.393,1242.637h-1.5c-0.674,0-1.301,0.259-1.764,0.729c-0.477,0.469-0.736,1.096-0.736,1.771v4.5\n                    c0,0.266,0.104,0.517,0.294,0.706s0.439,0.294,0.706,0.294c0.276,0,0.5,0.224,0.5,0.5v3.75c0,0.466,0.183,0.905,0.514,1.236\n                    c0.662,0.662,1.811,0.662,2.473,0c0.331-0.331,0.514-0.771,0.514-1.236v-3.75c0-0.276,0.224-0.5,0.5-0.5\n                    c0.267,0,0.517-0.104,0.705-0.293c0.19-0.19,0.295-0.441,0.295-0.707v-4.5c0-0.666-0.261-1.294-0.733-1.768\n                    C1151.7,1242.903,1151.057,1242.637,1150.393,1242.637z",
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("g", [
                      _c("polygon", {
                        staticClass: "st12",
                        attrs: {
                          points:
                            "1134.298,1243.393 1134.917,1242.575 1130.391,1242.575 1129.771,1243.393 \t\t\t\t",
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("g", [
                      _c("path", {
                        staticClass: "st1",
                        attrs: {
                          d: "M1149.643,1240.756c0.83,0,1.635-0.335,2.199-0.912c0.594-0.582,0.921-1.366,0.921-2.207\n                    c0-0.849-0.327-1.637-0.917-2.214c-1.167-1.171-3.255-1.162-4.417,0c-0.582,0.582-0.916,1.389-0.916,2.214\n                    c0,0.829,0.325,1.611,0.912,2.199C1148.007,1240.43,1148.794,1240.756,1149.643,1240.756z M1148.136,1236.13\n                    c0.396-0.396,0.946-0.624,1.507-0.624c0.555,0,1.101,0.228,1.5,0.628c0.399,0.392,0.62,0.925,0.62,1.503\n                    c0,0.57-0.221,1.101-0.628,1.5c-0.779,0.798-2.218,0.793-2.999-0.004c-0.401-0.402-0.623-0.934-0.623-1.496\n                    C1147.513,1237.076,1147.74,1236.527,1148.136,1236.13z",
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("g", [
                      _c("path", {
                        staticClass: "st1",
                        attrs: {
                          d: "M1152.869,1242.666c-0.644-0.653-1.546-1.028-2.477-1.028h-1.5c-0.944,0-1.823,0.365-2.471,1.022\n                    c-0.664,0.652-1.029,1.532-1.029,2.478v4.5c0,0.533,0.208,1.035,0.586,1.412c0.257,0.258,0.571,0.437,0.914,0.525v3.313\n                    c0,0.733,0.286,1.423,0.807,1.943s1.21,0.807,1.943,0.807s1.423-0.286,1.943-0.807s0.807-1.21,0.807-1.943v-3.313\n                    c0.343-0.089,0.657-0.268,0.913-0.524c0.379-0.378,0.587-0.88,0.587-1.413v-4.5\n                    C1153.893,1244.205,1153.528,1243.326,1152.869,1242.666z M1152.893,1249.637c0,0.266-0.104,0.517-0.295,0.707\n                    c-0.188,0.188-0.438,0.293-0.705,0.293c-0.276,0-0.5,0.224-0.5,0.5v3.75c0,0.466-0.183,0.905-0.514,1.236\n                    c-0.662,0.662-1.811,0.662-2.473,0c-0.331-0.331-0.514-0.771-0.514-1.236v-3.75c0-0.276-0.224-0.5-0.5-0.5\n                    c-0.267,0-0.517-0.104-0.706-0.294s-0.294-0.44-0.294-0.706v-4.5c0-0.675,0.26-1.302,0.736-1.771\n                    c0.463-0.471,1.09-0.729,1.764-0.729h1.5c0.664,0,1.308,0.266,1.767,0.732c0.473,0.474,0.733,1.102,0.733,1.768V1249.637z\n                    M1142.126,1242.575c0.209,0,0.379-0.17,0.378-0.4c-0.005-1.442-0.595-2.559-1.755-3.316c-0.913-0.598-1.981-0.834-2.704-0.959\n                    c-0.104-0.019-0.232-0.057-0.382-0.112l-0.028-0.011c-1.146-0.444-3.271-1.854-4.254-2.552l-0.688-1.44\n                    c-0.07-0.146-0.231-0.228-0.387-0.214l-3.894,0.456v-1.125c0-0.209-0.17-0.379-0.379-0.379h-1.203\n                    c-0.199,0-0.366,0.155-0.379,0.354l-0.114,1.694l-0.182,1.565l-0.778,3.116c-0.051,0.183-0.483,1.816,0.014,3.082\n                    c0.057,0.146,0.196,0.241,0.354,0.241h1.868l-0.619,0.818h-0.855c-0.147,0-0.283,0.087-0.345,0.221\n                    c-0.062,0.135-0.039,0.294,0.057,0.406l1.529,1.775c0.072,0.083,0.177,0.131,0.288,0.131h1.572c0.209,0,0.379-0.17,0.379-0.379\n                    c0-0.21-0.17-0.38-0.379-0.38h-1.398l-0.875-1.016h14.685c-0.04,0.127-0.087,0.244-0.141,0.353\n                    c-0.217,0.439-0.521,0.663-0.905,0.663h-9.777c-0.209,0-0.379,0.17-0.379,0.38c0,0.209,0.17,0.379,0.379,0.379h9.777\n                    c1.305,0,1.812-1.38,1.897-2.109c0.013-0.107-0.021-0.216-0.093-0.297c-0.072-0.081-0.176-0.127-0.284-0.127h-5.049l0.619-0.818\n                    H1142.126z M1141.729,1241.816h-3.843v-3.174c0.01,0.002,0.02,0.003,0.028,0.005\n                    C1140.324,1239.065,1141.573,1240.102,1141.729,1241.816z M1127.125,1234.177l0.061-0.896h0.469v0.834L1127.125,1234.177z\n                    M1136.743,1242.575l-0.619,0.818h-0.873l0.619-0.818H1136.743z M1129.438,1242.575l-0.62,0.818h-0.873l0.62-0.818H1129.438z\n                    M1126.019,1241.816c-0.271-1.015,0.075-2.306,0.093-2.373l0.243-0.97c0.361,0.041,0.983,0.154,1.602,0.466\n                    c1.127,0.568,1.746,1.536,1.842,2.877H1126.019z M1133.102,1236.988c-0.072,0.071-0.111,0.167-0.111,0.269\n                    c0,0.101,0.039,0.196,0.111,0.268c0.143,0.145,0.394,0.144,0.536,0l0.722-0.72c0.115,0.075,0.234,0.152,0.357,0.229\n                    l-0.583,0.583c-0.148,0.147-0.148,0.388-0.001,0.536c0.142,0.144,0.398,0.143,0.536,0l0.71-0.708\n                    c0.699,0.422,1.287,0.737,1.749,0.938v1.56l0.001,0.042l-0.001,1.831h-6.57c-0.128-2.058-1.295-3.068-2.26-3.554\n                    c-0.652-0.329-1.299-0.471-1.759-0.532l0.356-1.428c0.005-0.018,0.008-0.034,0.009-0.048l0.152-1.305l5.067-0.595l0.614,1.285\n                    c0.027,0.058,0.069,0.108,0.131,0.152c0.068,0.049,0.39,0.276,0.845,0.583L1133.102,1236.988z M1134.917,1242.575l-0.619,0.818\n                    h-4.526l0.619-0.818H1134.917z",
                        },
                      }),
                    ]),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.title.includes(52)
              ? _c("g", { attrs: { id: "debut-sentiers" } }, [
                  _c("g", [
                    _c("path", {
                      staticClass: "st0",
                      attrs: {
                        d: "M1098.257,1174.34L1098.257,1174.34c13.255,0,24,10.745,24,24l0,0c0,13.255-10.745,24-24,24l0,0\n                c-13.255,0-24-10.745-24-24l0,0C1074.257,1185.085,1085.002,1174.34,1098.257,1174.34z",
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("g"),
                  _vm._v(" "),
                  _c("g", [
                    _c("g", [
                      _c("path", {
                        staticClass: "st1",
                        attrs: {
                          d: "M1104.262,1191.479h-6.896c-0.163,0-0.316-0.079-0.409-0.213c-0.094-0.134-0.116-0.305-0.061-0.458\n                    l3.448-9.483c0.143-0.395,0.797-0.395,0.939,0l3.448,9.483c0.056,0.153,0.033,0.324-0.061,0.458\n                    C1104.578,1191.4,1104.425,1191.479,1104.262,1191.479z M1098.079,1190.479h5.469l-2.734-7.521L1098.079,1190.479z",
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("g", [
                      _c("path", {
                        staticClass: "st1",
                        attrs: {
                          d: "M1100.813,1194.928c-0.276,0-0.5-0.224-0.5-0.5v-3.448c0-0.276,0.224-0.5,0.5-0.5s0.5,0.224,0.5,0.5v3.448\n                    C1101.313,1194.704,1101.09,1194.928,1100.813,1194.928z",
                        },
                      }),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("g", [
                    _c("g", [
                      _c("path", {
                        staticClass: "st1",
                        attrs: {
                          d: "M1094.029,1207.177h-5.079c-0.163,0-0.316-0.079-0.409-0.213c-0.094-0.134-0.116-0.305-0.061-0.458\n                    l2.539-6.983c0.143-0.395,0.797-0.395,0.939,0l2.54,6.983c0.056,0.153,0.033,0.324-0.061,0.458\n                    C1094.346,1207.098,1094.192,1207.177,1094.029,1207.177z M1089.664,1206.177h3.651l-1.826-5.021L1089.664,1206.177z",
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("g", [
                      _c("path", {
                        staticClass: "st1",
                        attrs: {
                          d: "M1091.489,1209.716c-0.276,0-0.5-0.224-0.5-0.5v-2.539c0-0.276,0.224-0.5,0.5-0.5s0.5,0.224,0.5,0.5v2.539\n                    C1091.989,1209.492,1091.766,1209.716,1091.489,1209.716z",
                        },
                      }),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("g", [
                    _c("g", [
                      _c("path", {
                        staticClass: "st1",
                        attrs: {
                          d: "M1113.707,1201.911h-5.078c-0.163,0-0.316-0.079-0.409-0.213c-0.094-0.134-0.116-0.305-0.061-0.458\n                    l2.539-6.983c0.143-0.395,0.797-0.395,0.939,0l2.539,6.983c0.056,0.153,0.033,0.324-0.061,0.458\n                    C1114.023,1201.832,1113.87,1201.911,1113.707,1201.911z M1109.343,1200.911h3.65l-1.825-5.021L1109.343,1200.911z",
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("g", [
                      _c("path", {
                        staticClass: "st1",
                        attrs: {
                          d: "M1111.168,1204.45c-0.276,0-0.5-0.224-0.5-0.5v-2.539c0-0.276,0.224-0.5,0.5-0.5s0.5,0.224,0.5,0.5v2.539\n                    C1111.668,1204.227,1111.444,1204.45,1111.168,1204.45z",
                        },
                      }),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("g", [
                    _c("path", {
                      staticClass: "st1",
                      attrs: {
                        d: "M1104.054,1206.249c-0.102,0-0.203-0.03-0.292-0.094c-0.447-0.321-0.924-0.606-1.416-0.847\n                c-0.278-0.136-0.539-0.276-0.787-0.423c-0.237-0.14-0.317-0.446-0.177-0.685c0.14-0.238,0.447-0.316,0.685-0.177\n                c0.227,0.133,0.466,0.262,0.719,0.386c0.541,0.265,1.066,0.578,1.561,0.933c0.224,0.161,0.275,0.474,0.114,0.698\n                C1104.362,1206.177,1104.209,1206.249,1104.054,1206.249z",
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("g", [
                    _c("path", {
                      staticClass: "st1",
                      attrs: {
                        d: "M1098.73,1203.161c-0.119,0-0.238-0.042-0.334-0.128c-0.647-0.581-1.174-1.27-1.564-2.047\n                c-0.124-0.247-0.025-0.547,0.222-0.671c0.244-0.127,0.548-0.027,0.671,0.222c0.335,0.665,0.785,1.255,1.34,1.752\n                c0.205,0.185,0.223,0.5,0.038,0.706C1099.004,1203.105,1098.867,1203.161,1098.73,1203.161z",
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("g", [
                    _c("path", {
                      staticClass: "st1",
                      attrs: {
                        d: "M1093.679,1193.757c-0.098,0-0.196-0.028-0.282-0.088c-0.612-0.419-1.292-0.716-2.02-0.884\n                c-0.269-0.063-0.437-0.33-0.375-0.6c0.063-0.269,0.33-0.435,0.6-0.375c0.851,0.196,1.645,0.544,2.359,1.034\n                c0.229,0.155,0.286,0.467,0.13,0.694C1093.994,1193.681,1093.838,1193.757,1093.679,1193.757z",
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("g", [
                    _c("path", {
                      staticClass: "st1",
                      attrs: {
                        d: "M1096.323,1197.909c-0.224,0-0.427-0.15-0.484-0.376c-0.156-0.611-0.348-1.223-0.569-1.818\n                c-0.096-0.259,0.036-0.546,0.295-0.643c0.255-0.097,0.546,0.035,0.643,0.295c0.233,0.628,0.436,1.272,0.601,1.918\n                c0.068,0.268-0.093,0.54-0.36,0.608C1096.405,1197.904,1096.364,1197.909,1096.323,1197.909z",
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("g", [
                    _c("g", [
                      _c("path", {
                        staticClass: "st1",
                        attrs: {
                          d: "M1107.972,1210.856c-0.233,0-0.443-0.165-0.489-0.404l-0.892-4.557c-0.054-0.271,0.123-0.533,0.395-0.586\n                    c0.265-0.057,0.533,0.122,0.586,0.395l0.892,4.557c0.054,0.271-0.123,0.533-0.395,0.586\n                    C1108.036,1210.854,1108.004,1210.856,1107.972,1210.856z",
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("g", [
                      _c("path", {
                        staticClass: "st1",
                        attrs: {
                          d: "M1105.248,1209.023c-0.233,0-0.443-0.165-0.489-0.404c-0.054-0.271,0.123-0.533,0.395-0.586l4.557-0.892\n                    c0.265-0.058,0.533,0.122,0.586,0.395c0.054,0.271-0.123,0.533-0.395,0.586l-4.557,0.892\n                    C1105.313,1209.021,1105.28,1209.023,1105.248,1209.023z",
                        },
                      }),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("g", [
                    _c("path", {
                      staticClass: "st1",
                      attrs: {
                        d: "M1086.9,1193.053c-1.406,0-2.549-1.144-2.549-2.55s1.144-2.55,2.549-2.55c1.406,0,2.55,1.144,2.55,2.55\n                S1088.307,1193.053,1086.9,1193.053z M1086.9,1188.953c-0.854,0-1.549,0.695-1.549,1.55s0.695,1.55,1.549,1.55\n                s1.55-0.695,1.55-1.55S1087.755,1188.953,1086.9,1188.953z",
                      },
                    }),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.title.includes(20)
              ? _c("g", { attrs: { id: "toilette-list_2_" } }, [
                  _c("g", { attrs: { id: "toilette-1_2_" } }, [
                    _c("g", [
                      _c("path", {
                        staticClass: "st0",
                        attrs: {
                          d: "M1860,1076L1860,1076c13.255,0,24,10.745,24,24l0,0c0,13.255-10.745,24-24,24l0,0\n                    c-13.255,0-24-10.745-24-24l0,0C1836,1086.745,1846.745,1076,1860,1076z",
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("g", [
                      _c("path", {
                        staticClass: "st1",
                        attrs: {
                          d: "M1868.96,1111.742h-4.42c-0.168,0-0.313-0.118-0.346-0.283l-0.684-3.427h-2.081\n                    c-0.558,0-1.017-0.424-1.091-1.007c-0.002-0.12-0.002-0.224,0.037-0.339c0.098-0.484,0.196-1.043,0.298-1.614\n                    c0.565-3.185,1.25-7.037,4.352-8.057c-1.107-0.618-1.858-1.81-1.858-3.176c0-1.997,1.607-3.622,3.583-3.622\n                    s3.583,1.625,3.583,3.622c0,1.366-0.751,2.558-1.858,3.176c3.102,1.02,3.786,4.872,4.352,8.057c0.102,0.571,0.2,1.13,0.31,1.656\n                    c0.018,0.105,0.027,0.178,0.027,0.252c-0.076,0.628-0.535,1.052-1.093,1.052h-2.081l-0.684,3.427\n                    C1869.273,1111.624,1869.128,1111.742,1868.96,1111.742z M1864.829,1111.037h3.842l0.684-3.427\n                    c0.032-0.165,0.178-0.283,0.346-0.283h2.37c0.197,0,0.361-0.165,0.39-0.392c0.001,0.004-0.01-0.021-0.016-0.062\n                    c-0.11-0.535-0.211-1.1-0.313-1.679c-0.644-3.624-1.373-7.732-5.381-7.732s-4.737,4.108-5.381,7.732\n                    c-0.103,0.579-0.203,1.144-0.313,1.676c0.013,0.291,0.177,0.456,0.374,0.456h2.37c0.168,0,0.313,0.118,0.346,0.283\n                    L1864.829,1111.037z M1866.75,1090.923c-1.587,0-2.878,1.309-2.878,2.917s1.291,2.918,2.878,2.918s2.878-1.31,2.878-2.918\n                    S1868.337,1090.923,1866.75,1090.923z M1855.37,1111.742h-4.84c-0.179,0-0.329-0.133-0.351-0.31l-0.762-6.23h-2.107\n                    c-0.195,0-0.353-0.157-0.353-0.353v-2.449c0-1.625,0.622-3.148,1.751-4.288c0.702-0.716,1.575-1.238,2.522-1.527\n                    c-1.104-0.617-1.854-1.809-1.854-3.175c0-1.998,1.603-3.623,3.572-3.623c1.976,0,3.582,1.625,3.582,3.623\n                    c0,1.363-0.748,2.553-1.851,3.171c0.944,0.285,1.808,0.806,2.521,1.532c1.128,1.139,1.75,2.662,1.75,4.287v2.449\n                    c0,0.195-0.157,0.353-0.353,0.353h-2.108l-0.771,6.23C1855.698,1111.609,1855.548,1111.742,1855.37,1111.742z\n                    M1850.843,1111.037h4.216l0.771-6.23c0.022-0.177,0.173-0.31,0.351-0.31h2.067v-2.097c0-1.438-0.55-2.785-1.548-3.792\n                    c-0.998-1.017-2.329-1.576-3.749-1.576c-1.394,0-2.757,0.574-3.738,1.575c-0.999,1.008-1.549,2.354-1.549,3.793v2.097h2.067\n                    c0.179,0,0.329,0.133,0.351,0.31L1850.843,1111.037z M1852.95,1090.492c-1.581,0-2.867,1.31-2.867,2.918\n                    s1.286,2.917,2.867,2.917c1.586,0,2.877-1.309,2.877-2.917S1854.536,1090.492,1852.95,1090.492z",
                        },
                      }),
                    ]),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.title.includes(23)
              ? _c("g", { attrs: { id: "parking-list_1_" } }, [
                  _c("g", { attrs: { id: "parking-3_1_" } }, [
                    _c("g", [
                      _c("path", {
                        staticClass: "st0",
                        attrs: {
                          d: "M900,1043L900,1043c13.255,0,24,10.745,24,24l0,0c0,13.255-10.745,24-24,24l0,0c-13.255,0-24-10.745-24-24\n                    l0,0C876,1053.745,886.745,1043,900,1043z",
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("g", [
                      _c("path", {
                        staticClass: "st1",
                        attrs: {
                          d: "M905.978,1078.55h-11.84c-3.074,0-5.574-2.498-5.574-5.569v-11.841c0-3.076,2.5-5.579,5.574-5.579h11.84\n                    c3.073,0,5.574,2.503,5.574,5.579v11.841C911.552,1076.052,909.051,1078.55,905.978,1078.55z M894.138,1056.561\n                    c-2.522,0-4.574,2.054-4.574,4.579v11.841c0,2.52,2.052,4.569,4.574,4.569h11.84c2.522,0,4.574-2.05,4.574-4.569v-11.841\n                    c0-2.525-2.052-4.579-4.574-4.579H894.138z M897.029,1073.5c-0.276,0-0.5-0.224-0.5-0.5v-11.88c0-0.276,0.224-0.5,0.5-0.5h5.387\n                    c1.675,0,3.037,1.359,3.037,3.03v1.859c0,1.677-1.362,3.04-3.037,3.04h-4.887v4.45\n                    C897.529,1073.276,897.305,1073.5,897.029,1073.5z M897.529,1067.55h4.887c1.123,0,2.037-0.915,2.037-2.04v-1.859\n                    c0-1.119-0.914-2.03-2.037-2.03h-4.887V1067.55z",
                        },
                      }),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("g", { attrs: { id: "parking-2_1_" } }, [
                    _c("g", [
                      _c("path", {
                        staticClass: "st0",
                        attrs: {
                          d: "M1965,1009L1965,1009c13.255,0,24,10.745,24,24l0,0c0,13.255-10.745,24-24,24l0,0\n                    c-13.255,0-24-10.745-24-24l0,0C1941,1019.745,1951.745,1009,1965,1009z",
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("g", [
                      _c("path", {
                        staticClass: "st1",
                        attrs: {
                          d: "M1970.98,1044.55h-11.841c-3.076,0-5.579-2.498-5.579-5.569v-11.841c0-3.077,2.503-5.58,5.579-5.58h11.841\n                    c3.071,0,5.569,2.503,5.569,5.58v11.841C1976.55,1042.052,1974.052,1044.55,1970.98,1044.55z M1959.14,1022.56\n                    c-2.525,0-4.579,2.055-4.579,4.58v11.841c0,2.52,2.054,4.569,4.579,4.569h11.841c2.52,0,4.569-2.05,4.569-4.569v-11.841\n                    c0-2.525-2.05-4.58-4.569-4.58H1959.14z M1962.03,1039.5c-0.276,0-0.5-0.224-0.5-0.5v-11.88c0-0.276,0.224-0.5,0.5-0.5h5.39\n                    c1.671,0,3.03,1.359,3.03,3.03v1.859c0,1.677-1.359,3.04-3.03,3.04h-4.89v4.45C1962.53,1039.276,1962.307,1039.5,1962.03,1039.5\n                    z M1962.53,1033.55h4.89c1.119,0,2.03-0.915,2.03-2.04v-1.859c0-1.119-0.911-2.03-2.03-2.03h-4.89V1033.55z",
                        },
                      }),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("g", { attrs: { id: "parking-1_1_" } }, [
                    _c("g", [
                      _c("path", {
                        staticClass: "st0",
                        attrs: {
                          d: "M788,550L788,550c13.255,0,24,10.745,24,24l0,0c0,13.255-10.745,24-24,24l0,0c-13.255,0-24-10.745-24-24\n                    l0,0C764,560.745,774.745,550,788,550z",
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("g", [
                      _c("path", {
                        staticClass: "st1",
                        attrs: {
                          d: "M793.978,585.552h-11.84c-3.074,0-5.574-2.5-5.574-5.574v-11.839c0-3.074,2.5-5.574,5.574-5.574h11.84\n                    c3.073,0,5.574,2.5,5.574,5.574v11.839C799.552,583.051,797.051,585.552,793.978,585.552z M782.138,563.565\n                    c-2.522,0-4.574,2.052-4.574,4.574v11.839c0,2.522,2.052,4.574,4.574,4.574h11.84c2.522,0,4.574-2.052,4.574-4.574v-11.839\n                    c0-2.522-2.052-4.574-4.574-4.574H782.138z M785.029,580.501c-0.276,0-0.5-0.224-0.5-0.5v-11.885c0-0.276,0.224-0.5,0.5-0.5\n                    h5.387c1.675,0,3.037,1.362,3.037,3.037v1.859c0,1.674-1.362,3.037-3.037,3.037h-4.887v4.452\n                    C785.529,580.277,785.305,580.501,785.029,580.501z M785.529,574.549h4.887c1.123,0,2.037-0.914,2.037-2.037v-1.859\n                    c0-1.123-0.914-2.037-2.037-2.037h-4.887V574.549z",
                        },
                      }),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("g", { attrs: { id: "parking-4_2_" } }, [
                    _c("g", [
                      _c("path", {
                        staticClass: "st0",
                        attrs: {
                          d: "M1812,1124L1812,1124c13.255,0,24,10.745,24,24l0,0c0,13.255-10.745,24-24,24l0,0\n                    c-13.255,0-24-10.745-24-24l0,0C1788,1134.745,1798.745,1124,1812,1124z",
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("g", [
                      _c("path", {
                        staticClass: "st1",
                        attrs: {
                          d: "M1817.98,1159.55h-11.841c-3.076,0-5.579-2.498-5.579-5.569v-11.841c0-3.076,2.503-5.579,5.579-5.579\n                    h11.841c3.071,0,5.569,2.503,5.569,5.579v11.841C1823.55,1157.052,1821.052,1159.55,1817.98,1159.55z M1806.14,1137.561\n                    c-2.525,0-4.579,2.054-4.579,4.579v11.841c0,2.52,2.054,4.569,4.579,4.569h11.841c2.52,0,4.569-2.05,4.569-4.569v-11.841\n                    c0-2.525-2.05-4.579-4.569-4.579H1806.14z M1809.03,1154.5c-0.276,0-0.5-0.224-0.5-0.5v-11.88c0-0.276,0.224-0.5,0.5-0.5h5.39\n                    c1.671,0,3.03,1.359,3.03,3.03v1.859c0,1.677-1.359,3.04-3.03,3.04h-4.89v4.45C1809.53,1154.276,1809.307,1154.5,1809.03,1154.5\n                    z M1809.53,1148.55h4.89c1.119,0,2.03-0.915,2.03-2.04v-1.859c0-1.119-0.911-2.03-2.03-2.03h-4.89V1148.55z",
                        },
                      }),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("g", { attrs: { id: "parking-5_1_" } }, [
                    _c("g", [
                      _c("path", {
                        staticClass: "st0",
                        attrs: {
                          d: "M1445.214,1266.21L1445.214,1266.21c13.255,0,24,10.745,24,24l0,0c0,13.255-10.745,24-24,24l0,0\n                    c-13.255,0-24-10.745-24-24l0,0C1421.214,1276.955,1431.959,1266.21,1445.214,1266.21z",
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("g", [
                      _c("path", {
                        staticClass: "st1",
                        attrs: {
                          d: "M1451.193,1301.76h-11.84c-3.077,0-5.58-2.498-5.58-5.569v-11.841c0-3.071,2.503-5.569,5.58-5.569h11.84\n                    c3.071,0,5.57,2.498,5.57,5.569v11.841C1456.764,1299.262,1454.265,1301.76,1451.193,1301.76z M1439.354,1279.78\n                    c-2.525,0-4.58,2.05-4.58,4.569v11.841c0,2.52,2.055,4.569,4.58,4.569h11.84c2.521,0,4.57-2.05,4.57-4.569v-11.841\n                    c0-2.52-2.05-4.569-4.57-4.569H1439.354z M1442.243,1296.71c-0.276,0-0.5-0.224-0.5-0.5v-11.88c0-0.276,0.224-0.5,0.5-0.5h5.391\n                    c1.67,0,3.029,1.359,3.029,3.03v1.859c0,1.677-1.359,3.04-3.029,3.04h-4.891v4.45\n                    C1442.743,1296.486,1442.52,1296.71,1442.243,1296.71z M1442.743,1290.76h4.891c1.119,0,2.029-0.915,2.029-2.04v-1.859\n                    c0-1.119-0.91-2.03-2.029-2.03h-4.891V1290.76z",
                        },
                      }),
                    ]),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.title.includes(57)
              ? _c("g", { attrs: { id: "rouge-vin_" } }, [
                  _c("g", { attrs: { id: "rouge-vin" } }, [
                    _c("path", {
                      staticClass: "st0",
                      attrs: {
                        d: "M1814.493,1049.7h0c13.255,0,24,10.745,24,24h0c0,13.255-10.745,24-24,24h0c-13.255,0-24-10.745-24-24h0c0-13.255,10.745-24,24-24Z",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      staticClass: "st1",
                      attrs: {
                        d: "M1820.64,1085.25c-.276,0-.5-.224-.5-.5v-11.373c-2.28-.306-4.059-2.672-4.059-5.537,0-3.071,2.045-5.569,4.559-5.569s4.559,2.498,4.559,5.569c0,2.865-1.779,5.231-4.059,5.537v11.373c0,.276-.224.5-.5.5ZM1820.64,1063.27c-1.962,0-3.559,2.05-3.559,4.569s1.597,4.57,3.559,4.57,3.559-2.05,3.559-4.57-1.597-4.569-3.559-4.569ZM1808.631,1085.25c-.276,0-.5-.224-.5-.5v-13.056c-1.079-.112-2.075-.586-2.844-1.362-.878-.875-1.384-2.094-1.384-3.342v-4.22c0-.276.224-.5.5-.5s.5.224.5.5v4.22c0,.984.398,1.944,1.092,2.636.582.587,1.327.954,2.136,1.061v-7.916c0-.276.224-.5.5-.5s.5.224.5.5v7.916c.317-.043.628-.126.929-.249.456-.187.861-.458,1.204-.808.344-.342.624-.759.812-1.212.188-.453.284-.934.284-1.428v-4.22c0-.276.224-.5.5-.5s.5.224.5.5v4.22c0,.627-.121,1.236-.36,1.812-.24.573-.595,1.104-1.026,1.532-.435.442-.952.79-1.534,1.028-.422.173-.86.283-1.308.33v13.057c0,.276-.224.5-.5.5Z",
                      },
                    }),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.title.includes(21)
              ? _c("g", { attrs: { id: "food-truck-1_1_" } }, [
                  _c(
                    "g",
                    {
                      attrs: {
                        id: "food-truck-1-2-3",
                        "data-name": "food-truck-1",
                        transform: "translate(-941.10798,211.68029)",
                      },
                    },
                    [
                      _c("path", {
                        staticClass: "cls-11",
                        staticStyle: { fill: "#4d80d6", "stroke-width": "0px" },
                        attrs: {
                          d: "m 1814.69,1049.755 v 0 c 13.255,0 24,10.745 24,24 v 0 c 0,13.255 -10.745,24 -24,24 v 0 c -13.255,0 -24,-10.745 -24,-24 v 0 c 0,-13.255 10.745,-24 24,-24 z",
                          id: "path999-6",
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "g",
                        {
                          attrs: {
                            id: "g2139",
                            transform:
                              "matrix(-1.0125265,0,0,0.9677929,1838.8362,1050.5053)",
                          },
                        },
                        [
                          _c("path", {
                            staticStyle: {
                              stroke: "#ffffff",
                              "stroke-opacity": "1",
                            },
                            attrs: {
                              d: "m 11.517382,24.490647 h 7.175901",
                              fill: "none",
                              stroke: "#000000",
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                              "stroke-width": "1",
                              id: "path259",
                            },
                          }),
                          _vm._v(" "),
                          _c("path", {
                            staticStyle: {
                              stroke: "#ffffff",
                              "stroke-opacity": "1",
                            },
                            attrs: {
                              d: "m 12.115374,33.682138 a 2.3919672,2.4510641 0 1 0 4.783934,0 2.3919672,2.4510641 0 1 0 -4.783934,0",
                              fill: "none",
                              stroke: "#000000",
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                              "stroke-width": "1",
                              id: "path261",
                            },
                          }),
                          _vm._v(" "),
                          _c("path", {
                            staticStyle: {
                              stroke: "#ffffff",
                              "stroke-opacity": "1",
                            },
                            attrs: {
                              d: "m 28.859144,33.682138 a 2.3919672,2.4510641 0 1 0 4.783934,0 2.3919672,2.4510641 0 1 0 -4.783934,0",
                              fill: "none",
                              stroke: "#000000",
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                              "stroke-width": "1",
                              id: "path263",
                            },
                          }),
                          _vm._v(" "),
                          _c("path", {
                            staticStyle: {
                              stroke: "#ffffff",
                              "stroke-opacity": "1",
                            },
                            attrs: {
                              d: "M 12.115374,33.682138 H 9.7234061 A 0.59799179,0.61276604 0 0 1 9.1254145,33.069372 v -5.873975 a 0.59799179,0.61276604 0 0 1 0.1746138,-0.432614 l 2.2173537,-2.272136 2.647908,-4.88497 a 1.1959835,1.2255321 0 0 1 1.04529,-0.629924 h 3.482703 v -5.514894 a 0.59799179,0.61276604 0 0 1 0.597992,-0.612766 h 16.743771 a 0.59799179,0.61276604 0 0 1 0.597991,0.612766 v 19.608513 a 0.59799179,0.61276604 0 0 1 -0.597991,0.612766 h -2.391968",
                              fill: "none",
                              stroke: "#000000",
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                              "stroke-width": "1",
                              id: "path265",
                            },
                          }),
                          _vm._v(" "),
                          _c("path", {
                            staticStyle: {
                              stroke: "#ffffff",
                              "stroke-opacity": "1",
                            },
                            attrs: {
                              d: "M 16.899308,33.682138 H 28.859144",
                              fill: "none",
                              stroke: "#000000",
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                              "stroke-width": "1",
                              id: "path267",
                            },
                          }),
                          _vm._v(" "),
                          _c("path", {
                            staticStyle: {
                              stroke: "#ffffff",
                              "stroke-opacity": "1",
                            },
                            attrs: {
                              d: "m 18.693283,18.975753 v 12.25532",
                              fill: "none",
                              stroke: "#000000",
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                              "stroke-width": "1",
                              id: "path269",
                            },
                          }),
                          _vm._v(" "),
                          _c("path", {
                            staticStyle: {
                              stroke: "#ffffff",
                              "stroke-opacity": "1",
                            },
                            attrs: {
                              d: "M 9.1254145,31.231073 H 36.633037",
                              fill: "none",
                              stroke: "#000000",
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                              "stroke-width": "1",
                              id: "path271",
                            },
                          }),
                          _vm._v(" "),
                          _c("path", {
                            staticStyle: {
                              stroke: "#ffffff",
                              "stroke-opacity": "1",
                            },
                            attrs: {
                              d: "M 21.085251,20.201285 H 34.24107 l -2.391967,-3.676597 h -8.371885 z",
                              fill: "none",
                              stroke: "#000000",
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                              "stroke-width": "1",
                              id: "path273",
                            },
                          }),
                          _vm._v(" "),
                          _c("path", {
                            staticStyle: {
                              stroke: "#ffffff",
                              "stroke-opacity": "1",
                            },
                            attrs: {
                              d: "M 21.085251,25.103413 H 34.24107",
                              fill: "none",
                              stroke: "#000000",
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                              "stroke-width": "1",
                              id: "path275",
                            },
                          }),
                          _vm._v(" "),
                          _c("path", {
                            staticStyle: {
                              stroke: "#ffffff",
                              "stroke-opacity": "1",
                            },
                            attrs: {
                              d: "m 22.281234,20.201285 h 10.763852 v 7.353193 H 22.281234 Z",
                              fill: "none",
                              stroke: "#000000",
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                              "stroke-width": "1",
                              id: "path277-5",
                            },
                          }),
                        ]
                      ),
                    ]
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.title.includes(28)
              ? _c("g", { attrs: { id: "paserelle_1_" } }, [
                  _c("g", [
                    _c("path", {
                      staticClass: "st6",
                      attrs: {
                        d: "M774,901L774,901c12.703,0,23,10.297,23,23l0,0c0,12.703-10.297,23-23,23l0,0c-12.703,0-23-10.297-23-23l0,0\n                C751,911.297,761.297,901,774,901z",
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("g", [
                    _c("path", {
                      staticClass: "st1",
                      attrs: {
                        d: "M774,948c-13.233,0-24-10.767-24-24s10.767-24,24-24s24,10.767,24,24S787.233,948,774,948z M774,902\n                c-12.131,0-22,9.869-22,22s9.869,22,22,22s22-9.869,22-22S786.131,902,774,902z",
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("g", [
                    _c("path", {
                      staticClass: "st1",
                      attrs: {
                        d: "M786.809,934.476h-25.5c-0.276,0-0.5-0.224-0.5-0.5s0.224-0.5,0.5-0.5h25.5c0.276,0,0.5,0.224,0.5,0.5\n                S787.085,934.476,786.809,934.476z",
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("g", [
                    _c("path", {
                      staticClass: "st1",
                      attrs: {
                        d: "M783.976,928.809h-19.833c-0.276,0-0.5-0.224-0.5-0.5s0.224-0.5,0.5-0.5h19.833c0.276,0,0.5,0.224,0.5,0.5\n                S784.252,928.809,783.976,928.809z",
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("g", [
                    _c("path", {
                      staticClass: "st1",
                      attrs: {
                        d: "M786.809,934.475c-0.276,0-0.5-0.224-0.5-0.5v-11.333c0-0.276,0.224-0.5,0.5-0.5s0.5,0.224,0.5,0.5v11.333\n                C787.309,934.251,787.085,934.475,786.809,934.475z",
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("g", [
                    _c("rect", {
                      staticClass: "st1",
                      attrs: {
                        x: "778.265",
                        y: "927.1",
                        transform:
                          "matrix(0.4961 0.8683 -0.8683 0.4961 1200.47 -213.2738)",
                        width: "11.421",
                        height: "1",
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("g", [
                    _c("path", {
                      staticClass: "st1",
                      attrs: {
                        d: "M781.141,923.142h-14.166c-0.276,0-0.5-0.224-0.5-0.5s0.224-0.5,0.5-0.5h14.166c0.276,0,0.5,0.224,0.5,0.5\n                S781.417,923.142,781.141,923.142z",
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("g", [
                    _c("path", {
                      staticClass: "st1",
                      attrs: {
                        d: "M761.309,934.475c-0.276,0-0.5-0.224-0.5-0.5v-11.333c0-0.276,0.224-0.5,0.5-0.5s0.5,0.224,0.5,0.5v11.333\n                C761.809,934.251,761.585,934.475,761.309,934.475z",
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("g", [
                    _c("rect", {
                      staticClass: "st1",
                      attrs: {
                        x: "763.642",
                        y: "921.889",
                        transform:
                          "matrix(0.8682 0.4961 -0.4961 0.8682 560.8995 -256.903)",
                        width: "1",
                        height: "11.421",
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("g", [
                    _c("path", {
                      staticClass: "st1",
                      attrs: {
                        d: "M781.143,923.142c-0.276,0-0.5-0.224-0.5-0.5v-8.5c0-0.276,0.224-0.5,0.5-0.5s0.5,0.224,0.5,0.5v8.5\n                C781.643,922.918,781.419,923.142,781.143,923.142z",
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("g", [
                    _c("rect", {
                      staticClass: "st1",
                      attrs: {
                        x: "778.868",
                        y: "917.892",
                        transform:
                          "matrix(0.5547 0.8321 -0.8321 0.5547 1113.314 -243.3305)",
                        width: "10.215",
                        height: "1",
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("g", [
                    _c("path", {
                      staticClass: "st1",
                      attrs: {
                        d: "M766.975,923.142c-0.276,0-0.5-0.224-0.5-0.5v-8.5c0-0.276,0.224-0.5,0.5-0.5s0.5,0.224,0.5,0.5v8.5\n                C767.475,922.918,767.251,923.142,766.975,923.142z",
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("g", [
                    _c("path", {
                      staticClass: "st1",
                      attrs: {
                        d: "M761.309,923.142c-0.095,0-0.191-0.027-0.277-0.084c-0.23-0.153-0.292-0.464-0.139-0.693l5.666-8.5\n                c0.153-0.229,0.462-0.293,0.693-0.139c0.23,0.153,0.292,0.464,0.139,0.693l-5.666,8.5\n                C761.629,923.063,761.47,923.142,761.309,923.142z",
                      },
                    }),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.title.includes(22)
              ? _c("g", { attrs: { id: "belvedere_1_" } }, [
                  _c("g", [
                    _c("path", {
                      staticClass: "st1",
                      attrs: {
                        d: "M177.04,555.987c0,5.676-4.606,10.277-10.286,10.277c-5.68,0-10.285-4.601-10.285-10.277\n                c0-5.675,4.605-10.277,10.285-10.277C172.434,545.71,177.04,550.312,177.04,555.987z",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      staticClass: "st13",
                      attrs: {
                        d: "M166.754,566.949c-6.049,0-10.97-4.918-10.97-10.962s4.921-10.962,10.97-10.962\n                c6.049,0,10.971,4.917,10.971,10.962S172.803,566.949,166.754,566.949z M166.754,546.395c-5.293,0-9.6,4.303-9.6,9.592\n                s4.307,9.592,9.6,9.592c5.294,0,9.601-4.303,9.601-9.592S172.048,546.395,166.754,546.395z",
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("g", [
                    _c("path", {
                      staticClass: "st0",
                      attrs: {
                        d: "M162,531L162,531c12.703,0,23,10.297,23,23l0,0c0,12.703-10.297,23-23,23l0,0c-12.703,0-23-10.297-23-23l0,0\n                C139,541.297,149.297,531,162,531z",
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("g", [
                    _c("path", {
                      staticClass: "st1",
                      attrs: {
                        d: "M162,578c-13.233,0-24-10.767-24-24s10.767-24,24-24s24,10.767,24,24S175.233,578,162,578z M162,532\n                c-12.131,0-22,9.869-22,22s9.869,22,22,22s22-9.869,22-22S174.131,532,162,532z",
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("g", [
                    _c("path", {
                      staticClass: "st1",
                      attrs: {
                        d: "M168.823,565.552c-2.607,0-4.728-2.121-4.728-4.728v-5.074c0-0.276,0.224-0.5,0.5-0.5s0.5,0.224,0.5,0.5\n                v2.169c0.866-1.109,2.215-1.823,3.728-1.823c1.207,0,2.31,0.455,3.146,1.201l-2.487-12.767c-0.053-0.275-0.202-0.524-0.42-0.7\n                c-0.217-0.176-0.503-0.275-0.771-0.266h-2.005c-0.317,0-0.617,0.124-0.843,0.35c-0.225,0.224-0.348,0.523-0.348,0.842v2.537\n                c0,0.276-0.224,0.5-0.5,0.5s-0.5-0.224-0.5-0.5v-2.537c0-0.586,0.228-1.136,0.641-1.549c0.415-0.415,0.965-0.643,1.55-0.643\n                h1.996c0.517,0.011,1.011,0.165,1.41,0.489c0.401,0.324,0.675,0.781,0.772,1.287l3.027,15.542c0.013,0.065,0.012,0.129,0,0.19\n                c0.039,0.245,0.06,0.496,0.06,0.751C173.552,563.431,171.431,565.552,168.823,565.552z M168.823,557.096\n                c-2.056,0-3.728,1.672-3.728,3.728c0,2.055,1.672,3.728,3.728,3.728c2.056,0,3.729-1.672,3.729-3.728\n                C172.552,558.769,170.879,557.096,168.823,557.096z M155.293,565.552c-2.607,0-4.729-2.121-4.729-4.728\n                c0-0.326,0.033-0.645,0.097-0.953l2.991-15.531c0.097-0.504,0.371-0.961,0.772-1.287c0.399-0.324,0.905-0.493,1.419-0.489h1.987\n                c0.578,0,1.143,0.234,1.55,0.643c0.413,0.413,0.641,0.963,0.641,1.549v2.537c0,0.276-0.224,0.5-0.5,0.5s-0.5-0.224-0.5-0.5\n                v-2.537c0-0.318-0.124-0.617-0.349-0.842c-0.222-0.222-0.528-0.35-0.842-0.35h-1.996c-0.295-0.002-0.563,0.089-0.78,0.265\n                c-0.218,0.177-0.367,0.425-0.419,0.699l-2.454,12.739c0.833-0.729,1.922-1.171,3.113-1.171c1.513,0,2.862,0.714,3.728,1.823\n                v-2.169c0-0.276,0.224-0.5,0.5-0.5s0.5,0.224,0.5,0.5v5.074C160.021,563.431,157.9,565.552,155.293,565.552z M151.638,560.083\n                c-0.049,0.24-0.074,0.488-0.074,0.742c0,2.055,1.673,3.728,3.729,3.728c2.056,0,3.728-1.672,3.728-3.728\n                c0-2.056-1.672-3.728-3.728-3.728c-1.8,0-3.306,1.281-3.653,2.979C151.639,560.078,151.639,560.08,151.638,560.083z\n                M166.286,552.022h-8.456c-0.276,0-0.5-0.224-0.5-0.5s0.224-0.5,0.5-0.5h8.456c0.276,0,0.5,0.224,0.5,0.5\n                S166.563,552.022,166.286,552.022z",
                      },
                    }),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.title.includes(26)
              ? _c("g", { attrs: { id: "admin_1_" } }, [
                  _c("g", [
                    _c("path", {
                      staticClass: "st0",
                      attrs: {
                        d: "M1493.836,1231L1493.836,1231c13.255,0,24,10.745,24,24l0,0c0,13.255-10.745,24-24,24l0,0\n                c-13.255,0-24-10.745-24-24l0,0C1469.836,1241.745,1480.581,1231,1493.836,1231z",
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("g", [
                    _c("path", {
                      staticClass: "st1",
                      attrs: {
                        d: "M1503.196,1266.55h-18.6c-0.578,0-1.128-0.224-1.548-0.63c-0.423-0.423-0.652-0.975-0.652-1.56v-9.4\n                c0-0.296,0.06-0.591,0.177-0.879c0.151-0.317,0.324-0.552,0.54-0.744l10.444-9.634c0.191-0.178,0.486-0.178,0.678,0l10.45,9.64\n                c0.229,0.215,0.406,0.466,0.52,0.729c0.121,0.264,0.182,0.558,0.182,0.888v9.4c0,0.577-0.224,1.127-0.631,1.548\n                C1504.324,1266.326,1503.774,1266.55,1503.196,1266.55z M1493.896,1244.751l-10.111,9.326c-0.122,0.109-0.218,0.241-0.299,0.409\n                c-0.057,0.142-0.09,0.306-0.09,0.474v9.4c0,0.318,0.126,0.618,0.354,0.847c0.227,0.219,0.529,0.343,0.847,0.343h18.6\n                c0.317,0,0.62-0.124,0.853-0.349c0.214-0.222,0.338-0.524,0.338-0.841v-9.4c0-0.184-0.031-0.342-0.096-0.483\n                c-0.064-0.148-0.162-0.284-0.287-0.402L1493.896,1244.751z M1496.816,1261.99h-5.84c-0.885,0-2.2-0.583-2.2-2.19v-4.16\n                c0-0.88,0.586-2.189,2.2-2.189h0.3v-0.46c0-1.213,0.982-2.2,2.19-2.2h0.859c1.208,0,2.19,0.987,2.19,2.2v0.46h0.3\n                c0.881,0,2.19,0.583,2.19,2.189v4.16C1499.007,1260.681,1498.424,1261.99,1496.816,1261.99z M1490.977,1254.45\n                c-1.127,0-1.197,0.993-1.2,1.192v4.157c0,1.157,1.077,1.19,1.2,1.19h5.84c1.117,0,1.188-0.994,1.19-1.193v-4.157\n                c0-1.156-1.068-1.189-1.19-1.189H1490.977z M1492.276,1253.45h3.24v-0.46c0-0.662-0.534-1.2-1.19-1.2h-0.859\n                c-0.656,0-1.19,0.538-1.19,1.2V1253.45z",
                      },
                    }),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.title.includes(56)
              ? _c("g", { attrs: { id: "go-van" } }, [
                  _c("g", { attrs: { id: "go-van-1" } }, [
                    _c("path", {
                      staticClass: "st6",
                      attrs: {
                        d: "M1788,1171.891h0c13.255,0,24,10.745,24,24h0c0,13.255-10.745,24-24,24h0c-13.255,0-24-10.745-24-24h0c0-13.255,10.745-24,24-24Z",
                      },
                    }),
                    _vm._v(" "),
                    _c("g", [
                      _c("path", {
                        staticClass: "st1",
                        attrs: {
                          d: "M1792.371,1203.857h-8.53c-.276,0-.5-.224-.5-.5s.224-.5.5-.5h8.53c.276,0,.5.224.5.5s-.224.5-.5.5Z",
                        },
                      }),
                      _vm._v(" "),
                      _c("g", [
                        _c("path", {
                          staticClass: "st1",
                          attrs: {
                            d: "M1780.997,1206.701c-1.844,0-3.344-1.5-3.344-3.344s1.5-3.345,3.345-3.345c1.844,0,3.343,1.502,3.343,3.345s-1.5,3.344-3.344,3.344ZM1780.998,1201.013c-1.293,0-2.345,1.051-2.345,2.343v.002c0,1.292,1.052,2.344,2.344,2.344s2.344-1.052,2.344-2.344-1.051-2.344-2.343-2.345Z",
                          },
                        }),
                        _vm._v(" "),
                        _c("path", {
                          staticClass: "st1",
                          attrs: {
                            d: "M1795.215,1206.701c-1.844,0-3.344-1.5-3.344-3.344h0c0-1.845,1.502-3.345,3.345-3.345.894,0,1.733.349,2.364.98.632.632.979,1.472.979,2.364,0,1.844-1.5,3.344-3.344,3.344ZM1792.371,1203.355l.5.002c0,1.292,1.052,2.344,2.344,2.344s2.344-1.052,2.344-2.344c0-.626-.243-1.215-.686-1.657-.442-.443-1.031-.688-1.657-.688-1.292,0-2.344,1.051-2.345,2.343h-.5Z",
                          },
                        }),
                        _vm._v(" "),
                        _c("path", {
                          staticClass: "st1",
                          attrs: {
                            d: "M1799.48,1203.857h-1.422c-.276,0-.5-.224-.5-.5s.224-.5.5-.5h1.422c.509,0,.922-.413.922-.922v-6.438c0-.362-.085-.725-.247-1.048l-1.365-2.729c-.642-1.283-1.932-2.081-3.367-2.081h-15.848c-2.076,0-3.766,1.688-3.766,3.765v8.531c0,.509.413.922.922.922h1.422c.276,0,.5.224.5.5s-.224.5-.5.5h-1.422c-1.06,0-1.922-.862-1.922-1.922v-8.531c0-2.627,2.138-4.765,4.766-4.765h15.848c1.816,0,3.449,1.009,4.262,2.634l1.365,2.729c.23.461.353.979.353,1.495v6.438c0,1.06-.862,1.922-1.922,1.922Z",
                          },
                        }),
                        _vm._v(" "),
                        _c("path", {
                          staticClass: "st1",
                          attrs: {
                            d: "M1800.902,1196.748h-25.593c-.276,0-.5-.224-.5-.5s.224-.5.5-.5h25.593c.276,0,.5.224.5.5s-.224.5-.5.5Z",
                          },
                        }),
                        _vm._v(" "),
                        _c("path", {
                          staticClass: "st1",
                          attrs: {
                            d: "M1792.371,1196.748c-.276,0-.5-.224-.5-.5v-7.108c0-.276.224-.5.5-.5s.5.224.5.5v7.108c0,.276-.224.5-.5.5Z",
                          },
                        }),
                        _vm._v(" "),
                        _c("path", {
                          staticClass: "st1",
                          attrs: {
                            d: "M1791.66,1189.64h-9.952c-1.452,0-2.633-1.181-2.633-2.633s1.181-2.633,2.633-2.633h9.952c1.452,0,2.633,1.181,2.633,2.633s-1.181,2.633-2.633,2.633ZM1781.708,1185.374c-.9,0-1.633.732-1.633,1.633s.732,1.633,1.633,1.633h9.952c.9,0,1.633-.732,1.633-1.633s-.732-1.633-1.633-1.633h-9.952Z",
                          },
                        }),
                      ]),
                    ]),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.title.includes(49)
              ? _c("g", { attrs: { id: "parking-accessible" } }, [
                  _c("path", {
                    staticClass: "st0",
                    attrs: {
                      d: "M1113.707,1105.543L1113.707,1105.543c13.255,0,24,10.745,24,24l0,0c0,13.255-10.745,24-24,24l0,0\n            c-13.255,0-24-10.745-24-24l0,0C1089.707,1116.288,1100.453,1105.543,1113.707,1105.543z",
                    },
                  }),
                  _vm._v(" "),
                  _c("g", [
                    _c("g", [
                      _c("path", {
                        attrs: {
                          "stroke-color": "#fff",
                          d: "M1111.975,1120.67v-3.234 M1111.975,1117.436v-4.527h3.519c0.915,0,1.657,0.738,1.657,1.653v1.215\n                c0,0.915-0.742,1.659-1.657,1.659H1111.975z M1117.821,1109.603h-7.735c-1.831,0-3.315,1.49-3.315,3.319v7.735\n                c0,1.829,1.484,3.312,3.315,3.312h7.735c1.831,0,3.315-1.483,3.315-3.312v-7.735\n                C1121.136,1111.093,1119.651,1109.603,1117.821,1109.603z",
                        },
                      }),
                      _vm._v(" "),
                      _c("path", {
                        staticClass: "st1",
                        attrs: {
                          d: "M1099.205,1129.975c1.126,0,2.043-0.916,2.043-2.042s-0.916-2.043-2.043-2.043\n                    c-1.126,0-2.042,0.916-2.042,2.043S1098.078,1129.975,1099.205,1129.975z M1099.205,1126.564c0.754,0,1.368,0.614,1.368,1.368\n                    c0,0.754-0.613,1.368-1.368,1.368c-0.754,0-1.368-0.613-1.368-1.368S1098.451,1126.564,1099.205,1126.564z",
                        },
                      }),
                      _vm._v(" "),
                      _c("path", {
                        staticClass: "st1",
                        attrs: {
                          d: "M1097.238,1138.302v6.079c0,0.186,0.151,0.338,0.337,0.338c0.186,0,0.338-0.151,0.338-0.338v-6.253\n                    c0-0.005-0.001-0.01-0.001-0.015c0.001-0.121-0.064-0.239-0.179-0.3c-0.432-0.23-0.7-0.675-0.7-1.161v-3.71\n                    c0-0.724,0.589-1.313,1.313-1.313h1.73c0.724,0,1.313,0.589,1.313,1.313v3.71c0,0.486-0.268,0.931-0.7,1.161\n                    c-0.117,0.062-0.182,0.183-0.178,0.307c0,0.003,0,0.005,0,0.008v6.253c0,0.186,0.151,0.338,0.337,0.338\n                    c0.187,0,0.338-0.151,0.338-0.338v-6.079c0.547-0.368,0.879-0.983,0.879-1.649v-3.71c0-1.096-0.892-1.988-1.988-1.988h-1.73\n                    c-1.096,0-1.988,0.892-1.988,1.988v3.71C1096.359,1137.319,1096.691,1137.934,1097.238,1138.302z",
                        },
                      }),
                      _vm._v(" "),
                      _c("path", {
                        staticClass: "st1",
                        attrs: {
                          d: "M1105.67,1134.586c1.126,0,2.043-0.917,2.043-2.043c0-1.126-0.916-2.043-2.043-2.043\n                    c-1.126,0-2.042,0.916-2.042,2.043C1103.628,1133.669,1104.544,1134.586,1105.67,1134.586z M1105.67,1131.175\n                    c0.754,0,1.368,0.614,1.368,1.368c0,0.754-0.614,1.368-1.368,1.368c-0.754,0-1.368-0.614-1.368-1.368\n                    C1104.303,1131.789,1104.916,1131.175,1105.67,1131.175z",
                        },
                      }),
                      _vm._v(" "),
                      _c("path", {
                        staticClass: "st1",
                        attrs: {
                          d: "M1104.236,1141.139v3.242c0,0.186,0.151,0.338,0.338,0.338c0.186,0,0.337-0.151,0.337-0.338v-3.415\n                    c0-0.005,0-0.01-0.001-0.016c0-0.121-0.064-0.239-0.179-0.3c-0.432-0.23-0.7-0.675-0.7-1.161v-1.937\n                    c0-0.724,0.589-1.313,1.313-1.313h0.666c0.724,0,1.313,0.589,1.313,1.313v1.937c0,0.486-0.268,0.93-0.7,1.161\n                    c-0.117,0.062-0.182,0.183-0.178,0.307c0,0.003,0,0.005,0,0.008v3.415c0,0.186,0.151,0.338,0.338,0.338s0.338-0.151,0.338-0.338\n                    v-3.242c0.547-0.369,0.879-0.983,0.879-1.649v-1.937c0-1.096-0.892-1.988-1.988-1.988h-0.666c-1.096,0-1.988,0.892-1.988,1.988\n                    v1.937C1103.356,1140.156,1103.689,1140.771,1104.236,1141.139z",
                        },
                      }),
                      _vm._v(" "),
                      _c("path", {
                        staticClass: "st1",
                        attrs: {
                          d: "M1112.505,1131.039c1.126,0,2.042-0.916,2.042-2.042c0-1.127-0.916-2.043-2.042-2.043\n                    c-1.126,0-2.043,0.917-2.043,2.043C1110.462,1130.123,1111.378,1131.039,1112.505,1131.039z M1112.505,1127.628\n                    c0.754,0,1.367,0.614,1.367,1.368c0,0.754-0.614,1.367-1.367,1.367c-0.754,0-1.368-0.613-1.368-1.367\n                    C1111.137,1128.242,1111.75,1127.628,1112.505,1127.628z",
                        },
                      }),
                      _vm._v(" "),
                      _c("path", {
                        staticClass: "st1",
                        attrs: {
                          d: "M1109.095,1139.513h1.975v4.868c0,0.186,0.151,0.338,0.338,0.338s0.338-0.151,0.338-0.338v-5.206\n                    c0-0.023-0.002-0.046-0.007-0.068c-0.002-0.011-0.005-0.022-0.008-0.032c-0.043-0.137-0.171-0.237-0.322-0.237c0,0,0,0,0,0\n                    h-1.766l1.529-3.059c0.023-0.047,0.036-0.099,0.036-0.151v-1.636c0-0.716,0.583-1.298,1.299-1.298s1.298,0.582,1.298,1.298\n                    v1.636c0,0.052,0.012,0.104,0.036,0.151l1.529,3.059h-1.753c0,0,0,0,0,0c-0.151,0-0.28,0.1-0.322,0.237\n                    c-0.003,0.011-0.006,0.021-0.008,0.032c-0.005,0.022-0.007,0.045-0.007,0.068v5.206c0,0.186,0.151,0.338,0.337,0.338\n                    s0.338-0.151,0.338-0.338v-4.868h1.961c0.117,0,0.226-0.061,0.287-0.16c0.061-0.099,0.067-0.224,0.015-0.328l-1.738-3.476\n                    v-1.557c0-1.088-0.885-1.973-1.973-1.973c-1.088,0-1.974,0.885-1.974,1.973v1.557l-1.738,3.476\n                    c-0.052,0.105-0.047,0.229,0.015,0.328C1108.87,1139.452,1108.978,1139.513,1109.095,1139.513z",
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("g", [
                      _c("g", [
                        _c("g", [
                          _c("path", {
                            staticClass: "st1",
                            attrs: {
                              d: "M1121.46,1139.351c-0.522,0-0.922,0.399-0.922,0.922s0.399,0.922,0.922,0.922\n                            c0.522,0,0.921-0.399,0.921-0.922S1121.982,1139.351,1121.46,1139.351z M1121.46,1140.58c-0.184,0-0.307-0.123-0.307-0.307\n                            s0.123-0.307,0.307-0.307c0.184,0,0.307,0.123,0.307,0.307S1121.644,1140.58,1121.46,1140.58z",
                            },
                          }),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("g", [
                        _c("g", [
                          _c("path", {
                            staticClass: "st1",
                            attrs: {
                              d: "M1126.067,1134.437h-4.331l-0.215-1.935c-0.061-0.491-0.461-0.829-0.922-0.829h-1.29\n                            c-0.184,0-0.307,0.123-0.307,0.307c0,0.184,0.123,0.307,0.307,0.307h1.29c0.154,0,0.276,0.123,0.307,0.276l0.246,2.212v0.584\n                            c0,0.184,0.123,0.307,0.307,0.307c0.184,0,0.307-0.123,0.307-0.307v-0.307h4.3c0.184,0,0.307,0.123,0.307,0.307\n                            s-0.123,0.307-0.307,0.307h-1.843c-0.184,0-0.307,0.123-0.307,0.307c0,0.184,0.123,0.307,0.307,0.307h1.843\n                            c0.522,0,0.922-0.399,0.922-0.922S1126.589,1134.437,1126.067,1134.437z",
                            },
                          }),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("g", [
                        _c("g", [
                          _c("path", {
                            staticClass: "st1",
                            attrs: {
                              d: "M1129.446,1142.116c-0.184,0-0.307,0.123-0.307,0.307c0,0.184,0.123,0.307,0.307,0.307\n                            c0.338,0,0.614,0.276,0.614,0.614s-0.276,0.614-0.614,0.614s-0.614-0.276-0.614-0.614v-4.3c0-0.522-0.399-0.922-0.922-0.922\n                            h-1.843c-0.184,0-0.307,0.123-0.307,0.307s0.123,0.307,0.307,0.307h1.843c0.184,0,0.307,0.123,0.307,0.307v0.922h-2.764\n                            c-0.184,0-0.307,0.123-0.307,0.307c0,2.027-1.659,3.686-3.686,3.686c-2.027,0-3.686-1.659-3.686-3.686\n                            s1.659-3.686,3.686-3.686c1.72,0,3.194,1.167,3.594,2.826c0.031,0.154,0.215,0.276,0.369,0.215\n                            c0.154-0.031,0.276-0.215,0.215-0.369c-0.461-1.935-2.181-3.287-4.177-3.287c-2.365,0-4.3,1.935-4.3,4.3s1.935,4.3,4.3,4.3\n                            c2.273,0,4.116-1.751,4.3-3.993h2.457v2.765c0,0.676,0.553,1.229,1.229,1.229c0.676,0,1.229-0.553,1.229-1.229\n                            S1130.122,1142.116,1129.446,1142.116z",
                            },
                          }),
                        ]),
                      ]),
                    ]),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.title.includes(49)
              ? _c("g", { attrs: { id: "parking-accessible" } }, [
                  _c("path", {
                    staticClass: "st0",
                    attrs: {
                      d: "M1113.707,1105.543L1113.707,1105.543c13.255,0,24,10.745,24,24l0,0c0,13.255-10.745,24-24,24l0,0\n            c-13.255,0-24-10.745-24-24l0,0C1089.707,1116.288,1100.453,1105.543,1113.707,1105.543z",
                    },
                  }),
                  _vm._v(" "),
                  _c("g", [
                    _c("g", [
                      _c("path", {
                        attrs: {
                          stroke: "#fff",
                          d: "M1111.975,1120.67v-3.234 M1111.975,1117.436v-4.527h3.519c0.915,0,1.657,0.738,1.657,1.653v1.215\n                c0,0.915-0.742,1.659-1.657,1.659H1111.975z M1117.821,1109.603h-7.735c-1.831,0-3.315,1.49-3.315,3.319v7.735\n                c0,1.829,1.484,3.312,3.315,3.312h7.735c1.831,0,3.315-1.483,3.315-3.312v-7.735\n                C1121.136,1111.093,1119.651,1109.603,1117.821,1109.603z",
                        },
                      }),
                      _vm._v(" "),
                      _c("path", {
                        staticClass: "st1",
                        attrs: {
                          d: "M1099.205,1129.975c1.126,0,2.043-0.916,2.043-2.042s-0.916-2.043-2.043-2.043\n                    c-1.126,0-2.042,0.916-2.042,2.043S1098.078,1129.975,1099.205,1129.975z M1099.205,1126.564c0.754,0,1.368,0.614,1.368,1.368\n                    c0,0.754-0.613,1.368-1.368,1.368c-0.754,0-1.368-0.613-1.368-1.368S1098.451,1126.564,1099.205,1126.564z",
                        },
                      }),
                      _vm._v(" "),
                      _c("path", {
                        staticClass: "st1",
                        attrs: {
                          d: "M1097.238,1138.302v6.079c0,0.186,0.151,0.338,0.337,0.338c0.186,0,0.338-0.151,0.338-0.338v-6.253\n                    c0-0.005-0.001-0.01-0.001-0.015c0.001-0.121-0.064-0.239-0.179-0.3c-0.432-0.23-0.7-0.675-0.7-1.161v-3.71\n                    c0-0.724,0.589-1.313,1.313-1.313h1.73c0.724,0,1.313,0.589,1.313,1.313v3.71c0,0.486-0.268,0.931-0.7,1.161\n                    c-0.117,0.062-0.182,0.183-0.178,0.307c0,0.003,0,0.005,0,0.008v6.253c0,0.186,0.151,0.338,0.337,0.338\n                    c0.187,0,0.338-0.151,0.338-0.338v-6.079c0.547-0.368,0.879-0.983,0.879-1.649v-3.71c0-1.096-0.892-1.988-1.988-1.988h-1.73\n                    c-1.096,0-1.988,0.892-1.988,1.988v3.71C1096.359,1137.319,1096.691,1137.934,1097.238,1138.302z",
                        },
                      }),
                      _vm._v(" "),
                      _c("path", {
                        staticClass: "st1",
                        attrs: {
                          d: "M1105.67,1134.586c1.126,0,2.043-0.917,2.043-2.043c0-1.126-0.916-2.043-2.043-2.043\n                    c-1.126,0-2.042,0.916-2.042,2.043C1103.628,1133.669,1104.544,1134.586,1105.67,1134.586z M1105.67,1131.175\n                    c0.754,0,1.368,0.614,1.368,1.368c0,0.754-0.614,1.368-1.368,1.368c-0.754,0-1.368-0.614-1.368-1.368\n                    C1104.303,1131.789,1104.916,1131.175,1105.67,1131.175z",
                        },
                      }),
                      _vm._v(" "),
                      _c("path", {
                        staticClass: "st1",
                        attrs: {
                          d: "M1104.236,1141.139v3.242c0,0.186,0.151,0.338,0.338,0.338c0.186,0,0.337-0.151,0.337-0.338v-3.415\n                    c0-0.005,0-0.01-0.001-0.016c0-0.121-0.064-0.239-0.179-0.3c-0.432-0.23-0.7-0.675-0.7-1.161v-1.937\n                    c0-0.724,0.589-1.313,1.313-1.313h0.666c0.724,0,1.313,0.589,1.313,1.313v1.937c0,0.486-0.268,0.93-0.7,1.161\n                    c-0.117,0.062-0.182,0.183-0.178,0.307c0,0.003,0,0.005,0,0.008v3.415c0,0.186,0.151,0.338,0.338,0.338s0.338-0.151,0.338-0.338\n                    v-3.242c0.547-0.369,0.879-0.983,0.879-1.649v-1.937c0-1.096-0.892-1.988-1.988-1.988h-0.666c-1.096,0-1.988,0.892-1.988,1.988\n                    v1.937C1103.356,1140.156,1103.689,1140.771,1104.236,1141.139z",
                        },
                      }),
                      _vm._v(" "),
                      _c("path", {
                        staticClass: "st1",
                        attrs: {
                          d: "M1112.505,1131.039c1.126,0,2.042-0.916,2.042-2.042c0-1.127-0.916-2.043-2.042-2.043\n                    c-1.126,0-2.043,0.917-2.043,2.043C1110.462,1130.123,1111.378,1131.039,1112.505,1131.039z M1112.505,1127.628\n                    c0.754,0,1.367,0.614,1.367,1.368c0,0.754-0.614,1.367-1.367,1.367c-0.754,0-1.368-0.613-1.368-1.367\n                    C1111.137,1128.242,1111.75,1127.628,1112.505,1127.628z",
                        },
                      }),
                      _vm._v(" "),
                      _c("path", {
                        staticClass: "st1",
                        attrs: {
                          d: "M1109.095,1139.513h1.975v4.868c0,0.186,0.151,0.338,0.338,0.338s0.338-0.151,0.338-0.338v-5.206\n                    c0-0.023-0.002-0.046-0.007-0.068c-0.002-0.011-0.005-0.022-0.008-0.032c-0.043-0.137-0.171-0.237-0.322-0.237c0,0,0,0,0,0\n                    h-1.766l1.529-3.059c0.023-0.047,0.036-0.099,0.036-0.151v-1.636c0-0.716,0.583-1.298,1.299-1.298s1.298,0.582,1.298,1.298\n                    v1.636c0,0.052,0.012,0.104,0.036,0.151l1.529,3.059h-1.753c0,0,0,0,0,0c-0.151,0-0.28,0.1-0.322,0.237\n                    c-0.003,0.011-0.006,0.021-0.008,0.032c-0.005,0.022-0.007,0.045-0.007,0.068v5.206c0,0.186,0.151,0.338,0.337,0.338\n                    s0.338-0.151,0.338-0.338v-4.868h1.961c0.117,0,0.226-0.061,0.287-0.16c0.061-0.099,0.067-0.224,0.015-0.328l-1.738-3.476\n                    v-1.557c0-1.088-0.885-1.973-1.973-1.973c-1.088,0-1.974,0.885-1.974,1.973v1.557l-1.738,3.476\n                    c-0.052,0.105-0.047,0.229,0.015,0.328C1108.87,1139.452,1108.978,1139.513,1109.095,1139.513z",
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("g", [
                      _c("g", [
                        _c("g", [
                          _c("path", {
                            staticClass: "st1",
                            attrs: {
                              d: "M1121.46,1139.351c-0.522,0-0.922,0.399-0.922,0.922s0.399,0.922,0.922,0.922\n                            c0.522,0,0.921-0.399,0.921-0.922S1121.982,1139.351,1121.46,1139.351z M1121.46,1140.58c-0.184,0-0.307-0.123-0.307-0.307\n                            s0.123-0.307,0.307-0.307c0.184,0,0.307,0.123,0.307,0.307S1121.644,1140.58,1121.46,1140.58z",
                            },
                          }),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("g", [
                        _c("g", [
                          _c("path", {
                            staticClass: "st1",
                            attrs: {
                              d: "M1126.067,1134.437h-4.331l-0.215-1.935c-0.061-0.491-0.461-0.829-0.922-0.829h-1.29\n                            c-0.184,0-0.307,0.123-0.307,0.307c0,0.184,0.123,0.307,0.307,0.307h1.29c0.154,0,0.276,0.123,0.307,0.276l0.246,2.212v0.584\n                            c0,0.184,0.123,0.307,0.307,0.307c0.184,0,0.307-0.123,0.307-0.307v-0.307h4.3c0.184,0,0.307,0.123,0.307,0.307\n                            s-0.123,0.307-0.307,0.307h-1.843c-0.184,0-0.307,0.123-0.307,0.307c0,0.184,0.123,0.307,0.307,0.307h1.843\n                            c0.522,0,0.922-0.399,0.922-0.922S1126.589,1134.437,1126.067,1134.437z",
                            },
                          }),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("g", [
                        _c("g", [
                          _c("path", {
                            staticClass: "st1",
                            attrs: {
                              d: "M1129.446,1142.116c-0.184,0-0.307,0.123-0.307,0.307c0,0.184,0.123,0.307,0.307,0.307\n                            c0.338,0,0.614,0.276,0.614,0.614s-0.276,0.614-0.614,0.614s-0.614-0.276-0.614-0.614v-4.3c0-0.522-0.399-0.922-0.922-0.922\n                            h-1.843c-0.184,0-0.307,0.123-0.307,0.307s0.123,0.307,0.307,0.307h1.843c0.184,0,0.307,0.123,0.307,0.307v0.922h-2.764\n                            c-0.184,0-0.307,0.123-0.307,0.307c0,2.027-1.659,3.686-3.686,3.686c-2.027,0-3.686-1.659-3.686-3.686\n                            s1.659-3.686,3.686-3.686c1.72,0,3.194,1.167,3.594,2.826c0.031,0.154,0.215,0.276,0.369,0.215\n                            c0.154-0.031,0.276-0.215,0.215-0.369c-0.461-1.935-2.181-3.287-4.177-3.287c-2.365,0-4.3,1.935-4.3,4.3s1.935,4.3,4.3,4.3\n                            c2.273,0,4.116-1.751,4.3-3.993h2.457v2.765c0,0.676,0.553,1.229,1.229,1.229c0.676,0,1.229-0.553,1.229-1.229\n                            S1130.122,1142.116,1129.446,1142.116z",
                            },
                          }),
                        ]),
                      ]),
                    ]),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.title.includes(54)
              ? _c("g", { attrs: { id: "test-shop_2_" } }, [
                  _c("g", [
                    _c("path", {
                      staticClass: "st0",
                      attrs: {
                        d: "M1065.269,1215.19L1065.269,1215.19c13.255,0,24,10.745,24,24l0,0c0,13.255-10.745,24-24,24l0,0\n                c-13.255,0-24-10.745-24-24l0,0C1041.269,1225.935,1052.014,1215.19,1065.269,1215.19z",
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("g", [
                    _c("path", {
                      staticClass: "st1",
                      attrs: {
                        d: "M1078.078,1243.229c-0.132,0-0.264-0.052-0.362-0.155l-12.388-13.019l-12.388,13.019\n                c-0.19,0.201-0.507,0.208-0.707,0.018s-0.208-0.507-0.018-0.707l12.75-13.399c0.188-0.199,0.536-0.199,0.725,0l12.75,13.399\n                c0.19,0.2,0.183,0.517-0.018,0.707C1078.326,1243.184,1078.202,1243.229,1078.078,1243.229z",
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("g", [
                    _c("path", {
                      staticClass: "st1",
                      attrs: {
                        d: "M1063.264,1243.457c0-0.292-0.236-0.528-0.528-0.528s-0.528,0.236-0.528,0.528\n                c0.002,1.457,1.183,2.638,2.64,2.64v0.528c0,0.292,0.236,0.528,0.528,0.528s0.528-0.236,0.528-0.528v-0.528\n                c1.458,0,2.64-1.182,2.64-2.64c0-1.458-1.182-2.64-2.64-2.64v-3.168c0.875,0,1.584,0.709,1.584,1.584\n                c0,0.292,0.236,0.528,0.528,0.528c0.292,0,0.528-0.236,0.528-0.528c-0.002-1.457-1.183-2.638-2.64-2.64v-0.528\n                c0-0.292-0.236-0.528-0.528-0.528s-0.528,0.236-0.528,0.528v0.528c-1.458,0-2.64,1.182-2.64,2.64c0,1.458,1.182,2.64,2.64,2.64\n                v3.168C1063.973,1245.042,1063.264,1244.332,1063.264,1243.457z M1065.904,1241.873c0.875,0,1.584,0.709,1.584,1.584\n                c0,0.875-0.709,1.584-1.584,1.584V1241.873z M1063.264,1239.233c0-0.875,0.709-1.584,1.584-1.584v3.168\n                C1063.973,1240.817,1063.264,1240.108,1063.264,1239.233z",
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("g", [
                    _c("path", {
                      staticClass: "st1",
                      attrs: {
                        d: "M1073.328,1249.17c0,0.27,0.223,0.5,0.5,0.5c0.276,0,0.5-0.23,0.5-0.5H1073.328z M1073.328,1237.83v11.34h1\n                v-10.813L1073.328,1237.83z",
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("g", [
                    _c("path", {
                      staticClass: "st1",
                      attrs: {
                        d: "M1073.828,1249.917c0.27,0,0.5-0.223,0.5-0.5c0-0.276-0.23-0.5-0.5-0.5V1249.917z M1062.488,1249.917h11.34\n                v-1h-10.813L1062.488,1249.917z",
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("g", [
                    _c("path", {
                      staticClass: "st1",
                      attrs: {
                        d: "M1056.828,1248.917c-0.27,0-0.5,0.223-0.5,0.5c0,0.276,0.23,0.5,0.5,0.5V1248.917z M1068.168,1248.917\n                h-11.34v1h10.813L1068.168,1248.917z",
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("g", [
                    _c("path", {
                      staticClass: "st1",
                      attrs: {
                        d: "M1056.328,1249.17c0,0.27,0.223,0.5,0.5,0.5c0.276,0,0.5-0.23,0.5-0.5H1056.328z M1056.328,1238.145v11.025\n                h1v-11.34L1056.328,1238.145z",
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("g"),
                ])
              : _vm._e(),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.season == "ete"
        ? _c("g", { attrs: { id: "ete" } }, [
            _c("g", { attrs: { id: "bg" } }, [
              _c("g", [
                _c("rect", {
                  staticClass: "st0",
                  attrs: {
                    x: "0.563",
                    y: "0.483",
                    width: "2170.15",
                    height: "1537.06",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("g", [
                  _c("path", {
                    staticClass: "st14",
                    attrs: {
                      d: "M2107.86,998.26c-10.98-8.021-18.12-5.91-30.36-6.754c-12.2-0.844-10.98,0-27.4,0\n                    c-16.43,0-45.1,2.11-75.45-5.066c-30.36-7.175-50.17-7.175-65.79-8.864c-15.58-1.688-44.25-5.909-63.25-15.158\n                    c-18.95-9.286-28.36-1.803-38.03-0.537c0,0-6.95,1.036-13.7-2.839c-6.76-3.915-21.07,2.647-25.6,5.909\n                    c-4.53,3.262-17.62,4.643-30.36,2.226c-12.74-2.418-18.96-2.303-26.36,0.959c-7.37,3.262-17.39,2.648-20.34-0.192\n                    c-2.96-2.839-17.08-5.065-29.21-2.532c-12.13,2.532-36.58-5.142-44.9-7.522c-8.33-2.379-33.43-3.223-42.26-3.223\n                    c-8.83,0-44.48,0.883-59.64,0c-15.16-0.883-26.1,1.151-33.05,4.95c-6.94,3.799-14.7,6.639-19.3-0.614\n                    c-4.57-7.291-0.15-6.178-4.41-10.13c-4.26-3.953-13.13-5.833-27.83-5.68c-14.7,0.154-45.86,4.106-55.5,1.881\n                    c0,0-2.57-0.96-0.46-3.377c2.11-2.418,9.91-11.973,10.48-14.813c0.58-2.839,0.96-8.212,1.23-11.128\n                    c0.23-2.916-1.57-2.533-2.23-2.302c-0.61,0.23-3.14,4.911-4.41,9.171c-1.27,4.259-4.26,9.478-6.64,11.474\n                    c-2.38,1.957-8.14,8.212-9.48,13.047s-0.81,9.977-1.96,13.929c-1.19,3.953-3.64,4.989-4.49,6.332\n                    c-0.88,1.343-1.57,4.413-1.19,7.828c0.39,3.416-6.71,5.526-10.67,2.61c-3.95-2.917-10.36-5.833-10.67-8.634\n                    c-0.3-2.763-2.99-7.982-4.26-11.935c-1.26-3.952,0.39-6.101,0.23-8.135c-0.15-2.072,0.54-6.869-2.84-7.176\n                    c-3.41-0.307-15.08,4.567-25.06,9.095c-9.98,4.49-20.22,9.094-28.55,8.787c-8.29-0.307-20.19,1.113-25.14-8.365\n                    c-4.95-9.478-6.41-6.217-13.74-5.372c-7.33,0.844-7.1,0-13.74,1.88s-15.81,1.88-21.3,1.995c-5.49,0.116-10.32,0.538-14.43-2.417\n                    c-4.11-2.955-17.08-13.393-18.65-14.429c-1.58-1.036-13.28-8.097-24.26,2.955c0,0-10.21,12.011-19.07,12.97\n                    c-8.87,0.96-28.36-0.115-36.46-0.422c-8.1-0.307-24.45,5.488-32.47,6.025s-7.6-0.115-7.6-0.115l-5.83-77.822l-14.09-169.19\n                    c0,0-1.11-23.331-6.33-28.243c0,0,18.34-3.799,45.36-6.024c27.02-2.226,36.04-7.445,42.22-10.131\n                    c6.18-2.686,37-9.018,57.88-10.591c0,0,6.17-0.806,13.12-4.759c0,0,3.49-1.88-1.99-13.929c-5.45-12.011-9.02-17.614-11.4-19.763\n                    c-2.38-2.149-5.61-4.106-5.61-4.106s-3.07-1.88-1.42,2.993c1.65,4.912,1.27,6.332,3.15,10.515c1.88,4.183,1.96,5.756,1.8,8.941\n                    c-0.15,3.147,1.04,8.634-6.48,1.113c0,0-3.49-2.533-6.87-4.183c-3.42-1.65-10.13-5.526-13.05-11.474\n                    c-2.92-5.909-5.22-12.318-5.07-19.992c0.16-7.675,1.5-23.715-8.79-28.55c-10.28-4.835-20.37-6.102-22.29-6.179\n                    c-1.88-0.076-12.98-1.112-23.57-18.956c-10.59-17.844-26.48-20.07-37.46-22.372c-10.97-2.302-22.6-3.876-31.54-9.785\n                    c-8.95-5.91-13.36-4.682-21.036-2.917c-7.676,1.727-16.349,4.106-24.409-7.598c-8.059-11.704-16.848-8.135-18.882-8.711\n                    c-2.073-0.537-14.93-4.758-25.676-17.536c-10.746-12.817-32.162-20.07-34.695-22.219c-2.533-2.149-19.995-14.39-28.631-22.679\n                    c-8.635-8.288-27.287-12.663-39.07-18.035c-11.782-5.373-31.624-20.146-36.114-27.361c-4.491-7.176-11.552-11.857-17.847-19.762\n                    c-6.332-7.905-10.746-20.223-46.016-26.401c-35.271-6.178-47.897-18.189-54.69-28.627\n                    c-6.794-10.438-18.346-26.401-34.465-31.773c-16.119-5.373-37.611-6.486-55.496-21.989c-2.687-2.34-7.1-4.566-12.665-6.715\n                    l-30.205-24.943c0,0-22.144-26.977-36.191-31.505c-14.085-4.528-29.092-6.293-35.654-16.846\n                    c-6.563-10.553-20.61-16.692-29.859-21.105c-9.25-4.413-11.015-17.575-23.335-24.636c-12.32-7.023-20.226-11.436-23.296-14.966\n                    c-3.07-3.53-37.88-55.258-37.88-55.258H60.563c0,0,68.738,114.469,87.811,132.811c19.113,18.305,22.221,41.175,29.015,46.471\n                    c6.793,5.257,7.675,9.67,16.464,25.518c8.789,15.81,14.891,26.171,21.07,31.544c6.179,5.372,20.265,13.315,26.405,17.69\n                    c6.141,4.374,29.898,11.972,33.659,16.692c4.337,5.104,8.021,10.438,10.477,16.041c13.932,31.62,20.878,28.473,28.478,44.244\n                    c7.599,15.81,22.144,21.49,34.771,39.832c12.665,18.343,28.439,15.81,41.757,27.207c13.279,11.397,15.812,17.691,22.758,24.022\n                    c6.947,6.332,22.145,15.158,31.625,18.343c9.479,3.147,28.439,13.93,28.439,13.93s9.172,4.413,33.428,1.458\n                    s28.477-1.574,31.509-2.648c3.071-1.036,4.337-0.422,4.337-0.422s-1.689,6.946,9.365,14.121\n                    c11.053,7.176,26.136,9.479,45.747,11.167c19.612,1.689,34.35,10.745,50.814,19.609c16.427,8.864,27.825,12.97,45.864,17.69\n                    c18.038,4.759,29.091,15.158,38.264,18.957c9.172,3.799,10.439,0.959,20.571,6.025c10.132,5.065,28.784,8.519,37.304,11.051\n                    c8.52,2.533,17.079,5.373,36.038,9.786c18.96,4.413,34.465,9.171,42.064,14.85c7.599,5.68,19.612,12.011,30.972,17.384\n                    c11.398,5.372,31.624,9.785,44.596,9.478c12.972-0.307,13.587,2.839,24.333,7.291c10.746,4.413,16.771,6.945,24.025,7.598\n                    c0,0,2.149,0.307,3.646,0.806c0,0,4.491,6.638,5.221,16.615c0.73,9.978,13.51,162.014,13.51,162.014s0.31,1.305-13.09-2.456\n                    c-13.394-3.799-20.455,0.538-33.197-1.573c-12.742-2.111-21.608,0.23-26.443-2.302c-4.836-2.533-17.271-8.634-20.572-13.086\n                    c-3.262-4.413-8.75-11.819-22.029-12.318c-13.279-0.537-24.256,8.212-35.002,10.745c-10.746,2.533-29.514,2.724-53.961,0.537\n                    c-24.448-2.226-34.695-1.88-40.49-2.418c-5.795-0.537-16.004-1.573-22.03-2.724c-6.025-1.151-11.82-1.995-19.074-1.688\n                    c-7.254,0.307-22.644-1.152-28.784-3.262c-6.103-2.111-16.772-0.192-28.9,2.11c-12.128,2.303-9.173,0.845-17.194,2.533\n                    c-8.021,1.688-8.75,0.422-12.435,0.959c-3.684,0.538-13.087-0.614-12.972-10.744c0.115-10.131,12.972-7.598,14.239-7.79\n                    c1.266-0.23,5.68,1.88,11.706,0c6.025-1.88,7.675-7.176,13.471-9.709c5.795-2.532,10.439-5.372,14.967-10.629\n                    c4.529-5.257,12.666-11.167,22.452-11.704c9.787-0.537,17.079,1.573,31.202-0.307c14.124-1.881,21.186-5.181,31.51-4.221\n                    c10.324,0.959,26.443,5.794,34.042,6.869c7.599,1.036,19.727,1.266,22.989-6.217c3.262-7.483-7.062-8.02-16.656-11.704\n                    c-9.595-3.684-26.559-11.052-31.394-14.313c-4.836-3.262-17.386-5.181-29.399-7.598c-12.013-2.418-7.292-3.147-15.505-6.524\n                    c-8.213-3.377-15.812-12.855-27.211-17.268c-11.399-4.413-3.147-8.864-21.723-13.699c-18.537-4.836-16.848-8.443-27.633-8.212\n                    c-10.746,0.23-17.078-3.799-22.144-5.488c-5.066-1.688-19.382-10.322-40.682-10.975c-21.301-0.614-40.912-3.568-49.317-14.313\n                    c-8.444-10.745-8.444-15.158-32.047-22.756c-23.603-7.598-23.411-22.755-34.771-29.509\n                    c-11.399-6.754-17.271-13.086-44.482-11.397c0,0-9.71,1.036-23.411-6.524c-13.701-7.598-27.403-3.568-34.58-2.724\n                    c-7.177,0.844-15.582,2.533-17.923-8.02c-2.303-10.553-6.524-15.81-15.39-18.957c-8.865-3.147-22.336-2.533-33.083-2.11\n                    c-10.746,0.422-17.27,0.614-26.136-5.066c-8.865-5.679-13.548-6.447-17.808-6.754c-4.26-0.307-9.71,1.19-15.735,2.418\n                    c-6.026,1.228-9.864,1.42-11.514-4.106c-1.612-5.526-5.565-9.555-8.942-9.133c-3.378,0.422-1.881,3.07-4.951,2.725\n                    c-3.07-0.307-6.64,0.23-10.861-1.574c-4.222-1.803-7.791-4.106-13.395-4.528c-5.603-0.422-5.373-0.422-6.025,1.881\n                    c-0.614,2.302,0.959,2.302-3.263,0.613c-4.221-1.688-4.835-3.261-8.097-3.914c-3.263-0.614-9.442-2.302-14.546-4.221\n                    c0,0-12.013-6.945-18.115,3.377c-6.102,10.323-3.378,15.273,0,21.912c3.377,6.638,8.021,10.859,10.324,13.699\n                    c2.303,2.84,4.951,10.015,5.373,15.58c0.422,5.602,6.755,12.011,10.132,17.191c3.377,5.181,6.026,12.126,7.714,16.424\n                    c1.689,4.298,12.665,12.855,26.021,12.855c13.356,0,31.625,0.192,44.367,15.58c0,0,10.861,9.9,18.959,15.58\n                    c0,0,2.226,1.727,11.629,9.862c9.403,8.135,9.403,11.205,17.155,18.496c7.753,7.253,14.546,13.277,16.426,19.455\n                    c1.881,6.179,3.646,11.704,3.339,17.691c-0.307,6.024,2.38,16.193,5.22,21.873c2.84,5.679,10.324,20.453,16.35,27.936\n                    c6.025,7.483,19.918,23.523,23.91,28.55c3.991,5.065,14.737,20.031,19.189,27.706c4.414,7.713,17.54,26.708,24.832,48.849\n                    c7.253,22.142,7.1,22.602,9.786,32.234c2.687,9.632,21.339,45.051,26.252,52.649c4.912,7.598,8.904,41.328,9.556,51.228\n                    c0.614,9.9-1.267,10.13,5.68,31.39c6.947,21.3,8.444,39.41,7.177,51.65c-1.266,12.24-2.533,35.61,6.524,49.73\n                    c9.058,14.13,36.998,61.67,37.957,71.15c0.96,9.48,4.414,25.29,31.625,30.35c27.211,5.07,40.144,8.87,61.023,41.75\n                    c20.878,32.89,23.411,27.82,37.304,62.59c13.932,34.77,38.878,72.72,85.048,95.17c46.17,22.45,130.605,24.98,202.681,14.85\n                    c72.071-10.13,82.511-19.92,100.551-27.21c18.04-7.25,56.61-30.35,74.96-30.97c18.34-0.61,43.94-2.53,53.11-2.22\n                    c9.18,0.3,33.85,0.61,46.48-4.42c12.67-5.06,11.55-1.57,20.72-2.53l9.18-0.96c0,0,25.6-2.07,40.95-3.8\n                    c15.35-1.72,70.19-6.17,103.7-12.81c33.5-6.64,75.57-12.97,112.56-25.14c37-12.16,68.47-25.59,85.86-29.89\n                    c17.38-4.26,38.42-20.07,43.64-24.33c5.22-4.26,26.86-15.35,31.31-16.92c4.42-1.58,9.79-4.76,14.09-10.13\n                    c4.26-5.38,62.82-24.14,77.14-27.29c14.32-3.14,59.64-16.11,69.04-17.8c9.37-1.69,33.43-12.67,46.29-19.61\n                    c12.86-6.95,23.72-14.85,30.55-27.4c6.87-12.55,19.3-35.3,35-43.09c0,0,19.11-10.21,29.55-16.39\n                    c10.44-6.18,39.99-26.09,55.35-34c15.35-7.9,46.17-33.35,50.43-38.1c4.26-4.76,17.69-26.71,26.55-32.51\n                    c8.87-5.79,31.63-18.03,20.65-26.014L2107.86,998.26z M987.764,941.735c-7.906-0.153-22.605-7.099-31.317-13.277\n                    c-8.712-6.178-9.173-8.519-14.853-12.817c-5.68-4.26-15.16-12.165-17.232-13.124c-2.073-0.959-12.474-7.598-8.52-16.616\n                    c3.953-9.018,9.326-9.977,19.918-9.977c10.593,0,24.333-0.307,35.731,1.573c11.399,1.881,16.772,2.226,23.719,2.84\n                    c6.95,0.614,18.34,0.461,21.18,1.573l5.84,67.346c0,0-26.56-7.444-34.466-7.598V941.735z",
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("g", [
                  _c("path", {
                    staticClass: "st14",
                    attrs: {
                      d: "M1115.22,731.447c0,0-19.38,7.253-22.14,19.801c-2.73,12.548-6.22,16.002-1.16,24.674\n                    c5.07,8.634,11.06,14.966,31.32,15.388c20.23,0.422,35.73-1.573,47.63,2.302c11.9,3.914,19.07,9.786,25.83,16.539\n                    c6.75,6.754,12.13,17.077,45.63,18.535c33.51,1.458,37.31,1.803,43.95,2.724c6.64,0.96,13.58,3.262,15.92,8.443\n                    c2.31,5.18,3.38,11.166,10.63,11.166c7.26,0,8.64-3.07,10.87-3.799c2.22-0.729,6.44-1.995,9.9,1.881\n                    c3.49,3.914,4.95,6.101,21.91,3.146c0,0,6.64-0.614,11.59,2.303c0,0,3.57,3.07,10.98,0c0,0,1.27,0.115,1.57-3.569\n                    c0.31-3.684,2.31-8.02,12.55-5.487c10.21,2.532,19.38,3.683,29.63,3.146c10.21-0.537,16.97,0.115,29.52,0\n                    c12.55-0.115,25.94-0.23,25.4-7.483c-0.54-7.291-4.41-7.674-16.42-12.011c-12.02-4.336-18.12-6.101-28.56-8.941\n                    c-10.44-2.839-23.18-7.905-27.52-10.437c-4.33-2.533-21.49-10.438-28.36-12.126c-6.87-1.689-13.09-7.598-16-6.869\n                    c-2.96,0.729-12.86,0.959-15.7,0.192c-2.84-0.73-12.32-4.106-16.77-5.258c-4.41-1.151-15.7-8.442-19.19-10.975\n                    c-3.49-2.532-20.65-14.658-21.8-15.503c-1.15-0.844-3.8-5.602-22.87-3.99c0,0-8.45,0.115-17.81-16.539\n                    c-9.37-16.655-42.91-30.776-51.55-31.083c-8.63-0.307-29.62-1.036-54.26,11.819c-24.68,12.855-11.82,4.758-24.68,11.896\n                    L1115.22,731.447z",
                    },
                  }),
                ]),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st2",
                  attrs: {
                    d: "M569.008,1262.98c0,0,52.08,23.01,69.159,36.28s14.392,8.74,37.612,18.49\n                c19.419,8.16,19.304,11.54,25.598,26.07c6.333,14.54,27.211,48.97,34.158,54.65c6.946,5.67,26.558,15.14,37.304,18.33\n                c10.747,3.14,9.48,5.67,22.145,11.39c12.665,5.67,80.942,5.06,101.168,3.79c20.225-1.26,37.956-0.61,58.796-3.14\n                c20.879-2.53,25.945-3.15,43.637-5.06c17.695-1.88,28.515-1.88,49.665-5.07c21.14-3.14,21.8-7.59,38.88-10.12\n                c17.07-2.53,31.62-3.8,31.62-3.8s76.34,4.07,86.55,1.27c0,0,10.13,0.42-19.5,4.83s-46.13-1.46-72.81,2.34\n                c-26.36,3.76-33.96,7.02-39.95,11.04c-5.99,4.03-52.62,28.38-80.518,34.9c-27.902,6.48-77.987,20.52-138.05,18.1\n                c-57.377-2.3-125.692,1.99-180.958-63.54c-55.266-65.5-17.731-41.22-55.419-94.37\n                C580.176,1265.86,607.042,1293.74,569.008,1262.98z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st1",
                  attrs: {
                    d: "M176.505,816.121v11.082h-5.45v-27.878h9.096c2.763,0,4.912,0.728,6.486,2.186\n                c1.573,1.457,2.341,3.451,2.341,6.058c0,1.458-0.307,2.723-0.96,3.759c-0.652,1.035-1.612,1.879-2.84,2.53\n                c1.42,0.499,2.456,1.304,3.109,2.416c0.614,1.112,0.959,2.531,0.959,4.219v1.955c0,0.767,0.077,1.573,0.269,2.455\n                c0.192,0.882,0.499,1.495,0.96,1.917v0.383h-5.642c-0.461-0.421-0.729-1.073-0.845-1.994c-0.115-0.92-0.153-1.84-0.153-2.799\n                v-1.879c0-1.381-0.269-2.454-0.844-3.221c-0.576-0.767-1.382-1.151-2.457-1.151h-3.953L176.505,816.121z M176.505,811.788h3.646\n                c1.113,0,1.957-0.345,2.533-0.997c0.575-0.691,0.844-1.649,0.844-2.876c0-1.228-0.307-2.301-0.844-3.03\n                c-0.576-0.767-1.42-1.112-2.495-1.112h-3.646v8.091L176.505,811.788z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st1",
                  attrs: {
                    d: "M199.033,827.203h-5.412v-27.878h5.412V827.203z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st1",
                  attrs: {
                    d: "M211.965,820.071l0.23,1.073h0.115l0.23-0.997l4.644-20.822h5.719l-7.791,27.878h-5.68l-7.791-27.878h5.718\n                l4.606,20.784V820.071z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st1",
                  attrs: {
                    d: "M230.927,827.203h-5.411v-27.878h5.411V827.203z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st1",
                  attrs: {
                    d: "M250.267,814.971h-9.365v7.899h11.015v4.333h-16.503v-27.878h16.465v4.333h-10.977v6.941h9.365v4.333\n                V814.971z M245.968,797.331h-4.413l-4.721-4.985v-0.116h5.757l3.339,5.101H245.968z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st1",
                  attrs: {
                    d: "M260.247,816.121v11.082h-5.45v-27.878h9.096c2.763,0,4.912,0.728,6.486,2.186\n                c1.573,1.457,2.341,3.451,2.341,6.058c0,1.458-0.307,2.723-0.96,3.759c-0.652,1.035-1.611,1.879-2.84,2.53\n                c1.42,0.499,2.457,1.304,3.109,2.416c0.614,1.112,0.96,2.531,0.96,4.219v1.955c0,0.767,0.076,1.573,0.268,2.455\n                c0.192,0.882,0.499,1.495,0.96,1.917v0.383h-5.642c-0.461-0.421-0.729-1.073-0.844-1.994c-0.115-0.92-0.154-1.84-0.154-2.799\n                v-1.879c0-1.381-0.269-2.454-0.844-3.221c-0.576-0.767-1.382-1.151-2.456-1.151h-3.954L260.247,816.121z M260.247,811.788h3.646\n                c1.113,0,1.957-0.345,2.533-0.997c0.575-0.691,0.844-1.649,0.844-2.876c0-1.228-0.307-2.301-0.844-3.03\n                c-0.576-0.767-1.42-1.112-2.495-1.112h-3.646v8.091L260.247,811.788z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st1",
                  attrs: {
                    d: "M291.872,814.971h-9.364v7.899h11.015v4.333H277.02v-27.878h16.464v4.333h-10.976v6.941h9.364v4.333V814.971\n                z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st1",
                  attrs: {
                    d: "M120.7,867.008c0-1.074-0.268-1.956-0.844-2.569c-0.576-0.614-1.535-1.266-2.955-1.879\n                c-2.917-0.997-5.066-2.148-6.525-3.452c-1.458-1.265-2.187-3.068-2.187-5.407s0.844-4.141,2.533-5.598\n                c1.688-1.419,3.838-2.148,6.447-2.148c2.61,0,4.836,0.805,6.487,2.416c1.65,1.611,2.456,3.643,2.417,6.059v0.115h-5.334\n                c0-1.266-0.307-2.301-0.96-3.106c-0.652-0.805-1.535-1.189-2.725-1.189c-1.074,0-1.919,0.345-2.533,0.997\n                c-0.614,0.652-0.921,1.496-0.921,2.493c0,0.92,0.346,1.687,0.998,2.262c0.653,0.575,1.842,1.266,3.531,1.994\n                c2.648,0.882,4.644,2.033,5.987,3.413c1.343,1.381,1.996,3.221,1.996,5.561c0,2.339-0.806,4.294-2.418,5.675\n                c-1.612,1.38-3.761,2.032-6.409,2.032c-2.649,0-4.951-0.767-6.909-2.339c-1.957-1.572-2.878-3.758-2.84-6.672v-0.115h5.335\n                c0,1.725,0.384,2.952,1.113,3.719c0.729,0.767,1.842,1.112,3.301,1.112c1.151,0,1.995-0.306,2.571-0.92\n                c0.537-0.613,0.844-1.457,0.844-2.492V867.008z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st1",
                  attrs: {
                    d: "M142.116,868.312h-7.369l-1.497,5.944h-5.488l7.867-27.879h5.681l7.829,27.879h-5.488l-1.497-5.944H142.116z\n                M135.86,863.978h5.143l-2.533-9.855h-0.116L135.86,863.978z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st1",
                  attrs: {
                    d: "M157.005,874.294h-5.411v-27.878h5.411V874.294z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st1",
                  attrs: {
                    d: "M181.071,874.294h-5.412l-8.52-17.831h-0.115v17.831h-5.45v-27.878h5.45l8.52,17.831h0.115v-17.831h5.412\n                V874.294z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st1",
                  attrs: {
                    d: "M201.219,850.749h-6.295v23.545h-5.449v-23.545h-6.256v-4.333h18V850.749z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st1",
                  attrs: { d: "M209.088,864.477h-9.518v-4.333h9.518V864.477z" },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st1",
                  attrs: {
                    d: "M220.718,846.377l4.989,20.478h0.115l5.066-20.478h7.101v27.879h-5.412v-8.091l0.461-10.853h-0.115\n                l-5.335,18.944h-3.608l-5.258-18.829h-0.115l0.461,10.699v8.091h-5.412v-27.878h7.062V846.377z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st1",
                  attrs: {
                    d: "M255.026,868.312h-7.369l-1.497,5.944h-5.488l7.868-27.879h5.68l7.829,27.879h-5.488l-1.497-5.944H255.026z\n                M248.77,863.978h5.143l-2.533-9.855h-0.115L248.77,863.978z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st1",
                  attrs: {
                    d: "M282.506,846.377v18.982c0,2.991-0.883,5.254-2.61,6.903c-1.765,1.61-4.029,2.415-6.869,2.415\n                c-2.841,0-5.105-0.805-6.87-2.415c-1.727-1.611-2.61-3.912-2.61-6.865v-18.982h5.45v18.982c0,1.688,0.345,2.953,1.036,3.758\n                c0.691,0.806,1.689,1.189,2.955,1.189c1.267,0,2.303-0.383,2.994-1.15c0.691-0.767,1.036-2.033,1.036-3.797v-18.982h5.411\n                L282.506,846.377z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st1",
                  attrs: {
                    d: "M291.872,863.173v11.083h-5.45v-27.879h9.096c2.763,0,4.912,0.729,6.486,2.186\n                c1.573,1.457,2.341,3.451,2.341,6.059c0,1.457-0.307,2.722-0.96,3.758c-0.652,1.035-1.611,1.879-2.84,2.531\n                c1.42,0.498,2.457,1.303,3.109,2.416c0.614,1.112,0.96,2.531,0.96,4.218v1.956c0,0.766,0.076,1.572,0.268,2.454\n                c0.192,0.882,0.499,1.495,0.96,1.917v0.384H300.2c-0.461-0.422-0.729-1.074-0.844-1.994c-0.115-0.921-0.154-1.841-0.154-2.8\n                v-1.879c0-1.38-0.269-2.454-0.844-3.221c-0.576-0.767-1.382-1.15-2.456-1.15h-3.954L291.872,863.173z M291.872,858.84h3.646\n                c1.113,0,1.957-0.345,2.533-0.997c0.575-0.69,0.844-1.649,0.844-2.876s-0.307-2.301-0.844-3.03\n                c-0.576-0.767-1.42-1.112-2.495-1.112h-3.646v8.092L291.872,858.84z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st1",
                  attrs: { d: "M314.4,874.294h-5.412v-27.878h5.412V874.294z" },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st1",
                  attrs: {
                    d: "M336.431,865.283v0.115c0.076,3.067-0.653,5.368-2.111,6.94c-1.497,1.573-3.685,2.34-6.563,2.34\n                c-2.878,0-5.181-0.882-6.908-2.646c-1.727-1.764-2.572-4.257-2.572-7.516v-8.322c0-3.221,0.845-5.752,2.495-7.516\n                c1.65-1.764,3.915-2.684,6.716-2.684c2.956,0,5.22,0.805,6.717,2.377c1.496,1.572,2.302,3.912,2.341,7.018v0.115h-5.297\n                c0.077-1.841-0.153-3.145-0.729-3.95c-0.575-0.805-1.573-1.227-2.993-1.227c-1.228,0-2.15,0.46-2.802,1.457\n                s-0.959,2.416-0.959,4.333v8.399c0,1.955,0.345,3.451,1.036,4.41c0.691,0.958,1.727,1.418,3.07,1.418\n                c1.343,0,2.226-0.383,2.763-1.15c0.538-0.767,0.73-2.071,0.691-3.911h5.258H336.431z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st1",
                  attrs: {
                    d: "M354.622,862.023h-9.364v7.899h11.015v4.334H339.77v-27.879h16.464v4.333h-10.976v6.941h9.364v4.333V862.023\n                z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st6",
                  attrs: {
                    d: "M1080.95,1225.79c-75.99,1.19-88.964-13.23-89.117-13.35l-2.994,2.3l-3.109,2.19\n                c1.229,1.76,13.702,16.53,86.47,16.53c2.88,0,5.83,0,8.9-0.08l-0.11-7.59H1080.95z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st6",
                  attrs: {
                    d: "M1086.55,1140.43c-75.99,1.19-88.962-13.23-89.116-13.35l-2.993,2.3l-3.109,2.19\n                c1.228,1.76,13.698,16.53,86.468,16.53c2.88,0,5.83,0,8.9-0.08l-0.11-7.59H1086.55z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st3",
                  attrs: {
                    d: "M1499.51,1255.16l9.94,18.03l-24.18,2.68l-13.59-20.71H1499.51z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st3",
                  attrs: {
                    d: "M1819.48,1082.29l35,10.36l6.1-20.44l21.53,5.67l-4.22,15.8l12.44,2.3l-1.08,14.15l-9.06-1.26l-4.22,11.58\n                l-26.98-6.75l-0.88,2.72l-36.42-9.47L1819.48,1082.29z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", { staticClass: "st8" }, [
                _c("path", {
                  staticClass: "st1",
                  attrs: {
                    d: "M1899.8,1127.69c-2.53,0-5.06-0.84-7.17-2.56c-4.88-3.95-5.61-11.13-1.61-16c0.3-0.38,7.4-9.08,22.75-25\n                c1.42-1.49,3.8-4.29,3.5-6.29c-0.31-2.07-3.11-8.05-22.76-19.25c-18.42-10.47-26.87-8.4-26.98-8.36\n                c0.54-0.15-4.61,1.34-4.61,1.34l-11.17-19.71c2.81-1.22,25.49-9.28,54,6.95c15.55,8.85,31.74,20.01,34.01,35.74\n                c1.26,8.82-1.96,17.33-9.6,25.3c-14.58,15.19-21.45,23.55-21.53,23.66C1906.37,1126.28,1903.11,1127.69,1899.8,1127.69z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st4",
                  attrs: {
                    d: "M1032.09,1239.19l-12.16,56.46l29.26,6.29l12.17-56.46L1032.09,1239.19z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st4",
                  attrs: {
                    d: "M1019.89,1277.6c0,8.09-6.57,14.61-14.63,14.61c-8.057,0-14.619-6.56-14.619-14.61\n                c0-8.06,6.562-14.62,14.619-14.62C1013.32,1262.98,1019.89,1269.54,1019.89,1277.6z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st1",
                  attrs: {
                    d: "M177.04,556.47c0,5.675-4.606,10.277-10.286,10.277c-5.68,0-10.285-4.602-10.285-10.277\n                c0-5.675,4.605-10.277,10.285-10.277C172.434,546.193,177.04,550.795,177.04,556.47z",
                  },
                }),
                _vm._v(" "),
                _c("path", {
                  staticClass: "st13",
                  attrs: {
                    d: "M166.754,567.432c-6.049,0-10.97-4.918-10.97-10.962s4.921-10.962,10.97-10.962\n                c6.049,0,10.971,4.917,10.971,10.962S172.803,567.432,166.754,567.432z M166.754,546.878c-5.293,0-9.6,4.303-9.6,9.592\n                s4.307,9.592,9.6,9.592c5.294,0,9.601-4.303,9.601-9.592S172.048,546.878,166.754,546.878z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st1",
                  attrs: {
                    d: "M726.053,903.247l-0.729,8.973c0,0,5.719,0.46,11.437,0.882c5.719,0.422,11.476,0.844,11.476,0.844\n                l0.614-8.974c0,0-5.719-0.422-11.399-0.843C731.734,903.668,726.053,903.247,726.053,903.247z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st1",
                  attrs: {
                    d: "M759.412,907.93l-3.626,8.241c0,0,5.253,2.306,10.519,4.576c5.265,2.27,10.567,4.552,10.567,4.552\n                l3.517-8.278c0,0-5.266-2.27-10.495-4.527C764.641,910.187,759.412,907.93,759.412,907.93z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st1",
                  attrs: {
                    d: "M692.126,900.294l-0.845,8.935c0,0,5.719,0.537,11.437,1.035c5.719,0.499,11.437,0.997,11.437,0.997\n                l0.768-8.935c0,0-5.719-0.498-11.399-0.997C697.844,900.792,692.126,900.294,692.126,900.294z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st1",
                  attrs: {
                    d: "M658.315,896.613l-1.151,8.896c0,0,5.719,0.767,11.437,1.381c2.878,0.307,5.719,0.613,7.868,0.844\n                c2.149,0.23,3.569,0.383,3.569,0.383l0.921-8.935c0,0-1.42-0.153-3.531-0.383c-2.111-0.231-4.951-0.537-7.791-0.844\n                C663.957,897.341,658.315,896.613,658.315,896.613z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st1",
                  attrs: {
                    d: "M625.425,890.17l-2.265,8.705c3.992,1.035,7.791,1.84,11.552,2.799c1.843,0.499,3.723,0.844,5.604,1.266\n                c1.88,0.383,3.761,0.652,5.603,0.997l1.458-8.859c-1.765-0.306-3.53-0.575-5.296-0.92c-1.727-0.383-3.492-0.729-5.181-1.189\n                c-3.915-0.997-7.829-1.802-11.475-2.761V890.17z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st1",
                  attrs: {
                    d: "M610.339,869.961l-9.019,0.345v0.23c0,0,0,0.422,0,0.729c0.039,0.652,0,1.572,0.154,2.761\n                c0.153,2.339,0.537,5.484,1.612,8.743c0.499,1.611,1.228,3.221,2.072,4.717c0.883,1.457,1.842,2.761,2.802,3.758\n                c0.959,0.997,1.842,1.726,2.456,2.186c0.307,0.23,0.576,0.422,0.729,0.537c0.192,0.115,0.269,0.192,0.269,0.192l4.989-7.478\n                c0,0-0.038,0-0.153-0.115c-0.115-0.077-0.269-0.154-0.422-0.307c-0.384-0.269-0.845-0.69-1.382-1.227s-1.036-1.227-1.535-2.071\n                c-0.461-0.844-0.96-1.802-1.267-2.953c-0.729-2.186-1.074-4.716-1.189-6.672c-0.116-0.959-0.077-1.841-0.116-2.416\n                c0-0.307,0-0.537,0-0.729c0-0.191,0-0.268,0-0.268V869.961z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st1",
                  attrs: {
                    d: "M609.379,834.758l-8.75,2.838c0,0,0.269,1.342,0.614,3.374c0.23,0.997,0.307,2.225,0.461,3.49\n                c0.076,0.652,0.153,1.304,0.23,1.994c0.077,0.69,0.153,1.342,0.153,2.032c0.077,2.761,0.231,5.523,0,7.593\n                c-0.115,2.071-0.192,3.452-0.192,3.452l9.019-1.189c0,0,0.077-1.496,0.192-3.72c0.192-2.224,0-5.177-0.076-8.168\n                c0-0.729-0.115-1.496-0.192-2.186c-0.077-0.728-0.154-1.457-0.231-2.147c-0.191-1.381-0.268-2.685-0.498-3.758\n                c-0.423-2.186-0.691-3.643-0.691-3.643L609.379,834.758z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st1",
                  attrs: {
                    d: "M595.488,802.508l-7.715,5.1c0,0,0.768,1.15,1.881,2.876c0.576,0.844,1.19,1.918,1.804,3.03\n                c0.614,1.15,1.382,2.3,1.919,3.566c0.614,1.227,1.228,2.492,1.765,3.643c0.499,1.189,0.96,2.301,1.344,3.259\n                c0.383,0.959,0.729,1.764,0.921,2.34c0.192,0.575,0.307,0.882,0.307,0.882l8.481-3.605c0,0-0.115-0.345-0.345-0.959\n                c-0.192-0.613-0.576-1.457-0.998-2.492c-0.422-1.036-0.921-2.224-1.458-3.528c-0.614-1.266-1.267-2.57-1.919-3.912\n                c-0.614-1.342-1.42-2.607-2.073-3.834c-0.691-1.228-1.305-2.34-1.957-3.26c-1.228-1.879-2.034-3.106-2.034-3.106H595.488z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st1",
                  attrs: {
                    d: "M569.354,779.346l-6.026,6.787c0,0,1.19,0.69,2.994,1.726c0.921,0.498,1.957,1.112,3.07,1.764\n                c0.576,0.307,1.151,0.652,1.727,0.997c0.576,0.383,1.113,0.767,1.689,1.189l0.844,0.575c0.269,0.23,0.537,0.422,0.806,0.652\n                c0.537,0.422,1.036,0.843,1.535,1.265c0.998,0.844,1.842,1.687,2.61,2.378c0.768,0.69,1.343,1.342,1.765,1.802\n                c0.423,0.46,0.653,0.69,0.653,0.69l7.215-5.752c0,0-0.268-0.268-0.691-0.767c-0.46-0.46-1.036-1.188-1.88-1.917\n                c-0.806-0.767-1.727-1.687-2.802-2.608c-0.537-0.46-1.074-0.92-1.65-1.38c-0.269-0.23-0.576-0.46-0.845-0.69l-0.921-0.652\n                c-0.614-0.422-1.228-0.844-1.803-1.266c-0.615-0.383-1.267-0.728-1.843-1.074c-1.189-0.69-2.341-1.342-3.3-1.879\n                c-1.919-1.112-3.224-1.84-3.224-1.84H569.354z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st1",
                  attrs: {
                    d: "M538.878,761.859l-4.413,7.823c0,0,1.266,0.691,3.109,1.726c1.919,1.074,4.26,2.416,6.678,3.796\n                c4.797,2.761,9.633,5.484,9.633,5.484l5.373-7.209c0,0-5.143-2.953-10.286-5.906c-2.571-1.457-5.181-2.991-7.023-4.026\n                c-1.881-1.036-3.147-1.764-3.147-1.764L538.878,761.859z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st1",
                  attrs: {
                    d: "M509.095,745.295l-4.38,7.833l20.002,11.166l4.38-7.834L509.095,745.295z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st1",
                  attrs: {
                    d: "M479.207,728.57l-4.363,7.843l20.026,11.124l4.363-7.843L479.207,728.57z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st1",
                  attrs: {
                    d: "M449.374,712.12l-4.358,7.846l20.033,11.11l4.358-7.846L449.374,712.12z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st1",
                  attrs: {
                    d: "M419.483,695.489l-4.35,7.851l20.045,11.088l4.35-7.85L419.483,695.489z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st1",
                  attrs: {
                    d: "M390.314,678.338l-4.759,7.632l14.507,9.05l5.296,2.914l4.376-7.861l-5.105-2.8L390.314,678.338z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st1",
                  attrs: {
                    d: "M361.186,660.43l-4.682,7.67l19.535,11.964l4.721-7.631L361.186,660.43z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st1",
                  attrs: {
                    d: "M331.902,642.791l-4.605,7.746c0,0,4.912,2.914,9.825,5.867c4.912,2.953,9.787,5.905,9.787,5.905\n                l4.643-7.669c0,0-4.912-2.953-9.825-5.944c-4.912-2.953-9.863-5.905-9.863-5.905H331.902z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st1",
                  attrs: {
                    d: "M302.043,625.764l-4.184,7.938c0,0,1.229,0.652,3.109,1.649c1.881,0.997,4.337,2.416,6.832,3.796\n                c4.95,2.838,9.901,5.676,9.901,5.676l4.529-7.747c0,0-4.989-2.876-9.978-5.752c-2.533-1.419-5.028-2.837-6.947-3.873\n                c-1.919-1.035-3.224-1.725-3.224-1.725L302.043,625.764z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st1",
                  attrs: {
                    d: "M271.571,610.425l-4.145,7.976c0,0,5.104,2.646,10.209,5.292c2.571,1.304,5.142,2.608,7.061,3.566\n                c1.958,0.959,3.263,1.611,3.263,1.611l3.914-8.091c0,0-1.266-0.614-3.147-1.573c-1.919-0.958-4.452-2.224-6.985-3.528\n                c-5.066-2.607-10.132-5.253-10.132-5.253H271.571z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st1",
                  attrs: {
                    d: "M241.44,594.434l-4.26,7.899c0,0,5.066,2.723,10.132,5.407c5.066,2.685,10.132,5.369,10.132,5.369\n                l4.222-7.938l-20.188-10.775L241.44,594.434z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st1",
                  attrs: {
                    d: "M211.543,578.098l-4.375,7.861c0,0,5.028,2.761,10.055,5.522c5.028,2.761,10.056,5.484,10.056,5.484\n                l4.298-7.9c0,0-5.028-2.722-10.055-5.483c-5.028-2.761-10.017-5.522-10.017-5.522L211.543,578.098z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st1",
                  attrs: {
                    d: "M181.992,561.302l-4.605,7.708c0,0,4.989,2.952,9.978,5.79c4.99,2.838,10.017,5.676,10.017,5.676\n                l4.414-7.823c0,0-4.951-2.8-9.94-5.637c-4.951-2.838-9.825-5.714-9.825-5.714H181.992z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st6",
                  attrs: {
                    d: "M1241.1,1389.65c-13.12,0-26.94-0.19-41.06-0.39c-22.8-0.3-46.4-0.65-68.24-0.15c-3.61,0-6.68-2.8-6.76-6.44\n                c-0.07-3.65,2.81-6.67,6.45-6.75c22.07-0.5,45.79-0.15,68.7,0.15c40.03,0.54,77.83,1.08,102.32-2.68\n                c62.37-9.59,256.22-52.62,284.89-71.06c6.83-4.41,13.66-9.01,20.88-13.88c24.79-16.76,50.43-34.05,79.13-44.49\n                c11.9-4.33,30.55-8.59,52.16-13.57c41.45-9.51,98.25-22.55,113.8-39.84c6.25-6.98,12.7-14.73,18.92-22.24\n                c18.84-22.75,38.34-46.25,59.33-55.8c3.3-1.53,7.22-0.04,8.75,3.26c1.5,3.3,0.04,7.21-3.26,8.74\n                c-18.23,8.29-36.73,30.6-54.65,52.19c-6.3,7.6-12.82,15.46-19.27,22.63c-18.34,20.4-72.69,32.86-120.66,43.87\n                c-21.19,4.87-39.46,9.05-50.63,13.11c-27.17,9.86-52.11,26.69-76.22,42.99c-7.29,4.95-14.2,9.59-21.14,14.07\n                c-31.74,20.4-226.52,63.24-290.03,72.98c-16.66,2.57-38.81,3.22-63.45,3.22L1241.1,1389.65z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st1",
                  attrs: {
                    d: "M1382.07,1289.79c-30.67,33.29-74.65,44.64-99.17,51c-4.34,1.11-8.1,2.07-11.06,2.99\n                c-8.82,2.73-31.04,7.37-54.57,12.31c-30.32,6.37-64.71,13.62-81.75,18.98c-25.37,8.02-42.87,3.72-61.41-0.8\n                c-2.11-0.5-4.22-1.04-6.37-1.53c-2.07-0.5-4.56-1.12-7.36-1.84c1.65-5.87,5.18-18.34,8.17-28.54\n                c4.18-14.26,16.92-81.64,19.8-103.19c0.2-1.42,0.35-3.03,0.5-4.72h-12.7c-0.12,1.08-0.23,2.08-0.35,3.03\n                c-2.76,20.67-15.43,87.78-19.42,101.32c-3.03,10.31-6.6,22.85-8.25,28.76c-28.28-8.05-70.155-21.36-80.172-26.5\n                c-1.574-0.8-3.493-1.61-5.642-2.45c1.497-3.8,4.145-10.51,8.636-21.82c7.292-18.49,18.191-82.37,23.449-113.09\n                c0.845-4.91,1.535-8.94,1.996-11.62c2.802-15.88,3.339-52.42,3.683-76.58c0.08-5.41,0.15-10.05,0.23-13.38\n                c0.35-14.34-0.536-43.57-0.881-55.03c4.871-0.96,8.061-2.3,9.521-2.99c7.21-2.04,17.46-8.78,24.48-14.04\n                c-1.99-3.68-4.07-7.28-6.98-10.58c-6.6,4.98-15.93,11.16-21.34,12.54c-0.54,0.11-1.11,0.38-1.57,0.65\n                c-0.2,0.11-18.657,9.89-56.691-7.02c-41.871-18.63-93.913-37.655-94.412-37.847c-0.231-0.077-0.422-0.153-0.653-0.192\n                c-2.111-0.536-52.426-12.616-118.553-5.407c-13.931,1.496-25.253,2.876-35.27,4.065c-36.038,4.295-48.166,5.752-70.963,1.304\n                c-8.674-1.687-17.386-3.835-26.559-6.136c-22.183-5.483-45.134-11.159-67.509-10.008c-24.447,1.265-47.398,11.197-49.931,74.621\n                c-1.842,46.06,8.751,100.4,101.129,154.51c17.348,10.16,30.128,17.6,39.799,23.2c19.625,11.4,33.403,20.19,41.335,26.38\n                c3.531,2.76,8.098,6.33,14.699,11.31l5.642,4.3c33.927,25.77,58.413,44.36,93.875,56.06c29.821,9.86,60.102,11.24,84.396,12.35\n                c6.179,0.27,11.974,0.53,17.347,0.92c26.06,1.84,68.468,10.93,81.057,17.33c14.584,7.44,81.902,27.88,102.622,32.75\n                c2.11,0.5,4.19,1,6.26,1.53c11.47,2.8,23.14,5.68,36.73,5.68c9.4,0,19.73-1.38,31.51-5.1c16.42-5.18,50.5-12.35,80.56-18.64\n                c24.87-5.21,46.32-9.74,55.68-12.61c2.69-0.85,6.34-1.77,10.52-2.84c26.37-6.83,74.03-19.18,107.27-56.87\n                c-3.72-2.42-6.91-5.33-10.71-6.98c-0.19,0.19-0.34,0.42-0.54,0.61L1382.07,1289.79z M959.207,1312.11\n                c-4.759,12.12-7.483,18.94-8.903,22.55c-20.265-5.79-49.318-10.97-68.239-12.31c-5.526-0.39-11.437-0.65-17.692-0.96\n                c-23.565-1.08-52.848-2.42-81.019-11.7c-33.466-11.04-57.261-29.1-90.191-54.14l-5.68-4.3c-6.524-4.95-11.053-8.47-14.545-11.2\n                c-12.55-9.78-13.126-10.12-42.755-27.34c-9.671-5.6-22.413-13.04-39.761-23.16c-86.66-50.73-96.6-100.82-94.911-143.11\n                c2.034-50.737,15.467-61.321,37.957-62.51c20.533-1.074,42.524,4.372,63.824,9.625c8.943,2.224,18.192,4.487,27.173,6.251\n                c24.754,4.834,38.417,3.224,74.916-1.15c9.978-1.189,21.262-2.531,35.155-4.027c61.1-6.672,109.496,4.026,113.871,5.062\n                c4.605,1.689,53.577,19.789,93.261,37.429c19.036,8.47,34.081,10.97,45.134,11c0.384,11.85,1.19,40.08,0.883,53.61\n                c-0.077,3.42-0.154,8.06-0.23,13.54c-0.307,22.32-0.845,59.67-3.493,74.55c-0.499,2.72-1.151,6.75-2.034,11.69\n                C977.169,1229.43,966.001,1294.81,959.207,1312.11z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st1",
                  attrs: {
                    d: "M385.862,358.596l-3.608-2.224l11.437-18.522l3.608,2.225L385.862,358.596z M401.06,339.653l-0.192,0.268\n                l-2.84-1.725l-0.384-2.608l-2.495,0.805l-2.763-1.687l0.192-0.307l5.028-1.035l2.034,1.265l1.381,5.062L401.06,339.653z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st1",
                  attrs: {
                    d: "M394.267,359.824l6.755,4.179l-1.766,2.877l-10.401-6.405l11.437-18.521l3.608,2.224l-9.671,15.607\n                L394.267,359.824z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st1",
                  attrs: {
                    d: "M415.912,365.959l-6.217-3.835l-3.224,5.254l7.33,4.525l-1.765,2.876l-10.938-6.749l11.437-18.522\n                l10.899,6.749l-1.765,2.876l-7.292-4.487l-2.84,4.602l6.217,3.835l-1.765,2.876H415.912z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st1",
                  attrs: {
                    d: "M430.803,379.688c0.46-0.729,0.614-1.419,0.499-2.071s-0.499-1.457-1.19-2.454\n                c-1.497-1.841-2.495-3.528-2.917-4.947c-0.422-1.457-0.192-2.953,0.768-4.487c0.921-1.534,2.264-2.416,3.991-2.684\n                c1.727-0.269,3.416,0.153,5.181,1.227c1.766,1.074,2.879,2.493,3.301,4.257c0.461,1.764,0.154,3.413-0.883,5.023l-0.076,0.077\n                l-3.493-2.186c0.537-0.844,0.729-1.649,0.653-2.454c-0.116-0.806-0.538-1.419-1.305-1.879c-0.73-0.46-1.42-0.575-2.073-0.384\n                c-0.691,0.192-1.228,0.614-1.612,1.266c-0.384,0.613-0.46,1.265-0.268,1.917c0.191,0.652,0.729,1.572,1.535,2.761\n                c1.381,1.687,2.226,3.26,2.571,4.717c0.307,1.457,0,2.953-0.959,4.525c-0.998,1.61-2.303,2.531-3.915,2.761\n                s-3.339-0.192-5.104-1.266c-1.766-1.073-2.956-2.531-3.646-4.371c-0.653-1.841-0.384-3.682,0.844-5.599l0.077-0.077l3.531,2.186\n                c-0.691,1.151-0.96,2.109-0.806,2.915c0.191,0.805,0.767,1.495,1.727,2.109c0.767,0.46,1.458,0.613,2.072,0.422\n                c0.614-0.192,1.151-0.614,1.574-1.304H430.803z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st1",
                  attrs: {
                    d: "M444.466,389.351l-4.874-3.029l-3.454,3.336l-3.646-2.263l16.657-15.3l3.761,2.339l-6.256,21.705\n                l-3.646-2.263l1.458-4.563V389.351z M442.087,383.906l3.416,2.109l2.379-7.593h-0.077L442.087,383.906z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st1",
                  attrs: {
                    d: "M451.912,399.398l-3.607-2.224l11.437-18.522l3.607,2.225L451.912,399.398z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st1",
                  attrs: {
                    d: "M467.879,409.254l-3.608-2.224l1.651-15.339h-0.077l-7.292,11.772l-3.608-2.224l11.437-18.522l3.608,2.224\n                l-1.65,15.301h0.076l7.292-11.773l3.608,2.225l-11.437,18.521V409.254z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st1",
                  attrs: {
                    d: "M490.904,401.891l-4.183-2.569l-9.672,15.607l-3.608-2.224l9.672-15.607l-4.145-2.57l1.765-2.876\n                l11.936,7.363L490.904,401.891z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st1",
                  attrs: {
                    d: "M490.52,414.239l-6.332-3.912l1.765-2.876l6.333,3.912L490.52,414.239z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st1",
                  attrs: {
                    d: "M504.838,423.864v0.115c-1.267,2.032-2.687,3.298-4.299,3.72s-3.377,0.038-5.296-1.151\n                c-1.919-1.188-3.071-2.722-3.493-4.601s0-3.912,1.382-6.059l3.416-5.522c1.343-2.148,2.917-3.452,4.759-3.95\n                c1.842-0.499,3.684-0.192,5.526,0.959c1.958,1.227,3.147,2.646,3.493,4.333c0.345,1.687-0.077,3.566-1.343,5.637h-0.077\n                l-3.493-2.109c0.806-1.189,1.19-2.148,1.113-2.953c-0.038-0.767-0.537-1.457-1.497-2.032c-0.805-0.499-1.611-0.576-2.456-0.192\n                c-0.844,0.383-1.65,1.189-2.418,2.492l-3.454,5.561c-0.806,1.304-1.19,2.416-1.113,3.336c0.077,0.92,0.538,1.649,1.459,2.224\n                c0.882,0.537,1.65,0.652,2.302,0.384c0.653-0.307,1.344-1.074,2.073-2.301l3.492,2.147L504.838,423.864z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st1",
                  attrs: {
                    d: "M516.39,439.203l-3.608-2.224l4.759-7.67l-5.756-3.566l-4.759,7.67l-3.608-2.225l11.437-18.521l3.608,2.224\n                l-4.913,7.976l5.757,3.566l4.912-7.976l3.608,2.224L516.39,439.203z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st1",
                  attrs: {
                    d: "M527.366,435.828l-4.567,7.363l-3.608-2.224l11.437-18.484l6.026,3.72c1.842,1.112,2.955,2.493,3.416,4.103\n                c0.46,1.611,0.153,3.26-0.921,4.985c-0.615,0.959-1.344,1.649-2.188,2.11c-0.844,0.421-1.842,0.613-2.917,0.498\n                c0.768,0.92,1.113,1.879,1.075,2.876c0,0.997-0.422,2.071-1.113,3.183l-0.806,1.304c-0.307,0.498-0.614,1.074-0.845,1.764\n                c-0.23,0.652-0.307,1.189-0.153,1.649l-0.154,0.268l-3.722-2.301c-0.116-0.46-0.039-0.997,0.268-1.687\n                c0.307-0.69,0.653-1.304,1.037-1.956l0.767-1.265c0.576-0.92,0.806-1.764,0.768-2.493c-0.077-0.728-0.461-1.342-1.152-1.764\n                l-2.609-1.61L527.366,435.828z M529.132,432.952l2.417,1.496c0.73,0.46,1.421,0.575,2.111,0.345\n                c0.691-0.23,1.228-0.729,1.766-1.572c0.537-0.844,0.767-1.649,0.691-2.378c-0.077-0.728-0.461-1.342-1.19-1.764l-2.418-1.495\n                l-3.301,5.368H529.132z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st1",
                  attrs: {
                    d: "M537.768,452.394l-3.608-2.224l11.437-18.522l3.608,2.225L537.768,452.394z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st1",
                  attrs: {
                    d: "M551.966,454.504c0.461-0.729,0.614-1.419,0.499-2.071c-0.115-0.652-0.499-1.457-1.19-2.454\n                c-1.496-1.841-2.494-3.528-2.916-4.947c-0.423-1.457-0.192-2.953,0.767-4.487c0.921-1.534,2.265-2.416,3.953-2.684\n                c1.727-0.269,3.416,0.153,5.181,1.227c1.766,1.074,2.879,2.493,3.301,4.257c0.461,1.725,0.154,3.412-0.883,5.023l-0.076,0.077\n                l-3.493-2.186c0.537-0.844,0.729-1.649,0.653-2.454c-0.116-0.806-0.538-1.419-1.305-1.879c-0.73-0.461-1.42-0.576-2.073-0.384\n                c-0.691,0.192-1.228,0.614-1.612,1.266c-0.384,0.613-0.46,1.265-0.268,1.917c0.191,0.652,0.729,1.572,1.535,2.761\n                c1.381,1.687,2.226,3.26,2.571,4.717c0.307,1.457,0,2.953-0.959,4.525c-0.998,1.61-2.303,2.531-3.915,2.761\n                c-1.612,0.23-3.339-0.192-5.104-1.266c-1.766-1.073-2.956-2.531-3.646-4.371c-0.653-1.841-0.384-3.682,0.844-5.599l0.077-0.077\n                l3.531,2.186c-0.691,1.151-0.96,2.109-0.806,2.915c0.191,0.805,0.729,1.495,1.727,2.109c0.767,0.46,1.458,0.613,2.072,0.421\n                c0.614-0.191,1.152-0.613,1.574-1.303H551.966z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st1",
                  attrs: {
                    d: "M575.455,454.082l-4.184-2.569L561.6,467.12l-3.608-2.224l9.672-15.607l-4.145-2.57l1.765-2.876\n                l11.936,7.363L575.455,454.082z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st1",
                  attrs: {
                    d: "M583.744,471.607c-1.343,2.186-2.993,3.49-4.912,3.988c-1.919,0.499-3.877,0.115-5.834-1.074\n                c-1.957-1.227-3.147-2.799-3.569-4.716c-0.422-1.956,0.038-3.989,1.381-6.174l3.224-5.177c1.344-2.148,2.955-3.49,4.913-3.988\n                c1.919-0.499,3.876-0.154,5.833,1.035c1.958,1.189,3.148,2.799,3.57,4.755c0.422,1.956,0,4.027-1.382,6.174L583.744,471.607z\n                M583.36,464.167c0.806-1.342,1.19-2.492,1.113-3.451c-0.076-0.997-0.575-1.764-1.535-2.339c-0.959-0.575-1.88-0.69-2.763-0.307\n                c-0.883,0.384-1.765,1.227-2.571,2.57l-3.224,5.215c-0.845,1.342-1.228,2.492-1.152,3.451c0.077,0.959,0.576,1.764,1.497,2.339\n                c0.921,0.575,1.842,0.691,2.763,0.307c0.922-0.383,1.766-1.227,2.61-2.569l3.224-5.216H583.36z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st1",
                  attrs: {
                    d: "M589.73,475.326l-4.107,6.634l-3.607-2.224l11.437-18.522l6.447,3.989c1.843,1.15,2.956,2.607,3.378,4.333\n                c0.383,1.764,0.038,3.528-1.037,5.292c-1.113,1.764-2.533,2.876-4.26,3.298c-1.765,0.421-3.53,0.076-5.373-1.074l-2.801-1.726\n                H589.73z M591.495,472.45l2.802,1.726c0.768,0.46,1.535,0.575,2.303,0.23c0.767-0.307,1.42-0.92,1.957-1.802\n                c0.537-0.882,0.806-1.726,0.768-2.57c-0.039-0.843-0.461-1.495-1.229-1.955l-2.801-1.726l-3.761,6.097H591.495z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st1",
                  attrs: {
                    d: "M609.726,496.839l-3.608-2.224l4.759-7.669l-5.756-3.567l-4.759,7.67l-3.608-2.224l11.437-18.522\n                l3.608,2.224l-4.913,7.976l5.757,3.567l4.912-7.977l3.608,2.224L609.726,496.839z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st1",
                  attrs: {
                    d: "M627.381,496.533l-6.218-3.835l-3.224,5.253l7.331,4.525l-1.766,2.877l-10.938-6.75l11.437-18.521\n                l10.9,6.749l-1.765,2.876l-7.292-4.487l-2.84,4.602l6.217,3.835l-1.804,2.876H627.381z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st1",
                  attrs: {
                    d: "M1173.09,766.422l-3.95-1.495l7.68-20.363l3.95,1.496L1173.09,766.422z M1184.38,744.909l-0.12,0.307\n                l-3.11-1.189l-0.88-2.492l-2.26,1.265l-3.04-1.15l0.12-0.345l4.76-1.994l2.22,0.843l2.31,4.717V744.909z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st1",
                  attrs: {
                    d: "M1181.58,766l7.44,2.8l-1.19,3.183l-11.44-4.295l7.68-20.363l3.99,1.496L1181.58,766z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st1",
                  attrs: {
                    d: "M1204.03,767.88l-6.83-2.57l-2.19,5.752l8.06,3.03l-1.19,3.183l-12.05-4.525l7.67-20.363l12.02,4.525\n                l-1.19,3.183l-8.02-3.029l-1.92,5.061l6.83,2.57L1204.03,767.88z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st1",
                  attrs: {
                    d: "M1210.21,780.419l7.67-20.362l5.99,2.262c2.11,0.805,3.57,1.879,4.37,3.26c0.85,1.38,0.89,2.991,0.2,4.831\n                c-0.35,0.959-0.92,1.764-1.62,2.34c-0.69,0.575-1.57,0.92-2.57,0.958c0.96,0.652,1.58,1.496,1.77,2.531\n                c0.19,1.036,0.08,2.109-0.35,3.26c-0.73,1.956-1.84,3.221-3.34,3.796c-1.49,0.575-3.3,0.499-5.37-0.307l-6.79-2.569H1210.21z\n                M1217.58,772.941l-2.19,5.791l2.8,1.074c0.84,0.306,1.57,0.306,2.15,0c0.57-0.307,1.07-0.921,1.42-1.841\n                c0.38-0.959,0.46-1.764,0.31-2.454c-0.16-0.652-0.62-1.112-1.42-1.419L1217.58,772.941z M1218.61,770.142l2.19,0.844\n                c0.8,0.268,1.53,0.268,2.15,0c0.61-0.307,1.07-0.844,1.38-1.726c0.35-0.959,0.38-1.726,0.12-2.339\n                c-0.27-0.614-0.89-1.074-1.77-1.419l-2.03-0.767L1218.61,770.142z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st1",
                  attrs: {
                    d: "M1231.27,784.752l7.45,2.8l-1.19,3.183l-11.44-4.295l7.68-20.363l3.99,1.496L1231.27,784.752z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st1",
                  attrs: {
                    d: "M1255.07,789.009c-0.92,2.378-2.26,3.988-4.07,4.87c-1.8,0.844-3.8,0.882-5.94,0.077\n                c-2.15-0.805-3.61-2.148-4.42-3.95c-0.77-1.841-0.73-3.95,0.19-6.327l2.15-5.714c0.89-2.378,2.23-3.988,4.03-4.87\n                c1.81-0.882,3.76-0.882,5.91-0.077c2.15,0.805,3.61,2.148,4.42,3.988c0.8,1.841,0.73,3.95-0.16,6.328l-2.15,5.713\n                L1255.07,789.009z M1253.27,781.761c0.54-1.457,0.69-2.646,0.42-3.604c-0.27-0.959-0.92-1.611-1.96-1.994\n                c-1.03-0.384-1.95-0.307-2.76,0.23c-0.81,0.537-1.5,1.534-2.03,3.029l-2.19,5.752c-0.58,1.457-0.73,2.685-0.46,3.605\n                s0.88,1.61,1.92,1.994c1.03,0.383,1.95,0.307,2.76-0.23c0.81-0.537,1.5-1.534,2.07-3.03l2.19-5.752H1253.27z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st1",
                  attrs: {
                    d: "M1269.16,802.66l-3.96-1.495l-1.3-15.378h-0.08l-4.91,13l-3.99-1.495l7.67-20.363l4,1.496l1.3,15.339h0.12\n                l4.91-12.962l3.95,1.496l-7.67,20.362H1269.16z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st1",
                  attrs: {
                    d: "M1280.4,800.935l-0.15,0.844h0.08l0.42-0.652l9.13-13.92l4.19,1.572l-13.4,18.215l-4.14-1.572l1.99-22.51\n                l4.19,1.572l-2.34,16.413L1280.4,800.935z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st1",
                  attrs: {
                    d: "M1292.26,811.365l-3.95-1.495l7.67-20.363l3.96,1.496L1292.26,811.365z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st1",
                  attrs: {
                    d: "M1300.74,810.944l7.45,2.799l-1.19,3.183l-11.44-4.295l7.68-20.362l3.99,1.495L1300.74,810.944z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st1",
                  attrs: {
                    d: "M1314.14,816.006l7.44,2.799l-1.19,3.183l-11.43-4.295l7.67-20.362l3.99,1.495L1314.14,816.006z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st1",
                  attrs: {
                    d: "M1336.59,817.885l-6.83-2.57l-2.19,5.752l8.06,3.03l-1.19,3.183l-12.05-4.525l7.67-20.363l12.02,4.525\n                l-1.19,3.183l-8.03-3.03l-1.91,5.062l6.83,2.57L1336.59,817.885z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st6",
                  attrs: {
                    d: "M1795.49,1033.94c-0.34,0-0.65,0-1-0.08c-4.1-0.62-8.44-1.31-13.05-2.03c-27.51-4.3-65.2-10.17-114.48-14.54\n                c-55.15-4.87-255.68-8.93-326.18-9.74c-14.78-0.15-35.43-0.23-58.61-0.3c-76.83-0.27-172.44-0.58-190.9-4.41\n                c-7.79-1.62-18.53-4.146-30.97-7.099c-26.1-6.136-58.57-13.805-90.344-19.519c-61.867-11.082-107.538-17.218-128.608-17.218\n                c-28.401,0-54.921-22.395-56.034-23.354c-2.763-2.377-3.109-6.519-0.729-9.28c2.379-2.761,6.524-3.106,9.288-0.728\n                c0.23,0.191,24.025,20.209,47.475,20.209c27.94,0,86.621,9.472,130.949,17.41c32.123,5.752,66.163,13.766,91.033,19.634\n                c12.36,2.914,23.03,5.407,30.63,7.017c17.15,3.567,120.13,3.912,188.29,4.142c23.22,0.076,43.86,0.153,58.68,0.307\n                c70.65,0.805,271.68,4.87,327.18,9.779c49.7,4.41,87.66,10.31,115.37,14.65c4.6,0.73,8.94,1.38,13.01,2.03\n                c3.61,0.54,6.06,3.91,5.53,7.52C1801.52,1031.6,1798.72,1033.94,1795.49,1033.94z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st1",
                  attrs: {
                    d: "M1862.88,1038.23c-3.3-4.33-8.67-6.4-13.51-7.36c-8.55-2.57-37.45-7.6-57.26-10.93\n                c-1.95,4.45-4.3,8.43-5.75,13.04c16.61,6.02,18.61,15.72,21.64,23.04l0.54,1.31c1,2.41,2.26,4.56,3.57,6.44\n                c-24.18,33.9-61.49,85.55-75.92,102.43c-19.42,22.7-69.5,18.06-72.72,17.75c-3.23-0.54-43.83-7.48-76.46-12.31\n                c-32.31-4.79-66.81-14.26-69.27-14.95l-93.49-30.95c-1.11-0.35-110.65-35.82-133.83-42.99c-5.45-1.69-11.63-3.99-18.15-6.4\n                c-21.46-7.9-48.05-17.76-76.49-17.3c-32.97,0.62-66.44-6.09-69.78-6.75c-3.53-1.07-40.79-12.8-63.74-26.76\n                c-21.23-12.89-20.11-34.938-20.08-35.858c0-0.307,0-0.614,0-0.92l-1.91-24.543c-0.2-2.416-19.46-241.436-20.38-257.005\n                c-0.96-15.837-5.42-29.988-14.4-45.864c-8.363-14.725-26.977-25.692-28.972-26.843l-39.992-25.233l-142.002-88.007\n                c-1.229-0.767-123.313-79.111-282.125-177.818c-30.473-21.819-223.52-160.561-259.367-191.469\n                c-37.88-32.634-68.276-86.934-68.698-91.497h-12.627c0.96,10.392,36.268,68.949,73.381,100.931\n                c36.959,31.866,231.618,171.682,260.863,192.658l-0.154,0.23c1.113,0.69,2.226,1.38,3.301,2.07\n                c0.077,0.039,0.154,0.116,0.192,0.154c157.009,97.633,277.251,174.75,278.517,175.555l142.042,88.008l40.067,25.27\n                c0,0,0.154,0.115,0.269,0.154c0.192,0.115,17.424,9.97,24.332,22.165c8.023,14.073,11.933,26.536,12.783,40.341\n                c0.96,15.723,19.61,247.419,20.42,257.274l1.88,24.159c-0.08,2.454-0.12,12.308,4.83,23.278c-2.53,2.18-4.3,3.8-8.1,6.67\n                c2.92,3.3,4.99,6.9,6.99,10.59c3.72-2.77,5.33-4.22,7.75-6.29c3.65,4.56,8.37,8.97,14.62,12.77c3.57,2.14,7.41,4.25,11.4,6.28\n                c0.31,8.71,1.27,30.57,3.61,50.05c2.76,22.93,4.8,51.23,5.03,70.4c0,0.08,0,0.16,0,0.27c0,0.5,2.53,48.86,0.38,70.98h12.7\n                c2-23.23-0.26-68.14-0.46-71.51c-0.23-19.56-2.3-48.36-5.1-71.64c-1.8-15.03-2.8-31.98-3.26-42.49\n                c20.88,9.13,41.37,15.46,42.56,15.8c0.19,0.04,0.35,0.12,0.54,0.12c1.49,0.3,36.84,7.74,72.88,7.09\n                c25.91-0.5,51.43,8.94,71.88,16.49c6.68,2.46,13.01,4.8,18.81,6.6c23.1,7.17,132.6,42.6,133.64,42.95l5.56,1.84\n                c0,0.53,0,0.99-0.04,1.57c-0.96,28.68-3.18,95.91-36.07,139.39c-2.27,2.99-4.69,5.83-7.14,8.55c3.8,1.65,6.98,4.57,10.7,6.98\n                c1.46-1.65,2.92-3.37,4.34-5.1l19.15,11.09l38,20.28c4.37,2.19,10.78,4.26,17.23,4.26c6.79,0,13.59-2.3,18.08-9.2\n                c4.33-6.68,5.52-13.31,3.49-19.75c-3.07-9.9-13.63-18.41-32.24-26.08c-20.88-8.59-34.69-19.25-40.07-23.78\n                c14.43-39,16.28-81.37,17.04-104.07l75.53,25c0,0,0.2,0.04,0.27,0.08c0.39,0.11,36.85,10.28,71,15.34\n                c33.7,4.98,75.96,12.23,76.38,12.31c0.11,0,0.23,0,0.34,0.04c0.77,0.07,6.76,0.72,15.47,0.72c19.31,0,51.7-3.18,68.47-22.81\n                c14.66-17.14,51.12-67.61,75.41-101.62c1.88,1.3,3.38,2.11,4.07,2.41c11.82,6.87,23.22,5.64,31.24-3.41\n                c8.37-9.43,11.59-26.69,6.3-33.59L1862.88,1038.23z M1456.6,1283.31c18.31,7.52,23.68,14.03,24.99,18.14\n                c0.53,1.72,0.92,4.56-2.04,9.12c-4.72,7.29-18.88,0.62-18.92,0.62l-37.65-20.13l-17.88-10.32c4.3-6.56,8.02-13.5,11.24-20.63\n                C1423.71,1265.94,1437.34,1275.37,1456.6,1283.31z M1820.24,1052.5l-0.53-1.27c-1.73-4.18-4.03-9.7-8.48-15.19\n                c6.6,1.19,12.85,2.34,18.26,3.38C1827.11,1042.76,1823.97,1047.2,1820.24,1052.5z M1845.77,1064.8c-2.34,2-6.37,4.11-14.24-0.53\n                c-0.19-0.12-0.42-0.23-0.62-0.31c0,0-0.96-0.46-2.3-1.38c6.41-9.05,11.4-16.07,14.01-19.79c1.42,0.08,2.95,0.27,4.37,0.58\n                c0,0,0.08,0,0.12,0c2.38,0.5,4.49,1.26,5.49,2.34C1853.4,1048.51,1851.91,1059.55,1845.77,1064.8z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st3",
                  attrs: {
                    d: "M984.116,1303.96l-7.612,28.89l63.616,16.73l7.61-28.89L984.116,1303.96z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st1",
                  attrs: {
                    d: "M795.687,984.451c-0.151-0.38-15.203-38.157-22.918-51.507l2.979-1.721\n                c7.841,13.565,22.516,50.395,23.136,51.956L795.687,984.451z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("defs", [
                  _c("rect", {
                    attrs: {
                      id: "SVGID_4_",
                      x: "1295",
                      y: "1434.06",
                      width: "390",
                      height: "29.979",
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("clipPath", { attrs: { id: "SVGID_6_" } }, [
                  _c("use", {
                    staticStyle: { overflow: "visible" },
                    attrs: { "xlink:href": "#SVGID_4_" },
                  }),
                ]),
                _vm._v(" "),
                _c("g", { staticClass: "st15" }, [
                  _c("g", [
                    _c("path", {
                      staticClass: "st1",
                      attrs: {
                        d: "M1310.37,1451.54h-9.76v12.1H1295v-29.18h17.11v4.53h-11.5v7.94h9.76v4.53V1451.54z",
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("g", [
                    _c("path", {
                      staticClass: "st1",
                      attrs: {
                        d: "M1320.69,1459.07h10.51v4.53h-16.12v-29.14h5.61V1459.07z",
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("g", [
                    _c("path", {
                      staticClass: "st1",
                      attrs: {
                        d: "M1349.26,1450.86h-9.64v8.25h11.34v4.53h-16.99v-29.18h16.95v4.53h-11.3v7.26h9.64v4.53V1450.86z",
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("g", [
                    _c("path", {
                      staticClass: "st1",
                      attrs: {
                        d: "M1373.09,1434.46v19.84c0,3.13-0.9,5.53-2.68,7.22c-1.82,1.68-4.15,2.52-7.08,2.52\n                        c-2.92,0-5.25-0.84-7.07-2.52c-1.78-1.69-2.69-4.09-2.69-7.18v-19.88h5.61v19.84c0,1.77,0.36,3.09,1.07,3.93\n                        s1.74,1.24,3.04,1.24c1.31,0,2.37-0.4,3.09-1.2c0.71-0.8,1.06-2.12,1.06-3.97v-19.84h5.57H1373.09z",
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("g", [
                    _c("path", {
                      staticClass: "st1",
                      attrs: {
                        d: "M1385.78,1456.19l0.24,1.12h0.12l0.24-1.08l4.74-21.77h5.89l-8.03,29.14h-5.85l-8.02-29.14h5.89\n                        l4.74,21.73H1385.78z",
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("g", [
                    _c("path", {
                      staticClass: "st1",
                      attrs: {
                        d: "M1414.67,1450.86h-9.64v8.25h11.34v4.53h-16.99v-29.18h16.95v4.53h-11.3v7.26h9.64v4.53V1450.86z",
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("g", [
                    _c("path", {
                      staticClass: "st1",
                      attrs: {
                        d: "M1440.95,1456.03c0-1.13-0.27-2.05-0.87-2.69c-0.59-0.64-1.58-1.32-3.04-1.96c-3-1.04-5.22-2.25-6.72-3.61\n                        c-1.5-1.32-2.25-3.21-2.25-5.65c0-2.45,0.87-4.33,2.61-5.85c1.74-1.49,3.95-2.25,6.64-2.25c2.69,0,4.98,0.84,6.68,2.53\n                        c1.7,1.68,2.53,3.77,2.49,6.33v0.12h-5.5c0-1.32-0.31-2.4-0.98-3.25c-0.68-0.84-1.59-1.24-2.81-1.24\n                        c-1.11,0-1.98,0.32-2.61,1.04c-0.63,0.73-0.95,1.57-0.95,2.61c0,0.96,0.36,1.76,1.03,2.36c0.71,0.6,1.9,1.33,3.64,2.09\n                        c2.72,0.92,4.78,2.12,6.16,3.57c1.38,1.44,2.06,3.36,2.06,5.81c0,2.44-0.83,4.49-2.49,5.93c-1.66,1.44-3.88,2.12-6.6,2.12\n                        c-2.73,0-5.1-0.8-7.12-2.44c-2.01-1.65-2.96-3.97-2.92-6.98v-0.12h5.49c0,1.81,0.4,3.09,1.15,3.89c0.75,0.8,1.89,1.16,3.4,1.16\n                        c1.18,0,2.05-0.32,2.64-0.96c0.56-0.64,0.87-1.52,0.87-2.6V1456.03z",
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("g", [
                    _c("path", {
                      staticClass: "st1",
                      attrs: {
                        d: "M1462.97,1457.39h-7.59l-1.54,6.21h-5.65l8.1-29.14h5.85l8.06,29.14h-5.65l-1.54-6.21H1462.97z\n                        M1456.52,1452.86h5.3l-2.61-10.3h-0.12L1456.52,1452.86z",
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("g", [
                    _c("path", {
                      staticClass: "st1",
                      attrs: {
                        d: "M1478.34,1463.64h-5.57v-29.18h5.57v29.14V1463.64z",
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("g", [
                    _c("path", {
                      staticClass: "st1",
                      attrs: {
                        d: "M1503.12,1463.64h-5.57l-8.77-18.64h-0.12v18.64h-5.62v-29.18h5.62l8.77,18.64h0.12v-18.64h5.57v29.14\n                        V1463.64z",
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("g", [
                    _c("path", {
                      staticClass: "st1",
                      attrs: {
                        d: "M1523.83,1439.03h-6.48v24.61h-5.61v-24.61h-6.45v-4.57h18.54v4.53V1439.03z",
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("g", [
                    _c("path", {
                      staticClass: "st1",
                      attrs: { d: "M1531.97,1453.38h-9.8v-4.53h9.8V1453.38z" },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("g", [
                    _c("path", {
                      staticClass: "st1",
                      attrs: {
                        d: "M1542.37,1459.07h10.51v4.53h-16.13v-29.14h5.62V1459.07z",
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("g", [
                    _c("path", {
                      staticClass: "st1",
                      attrs: {
                        d: "M1568.96,1457.39h-7.58l-1.54,6.21h-5.66l8.11-29.14h5.84l8.07,29.14h-5.65l-1.55-6.21H1568.96z\n                        M1562.52,1452.86h5.3l-2.61-10.3h-0.12L1562.52,1452.86z",
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("g", [
                    _c("path", {
                      staticClass: "st1",
                      attrs: {
                        d: "M1597.26,1434.46v19.84c0,3.13-0.91,5.53-2.69,7.22c-1.81,1.68-4.15,2.52-7.07,2.52s-5.26-0.84-7.07-2.52\n                        c-1.78-1.69-2.69-4.09-2.69-7.18v-19.88h5.61v19.84c0,1.77,0.36,3.09,1.07,3.93c0.71,0.84,1.74,1.24,3.04,1.24\n                        c1.3,0,2.37-0.4,3.08-1.2c0.71-0.8,1.07-2.12,1.07-3.97v-19.84h5.57H1597.26z",
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("g", [
                    _c("path", {
                      staticClass: "st1",
                      attrs: {
                        d: "M1606.94,1452.06v11.58h-5.61v-29.14h9.37c2.84,0,5.06,0.77,6.68,2.29s2.41,3.61,2.41,6.33\n                        c0,1.52-0.32,2.85-0.99,3.93c-0.67,1.08-1.66,1.96-2.92,2.64c1.46,0.53,2.53,1.37,3.2,2.53c0.63,1.16,0.99,2.64,0.99,4.41v2.04\n                        c0,0.8,0.07,1.65,0.27,2.57c0.2,0.92,0.52,1.56,0.99,2v0.4h-5.81c-0.47-0.44-0.75-1.12-0.87-2.08\n                        c-0.12-0.96-0.16-1.93-0.16-2.93v-1.96c0-1.44-0.27-2.57-0.87-3.37c-0.59-0.8-1.42-1.2-2.53-1.2h-4.07L1606.94,1452.06z\n                        M1606.94,1447.53h3.76c1.14,0,2.01-0.36,2.61-1.04c0.59-0.72,0.87-1.73,0.87-3.01s-0.32-2.4-0.87-3.16\n                        c-0.6-0.81-1.47-1.17-2.57-1.17h-3.76v8.46L1606.94,1447.53z",
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("g", [
                    _c("path", {
                      staticClass: "st1",
                      attrs: {
                        d: "M1639.51,1450.86h-9.64v8.25h11.34v4.53h-17v-29.18h16.96v4.53h-11.3v7.26h9.64v4.53V1450.86z",
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("g", [
                    _c("path", {
                      staticClass: "st1",
                      attrs: {
                        d: "M1664.25,1463.64h-5.57l-8.78-18.64h-0.11v18.64h-5.62v-29.18h5.62l8.77,18.64h0.12v-18.64h5.57v29.14\n                        V1463.64z",
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("g", [
                    _c("path", {
                      staticClass: "st1",
                      attrs: {
                        d: "M1685,1439.03h-6.48v24.61h-5.61v-24.61h-6.45v-4.57H1685v4.53V1439.03z",
                      },
                    }),
                  ]),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("g", { attrs: { id: "preaux-list" } }, [
              _vm.attractions.includes(2214)
                ? _c("g", { attrs: { id: "pavillon-rosalie" } }, [
                    _c("g", [
                      _c("path", {
                        staticClass: "st16",
                        attrs: {
                          d: "M1140,1222L1140,1222c13.255,0,24,10.745,24,24l0,0c0,13.255-10.745,24-24,24l0,0\n                    c-13.255,0-24-10.745-24-24l0,0C1116,1232.745,1126.745,1222,1140,1222z",
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("g", [
                      _c("path", {
                        staticClass: "st1",
                        attrs: {
                          d: "M1146.77,1256.48c-0.276,0-0.5-0.224-0.5-0.5v-11.83c0-0.201,0.119-0.375,0.291-0.454l-6.5-6.831\n                    l-6.503,6.835c0.167,0.081,0.282,0.252,0.282,0.45v11.83c0,0.276-0.224,0.5-0.5,0.5s-0.5-0.224-0.5-0.5v-11.526l-5.167,5.431\n                    c-0.191,0.201-0.507,0.208-0.707,0.018s-0.208-0.507-0.018-0.707l12.75-13.4c0.189-0.199,0.535-0.199,0.725,0l12.75,13.4\n                    c0.19,0.2,0.183,0.517-0.018,0.707c-0.199,0.189-0.516,0.184-0.707-0.018l-5.179-5.443v11.539\n                    C1147.27,1256.257,1147.046,1256.48,1146.77,1256.48z",
                        },
                      }),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.attractions.includes(1602)
                ? _c("g", { attrs: { id: "preaux-1" } }, [
                    _c("g", { attrs: { id: "num_1_" } }, [
                      _c("g", [
                        _c("path", {
                          staticClass: "st10",
                          attrs: {
                            d: "M925.067,1175.714L925.067,1175.714c6.033,0,10.924,4.891,10.924,10.924l0,0\n                        c0,6.033-4.891,10.924-10.924,10.924l0,0c-6.033,0-10.924-4.891-10.924-10.924l0,0\n                        C914.143,1180.604,919.034,1175.714,925.067,1175.714z",
                          },
                        }),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("g", [
                      _c("path", {
                        staticClass: "st10",
                        attrs: {
                          d: "M906,1181L906,1181c13.255,0,24,10.745,24,24l0,0c0,13.255-10.745,24-24,24l0,0c-13.255,0-24-10.745-24-24\n                    l0,0C882,1191.745,892.745,1181,906,1181z",
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("g", [
                      _c("path", {
                        staticClass: "st1",
                        attrs: {
                          d: "M918.809,1209.04c-0.132,0-0.264-0.052-0.362-0.155l-12.388-13.02l-12.388,13.02\n                    c-0.189,0.201-0.507,0.208-0.707,0.018c-0.2-0.19-0.208-0.507-0.018-0.707l12.75-13.4c0.188-0.197,0.536-0.197,0.725,0\n                    l12.75,13.4c0.19,0.2,0.183,0.517-0.018,0.707C919.057,1208.994,918.933,1209.04,918.809,1209.04z",
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("g", [
                      _c("path", {
                        staticClass: "st1",
                        attrs: {
                          d: "M908.893,1215.48c-0.276,0-0.5-0.224-0.5-0.5v-6.591h-4.667v6.591c0,0.276-0.224,0.5-0.5,0.5\n                    s-0.5-0.224-0.5-0.5v-7.091c0-0.276,0.224-0.5,0.5-0.5h5.667c0.276,0,0.5,0.224,0.5,0.5v7.091\n                    C909.393,1215.257,909.169,1215.48,908.893,1215.48z",
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("g", [
                      _c("path", {
                        staticClass: "st1",
                        attrs: {
                          d: "M914.059,1214.98c0,0.27,0.223,0.5,0.5,0.5c0.276,0,0.5-0.23,0.5-0.5H914.059z M914.059,1203.64v11.34h1\n                    v-11.34H914.059z",
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("g", [
                      _c("path", {
                        staticClass: "st1",
                        attrs: {
                          d: "M897.059,1214.98c0,0.27,0.223,0.5,0.5,0.5c0.276,0,0.5-0.23,0.5-0.5H897.059z M897.059,1203.64v11.34h1\n                    v-11.34H897.059z",
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("g", [
                      _c("g", [
                        _c("path", {
                          staticClass: "st1",
                          attrs: {
                            d: "M924.819,1183.189h-0.024l-1.355,0.731l-0.204-0.803l1.703-0.912h0.9v7.796h-1.02V1183.189z",
                          },
                        }),
                      ]),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.attractions.includes(2051)
                ? _c("g", { attrs: { id: "preaux-2" } }, [
                    _c("g", [
                      _c("path", {
                        staticClass: "st10",
                        attrs: {
                          d: "M938.06,1236L938.06,1236c13.255,0,24,10.745,24,24l0,0c0,13.255-10.745,24-24,24l0,0\n                    c-13.255,0-24-10.745-24-24l0,0C914.06,1246.745,924.805,1236,938.06,1236z",
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("g", { attrs: { id: "num_2_" } }, [
                      _c("g", [
                        _c("path", {
                          staticClass: "st10",
                          attrs: {
                            d: "M955.87,1230.849L955.87,1230.849c6.033,0,10.924,4.891,10.924,10.924l0,0\n                        c0,6.033-4.891,10.924-10.924,10.924l0,0c-6.033,0-10.924-4.891-10.924-10.924l0,0\n                        C944.946,1235.74,949.837,1230.849,955.87,1230.849z",
                          },
                        }),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("g", [
                      _c("g", [
                        _c("path", {
                          staticClass: "st1",
                          attrs: {
                            d: "M953.332,1245.138v-0.647l0.828-0.804c1.991-1.895,2.891-2.902,2.902-4.078\n                        c0-0.791-0.384-1.522-1.547-1.522c-0.708,0-1.295,0.359-1.655,0.659l-0.336-0.743c0.54-0.456,1.308-0.792,2.207-0.792\n                        c1.679,0,2.387,1.151,2.387,2.267c0,1.439-1.043,2.603-2.687,4.186l-0.624,0.576v0.023h3.502v0.876H953.332z",
                          },
                        }),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("g", [
                      _c("path", {
                        staticClass: "st1",
                        attrs: {
                          d: "M950.869,1264.04c-0.132,0-0.264-0.052-0.362-0.155l-12.388-13.02l-12.388,13.02\n                    c-0.19,0.201-0.507,0.208-0.707,0.018s-0.208-0.507-0.018-0.707l12.75-13.4c0.188-0.197,0.536-0.197,0.725,0l12.75,13.4\n                    c0.19,0.2,0.183,0.517-0.018,0.707C951.117,1263.994,950.993,1264.04,950.869,1264.04z",
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("g", [
                      _c("path", {
                        staticClass: "st1",
                        attrs: {
                          d: "M940.953,1270.48c-0.276,0-0.5-0.224-0.5-0.5v-6.591h-4.667v6.591c0,0.276-0.224,0.5-0.5,0.5\n                    s-0.5-0.224-0.5-0.5v-7.091c0-0.276,0.224-0.5,0.5-0.5h5.667c0.276,0,0.5,0.224,0.5,0.5v7.091\n                    C941.453,1270.257,941.229,1270.48,940.953,1270.48z",
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("g", [
                      _c("path", {
                        staticClass: "st1",
                        attrs: {
                          d: "M946.119,1269.98c0,0.27,0.223,0.5,0.5,0.5c0.276,0,0.5-0.23,0.5-0.5H946.119z M946.119,1258.64v11.34h1\n                    v-11.34H946.119z",
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("g", [
                      _c("path", {
                        staticClass: "st1",
                        attrs: {
                          d: "M929.119,1269.98c0,0.27,0.223,0.5,0.5,0.5c0.276,0,0.5-0.23,0.5-0.5H929.119z M929.119,1258.64v11.34h1\n                    v-11.34H929.119z",
                        },
                      }),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.attractions.includes(2213)
                ? _c("g", { attrs: { id: "preaux-3" } }, [
                    _c("g", [
                      _c("path", {
                        staticClass: "st10",
                        attrs: {
                          d: "M1181.06,1301L1181.06,1301c13.255,0,24,10.745,24,24l0,0c0,13.255-10.745,24-24,24l0,0\n                    c-13.255,0-24-10.745-24-24l0,0C1157.06,1311.745,1167.805,1301,1181.06,1301z",
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("g", { attrs: { id: "num_3_" } }, [
                      _c("g", [
                        _c("path", {
                          staticClass: "st10",
                          attrs: {
                            d: "M1198.87,1295.849L1198.87,1295.849c6.033,0,10.924,4.891,10.924,10.924l0,0\n                        c0,6.033-4.891,10.924-10.924,10.924l0,0c-6.033,0-10.924-4.891-10.924-10.924l0,0\n                        C1187.946,1300.74,1192.837,1295.849,1198.87,1295.849z",
                          },
                        }),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("g", [
                      _c("g", [
                        _c("path", {
                          staticClass: "st1",
                          attrs: {
                            d: "M1196.584,1308.927c0.3,0.191,0.996,0.491,1.728,0.491c1.355,0,1.774-0.863,1.763-1.511\n                        c-0.012-1.092-0.995-1.56-2.015-1.56h-0.588v-0.791h0.588c0.768,0,1.739-0.396,1.739-1.319c0-0.624-0.396-1.176-1.367-1.176\n                        c-0.624,0-1.224,0.276-1.56,0.516l-0.275-0.768c0.407-0.3,1.199-0.6,2.038-0.6c1.535,0,2.231,0.911,2.231,1.859\n                        c0,0.804-0.48,1.487-1.439,1.835v0.023c0.959,0.192,1.739,0.912,1.739,2.003c0,1.247-0.972,2.339-2.843,2.339\n                        c-0.875,0-1.643-0.275-2.026-0.527L1196.584,1308.927z",
                          },
                        }),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("g", [
                      _c("path", {
                        staticClass: "st1",
                        attrs: {
                          d: "M1193.869,1329.04c-0.132,0-0.264-0.052-0.362-0.155l-12.388-13.02l-12.388,13.02\n                    c-0.191,0.202-0.508,0.207-0.707,0.018c-0.2-0.19-0.208-0.507-0.018-0.707l12.75-13.4c0.189-0.197,0.535-0.197,0.725,0\n                    l12.75,13.4c0.19,0.2,0.183,0.517-0.018,0.707C1194.117,1328.994,1193.993,1329.04,1193.869,1329.04z",
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("g", [
                      _c("path", {
                        staticClass: "st1",
                        attrs: {
                          d: "M1183.953,1335.48c-0.276,0-0.5-0.224-0.5-0.5v-6.591h-4.667v6.591c0,0.276-0.224,0.5-0.5,0.5\n                    s-0.5-0.224-0.5-0.5v-7.091c0-0.276,0.224-0.5,0.5-0.5h5.667c0.276,0,0.5,0.224,0.5,0.5v7.091\n                    C1184.453,1335.257,1184.229,1335.48,1183.953,1335.48z",
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("g", [
                      _c("path", {
                        staticClass: "st1",
                        attrs: {
                          d: "M1189.119,1334.98c0,0.27,0.223,0.5,0.5,0.5c0.276,0,0.5-0.23,0.5-0.5H1189.119z M1189.119,1323.64v11.34h1\n                    v-11.34H1189.119z",
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("g", [
                      _c("path", {
                        staticClass: "st1",
                        attrs: {
                          d: "M1172.119,1334.98c0,0.27,0.223,0.5,0.5,0.5c0.276,0,0.5-0.23,0.5-0.5H1172.119z M1172.119,1323.64v11.34h1\n                    v-11.34H1172.119z",
                        },
                      }),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.attractions.includes(2212)
                ? _c("g", { attrs: { id: "preaux-4" } }, [
                    _c("g", [
                      _c("path", {
                        staticClass: "st10",
                        attrs: {
                          d: "M1377,1331L1377,1331c13.255,0,24,10.745,24,24l0,0c0,13.255-10.745,24-24,24l0,0\n                    c-13.255,0-24-10.745-24-24l0,0C1353,1341.745,1363.745,1331,1377,1331z",
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("g", { attrs: { id: "num" } }, [
                      _c("g", [
                        _c("path", {
                          staticClass: "st10",
                          attrs: {
                            d: "M1394.81,1325.849L1394.81,1325.849c6.033,0,10.924,4.891,10.924,10.924l0,0\n                        c0,6.033-4.891,10.924-10.924,10.924l0,0c-6.033,0-10.924-4.891-10.924-10.924l0,0\n                        C1383.886,1330.74,1388.777,1325.849,1394.81,1325.849z",
                          },
                        }),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("g", [
                      _c("g", [
                        _c("path", {
                          staticClass: "st1",
                          attrs: {
                            d: "M1395.534,1340.138v-2.123h-3.622v-0.695l3.479-4.978h1.139v4.846h1.092v0.827h-1.092v2.123H1395.534z\n                        M1395.534,1337.188v-2.603c0-0.408,0.013-0.815,0.036-1.224h-0.036c-0.239,0.456-0.432,0.792-0.647,1.151l-1.907,2.65v0.024\n                        H1395.534z",
                          },
                        }),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("g", [
                      _c("path", {
                        staticClass: "st1",
                        attrs: {
                          d: "M1389.809,1359.04c-0.132,0-0.264-0.052-0.362-0.155l-12.388-13.02l-12.388,13.02\n                    c-0.19,0.202-0.507,0.207-0.707,0.018c-0.2-0.19-0.208-0.507-0.018-0.707l12.75-13.4c0.189-0.197,0.535-0.197,0.725,0\n                    l12.75,13.4c0.19,0.2,0.183,0.517-0.018,0.707C1390.057,1358.994,1389.933,1359.04,1389.809,1359.04z",
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("g", [
                      _c("path", {
                        staticClass: "st1",
                        attrs: {
                          d: "M1379.893,1365.48c-0.276,0-0.5-0.224-0.5-0.5v-6.591h-4.667v6.591c0,0.276-0.224,0.5-0.5,0.5\n                    s-0.5-0.224-0.5-0.5v-7.091c0-0.276,0.224-0.5,0.5-0.5h5.667c0.276,0,0.5,0.224,0.5,0.5v7.091\n                    C1380.393,1365.257,1380.169,1365.48,1379.893,1365.48z",
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("g", [
                      _c("path", {
                        staticClass: "st1",
                        attrs: {
                          d: "M1385.059,1364.98c0,0.27,0.223,0.5,0.5,0.5c0.276,0,0.5-0.23,0.5-0.5H1385.059z M1385.059,1353.64v11.34h1\n                    v-11.34H1385.059z",
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("g", [
                      _c("path", {
                        staticClass: "st1",
                        attrs: {
                          d: "M1368.059,1364.98c0,0.27,0.223,0.5,0.5,0.5c0.276,0,0.5-0.23,0.5-0.5H1368.059z M1368.059,1353.64v11.34h1\n                    v-11.34H1368.059z",
                        },
                      }),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.attractions.includes(1592)
                ? _c("g", { attrs: { id: "preaux-5" } }, [
                    _c("g", [
                      _c("path", {
                        staticClass: "st10",
                        attrs: {
                          d: "M843,1405L843,1405c13.255,0,24,10.745,24,24l0,0c0,13.255-10.745,24-24,24l0,0c-13.255,0-24-10.745-24-24\n                    l0,0C819,1415.745,829.745,1405,843,1405z",
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("g", { attrs: { id: "num_4_" } }, [
                      _c("g", [
                        _c("path", {
                          staticClass: "st10",
                          attrs: {
                            d: "M860.81,1399.849L860.81,1399.849c6.033,0,10.924,4.891,10.924,10.924l0,0\n                        c0,6.033-4.891,10.924-10.924,10.924l0,0c-6.033,0-10.924-4.891-10.924-10.924l0,0\n                        C849.886,1404.74,854.777,1399.849,860.81,1399.849z",
                          },
                        }),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("g", [
                      _c("g", [
                        _c("path", {
                          staticClass: "st1",
                          attrs: {
                            d: "M862.926,1407.229h-2.975l-0.3,2.003c0.18-0.024,0.348-0.048,0.636-0.048c0.6,0,1.199,0.132,1.679,0.42\n                        c0.611,0.348,1.115,1.02,1.115,2.003c0,1.522-1.211,2.662-2.902,2.662c-0.852,0-1.571-0.24-1.943-0.479l0.264-0.804\n                        c0.324,0.191,0.959,0.432,1.667,0.432c0.996,0,1.847-0.647,1.847-1.691c-0.012-1.007-0.684-1.727-2.243-1.727\n                        c-0.444,0-0.792,0.048-1.08,0.084l0.504-3.742h3.73V1407.229z",
                          },
                        }),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("g", [
                      _c("path", {
                        staticClass: "st1",
                        attrs: {
                          d: "M855.809,1433.04c-0.132,0-0.264-0.052-0.362-0.155l-12.388-13.02l-12.388,13.02\n                    c-0.19,0.201-0.507,0.208-0.707,0.018c-0.2-0.19-0.208-0.507-0.018-0.707l12.75-13.4c0.188-0.197,0.536-0.197,0.725,0\n                    l12.75,13.4c0.19,0.2,0.183,0.517-0.018,0.707C856.057,1432.994,855.933,1433.04,855.809,1433.04z",
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("g", [
                      _c("path", {
                        staticClass: "st1",
                        attrs: {
                          d: "M845.893,1439.48c-0.276,0-0.5-0.224-0.5-0.5v-6.591h-4.667v6.591c0,0.276-0.224,0.5-0.5,0.5\n                    s-0.5-0.224-0.5-0.5v-7.091c0-0.276,0.224-0.5,0.5-0.5h5.667c0.276,0,0.5,0.224,0.5,0.5v7.091\n                    C846.393,1439.257,846.169,1439.48,845.893,1439.48z",
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("g", [
                      _c("path", {
                        staticClass: "st1",
                        attrs: {
                          d: "M851.059,1438.98c0,0.27,0.223,0.5,0.5,0.5c0.276,0,0.5-0.23,0.5-0.5H851.059z M851.059,1427.64v11.34h1\n                    v-11.34H851.059z",
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("g", [
                      _c("path", {
                        staticClass: "st1",
                        attrs: {
                          d: "M834.059,1438.98c0,0.27,0.223,0.5,0.5,0.5c0.276,0,0.5-0.23,0.5-0.5H834.059z M834.059,1427.64v11.34h1\n                    v-11.34H834.059z",
                        },
                      }),
                    ]),
                  ])
                : _vm._e(),
            ]),
            _vm._v(" "),
            _vm.title.includes(20)
              ? _c("g", { attrs: { id: "toilette-list" } }, [
                  _c("g", { attrs: { id: "toilette-1" } }, [
                    _c("g", [
                      _c("path", {
                        staticClass: "st0",
                        attrs: {
                          d: "M1860,1076L1860,1076c13.255,0,24,10.745,24,24l0,0c0,13.255-10.745,24-24,24l0,0\n                    c-13.255,0-24-10.745-24-24l0,0C1836,1086.745,1846.745,1076,1860,1076z",
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("g", [
                      _c("path", {
                        staticClass: "st1",
                        attrs: {
                          d: "M1868.96,1111.742h-4.42c-0.168,0-0.313-0.118-0.346-0.283l-0.684-3.427h-2.081\n                    c-0.558,0-1.017-0.424-1.091-1.007c-0.002-0.12-0.002-0.224,0.037-0.339c0.098-0.484,0.196-1.043,0.298-1.614\n                    c0.565-3.185,1.25-7.037,4.352-8.057c-1.107-0.618-1.858-1.81-1.858-3.176c0-1.997,1.607-3.622,3.583-3.622\n                    s3.583,1.625,3.583,3.622c0,1.366-0.751,2.558-1.858,3.176c3.102,1.02,3.786,4.872,4.352,8.057c0.102,0.571,0.2,1.13,0.31,1.656\n                    c0.018,0.105,0.027,0.178,0.027,0.252c-0.076,0.628-0.535,1.052-1.093,1.052h-2.081l-0.684,3.427\n                    C1869.273,1111.624,1869.128,1111.742,1868.96,1111.742z M1864.829,1111.037h3.842l0.684-3.427\n                    c0.032-0.165,0.178-0.283,0.346-0.283h2.37c0.197,0,0.361-0.165,0.39-0.392c0.001,0.004-0.01-0.021-0.016-0.062\n                    c-0.11-0.535-0.211-1.1-0.313-1.679c-0.644-3.624-1.373-7.732-5.381-7.732s-4.737,4.108-5.381,7.732\n                    c-0.103,0.579-0.203,1.144-0.313,1.676c0.013,0.291,0.177,0.456,0.374,0.456h2.37c0.168,0,0.313,0.118,0.346,0.283\n                    L1864.829,1111.037z M1866.75,1090.923c-1.587,0-2.878,1.309-2.878,2.917s1.291,2.918,2.878,2.918s2.878-1.31,2.878-2.918\n                    S1868.337,1090.923,1866.75,1090.923z M1855.37,1111.742h-4.84c-0.179,0-0.329-0.133-0.351-0.31l-0.762-6.23h-2.107\n                    c-0.195,0-0.353-0.157-0.353-0.353v-2.449c0-1.625,0.622-3.148,1.751-4.288c0.702-0.716,1.575-1.238,2.522-1.527\n                    c-1.104-0.617-1.854-1.809-1.854-3.175c0-1.998,1.603-3.623,3.572-3.623c1.976,0,3.582,1.625,3.582,3.623\n                    c0,1.363-0.748,2.553-1.851,3.171c0.944,0.285,1.808,0.806,2.521,1.532c1.128,1.139,1.75,2.662,1.75,4.287v2.449\n                    c0,0.195-0.157,0.353-0.353,0.353h-2.108l-0.771,6.23C1855.698,1111.609,1855.548,1111.742,1855.37,1111.742z\n                    M1850.843,1111.037h4.216l0.771-6.23c0.022-0.177,0.173-0.31,0.351-0.31h2.067v-2.097c0-1.438-0.55-2.785-1.548-3.792\n                    c-0.998-1.017-2.329-1.576-3.749-1.576c-1.394,0-2.757,0.574-3.738,1.575c-0.999,1.008-1.549,2.354-1.549,3.793v2.097h2.067\n                    c0.179,0,0.329,0.133,0.351,0.31L1850.843,1111.037z M1852.95,1090.492c-1.581,0-2.867,1.31-2.867,2.918\n                    s1.286,2.917,2.867,2.917c1.586,0,2.877-1.309,2.877-2.917S1854.536,1090.492,1852.95,1090.492z",
                        },
                      }),
                    ]),
                  ]),
                ])
              : _vm._e(),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.title.includes(49)
        ? _c("g", { attrs: { id: "parking-accessible" } }, [
            _c("path", {
              staticClass: "st0",
              attrs: {
                d: "M1113.707,1105.543L1113.707,1105.543c13.255,0,24,10.745,24,24l0,0c0,13.255-10.745,24-24,24l0,0\n            c-13.255,0-24-10.745-24-24l0,0C1089.707,1116.288,1100.453,1105.543,1113.707,1105.543z",
              },
            }),
            _vm._v(" "),
            _c("g", [
              _c("g", [
                _c("path", {
                  attrs: {
                    stroke: "#fff",
                    d: "M1111.975,1120.67v-3.234 M1111.975,1117.436v-4.527h3.519c0.915,0,1.657,0.738,1.657,1.653v1.215\n                c0,0.915-0.742,1.659-1.657,1.659H1111.975z M1117.821,1109.603h-7.735c-1.831,0-3.315,1.49-3.315,3.319v7.735\n                c0,1.829,1.484,3.312,3.315,3.312h7.735c1.831,0,3.315-1.483,3.315-3.312v-7.735\n                C1121.136,1111.093,1119.651,1109.603,1117.821,1109.603z",
                  },
                }),
                _vm._v(" "),
                _c("path", {
                  staticClass: "st1",
                  attrs: {
                    d: "M1099.205,1129.975c1.126,0,2.043-0.916,2.043-2.042s-0.916-2.043-2.043-2.043\n                    c-1.126,0-2.042,0.916-2.042,2.043S1098.078,1129.975,1099.205,1129.975z M1099.205,1126.564c0.754,0,1.368,0.614,1.368,1.368\n                    c0,0.754-0.613,1.368-1.368,1.368c-0.754,0-1.368-0.613-1.368-1.368S1098.451,1126.564,1099.205,1126.564z",
                  },
                }),
                _vm._v(" "),
                _c("path", {
                  staticClass: "st1",
                  attrs: {
                    d: "M1097.238,1138.302v6.079c0,0.186,0.151,0.338,0.337,0.338c0.186,0,0.338-0.151,0.338-0.338v-6.253\n                    c0-0.005-0.001-0.01-0.001-0.015c0.001-0.121-0.064-0.239-0.179-0.3c-0.432-0.23-0.7-0.675-0.7-1.161v-3.71\n                    c0-0.724,0.589-1.313,1.313-1.313h1.73c0.724,0,1.313,0.589,1.313,1.313v3.71c0,0.486-0.268,0.931-0.7,1.161\n                    c-0.117,0.062-0.182,0.183-0.178,0.307c0,0.003,0,0.005,0,0.008v6.253c0,0.186,0.151,0.338,0.337,0.338\n                    c0.187,0,0.338-0.151,0.338-0.338v-6.079c0.547-0.368,0.879-0.983,0.879-1.649v-3.71c0-1.096-0.892-1.988-1.988-1.988h-1.73\n                    c-1.096,0-1.988,0.892-1.988,1.988v3.71C1096.359,1137.319,1096.691,1137.934,1097.238,1138.302z",
                  },
                }),
                _vm._v(" "),
                _c("path", {
                  staticClass: "st1",
                  attrs: {
                    d: "M1105.67,1134.586c1.126,0,2.043-0.917,2.043-2.043c0-1.126-0.916-2.043-2.043-2.043\n                    c-1.126,0-2.042,0.916-2.042,2.043C1103.628,1133.669,1104.544,1134.586,1105.67,1134.586z M1105.67,1131.175\n                    c0.754,0,1.368,0.614,1.368,1.368c0,0.754-0.614,1.368-1.368,1.368c-0.754,0-1.368-0.614-1.368-1.368\n                    C1104.303,1131.789,1104.916,1131.175,1105.67,1131.175z",
                  },
                }),
                _vm._v(" "),
                _c("path", {
                  staticClass: "st1",
                  attrs: {
                    d: "M1104.236,1141.139v3.242c0,0.186,0.151,0.338,0.338,0.338c0.186,0,0.337-0.151,0.337-0.338v-3.415\n                    c0-0.005,0-0.01-0.001-0.016c0-0.121-0.064-0.239-0.179-0.3c-0.432-0.23-0.7-0.675-0.7-1.161v-1.937\n                    c0-0.724,0.589-1.313,1.313-1.313h0.666c0.724,0,1.313,0.589,1.313,1.313v1.937c0,0.486-0.268,0.93-0.7,1.161\n                    c-0.117,0.062-0.182,0.183-0.178,0.307c0,0.003,0,0.005,0,0.008v3.415c0,0.186,0.151,0.338,0.338,0.338s0.338-0.151,0.338-0.338\n                    v-3.242c0.547-0.369,0.879-0.983,0.879-1.649v-1.937c0-1.096-0.892-1.988-1.988-1.988h-0.666c-1.096,0-1.988,0.892-1.988,1.988\n                    v1.937C1103.356,1140.156,1103.689,1140.771,1104.236,1141.139z",
                  },
                }),
                _vm._v(" "),
                _c("path", {
                  staticClass: "st1",
                  attrs: {
                    d: "M1112.505,1131.039c1.126,0,2.042-0.916,2.042-2.042c0-1.127-0.916-2.043-2.042-2.043\n                    c-1.126,0-2.043,0.917-2.043,2.043C1110.462,1130.123,1111.378,1131.039,1112.505,1131.039z M1112.505,1127.628\n                    c0.754,0,1.367,0.614,1.367,1.368c0,0.754-0.614,1.367-1.367,1.367c-0.754,0-1.368-0.613-1.368-1.367\n                    C1111.137,1128.242,1111.75,1127.628,1112.505,1127.628z",
                  },
                }),
                _vm._v(" "),
                _c("path", {
                  staticClass: "st1",
                  attrs: {
                    d: "M1109.095,1139.513h1.975v4.868c0,0.186,0.151,0.338,0.338,0.338s0.338-0.151,0.338-0.338v-5.206\n                    c0-0.023-0.002-0.046-0.007-0.068c-0.002-0.011-0.005-0.022-0.008-0.032c-0.043-0.137-0.171-0.237-0.322-0.237c0,0,0,0,0,0\n                    h-1.766l1.529-3.059c0.023-0.047,0.036-0.099,0.036-0.151v-1.636c0-0.716,0.583-1.298,1.299-1.298s1.298,0.582,1.298,1.298\n                    v1.636c0,0.052,0.012,0.104,0.036,0.151l1.529,3.059h-1.753c0,0,0,0,0,0c-0.151,0-0.28,0.1-0.322,0.237\n                    c-0.003,0.011-0.006,0.021-0.008,0.032c-0.005,0.022-0.007,0.045-0.007,0.068v5.206c0,0.186,0.151,0.338,0.337,0.338\n                    s0.338-0.151,0.338-0.338v-4.868h1.961c0.117,0,0.226-0.061,0.287-0.16c0.061-0.099,0.067-0.224,0.015-0.328l-1.738-3.476\n                    v-1.557c0-1.088-0.885-1.973-1.973-1.973c-1.088,0-1.974,0.885-1.974,1.973v1.557l-1.738,3.476\n                    c-0.052,0.105-0.047,0.229,0.015,0.328C1108.87,1139.452,1108.978,1139.513,1109.095,1139.513z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("g", [
                  _c("g", [
                    _c("path", {
                      staticClass: "st1",
                      attrs: {
                        d: "M1121.46,1139.351c-0.522,0-0.922,0.399-0.922,0.922s0.399,0.922,0.922,0.922\n                            c0.522,0,0.921-0.399,0.921-0.922S1121.982,1139.351,1121.46,1139.351z M1121.46,1140.58c-0.184,0-0.307-0.123-0.307-0.307\n                            s0.123-0.307,0.307-0.307c0.184,0,0.307,0.123,0.307,0.307S1121.644,1140.58,1121.46,1140.58z",
                      },
                    }),
                  ]),
                ]),
                _vm._v(" "),
                _c("g", [
                  _c("g", [
                    _c("path", {
                      staticClass: "st1",
                      attrs: {
                        d: "M1126.067,1134.437h-4.331l-0.215-1.935c-0.061-0.491-0.461-0.829-0.922-0.829h-1.29\n                            c-0.184,0-0.307,0.123-0.307,0.307c0,0.184,0.123,0.307,0.307,0.307h1.29c0.154,0,0.276,0.123,0.307,0.276l0.246,2.212v0.584\n                            c0,0.184,0.123,0.307,0.307,0.307c0.184,0,0.307-0.123,0.307-0.307v-0.307h4.3c0.184,0,0.307,0.123,0.307,0.307\n                            s-0.123,0.307-0.307,0.307h-1.843c-0.184,0-0.307,0.123-0.307,0.307c0,0.184,0.123,0.307,0.307,0.307h1.843\n                            c0.522,0,0.922-0.399,0.922-0.922S1126.589,1134.437,1126.067,1134.437z",
                      },
                    }),
                  ]),
                ]),
                _vm._v(" "),
                _c("g", [
                  _c("g", [
                    _c("path", {
                      staticClass: "st1",
                      attrs: {
                        d: "M1129.446,1142.116c-0.184,0-0.307,0.123-0.307,0.307c0,0.184,0.123,0.307,0.307,0.307\n                            c0.338,0,0.614,0.276,0.614,0.614s-0.276,0.614-0.614,0.614s-0.614-0.276-0.614-0.614v-4.3c0-0.522-0.399-0.922-0.922-0.922\n                            h-1.843c-0.184,0-0.307,0.123-0.307,0.307s0.123,0.307,0.307,0.307h1.843c0.184,0,0.307,0.123,0.307,0.307v0.922h-2.764\n                            c-0.184,0-0.307,0.123-0.307,0.307c0,2.027-1.659,3.686-3.686,3.686c-2.027,0-3.686-1.659-3.686-3.686\n                            s1.659-3.686,3.686-3.686c1.72,0,3.194,1.167,3.594,2.826c0.031,0.154,0.215,0.276,0.369,0.215\n                            c0.154-0.031,0.276-0.215,0.215-0.369c-0.461-1.935-2.181-3.287-4.177-3.287c-2.365,0-4.3,1.935-4.3,4.3s1.935,4.3,4.3,4.3\n                            c2.273,0,4.116-1.751,4.3-3.993h2.457v2.765c0,0.676,0.553,1.229,1.229,1.229c0.676,0,1.229-0.553,1.229-1.229\n                            S1130.122,1142.116,1129.446,1142.116z",
                      },
                    }),
                  ]),
                ]),
              ]),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.title.includes(57)
        ? _c("g", { attrs: { id: "rouge-vin_" } }, [
            _c("g", { attrs: { id: "rouge-vin" } }, [
              _c("path", {
                staticClass: "st0",
                attrs: {
                  d: "M1814.493,1049.7h0c13.255,0,24,10.745,24,24h0c0,13.255-10.745,24-24,24h0c-13.255,0-24-10.745-24-24h0c0-13.255,10.745-24,24-24Z",
                },
              }),
              _vm._v(" "),
              _c("path", {
                staticClass: "st1",
                attrs: {
                  d: "M1820.64,1085.25c-.276,0-.5-.224-.5-.5v-11.373c-2.28-.306-4.059-2.672-4.059-5.537,0-3.071,2.045-5.569,4.559-5.569s4.559,2.498,4.559,5.569c0,2.865-1.779,5.231-4.059,5.537v11.373c0,.276-.224.5-.5.5ZM1820.64,1063.27c-1.962,0-3.559,2.05-3.559,4.569s1.597,4.57,3.559,4.57,3.559-2.05,3.559-4.57-1.597-4.569-3.559-4.569ZM1808.631,1085.25c-.276,0-.5-.224-.5-.5v-13.056c-1.079-.112-2.075-.586-2.844-1.362-.878-.875-1.384-2.094-1.384-3.342v-4.22c0-.276.224-.5.5-.5s.5.224.5.5v4.22c0,.984.398,1.944,1.092,2.636.582.587,1.327.954,2.136,1.061v-7.916c0-.276.224-.5.5-.5s.5.224.5.5v7.916c.317-.043.628-.126.929-.249.456-.187.861-.458,1.204-.808.344-.342.624-.759.812-1.212.188-.453.284-.934.284-1.428v-4.22c0-.276.224-.5.5-.5s.5.224.5.5v4.22c0,.627-.121,1.236-.36,1.812-.24.573-.595,1.104-1.026,1.532-.435.442-.952.79-1.534,1.028-.422.173-.86.283-1.308.33v13.057c0,.276-.224.5-.5.5Z",
                },
              }),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.title.includes(21)
        ? _c("g", { attrs: { id: "food-truck-1" } }, [
            _c(
              "g",
              {
                attrs: {
                  id: "food-truck-1-2-3",
                  "data-name": "food-truck-1",
                  transform: "translate(-941.10798,211.68029)",
                },
              },
              [
                _c("path", {
                  staticClass: "cls-11",
                  staticStyle: { fill: "#4d80d6", "stroke-width": "0px" },
                  attrs: {
                    d: "m 1814.69,1049.755 v 0 c 13.255,0 24,10.745 24,24 v 0 c 0,13.255 -10.745,24 -24,24 v 0 c -13.255,0 -24,-10.745 -24,-24 v 0 c 0,-13.255 10.745,-24 24,-24 z",
                    id: "path999-6",
                  },
                }),
                _vm._v(" "),
                _c(
                  "g",
                  {
                    attrs: {
                      id: "g2139",
                      transform:
                        "matrix(-1.0125265,0,0,0.9677929,1838.8362,1050.5053)",
                    },
                  },
                  [
                    _c("path", {
                      staticStyle: { stroke: "#ffffff", "stroke-opacity": "1" },
                      attrs: {
                        d: "m 11.517382,24.490647 h 7.175901",
                        fill: "none",
                        stroke: "#000000",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        "stroke-width": "1",
                        id: "path259",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      staticStyle: { stroke: "#ffffff", "stroke-opacity": "1" },
                      attrs: {
                        d: "m 12.115374,33.682138 a 2.3919672,2.4510641 0 1 0 4.783934,0 2.3919672,2.4510641 0 1 0 -4.783934,0",
                        fill: "none",
                        stroke: "#000000",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        "stroke-width": "1",
                        id: "path261",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      staticStyle: { stroke: "#ffffff", "stroke-opacity": "1" },
                      attrs: {
                        d: "m 28.859144,33.682138 a 2.3919672,2.4510641 0 1 0 4.783934,0 2.3919672,2.4510641 0 1 0 -4.783934,0",
                        fill: "none",
                        stroke: "#000000",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        "stroke-width": "1",
                        id: "path263",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      staticStyle: { stroke: "#ffffff", "stroke-opacity": "1" },
                      attrs: {
                        d: "M 12.115374,33.682138 H 9.7234061 A 0.59799179,0.61276604 0 0 1 9.1254145,33.069372 v -5.873975 a 0.59799179,0.61276604 0 0 1 0.1746138,-0.432614 l 2.2173537,-2.272136 2.647908,-4.88497 a 1.1959835,1.2255321 0 0 1 1.04529,-0.629924 h 3.482703 v -5.514894 a 0.59799179,0.61276604 0 0 1 0.597992,-0.612766 h 16.743771 a 0.59799179,0.61276604 0 0 1 0.597991,0.612766 v 19.608513 a 0.59799179,0.61276604 0 0 1 -0.597991,0.612766 h -2.391968",
                        fill: "none",
                        stroke: "#000000",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        "stroke-width": "1",
                        id: "path265",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      staticStyle: { stroke: "#ffffff", "stroke-opacity": "1" },
                      attrs: {
                        d: "M 16.899308,33.682138 H 28.859144",
                        fill: "none",
                        stroke: "#000000",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        "stroke-width": "1",
                        id: "path267",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      staticStyle: { stroke: "#ffffff", "stroke-opacity": "1" },
                      attrs: {
                        d: "m 18.693283,18.975753 v 12.25532",
                        fill: "none",
                        stroke: "#000000",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        "stroke-width": "1",
                        id: "path269",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      staticStyle: { stroke: "#ffffff", "stroke-opacity": "1" },
                      attrs: {
                        d: "M 9.1254145,31.231073 H 36.633037",
                        fill: "none",
                        stroke: "#000000",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        "stroke-width": "1",
                        id: "path271",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      staticStyle: { stroke: "#ffffff", "stroke-opacity": "1" },
                      attrs: {
                        d: "M 21.085251,20.201285 H 34.24107 l -2.391967,-3.676597 h -8.371885 z",
                        fill: "none",
                        stroke: "#000000",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        "stroke-width": "1",
                        id: "path273",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      staticStyle: { stroke: "#ffffff", "stroke-opacity": "1" },
                      attrs: {
                        d: "M 21.085251,25.103413 H 34.24107",
                        fill: "none",
                        stroke: "#000000",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        "stroke-width": "1",
                        id: "path275",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      staticStyle: { stroke: "#ffffff", "stroke-opacity": "1" },
                      attrs: {
                        d: "m 22.281234,20.201285 h 10.763852 v 7.353193 H 22.281234 Z",
                        fill: "none",
                        stroke: "#000000",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        "stroke-width": "1",
                        id: "path277-5",
                      },
                    }),
                  ]
                ),
              ]
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.title.includes(20)
        ? _c("g", { attrs: { id: "toilette-list_1_" } }, [
            _c("g", { attrs: { id: "toilette-1_1_" } }, [
              _c("g", [
                _c("path", {
                  staticClass: "st0",
                  attrs: {
                    d: "M1860,1076L1860,1076c13.255,0,24,10.745,24,24l0,0c0,13.255-10.745,24-24,24l0,0\n                    c-13.255,0-24-10.745-24-24l0,0C1836,1086.745,1846.745,1076,1860,1076z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st1",
                  attrs: {
                    d: "M1868.96,1111.742h-4.42c-0.168,0-0.313-0.118-0.346-0.283l-0.684-3.427h-2.081\n                    c-0.558,0-1.017-0.424-1.091-1.007c-0.002-0.12-0.002-0.224,0.037-0.339c0.098-0.484,0.196-1.043,0.298-1.614\n                    c0.565-3.185,1.25-7.037,4.352-8.057c-1.107-0.618-1.858-1.81-1.858-3.176c0-1.997,1.607-3.622,3.583-3.622\n                    s3.583,1.625,3.583,3.622c0,1.366-0.751,2.558-1.858,3.176c3.102,1.02,3.786,4.872,4.352,8.057c0.102,0.571,0.2,1.13,0.31,1.656\n                    c0.018,0.105,0.027,0.178,0.027,0.252c-0.076,0.628-0.535,1.052-1.093,1.052h-2.081l-0.684,3.427\n                    C1869.273,1111.624,1869.128,1111.742,1868.96,1111.742z M1864.829,1111.037h3.842l0.684-3.427\n                    c0.032-0.165,0.178-0.283,0.346-0.283h2.37c0.197,0,0.361-0.165,0.39-0.392c0.001,0.004-0.01-0.021-0.016-0.062\n                    c-0.11-0.535-0.211-1.1-0.313-1.679c-0.644-3.624-1.373-7.732-5.381-7.732s-4.737,4.108-5.381,7.732\n                    c-0.103,0.579-0.203,1.144-0.313,1.676c0.013,0.291,0.177,0.456,0.374,0.456h2.37c0.168,0,0.313,0.118,0.346,0.283\n                    L1864.829,1111.037z M1866.75,1090.923c-1.587,0-2.878,1.309-2.878,2.917s1.291,2.918,2.878,2.918s2.878-1.31,2.878-2.918\n                    S1868.337,1090.923,1866.75,1090.923z M1855.37,1111.742h-4.84c-0.179,0-0.329-0.133-0.351-0.31l-0.762-6.23h-2.107\n                    c-0.195,0-0.353-0.157-0.353-0.353v-2.449c0-1.625,0.622-3.148,1.751-4.288c0.702-0.716,1.575-1.238,2.522-1.527\n                    c-1.104-0.617-1.854-1.809-1.854-3.175c0-1.998,1.603-3.623,3.572-3.623c1.976,0,3.582,1.625,3.582,3.623\n                    c0,1.363-0.748,2.553-1.851,3.171c0.944,0.285,1.808,0.806,2.521,1.532c1.128,1.139,1.75,2.662,1.75,4.287v2.449\n                    c0,0.195-0.157,0.353-0.353,0.353h-2.108l-0.771,6.23C1855.698,1111.609,1855.548,1111.742,1855.37,1111.742z\n                    M1850.843,1111.037h4.216l0.771-6.23c0.022-0.177,0.173-0.31,0.351-0.31h2.067v-2.097c0-1.438-0.55-2.785-1.548-3.792\n                    c-0.998-1.017-2.329-1.576-3.749-1.576c-1.394,0-2.757,0.574-3.738,1.575c-0.999,1.008-1.549,2.354-1.549,3.793v2.097h2.067\n                    c0.179,0,0.329,0.133,0.351,0.31L1850.843,1111.037z M1852.95,1090.492c-1.581,0-2.867,1.31-2.867,2.918\n                    s1.286,2.917,2.867,2.917c1.586,0,2.877-1.309,2.877-2.917S1854.536,1090.492,1852.95,1090.492z",
                  },
                }),
              ]),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.title.includes(28)
        ? _c("g", { attrs: { id: "paserelle" } }, [
            _c("g", [
              _c("path", {
                staticClass: "st6",
                attrs: {
                  d: "M774,901L774,901c12.703,0,23,10.297,23,23l0,0c0,12.703-10.297,23-23,23l0,0c-12.703,0-23-10.297-23-23l0,0\n                C751,911.297,761.297,901,774,901z",
                },
              }),
            ]),
            _vm._v(" "),
            _c("g", [
              _c("path", {
                staticClass: "st1",
                attrs: {
                  d: "M774,948c-13.233,0-24-10.767-24-24s10.767-24,24-24s24,10.767,24,24S787.233,948,774,948z M774,902\n                c-12.131,0-22,9.869-22,22s9.869,22,22,22s22-9.869,22-22S786.131,902,774,902z",
                },
              }),
            ]),
            _vm._v(" "),
            _c("g", [
              _c("path", {
                staticClass: "st1",
                attrs: {
                  d: "M786.809,934.476h-25.5c-0.276,0-0.5-0.224-0.5-0.5s0.224-0.5,0.5-0.5h25.5c0.276,0,0.5,0.224,0.5,0.5\n                S787.085,934.476,786.809,934.476z",
                },
              }),
            ]),
            _vm._v(" "),
            _c("g", [
              _c("path", {
                staticClass: "st1",
                attrs: {
                  d: "M783.976,928.809h-19.833c-0.276,0-0.5-0.224-0.5-0.5s0.224-0.5,0.5-0.5h19.833c0.276,0,0.5,0.224,0.5,0.5\n                S784.252,928.809,783.976,928.809z",
                },
              }),
            ]),
            _vm._v(" "),
            _c("g", [
              _c("path", {
                staticClass: "st1",
                attrs: {
                  d: "M786.809,934.475c-0.276,0-0.5-0.224-0.5-0.5v-11.333c0-0.276,0.224-0.5,0.5-0.5s0.5,0.224,0.5,0.5v11.333\n                C787.309,934.251,787.085,934.475,786.809,934.475z",
                },
              }),
            ]),
            _vm._v(" "),
            _c("g", [
              _c("rect", {
                staticClass: "st1",
                attrs: {
                  x: "778.265",
                  y: "927.1",
                  transform:
                    "matrix(0.4961 0.8683 -0.8683 0.4961 1200.47 -213.2738)",
                  width: "11.421",
                  height: "1",
                },
              }),
            ]),
            _vm._v(" "),
            _c("g", [
              _c("path", {
                staticClass: "st1",
                attrs: {
                  d: "M781.141,923.142h-14.166c-0.276,0-0.5-0.224-0.5-0.5s0.224-0.5,0.5-0.5h14.166c0.276,0,0.5,0.224,0.5,0.5\n                S781.417,923.142,781.141,923.142z",
                },
              }),
            ]),
            _vm._v(" "),
            _c("g", [
              _c("path", {
                staticClass: "st1",
                attrs: {
                  d: "M761.309,934.475c-0.276,0-0.5-0.224-0.5-0.5v-11.333c0-0.276,0.224-0.5,0.5-0.5s0.5,0.224,0.5,0.5v11.333\n                C761.809,934.251,761.585,934.475,761.309,934.475z",
                },
              }),
            ]),
            _vm._v(" "),
            _c("g", [
              _c("rect", {
                staticClass: "st1",
                attrs: {
                  x: "763.642",
                  y: "921.889",
                  transform:
                    "matrix(0.8682 0.4961 -0.4961 0.8682 560.8995 -256.903)",
                  width: "1",
                  height: "11.421",
                },
              }),
            ]),
            _vm._v(" "),
            _c("g", [
              _c("path", {
                staticClass: "st1",
                attrs: {
                  d: "M781.143,923.142c-0.276,0-0.5-0.224-0.5-0.5v-8.5c0-0.276,0.224-0.5,0.5-0.5s0.5,0.224,0.5,0.5v8.5\n                C781.643,922.918,781.419,923.142,781.143,923.142z",
                },
              }),
            ]),
            _vm._v(" "),
            _c("g", [
              _c("rect", {
                staticClass: "st1",
                attrs: {
                  x: "778.868",
                  y: "917.892",
                  transform:
                    "matrix(0.5547 0.8321 -0.8321 0.5547 1113.314 -243.3305)",
                  width: "10.215",
                  height: "1",
                },
              }),
            ]),
            _vm._v(" "),
            _c("g", [
              _c("path", {
                staticClass: "st1",
                attrs: {
                  d: "M766.975,923.142c-0.276,0-0.5-0.224-0.5-0.5v-8.5c0-0.276,0.224-0.5,0.5-0.5s0.5,0.224,0.5,0.5v8.5\n                C767.475,922.918,767.251,923.142,766.975,923.142z",
                },
              }),
            ]),
            _vm._v(" "),
            _c("g", [
              _c("path", {
                staticClass: "st1",
                attrs: {
                  d: "M761.309,923.142c-0.095,0-0.191-0.027-0.277-0.084c-0.23-0.153-0.292-0.464-0.139-0.693l5.666-8.5\n                c0.153-0.229,0.462-0.293,0.693-0.139c0.23,0.153,0.292,0.464,0.139,0.693l-5.666,8.5\n                C761.629,923.063,761.47,923.142,761.309,923.142z",
                },
              }),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.title.includes(25)
        ? _c("g", { attrs: { id: "camping-1" } }, [
            _c("g", [
              _c("path", {
                staticClass: "st6",
                attrs: {
                  d: "M783,1191L783,1191c13.255,0,24,10.745,24,24l0,0c0,13.255-10.745,24-24,24l0,0c-13.255,0-24-10.745-24-24\n                l0,0C759,1201.745,769.745,1191,783,1191z",
                },
              }),
            ]),
            _vm._v(" "),
            _c("g", [
              _c("path", {
                staticClass: "st1",
                attrs: {
                  d: "M778.384,1228.311c-0.004,0-0.008,0-0.012,0h-7.8c-0.421,0-0.763-0.341-0.763-0.761v-7.72\n                c0-0.178,0.065-0.353,0.183-0.492l12.381-14.036l-2.642-2.638c-0.196-0.194-0.196-0.512-0.001-0.707\n                c0.195-0.195,0.513-0.195,0.707,0l2.622,2.617l2.622-2.617c0.194-0.195,0.512-0.195,0.707,0c0.195,0.195,0.195,0.513-0.001,0.707\n                l-2.642,2.638l12.373,14.027c0.125,0.149,0.191,0.324,0.191,0.501v7.72c0,0.42-0.343,0.761-0.764,0.761h-7.799\n                c-0.008,0-0.016,0-0.023,0h-9.327C778.392,1228.311,778.388,1228.311,778.384,1228.311z M788.087,1227.311h7.222v-7.387\n                l-11.75-13.321v7.941L788.087,1227.311z M779.092,1227.311h7.934l-3.967-11.185L779.092,1227.311z M770.809,1227.311h7.222\n                l4.528-12.767v-7.941l-11.75,13.32V1227.311z",
                },
              }),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.title.includes(24)
        ? _c("g", { attrs: { id: "playground" } }, [
            _c("g", [
              _c("path", {
                staticClass: "st16",
                attrs: {
                  d: "M1125,1315L1125,1315c13.255,0,24,10.745,24,24l0,0c0,13.255-10.745,24-24,24l0,0\n                c-13.255,0-24-10.745-24-24l0,0C1101,1325.745,1111.745,1315,1125,1315z",
                },
              }),
            ]),
            _vm._v(" "),
            _c("g", [
              _c("path", {
                staticClass: "st1",
                attrs: {
                  d: "M1114.062,1350.55c-0.02,0-0.039-0.001-0.059-0.003c-0.274-0.032-0.471-0.28-0.439-0.555l2.279-19.739\n                c0.18-1.529,1.478-2.683,3.018-2.683h12.39c1.553,0,2.85,1.154,3.017,2.686l2.28,19.736c0.031,0.274-0.165,0.522-0.439,0.555\n                c-0.272,0.025-0.522-0.165-0.555-0.439l-2.28-19.739c-0.111-1.026-0.981-1.798-2.022-1.798h-1.46v15.968\n                c0.968,0.227,1.69,1.097,1.69,2.132c0,1.208-0.982,2.19-2.19,2.19h-8.46c-1.208,0-2.19-0.982-2.19-2.19\n                c0-1.035,0.723-1.905,1.69-2.132v-15.968h-1.47c-1.033,0-1.903,0.773-2.023,1.799l-2.279,19.738\n                C1114.527,1350.362,1114.312,1350.55,1114.062,1350.55z M1120.83,1345.48c-0.656,0-1.19,0.533-1.19,1.189s0.534,1.19,1.19,1.19\n                h8.46c0.656,0,1.19-0.534,1.19-1.19s-0.534-1.189-1.19-1.189H1120.83z M1121.33,1344.48h7.46v-15.91h-7.46V1344.48z",
                },
              }),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.title.includes(56)
        ? _c("g", { attrs: { id: "go-van" } }, [
            _c("g", { attrs: { id: "go-van-1" } }, [
              _c("path", {
                staticClass: "st6",
                attrs: {
                  d: "M1788,1171.891h0c13.255,0,24,10.745,24,24h0c0,13.255-10.745,24-24,24h0c-13.255,0-24-10.745-24-24h0c0-13.255,10.745-24,24-24Z",
                },
              }),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st1",
                  attrs: {
                    d: "M1792.371,1203.857h-8.53c-.276,0-.5-.224-.5-.5s.224-.5.5-.5h8.53c.276,0,.5.224.5.5s-.224.5-.5.5Z",
                  },
                }),
                _vm._v(" "),
                _c("g", [
                  _c("path", {
                    staticClass: "st1",
                    attrs: {
                      d: "M1780.997,1206.701c-1.844,0-3.344-1.5-3.344-3.344s1.5-3.345,3.345-3.345c1.844,0,3.343,1.502,3.343,3.345s-1.5,3.344-3.344,3.344ZM1780.998,1201.013c-1.293,0-2.345,1.051-2.345,2.343v.002c0,1.292,1.052,2.344,2.344,2.344s2.344-1.052,2.344-2.344-1.051-2.344-2.343-2.345Z",
                    },
                  }),
                  _vm._v(" "),
                  _c("path", {
                    staticClass: "st1",
                    attrs: {
                      d: "M1795.215,1206.701c-1.844,0-3.344-1.5-3.344-3.344h0c0-1.845,1.502-3.345,3.345-3.345.894,0,1.733.349,2.364.98.632.632.979,1.472.979,2.364,0,1.844-1.5,3.344-3.344,3.344ZM1792.371,1203.355l.5.002c0,1.292,1.052,2.344,2.344,2.344s2.344-1.052,2.344-2.344c0-.626-.243-1.215-.686-1.657-.442-.443-1.031-.688-1.657-.688-1.292,0-2.344,1.051-2.345,2.343h-.5Z",
                    },
                  }),
                  _vm._v(" "),
                  _c("path", {
                    staticClass: "st1",
                    attrs: {
                      d: "M1799.48,1203.857h-1.422c-.276,0-.5-.224-.5-.5s.224-.5.5-.5h1.422c.509,0,.922-.413.922-.922v-6.438c0-.362-.085-.725-.247-1.048l-1.365-2.729c-.642-1.283-1.932-2.081-3.367-2.081h-15.848c-2.076,0-3.766,1.688-3.766,3.765v8.531c0,.509.413.922.922.922h1.422c.276,0,.5.224.5.5s-.224.5-.5.5h-1.422c-1.06,0-1.922-.862-1.922-1.922v-8.531c0-2.627,2.138-4.765,4.766-4.765h15.848c1.816,0,3.449,1.009,4.262,2.634l1.365,2.729c.23.461.353.979.353,1.495v6.438c0,1.06-.862,1.922-1.922,1.922Z",
                    },
                  }),
                  _vm._v(" "),
                  _c("path", {
                    staticClass: "st1",
                    attrs: {
                      d: "M1800.902,1196.748h-25.593c-.276,0-.5-.224-.5-.5s.224-.5.5-.5h25.593c.276,0,.5.224.5.5s-.224.5-.5.5Z",
                    },
                  }),
                  _vm._v(" "),
                  _c("path", {
                    staticClass: "st1",
                    attrs: {
                      d: "M1792.371,1196.748c-.276,0-.5-.224-.5-.5v-7.108c0-.276.224-.5.5-.5s.5.224.5.5v7.108c0,.276-.224.5-.5.5Z",
                    },
                  }),
                  _vm._v(" "),
                  _c("path", {
                    staticClass: "st1",
                    attrs: {
                      d: "M1791.66,1189.64h-9.952c-1.452,0-2.633-1.181-2.633-2.633s1.181-2.633,2.633-2.633h9.952c1.452,0,2.633,1.181,2.633,2.633s-1.181,2.633-2.633,2.633ZM1781.708,1185.374c-.9,0-1.633.732-1.633,1.633s.732,1.633,1.633,1.633h9.952c.9,0,1.633-.732,1.633-1.633s-.732-1.633-1.633-1.633h-9.952Z",
                    },
                  }),
                ]),
              ]),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.title.includes(22)
        ? _c("g", { attrs: { id: "belvedere" } }, [
            _c("g", [
              _c("path", {
                staticClass: "st1",
                attrs: {
                  d: "M177.04,555.987c0,5.676-4.606,10.277-10.286,10.277c-5.68,0-10.285-4.601-10.285-10.277\n                c0-5.675,4.605-10.277,10.285-10.277C172.434,545.71,177.04,550.312,177.04,555.987z",
                },
              }),
              _vm._v(" "),
              _c("path", {
                staticClass: "st13",
                attrs: {
                  d: "M166.754,566.949c-6.049,0-10.97-4.918-10.97-10.962s4.921-10.962,10.97-10.962\n                c6.049,0,10.971,4.917,10.971,10.962S172.803,566.949,166.754,566.949z M166.754,546.395c-5.293,0-9.6,4.303-9.6,9.592\n                s4.307,9.592,9.6,9.592c5.294,0,9.601-4.303,9.601-9.592S172.048,546.395,166.754,546.395z",
                },
              }),
            ]),
            _vm._v(" "),
            _c("g", [
              _c("path", {
                staticClass: "st0",
                attrs: {
                  d: "M162,531L162,531c12.703,0,23,10.297,23,23l0,0c0,12.703-10.297,23-23,23l0,0c-12.703,0-23-10.297-23-23l0,0\n                C139,541.297,149.297,531,162,531z",
                },
              }),
            ]),
            _vm._v(" "),
            _c("g", [
              _c("path", {
                staticClass: "st1",
                attrs: {
                  d: "M162,578c-13.233,0-24-10.767-24-24s10.767-24,24-24s24,10.767,24,24S175.233,578,162,578z M162,532\n                c-12.131,0-22,9.869-22,22s9.869,22,22,22s22-9.869,22-22S174.131,532,162,532z",
                },
              }),
            ]),
            _vm._v(" "),
            _c("g", [
              _c("path", {
                staticClass: "st1",
                attrs: {
                  d: "M168.823,565.552c-2.607,0-4.728-2.121-4.728-4.728v-5.074c0-0.276,0.224-0.5,0.5-0.5s0.5,0.224,0.5,0.5\n                v2.169c0.866-1.109,2.215-1.823,3.728-1.823c1.207,0,2.31,0.455,3.146,1.201l-2.487-12.767c-0.053-0.275-0.202-0.524-0.42-0.7\n                c-0.217-0.176-0.503-0.275-0.771-0.266h-2.005c-0.317,0-0.617,0.124-0.843,0.35c-0.225,0.224-0.348,0.523-0.348,0.842v2.537\n                c0,0.276-0.224,0.5-0.5,0.5s-0.5-0.224-0.5-0.5v-2.537c0-0.586,0.228-1.136,0.641-1.549c0.415-0.415,0.965-0.643,1.55-0.643\n                h1.996c0.517,0.011,1.011,0.165,1.41,0.489c0.401,0.324,0.675,0.781,0.772,1.287l3.027,15.542c0.013,0.065,0.012,0.129,0,0.19\n                c0.039,0.245,0.06,0.496,0.06,0.751C173.552,563.431,171.431,565.552,168.823,565.552z M168.823,557.096\n                c-2.056,0-3.728,1.672-3.728,3.728c0,2.055,1.672,3.728,3.728,3.728c2.056,0,3.729-1.672,3.729-3.728\n                C172.552,558.769,170.879,557.096,168.823,557.096z M155.293,565.552c-2.607,0-4.729-2.121-4.729-4.728\n                c0-0.326,0.033-0.645,0.097-0.953l2.991-15.531c0.097-0.504,0.371-0.961,0.772-1.287c0.399-0.324,0.905-0.493,1.419-0.489h1.987\n                c0.578,0,1.143,0.234,1.55,0.643c0.413,0.413,0.641,0.963,0.641,1.549v2.537c0,0.276-0.224,0.5-0.5,0.5s-0.5-0.224-0.5-0.5\n                v-2.537c0-0.318-0.124-0.617-0.349-0.842c-0.222-0.222-0.528-0.35-0.842-0.35h-1.996c-0.295-0.002-0.563,0.089-0.78,0.265\n                c-0.218,0.177-0.367,0.425-0.419,0.699l-2.454,12.739c0.833-0.729,1.922-1.171,3.113-1.171c1.513,0,2.862,0.714,3.728,1.823\n                v-2.169c0-0.276,0.224-0.5,0.5-0.5s0.5,0.224,0.5,0.5v5.074C160.021,563.431,157.9,565.552,155.293,565.552z M151.638,560.083\n                c-0.049,0.24-0.074,0.488-0.074,0.742c0,2.055,1.673,3.728,3.729,3.728c2.056,0,3.728-1.672,3.728-3.728\n                c0-2.056-1.672-3.728-3.728-3.728c-1.8,0-3.306,1.281-3.653,2.979C151.639,560.078,151.639,560.08,151.638,560.083z\n                M166.286,552.022h-8.456c-0.276,0-0.5-0.224-0.5-0.5s0.224-0.5,0.5-0.5h8.456c0.276,0,0.5,0.224,0.5,0.5\n                S166.563,552.022,166.286,552.022z",
                },
              }),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.title.includes(27)
        ? _c("g", { attrs: { id: "vestiaire-1" } }, [
            _c("g", [
              _c("path", {
                staticClass: "st0",
                attrs: {
                  d: "M737,1368L737,1368c13.255,0,24,10.745,24,24l0,0c0,13.255-10.745,24-24,24l0,0c-13.255,0-24-10.745-24-24\n                l0,0C713,1378.745,723.745,1368,737,1368z",
                },
              }),
            ]),
            _vm._v(" "),
            _c("g", [
              _c("defs", [
                _c("rect", {
                  attrs: {
                    id: "SVGID_8_",
                    x: "725.059",
                    y: "1380.06",
                    width: "24",
                    height: "24",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("clipPath", { attrs: { id: "SVGID_9_" } }, [
                _c("use", {
                  staticStyle: { overflow: "visible" },
                  attrs: { "xlink:href": "#SVGID_8_" },
                }),
              ]),
              _vm._v(" "),
              _c("g", { staticClass: "st17" }, [
                _c("g", [
                  _c("defs", [
                    _c("rect", {
                      attrs: {
                        id: "SVGID_10_",
                        x: "725.059",
                        y: "1380.06",
                        width: "24",
                        height: "24",
                      },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("clipPath", { attrs: { id: "SVGID_11_" } }, [
                    _c("use", {
                      staticStyle: { overflow: "visible" },
                      attrs: { "xlink:href": "#SVGID_10_" },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("g", { staticClass: "st18" }, [
                    _c("g", [
                      _c("path", {
                        staticClass: "st1",
                        attrs: {
                          d: "M744.559,1386.93c-0.843,0-1.629-0.326-2.213-0.919c-0.587-0.584-0.912-1.367-0.912-2.2\n                                c0-0.829,0.333-1.637,0.916-2.215c1.178-1.173,3.238-1.173,4.418,0c0.583,0.579,0.917,1.386,0.917,2.215\n                                c0,0.833-0.325,1.615-0.916,2.204C746.187,1386.604,745.401,1386.93,744.559,1386.93z M744.559,1381.68\n                                c-0.557,0-1.105,0.228-1.504,0.625c-0.395,0.393-0.621,0.941-0.621,1.506c0,0.565,0.221,1.097,0.621,1.495\n                                c0.795,0.807,2.214,0.805,3.004,0.003c0.404-0.402,0.625-0.934,0.625-1.498s-0.227-1.113-0.622-1.506\n                                C745.663,1381.907,745.115,1381.68,744.559,1381.68z",
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("g", [
                      _c("path", {
                        staticClass: "st1",
                        attrs: {
                          d: "M744.559,1403.811c-0.72,0-1.429-0.294-1.944-0.806c-0.52-0.518-0.806-1.208-0.806-1.944v-3.314\n                                c-0.343-0.09-0.661-0.27-0.914-0.522c-0.378-0.376-0.586-0.878-0.586-1.413v-4.5c0-0.937,0.364-1.816,1.025-2.476\n                                c0.653-0.659,1.533-1.024,2.475-1.024h1.5c0.942,0,1.821,0.365,2.477,1.027c0.659,0.656,1.023,1.535,1.023,2.473v4.5\n                                c0,0.535-0.208,1.037-0.587,1.414c-0.253,0.252-0.571,0.432-0.913,0.521v3.314c0,0.736-0.287,1.427-0.807,1.944\n                                C745.988,1403.517,745.28,1403.811,744.559,1403.811z M743.809,1388.811c-0.673,0-1.301,0.26-1.767,0.73\n                                c-0.474,0.473-0.733,1.101-0.733,1.77v4.5c0,0.268,0.104,0.518,0.292,0.705c0.188,0.188,0.446,0.295,0.708,0.295\n                                c0.276,0,0.5,0.224,0.5,0.5v3.75c0,0.469,0.182,0.907,0.511,1.235c0.659,0.655,1.82,0.653,2.477,0\n                                c0.33-0.328,0.512-0.767,0.512-1.235v-3.75c0-0.276,0.224-0.5,0.5-0.5c0.262,0,0.519-0.107,0.707-0.295\n                                c0.189-0.188,0.293-0.438,0.293-0.705v-4.5c0-0.67-0.26-1.297-0.732-1.767c-0.468-0.474-1.095-0.733-1.768-0.733H743.809z",
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("g", [
                      _c("path", {
                        staticClass: "st1",
                        attrs: {
                          d: "M733.309,1385.811c-0.276,0-0.5-0.224-0.5-0.5v-1.5c0-0.276,0.224-0.5,0.5-0.5\n                                c0.195,0,0.389-0.059,0.562-0.17c0.16-0.111,0.286-0.265,0.359-0.447c0.079-0.187,0.098-0.383,0.06-0.577\n                                c-0.039-0.191-0.136-0.375-0.274-0.513c-0.138-0.138-0.316-0.232-0.517-0.274c-0.189-0.036-0.391-0.019-0.579,0.055\n                                c-0.176,0.077-0.334,0.208-0.442,0.372c-0.113,0.164-0.169,0.354-0.169,0.555c0,0.276-0.224,0.5-0.5,0.5s-0.5-0.224-0.5-0.5\n                                c0-0.404,0.117-0.789,0.339-1.113c0.21-0.317,0.518-0.575,0.886-0.735c0.384-0.153,0.782-0.19,1.167-0.112\n                                c0.393,0.082,0.746,0.271,1.021,0.547c0.28,0.28,0.469,0.634,0.548,1.024c0.078,0.393,0.038,0.791-0.116,1.154\n                                c-0.143,0.354-0.395,0.667-0.728,0.896c-0.197,0.127-0.405,0.219-0.618,0.274v1.064\n                                C733.809,1385.587,733.585,1385.811,733.309,1385.811z",
                        },
                      }),
                    ]),
                    _vm._v(" "),
                    _c("g", [
                      _c("path", {
                        staticClass: "st1",
                        attrs: {
                          d: "M736.309,1391.811h-10.5c-0.276,0-0.5-0.224-0.5-0.5v-1.5c0-0.176,0.092-0.339,0.243-0.429l7.5-4.5\n                                c0.147-0.089,0.328-0.095,0.481-0.019l4.5,2.25c0.247,0.124,0.347,0.424,0.224,0.671c-0.124,0.247-0.423,0.349-0.671,0.224\n                                l-4.254-2.127l-7.022,4.213v0.717h10c0.276,0,0.5,0.224,0.5,0.5S736.585,1391.811,736.309,1391.811z",
                        },
                      }),
                    ]),
                  ]),
                ]),
              ]),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.title.includes(23)
        ? _c("g", { attrs: { id: "parking-list" } }, [
            _c("g", { attrs: { id: "parking-5" } }, [
              _c("g", [
                _c("path", {
                  staticClass: "st0",
                  attrs: {
                    d: "M1445.214,1266.21L1445.214,1266.21c13.255,0,24,10.745,24,24l0,0c0,13.255-10.745,24-24,24l0,0\n                    c-13.255,0-24-10.745-24-24l0,0C1421.214,1276.955,1431.959,1266.21,1445.214,1266.21z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st1",
                  attrs: {
                    d: "M1451.193,1301.76h-11.84c-3.077,0-5.58-2.498-5.58-5.569v-11.841c0-3.071,2.503-5.569,5.58-5.569h11.84\n                    c3.071,0,5.57,2.498,5.57,5.569v11.841C1456.764,1299.262,1454.265,1301.76,1451.193,1301.76z M1439.354,1279.78\n                    c-2.525,0-4.58,2.05-4.58,4.569v11.841c0,2.52,2.055,4.569,4.58,4.569h11.84c2.521,0,4.57-2.05,4.57-4.569v-11.841\n                    c0-2.52-2.05-4.569-4.57-4.569H1439.354z M1442.243,1296.71c-0.276,0-0.5-0.224-0.5-0.5v-11.88c0-0.276,0.224-0.5,0.5-0.5h5.391\n                    c1.67,0,3.029,1.359,3.029,3.03v1.859c0,1.677-1.359,3.04-3.029,3.04h-4.891v4.45\n                    C1442.743,1296.486,1442.52,1296.71,1442.243,1296.71z M1442.743,1290.76h4.891c1.119,0,2.029-0.915,2.029-2.04v-1.859\n                    c0-1.119-0.91-2.03-2.029-2.03h-4.891V1290.76z",
                  },
                }),
              ]),
            ]),
            _vm._v(" "),
            _c("g", { attrs: { id: "parking-3" } }, [
              _c("g", [
                _c("path", {
                  staticClass: "st0",
                  attrs: {
                    d: "M900,1043L900,1043c13.255,0,24,10.745,24,24l0,0c0,13.255-10.745,24-24,24l0,0c-13.255,0-24-10.745-24-24\n                    l0,0C876,1053.745,886.745,1043,900,1043z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st1",
                  attrs: {
                    d: "M905.978,1078.55h-11.84c-3.074,0-5.574-2.498-5.574-5.569v-11.841c0-3.076,2.5-5.579,5.574-5.579h11.84\n                    c3.073,0,5.574,2.503,5.574,5.579v11.841C911.552,1076.052,909.051,1078.55,905.978,1078.55z M894.138,1056.561\n                    c-2.522,0-4.574,2.054-4.574,4.579v11.841c0,2.52,2.052,4.569,4.574,4.569h11.84c2.522,0,4.574-2.05,4.574-4.569v-11.841\n                    c0-2.525-2.052-4.579-4.574-4.579H894.138z M897.029,1073.5c-0.276,0-0.5-0.224-0.5-0.5v-11.88c0-0.276,0.224-0.5,0.5-0.5h5.387\n                    c1.675,0,3.037,1.359,3.037,3.03v1.859c0,1.677-1.362,3.04-3.037,3.04h-4.887v4.45\n                    C897.529,1073.276,897.305,1073.5,897.029,1073.5z M897.529,1067.55h4.887c1.123,0,2.037-0.915,2.037-2.04v-1.859\n                    c0-1.119-0.914-2.03-2.037-2.03h-4.887V1067.55z",
                  },
                }),
              ]),
            ]),
            _vm._v(" "),
            _c("g", { attrs: { id: "parking-2" } }, [
              _c("g", [
                _c("path", {
                  staticClass: "st0",
                  attrs: {
                    d: "M1965,1009L1965,1009c13.255,0,24,10.745,24,24l0,0c0,13.255-10.745,24-24,24l0,0\n                    c-13.255,0-24-10.745-24-24l0,0C1941,1019.745,1951.745,1009,1965,1009z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st1",
                  attrs: {
                    d: "M1970.98,1044.55h-11.841c-3.076,0-5.579-2.498-5.579-5.569v-11.841c0-3.077,2.503-5.58,5.579-5.58h11.841\n                    c3.071,0,5.569,2.503,5.569,5.58v11.841C1976.55,1042.052,1974.052,1044.55,1970.98,1044.55z M1959.14,1022.56\n                    c-2.525,0-4.579,2.055-4.579,4.58v11.841c0,2.52,2.054,4.569,4.579,4.569h11.841c2.52,0,4.569-2.05,4.569-4.569v-11.841\n                    c0-2.525-2.05-4.58-4.569-4.58H1959.14z M1962.03,1039.5c-0.276,0-0.5-0.224-0.5-0.5v-11.88c0-0.276,0.224-0.5,0.5-0.5h5.39\n                    c1.671,0,3.03,1.359,3.03,3.03v1.859c0,1.677-1.359,3.04-3.03,3.04h-4.89v4.45C1962.53,1039.276,1962.307,1039.5,1962.03,1039.5\n                    z M1962.53,1033.55h4.89c1.119,0,2.03-0.915,2.03-2.04v-1.859c0-1.119-0.911-2.03-2.03-2.03h-4.89V1033.55z",
                  },
                }),
              ]),
            ]),
            _vm._v(" "),
            _c("g", { attrs: { id: "parking-1" } }, [
              _c("g", [
                _c("path", {
                  staticClass: "st0",
                  attrs: {
                    d: "M788,550L788,550c13.255,0,24,10.745,24,24l0,0c0,13.255-10.745,24-24,24l0,0c-13.255,0-24-10.745-24-24\n                    l0,0C764,560.745,774.745,550,788,550z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st1",
                  attrs: {
                    d: "M793.978,585.552h-11.84c-3.074,0-5.574-2.5-5.574-5.574v-11.839c0-3.074,2.5-5.574,5.574-5.574h11.84\n                    c3.073,0,5.574,2.5,5.574,5.574v11.839C799.552,583.051,797.051,585.552,793.978,585.552z M782.138,563.565\n                    c-2.522,0-4.574,2.052-4.574,4.574v11.839c0,2.522,2.052,4.574,4.574,4.574h11.84c2.522,0,4.574-2.052,4.574-4.574v-11.839\n                    c0-2.522-2.052-4.574-4.574-4.574H782.138z M785.029,580.501c-0.276,0-0.5-0.224-0.5-0.5v-11.885c0-0.276,0.224-0.5,0.5-0.5\n                    h5.387c1.675,0,3.037,1.362,3.037,3.037v1.859c0,1.674-1.362,3.037-3.037,3.037h-4.887v4.452\n                    C785.529,580.277,785.305,580.501,785.029,580.501z M785.529,574.549h4.887c1.123,0,2.037-0.914,2.037-2.037v-1.859\n                    c0-1.123-0.914-2.037-2.037-2.037h-4.887V574.549z",
                  },
                }),
              ]),
            ]),
            _vm._v(" "),
            _c("g", { attrs: { id: "parking-4_1_" } }, [
              _c("g", [
                _c("path", {
                  staticClass: "st0",
                  attrs: {
                    d: "M1812,1124L1812,1124c13.255,0,24,10.745,24,24l0,0c0,13.255-10.745,24-24,24l0,0\n                    c-13.255,0-24-10.745-24-24l0,0C1788,1134.745,1798.745,1124,1812,1124z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st1",
                  attrs: {
                    d: "M1817.98,1159.55h-11.841c-3.076,0-5.579-2.498-5.579-5.569v-11.841c0-3.076,2.503-5.579,5.579-5.579\n                    h11.841c3.071,0,5.569,2.503,5.569,5.579v11.841C1823.55,1157.052,1821.052,1159.55,1817.98,1159.55z M1806.14,1137.561\n                    c-2.525,0-4.579,2.054-4.579,4.579v11.841c0,2.52,2.054,4.569,4.579,4.569h11.841c2.52,0,4.569-2.05,4.569-4.569v-11.841\n                    c0-2.525-2.05-4.579-4.569-4.579H1806.14z M1809.03,1154.5c-0.276,0-0.5-0.224-0.5-0.5v-11.88c0-0.276,0.224-0.5,0.5-0.5h5.39\n                    c1.671,0,3.03,1.359,3.03,3.03v1.859c0,1.677-1.359,3.04-3.03,3.04h-4.89v4.45C1809.53,1154.276,1809.307,1154.5,1809.03,1154.5\n                    z M1809.53,1148.55h4.89c1.119,0,2.03-0.915,2.03-2.04v-1.859c0-1.119-0.911-2.03-2.03-2.03h-4.89V1148.55z",
                  },
                }),
              ]),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("g", { attrs: { id: "pool-list" } }, [
        _vm.title.includes(53)
          ? _c("g", { attrs: { id: "pool-wip" } }, [
              _c("g", [
                _c("path", {
                  staticClass: "st16",
                  attrs: {
                    d: "M1022.81,1242.435L1022.81,1242.435c13.255,0,24,10.745,24,24l0,0c0,13.255-10.745,24-24,24l0,0\n                    c-13.255,0-24-10.745-24-24l0,0C998.81,1253.18,1009.555,1242.435,1022.81,1242.435z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st1",
                  attrs: {
                    d: "M1038.178,1278.737h-30.616c-0.78,0-1.504-0.421-1.89-1.1c-0.385-0.678-0.377-1.516,0.021-2.187\n                    l15.308-25.737c0.396-0.665,1.095-1.063,1.869-1.063c0.774,0,1.473,0.397,1.868,1.063l15.308,25.737\n                    c0.398,0.671,0.407,1.509,0.021,2.187C1039.682,1278.316,1038.958,1278.737,1038.178,1278.737z M1022.87,1249.651\n                    c-0.418,0-0.795,0.215-1.009,0.574l-15.308,25.737c-0.215,0.362-0.22,0.814-0.012,1.181s0.599,0.594,1.021,0.594h30.616\n                    c0.421,0,0.812-0.228,1.021-0.594c0.208-0.366,0.204-0.818-0.012-1.181l-15.308-25.737\n                    C1023.665,1249.866,1023.288,1249.651,1022.87,1249.651z",
                  },
                }),
              ]),
              _vm._v(" "),
              _c("g", [
                _c("path", {
                  staticClass: "st1",
                  attrs: {
                    d: "M1023.571,1260.209c0.781,0,1.414,0.633,1.414,1.414s-0.633,1.414-1.414,1.414s-1.414-0.633-1.414-1.414\n                    S1022.79,1260.209,1023.571,1260.209z M1018.383,1268.779l-0.013-0.013l0,0c-0.059-0.039-0.111-0.072-0.156-0.124l0.156,1.792\n                    l-1.968,2.789c-0.28,0.404-0.182,0.951,0.208,1.232c0.404,0.28,0.952,0.182,1.232-0.208l2.125-3.063\n                    c0.111-0.156,0.182-0.365,0.156-0.573l-0.072-0.867L1018.383,1268.779z M1024.229,1274.612h8.433l-1.577-4.92\n                    c0,0-0.893,0.222-2.659,2.099c-0.039,0.039-0.085,0.085-0.124,0.124l-4.262-2.464c0.072-0.137,0.085-0.293,0.059-0.463\n                    l-1.512-5.605c-0.124-0.547-0.613-0.965-1.186-0.965h-2.822c-0.208,0-0.417,0.111-0.534,0.293l-1.408,2.444\n                    c-0.182,0.293-0.072,0.671,0.222,0.841l1.577,0.906l-0.208,0.352c-0.254,0.417-0.111,0.952,0.319,1.186l3.539,2.04v3.233\n                    c0,0.489,0.391,0.88,0.88,0.88s0.88-0.391,0.88-0.88v-3.689l3.917,2.268c-0.808,0.463-1.734,0.547-2.392,0.938\n                    C1024.562,1273.713,1024.229,1274.612,1024.229,1274.612z M1018.735,1266.387l-1.036-0.6l0,0l1.232-2.125h1.382\n                    L1018.735,1266.387z M1021.01,1267.704l0.977-1.707l0.73,2.685L1021.01,1267.704z M1007.759,1276.68L1007.759,1276.68\n                    C1007.759,1276.68,1007.759,1276.68,1007.759,1276.68L1007.759,1276.68z",
                  },
                }),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("g", { staticClass: "st19", attrs: { id: "pool-ready_1_" } }, [
          _c("g", { staticClass: "st20", attrs: { id: "pool-ready" } }, [
            _c("g", [
              _c("path", {
                staticClass: "st0",
                attrs: {
                  d: "M1022.81,1242.435L1022.81,1242.435c13.255,0,24,10.745,24,24l0,0c0,13.255-10.745,24-24,24l0,0\n                        c-13.255,0-24-10.745-24-24l0,0C998.81,1253.18,1009.555,1242.435,1022.81,1242.435z",
                },
              }),
            ]),
          ]),
          _vm._v(" "),
          _c("g", { staticClass: "st20" }, [
            _c("path", {
              staticClass: "st1",
              attrs: {
                d: "M1014.367,1275.197c0.015-0.232,0.197-0.422,0.43-0.445c0.245-0.024,0.469,0.142,0.518,0.384\n                    c0.364,1.831,1.553,3.627,3.397,3.263c0.313-0.061,0.619-0.239,0.859-0.467c0.755-0.72,1.154-1.76,1.404-2.813\n                    c0.057-0.237,0.281-0.394,0.523-0.365c0.234,0.027,0.412,0.22,0.423,0.454c0.375,1.817,1.559,3.582,3.389,3.22\n                    c0.313-0.061,0.618-0.239,0.859-0.467c0.755-0.72,1.154-1.76,1.403-2.813c0.053-0.22,0.25-0.373,0.476-0.368\n                    c0.225,0.004,0.417,0.164,0.461,0.385c0.365,1.831,1.553,3.626,3.398,3.263c0.313-0.061,0.619-0.239,0.859-0.467\n                    c0.755-0.72,1.154-1.76,1.404-2.813c0.06-0.257,0.319-0.417,0.577-0.356c0.257,0.06,0.416,0.319,0.356,0.577\n                    c-0.292,1.234-0.789,2.441-1.675,3.286c-0.372,0.354-0.851,0.617-1.336,0.713c-1.854,0.366-3.291-0.862-4.052-2.542\n                    c-0.291,0.691-0.681,1.324-1.21,1.828c-0.371,0.354-0.85,0.617-1.335,0.713c-1.86,0.367-3.299-0.869-4.059-2.556\n                    c-0.29,0.686-0.678,1.313-1.203,1.813c-0.371,0.354-0.851,0.618-1.335,0.713c-1.849,0.365-3.284-0.855-4.046-2.527\n                    c-0.291,0.697-0.683,1.336-1.216,1.844c-0.372,0.354-0.851,0.617-1.336,0.713c-2.367,0.467-4.055-1.663-4.523-4.016\n                    c-0.052-0.259,0.117-0.512,0.376-0.564c0.26-0.052,0.512,0.117,0.564,0.377c0.365,1.831,1.553,3.626,3.398,3.263\n                    c0.313-0.061,0.619-0.239,0.859-0.467C1013.718,1277.253,1014.116,1276.233,1014.367,1275.197L1014.367,1275.197z",
              },
            }),
          ]),
          _vm._v(" "),
          _c("g", { staticClass: "st20" }, [
            _c("path", {
              staticClass: "st1",
              attrs: {
                d: "M1014.369,1269.113c0.015-0.232,0.197-0.421,0.43-0.444c0.245-0.024,0.47,0.142,0.518,0.384\n                    c0.361,1.817,1.565,3.256,3.394,2.896c0.313-0.062,0.619-0.239,0.859-0.468c0.755-0.719,1.154-1.759,1.404-2.812\n                    c0.057-0.237,0.281-0.394,0.523-0.365c0.234,0.027,0.412,0.22,0.423,0.454c0.375,1.817,1.559,3.581,3.389,3.22\n                    c0.313-0.062,0.618-0.239,0.859-0.468c0.745-0.709,1.113-1.266,1.359-2.303c0.053-0.219,0.25-0.373,0.475-0.369\n                    c0.225,0.004,0.417,0.165,0.461,0.385c0.362,1.814,1.616,3.114,3.442,2.755c0.313-0.062,0.619-0.239,0.859-0.468\n                    c0.755-0.719,1.154-1.759,1.404-2.812c0.06-0.257,0.319-0.417,0.577-0.356c0.257,0.06,0.416,0.319,0.356,0.576\n                    c-0.292,1.235-0.789,2.442-1.675,3.287c-0.372,0.353-0.851,0.617-1.336,0.713c-1.889,0.373-3.354-0.558-4.116-2.139\n                    c-0.272,0.51-0.634,0.939-1.146,1.426c-0.371,0.353-0.85,0.617-1.335,0.713c-1.86,0.367-3.299-0.869-4.059-2.556\n                    c-0.29,0.686-0.678,1.313-1.203,1.813c-0.371,0.353-0.851,0.617-1.335,0.713c-1.878,0.37-3.311-0.641-4.064-2.244\n                    c-0.289,0.57-0.674,1.06-1.198,1.56c-0.372,0.353-0.851,0.617-1.336,0.713c-2.367,0.467-4.055-1.664-4.523-4.016\n                    c-0.052-0.26,0.117-0.512,0.376-0.564c0.26-0.052,0.512,0.117,0.564,0.377c0.365,1.831,1.553,3.626,3.398,3.263\n                    c0.313-0.062,0.619-0.239,0.859-0.468C1013.712,1270.808,1014.121,1270.129,1014.369,1269.113L1014.369,1269.113z",
              },
            }),
          ]),
          _vm._v(" "),
          _c("g", { staticClass: "st20" }, [
            _c("path", {
              staticClass: "st1",
              attrs: {
                d: "M1021.079,1255.543c0-2.023-1.517-3.643-3.356-3.643s-3.356,1.62-3.356,3.643l0.003,14.062\n                    c0.001,0.265,0.216,0.479,0.48,0.479c0.265,0,0.479-0.215,0.478-0.479l-0.003-14.062c0-1.47,1.061-2.685,2.397-2.685\n                    c1.337,0,2.397,1.215,2.397,2.685c0,0.265,0.215,0.479,0.479,0.479S1021.079,1255.808,1021.079,1255.543L1021.079,1255.543z",
              },
            }),
          ]),
          _vm._v(" "),
          _c("g", { staticClass: "st20" }, [
            _c("path", {
              staticClass: "st1",
              attrs: {
                d: "M1027.514,1262.191v-6.648c0-2.023,1.517-3.643,3.356-3.643s3.356,1.62,3.356,3.643\n                    c0,0.265-0.215,0.479-0.479,0.479s-0.479-0.215-0.479-0.479c0-1.47-1.061-2.685-2.397-2.685c-1.337,0-2.397,1.215-2.397,2.685\n                    v13.694l-0.001,0.025l-0.002,0.024l-0.003,0.024l-0.004,0.024c-0.002,0.008-0.004,0.015-0.006,0.023l-0.007,0.023l-0.007,0.022\n                    l-0.009,0.022l-0.01,0.021l-0.01,0.02l-0.012,0.02l-0.012,0.02l-0.013,0.018l-0.014,0.018l-0.015,0.017l-0.016,0.017\n                    l-0.016,0.015l-0.017,0.015l-0.018,0.014l-0.019,0.013l-0.019,0.012l-0.02,0.011l-0.02,0.011l-0.021,0.01l-0.022,0.009\n                    l-0.022,0.008l-0.023,0.006l-0.023,0.006l-0.024,0.004l-0.024,0.003l-0.024,0.002l-0.025,0.001l-0.025-0.001l-0.024-0.002\n                    l-0.024-0.003l-0.024-0.004l-0.023-0.006l-0.023-0.006l-0.022-0.008l-0.022-0.009l-0.021-0.01l-0.02-0.011l-0.02-0.011\n                    l-0.02-0.012l-0.018-0.013l-0.018-0.014l-0.017-0.015l-0.017-0.015l-0.015-0.017l-0.015-0.017l-0.014-0.018l-0.013-0.018\n                    l-0.012-0.02l-0.011-0.02l-0.01-0.02l-0.01-0.021l-0.009-0.022l-0.008-0.022l-0.006-0.023l-0.006-0.023l-0.004-0.024\n                    l-0.004-0.024l-0.001-0.024l-0.001-0.025v-6.087h-12.667c-0.265,0-0.479-0.215-0.479-0.479s0.215-0.479,0.479-0.479H1027.514\n                    L1027.514,1262.191z",
              },
            }),
          ]),
          _vm._v(" "),
          _c("g", { staticClass: "st20" }, [
            _c("path", {
              staticClass: "st1",
              attrs: {
                d: "M1014.836,1267.949c0.42,0.01,13.156-0.019,13.156-0.019c0.265-0.001,0.478-0.216,0.478-0.48\n                    c-0.001-0.265-0.217-0.479-0.481-0.478c0,0-12.712,0.029-13.131,0.019c-0.265-0.006-0.484,0.203-0.49,0.468\n                    C1014.362,1267.723,1014.572,1267.942,1014.836,1267.949L1014.836,1267.949z",
              },
            }),
          ]),
          _vm._v(" "),
          _c("g", { staticClass: "st20" }, [
            _c("path", {
              staticClass: "st1",
              attrs: {
                d: "M1014.858,1258.291c0.42,0.01,13.156-0.019,13.156-0.019c0.265,0,0.479-0.216,0.478-0.48\n                    c0-0.265-0.216-0.478-0.48-0.478c0,0-12.713,0.029-13.132,0.019c-0.264-0.006-0.484,0.204-0.49,0.469\n                    S1014.594,1258.285,1014.858,1258.291L1014.858,1258.291z",
              },
            }),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _vm.title.includes(54)
        ? _c("g", { attrs: { id: "test-shop_1_" } }, [
            _c("g", [
              _c("path", {
                staticClass: "st0",
                attrs: {
                  d: "M1065.269,1215.19L1065.269,1215.19c13.255,0,24,10.745,24,24l0,0c0,13.255-10.745,24-24,24l0,0\n                c-13.255,0-24-10.745-24-24l0,0C1041.269,1225.935,1052.014,1215.19,1065.269,1215.19z",
                },
              }),
            ]),
            _vm._v(" "),
            _c("g", [
              _c("path", {
                staticClass: "st1",
                attrs: {
                  d: "M1078.078,1243.229c-0.132,0-0.264-0.052-0.362-0.155l-12.388-13.019l-12.388,13.019\n                c-0.19,0.201-0.507,0.208-0.707,0.018s-0.208-0.507-0.018-0.707l12.75-13.399c0.188-0.199,0.536-0.199,0.725,0l12.75,13.399\n                c0.19,0.2,0.183,0.517-0.018,0.707C1078.326,1243.184,1078.202,1243.229,1078.078,1243.229z",
                },
              }),
            ]),
            _vm._v(" "),
            _c("g", [
              _c("path", {
                staticClass: "st1",
                attrs: {
                  d: "M1063.264,1243.457c0-0.292-0.236-0.528-0.528-0.528s-0.528,0.236-0.528,0.528\n                c0.002,1.457,1.183,2.638,2.64,2.64v0.528c0,0.292,0.236,0.528,0.528,0.528s0.528-0.236,0.528-0.528v-0.528\n                c1.458,0,2.64-1.182,2.64-2.64c0-1.458-1.182-2.64-2.64-2.64v-3.168c0.875,0,1.584,0.709,1.584,1.584\n                c0,0.292,0.236,0.528,0.528,0.528c0.292,0,0.528-0.236,0.528-0.528c-0.002-1.457-1.183-2.638-2.64-2.64v-0.528\n                c0-0.292-0.236-0.528-0.528-0.528s-0.528,0.236-0.528,0.528v0.528c-1.458,0-2.64,1.182-2.64,2.64c0,1.458,1.182,2.64,2.64,2.64\n                v3.168C1063.973,1245.042,1063.264,1244.332,1063.264,1243.457z M1065.904,1241.873c0.875,0,1.584,0.709,1.584,1.584\n                c0,0.875-0.709,1.584-1.584,1.584V1241.873z M1063.264,1239.233c0-0.875,0.709-1.584,1.584-1.584v3.168\n                C1063.973,1240.817,1063.264,1240.108,1063.264,1239.233z",
                },
              }),
            ]),
            _vm._v(" "),
            _c("g", [
              _c("path", {
                staticClass: "st1",
                attrs: {
                  d: "M1073.328,1249.17c0,0.27,0.223,0.5,0.5,0.5c0.276,0,0.5-0.23,0.5-0.5H1073.328z M1073.328,1237.83v11.34h1\n                v-10.813L1073.328,1237.83z",
                },
              }),
            ]),
            _vm._v(" "),
            _c("g", [
              _c("path", {
                staticClass: "st1",
                attrs: {
                  d: "M1073.828,1249.917c0.27,0,0.5-0.223,0.5-0.5c0-0.276-0.23-0.5-0.5-0.5V1249.917z M1062.488,1249.917h11.34\n                v-1h-10.813L1062.488,1249.917z",
                },
              }),
            ]),
            _vm._v(" "),
            _c("g", [
              _c("path", {
                staticClass: "st1",
                attrs: {
                  d: "M1056.828,1248.917c-0.27,0-0.5,0.223-0.5,0.5c0,0.276,0.23,0.5,0.5,0.5V1248.917z M1068.168,1248.917\n                h-11.34v1h10.813L1068.168,1248.917z",
                },
              }),
            ]),
            _vm._v(" "),
            _c("g", [
              _c("path", {
                staticClass: "st1",
                attrs: {
                  d: "M1056.328,1249.17c0,0.27,0.223,0.5,0.5,0.5c0.276,0,0.5-0.23,0.5-0.5H1056.328z M1056.328,1238.145v11.025\n                h1v-11.34L1056.328,1238.145z",
                },
              }),
            ]),
            _vm._v(" "),
            _c("g"),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.title.includes(26)
        ? _c("g", { attrs: { id: "admin_2_" } }, [
            _c("g", [
              _c("path", {
                staticClass: "st0",
                attrs: {
                  d: "M1493.836,1231L1493.836,1231c13.255,0,24,10.745,24,24l0,0c0,13.255-10.745,24-24,24l0,0\n                c-13.255,0-24-10.745-24-24l0,0C1469.836,1241.745,1480.581,1231,1493.836,1231z",
                },
              }),
            ]),
            _vm._v(" "),
            _c("g", [
              _c("path", {
                staticClass: "st1",
                attrs: {
                  d: "M1503.196,1266.55h-18.6c-0.578,0-1.128-0.224-1.548-0.63c-0.423-0.423-0.652-0.975-0.652-1.56v-9.4\n                c0-0.296,0.06-0.591,0.177-0.879c0.151-0.317,0.324-0.552,0.54-0.744l10.444-9.634c0.191-0.178,0.486-0.178,0.678,0l10.45,9.64\n                c0.229,0.215,0.406,0.466,0.52,0.729c0.121,0.264,0.182,0.558,0.182,0.888v9.4c0,0.577-0.224,1.127-0.631,1.548\n                C1504.324,1266.326,1503.774,1266.55,1503.196,1266.55z M1493.896,1244.751l-10.111,9.326c-0.122,0.109-0.218,0.241-0.299,0.409\n                c-0.057,0.142-0.09,0.306-0.09,0.474v9.4c0,0.318,0.126,0.618,0.354,0.847c0.227,0.219,0.529,0.343,0.847,0.343h18.6\n                c0.317,0,0.62-0.124,0.853-0.349c0.214-0.222,0.338-0.524,0.338-0.841v-9.4c0-0.184-0.031-0.342-0.096-0.483\n                c-0.064-0.148-0.162-0.284-0.287-0.402L1493.896,1244.751z M1496.816,1261.99h-5.84c-0.885,0-2.2-0.583-2.2-2.19v-4.16\n                c0-0.88,0.586-2.189,2.2-2.189h0.3v-0.46c0-1.213,0.982-2.2,2.19-2.2h0.859c1.208,0,2.19,0.987,2.19,2.2v0.46h0.3\n                c0.881,0,2.19,0.583,2.19,2.189v4.16C1499.007,1260.681,1498.424,1261.99,1496.816,1261.99z M1490.977,1254.45\n                c-1.127,0-1.197,0.993-1.2,1.192v4.157c0,1.157,1.077,1.19,1.2,1.19h5.84c1.117,0,1.188-0.994,1.19-1.193v-4.157\n                c0-1.156-1.068-1.189-1.19-1.189H1490.977z M1492.276,1253.45h3.24v-0.46c0-0.662-0.534-1.2-1.19-1.2h-0.859\n                c-0.656,0-1.19,0.538-1.19,1.2V1253.45z",
                },
              }),
            ]),
          ])
        : _vm._e(),
    ]
  )
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-f4adaed0_0", { source: "\n.st0[data-v-f4adaed0]{fill:#4D80D6;}\n.st1[data-v-f4adaed0]{fill:#FFFFFF;}\n.st2[data-v-f4adaed0]{fill:#FFCF70;}\n.st3[data-v-f4adaed0]{fill:#C6E9FA;}\n.st4[data-v-f4adaed0]{fill:#66CDF5;}\n.st5[data-v-f4adaed0]{fill:#254170;}\n.st6[data-v-f4adaed0]{fill:#487264;}\n.st7[data-v-f4adaed0]{fill:#93B8F5;}\n.st8[data-v-f4adaed0]{opacity:0.4;enable-background:new    ;}\n.st9[data-v-f4adaed0]{clip-path:url(#SVGID_2_);}\n.st10[data-v-f4adaed0]{fill:#663108;}\n.st11[data-v-f4adaed0]{opacity:0;}\n.st12[data-v-f4adaed0]{fill:none;}\n.st13[data-v-f4adaed0]{fill:#0389CA;}\n.st14[data-v-f4adaed0]{fill:#9CBEAF;}\n.st15[data-v-f4adaed0]{clip-path:url(#SVGID_6_);}\n.st16[data-v-f4adaed0]{fill:#DB8544;}\n.st17[data-v-f4adaed0]{clip-path:url(#SVGID_9_);}\n.st18[data-v-f4adaed0]{clip-path:url(#SVGID_11_);}\n.st19[data-v-f4adaed0]{display:none;}\n.st20[data-v-f4adaed0]{display:inline;}\n", map: {"version":3,"sources":["src/js/Vue/card.vue"],"names":[],"mappings":";AAuiGA,sBAAA,YAAA,CAAA;AACA,sBAAA,YAAA,CAAA;AACA,sBAAA,YAAA,CAAA;AACA,sBAAA,YAAA,CAAA;AACA,sBAAA,YAAA,CAAA;AACA,sBAAA,YAAA,CAAA;AACA,sBAAA,YAAA,CAAA;AACA,sBAAA,YAAA,CAAA;AACA,sBAAA,WAAA,CAAA,yBAAA,CAAA;AACA,sBAAA,wBAAA,CAAA;AACA,uBAAA,YAAA,CAAA;AACA,uBAAA,SAAA,CAAA;AACA,uBAAA,SAAA,CAAA;AACA,uBAAA,YAAA,CAAA;AACA,uBAAA,YAAA,CAAA;AACA,uBAAA,wBAAA,CAAA;AACA,uBAAA,YAAA,CAAA;AACA,uBAAA,wBAAA,CAAA;AACA,uBAAA,yBAAA,CAAA;AACA,uBAAA,YAAA,CAAA;AACA,uBAAA,cAAA,CAAA","file":"card.vue","sourcesContent":["<template>\n    <svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"2171px\"\n        height=\"1538px\" viewBox=\"0 0 2171 1538\" style=\"enable-background:new 0 0 2171 1538;\" xml:space=\"preserve\">\n    <g v-if=\"season=='hiver'\" id=\"hiver\">\n        <g id=\"water-bg\">\n            <rect class=\"st0\" width=\"2170.15\" height=\"1537.06\"/>\n        </g>\n        <g id=\"land\">\n            <g>\n                <path class=\"st1\" d=\"M2107.3,997.777c-10.98-8.021-18.12-5.91-30.36-6.754c-12.21-0.844-10.98,0-27.4,0\n                    c-16.43,0-45.1,2.11-75.46-5.066c-30.36-7.175-50.16-7.175-65.78-8.864c-15.58-1.688-44.25-5.909-63.25-15.157\n                    c-18.96-9.287-28.36-1.804-38.03-0.538c0,0-6.95,1.036-13.7-2.839c-6.76-3.914-21.07,2.647-25.6,5.909\n                    c-4.53,3.262-17.62,4.643-30.36,2.226c-12.74-2.418-18.96-2.303-26.37,0.959c-7.37,3.262-17.38,2.648-20.34-0.192\n                    c-2.95-2.839-17.08-5.065-29.2-2.532c-12.13,2.532-36.58-5.142-44.91-7.522c-8.33-2.379-33.43-3.223-42.25-3.223\n                    c-8.83,0-44.48,0.883-59.64,0s-26.1,1.151-33.05,4.95c-6.95,3.799-14.7,6.639-19.3-0.614c-4.57-7.291-0.16-6.178-4.42-10.13\n                    c-4.26-3.953-13.12-5.833-27.82-5.68c-14.7,0.154-45.86,4.106-55.5,1.881c0,0-2.57-0.96-0.46-3.377\n                    c2.11-2.418,9.9-11.973,10.48-14.813c0.57-2.839,0.96-8.211,1.23-11.128c0.23-2.916-1.58-2.533-2.23-2.302\n                    c-0.61,0.23-3.15,4.912-4.41,9.171c-1.27,4.259-4.26,9.478-6.64,11.474c-2.38,1.957-8.14,8.212-9.48,13.047\n                    c-1.34,4.835-0.81,9.977-1.96,13.929c-1.19,3.953-3.64,4.989-4.49,6.332c-0.88,1.343-1.57,4.413-1.19,7.828\n                    c0.38,3.416-6.72,5.526-10.67,2.61c-3.95-2.917-10.36-5.833-10.67-8.634c-0.3-2.763-2.99-7.982-4.26-11.935\n                    c-1.26-3.952,0.39-6.101,0.23-8.135c-0.15-2.072,0.54-6.869-2.84-7.176c-3.41-0.307-15.08,4.567-25.06,9.095\n                    c-9.98,4.49-20.23,9.095-28.55,8.788c-8.29-0.307-20.19,1.112-25.14-8.366c-4.95-9.478-6.41-6.216-13.74-5.372\n                    c-7.33,0.844-7.1,0-13.74,1.88s-15.81,1.88-21.3,1.995c-5.49,0.116-10.33,0.538-14.43-2.417\n                    c-4.11-2.955-17.08-13.392-18.65-14.429c-1.58-1.036-13.28-8.096-24.26,2.955c0,0-10.21,12.011-19.07,12.97\n                    c-8.87,0.96-28.37-0.115-36.46-0.422c-8.1-0.307-24.45,5.488-32.47,6.025c-8.02,0.537-7.6-0.115-7.6-0.115l-5.84-77.822\n                    l-14.08-169.19c0,0-1.11-23.331-6.33-28.243c0,0,18.34-3.799,45.36-6.024c27.02-2.226,36.04-7.445,42.22-10.131\n                    c6.18-2.686,36.99-9.018,57.87-10.591c0,0,6.18-0.806,13.13-4.758c0,0,3.49-1.881-2-13.93c-5.45-12.011-9.02-17.614-11.4-19.763\n                    c-2.37-2.148-5.6-4.106-5.6-4.106s-3.07-1.88-1.42,2.994c1.65,4.911,1.27,6.331,3.15,10.514c1.88,4.183,1.96,5.756,1.8,8.941\n                    c-0.15,3.147,1.04,8.634-6.48,1.113c0,0-3.5-2.533-6.87-4.183c-3.42-1.65-10.14-5.526-13.05-11.474\n                    c-2.92-5.909-5.22-12.318-5.07-19.992c0.15-7.675,1.5-23.715-8.79-28.55c-10.28-4.835-20.38-6.102-22.3-6.178\n                    c-1.88-0.077-12.97-1.113-23.56-18.957c-10.59-17.844-26.48-20.07-37.46-22.372s-22.6-3.876-31.55-9.785\n                    c-8.939-5.91-13.352-4.682-21.028-2.917c-7.676,1.727-16.35,4.106-24.409-7.598c-8.06-11.704-16.849-8.135-18.883-8.71\n                    c-2.072-0.538-14.929-4.759-25.676-17.537c-10.746-12.817-32.161-20.07-34.694-22.219c-2.533-2.149-19.996-14.39-28.631-22.678\n                    c-8.635-8.289-27.288-12.664-39.07-18.036c-11.782-5.372-31.624-20.146-36.115-27.361c-4.49-7.175-11.552-11.857-17.846-19.762\n                    c-6.333-7.905-10.746-20.223-46.017-26.401c-35.27-6.178-47.897-18.189-54.69-28.627c-6.793-10.438-18.345-26.401-34.464-31.773\n                    c-16.12-5.373-37.612-6.486-55.497-21.988c-2.686-2.341-7.1-4.567-12.665-6.716l-30.204-24.943c0,0-22.145-26.977-36.192-31.505\n                    c-14.085-4.528-29.091-6.293-35.654-16.846c-6.563-10.552-20.609-16.692-29.859-21.105c-9.249-4.413-11.015-17.575-23.334-24.636\n                    c-12.32-7.023-20.226-11.435-23.296-14.966C377.165,111.728,342.355,60,342.355,60H60c0,0,68.737,114.469,87.811,132.811\n                    c19.113,18.305,22.222,41.175,29.015,46.471c6.793,5.257,7.676,9.67,16.465,25.518c8.789,15.81,14.891,26.171,21.07,31.544\n                    c6.179,5.372,20.264,13.315,26.405,17.69c6.14,4.375,29.897,11.973,33.658,16.693c4.337,5.103,8.021,10.437,10.478,16.04\n                    c13.931,31.62,20.878,28.473,28.477,44.245c7.599,15.81,22.145,21.489,34.772,39.831c12.665,18.343,28.438,15.81,41.756,27.207\n                    c13.279,11.397,15.812,17.691,22.759,24.022c6.946,6.332,22.145,15.158,31.624,18.343c9.48,3.147,28.439,13.93,28.439,13.93\n                    s9.173,4.413,33.428,1.458c24.256-2.955,28.478-1.573,31.51-2.648c3.07-1.036,4.337-0.422,4.337-0.422s-1.689,6.946,9.364,14.121\n                    c11.053,7.176,26.136,9.479,45.748,11.167c19.612,1.689,34.349,10.745,50.814,19.609c16.426,8.865,27.825,12.971,45.863,17.69\n                    c18.038,4.759,29.091,15.158,38.264,18.957c9.173,3.799,10.439,0.959,20.571,6.025c10.132,5.065,28.785,8.519,37.305,11.051\n                    c8.52,2.533,17.078,5.373,36.038,9.786c18.959,4.413,34.464,9.171,42.063,14.85c7.599,5.68,19.612,12.011,30.972,17.384\n                    c11.399,5.372,31.625,9.785,44.597,9.478c12.972-0.307,13.586,2.84,24.332,7.291c10.746,4.413,16.772,6.946,24.026,7.598\n                    c0,0,2.149,0.307,3.646,0.806c0,0,4.493,6.638,5.223,16.616c0.73,9.977,13.51,162.013,13.51,162.013s0.3,1.305-13.09-2.456\n                    c-13.396-3.799-20.458,0.538-33.2-1.573c-12.742-2.11-21.607,0.23-26.443-2.302c-4.836-2.533-17.27-8.634-20.571-13.086\n                    c-3.262-4.413-8.751-11.819-22.03-12.318c-13.279-0.537-24.255,8.212-35.001,10.745c-10.747,2.533-29.514,2.724-53.962,0.537\n                    c-24.447-2.226-34.694-1.88-40.49-2.417c-5.795-0.538-16.004-1.574-22.029-2.725c-6.026-1.151-11.821-1.995-19.075-1.688\n                    c-7.253,0.307-22.643-1.152-28.784-3.262c-6.102-2.111-16.772-0.192-28.899,2.11c-12.128,2.303-9.173,0.845-17.194,2.533\n                    c-8.022,1.689-8.751,0.422-12.435,0.959c-3.685,0.538-13.087-0.614-12.972-10.744c0.115-10.131,12.972-7.598,14.238-7.79\n                    c1.267-0.23,5.68,1.88,11.706,0s7.676-7.176,13.471-9.709c5.795-2.532,10.439-5.372,14.968-10.629\n                    c4.529-5.257,12.665-11.167,22.452-11.704c9.786-0.537,17.078,1.573,31.202-0.307c14.124-1.88,21.185-5.181,31.509-4.221\n                    c10.324,0.959,26.443,5.794,34.043,6.869c7.599,1.036,19.726,1.266,22.989-6.217c3.262-7.483-7.062-8.02-16.657-11.704\n                    c-9.595-3.684-26.558-11.051-31.394-14.313s-17.386-5.181-29.398-7.598c-12.013-2.418-7.293-3.147-15.506-6.524\n                    c-8.213-3.377-15.812-12.855-27.21-17.268c-11.399-4.413-3.148-8.864-21.723-13.699c-18.537-4.835-16.848-8.443-27.633-8.212\n                    c-10.746,0.23-17.079-3.799-22.145-5.488c-5.066-1.688-19.381-10.322-40.682-10.975c-21.3-0.614-40.912-3.568-49.317-14.313\n                    c-8.443-10.745-8.443-15.158-32.046-22.756c-23.604-7.598-23.412-22.755-34.772-29.509\n                    c-11.399-6.754-17.271-13.085-44.481-11.397c0,0-9.71,1.036-23.412-6.524c-13.701-7.597-27.402-3.568-34.579-2.724\n                    s-15.582,2.533-17.923-8.02c-2.303-10.553-6.525-15.81-15.39-18.957c-8.866-3.146-22.337-2.532-33.083-2.11\n                    s-17.271,0.614-26.136-5.066c-8.866-5.679-13.548-6.446-17.808-6.753s-9.71,1.189-15.736,2.417\n                    c-6.025,1.228-9.863,1.42-11.513-4.106c-1.612-5.526-5.565-9.555-8.943-9.133c-3.377,0.422-1.88,3.07-4.951,2.725\n                    c-3.07-0.307-6.639,0.23-10.861-1.574c-4.222-1.803-7.791-4.106-13.394-4.528c-5.604-0.422-5.373-0.422-6.026,1.881\n                    c-0.614,2.302,0.96,2.302-3.262,0.614c-4.222-1.689-4.836-3.262-8.098-3.915c-3.262-0.613-9.441-2.302-14.546-4.221\n                    c0,0-12.012-6.945-18.115,3.377c-6.102,10.323-3.377,15.273,0,21.912c3.378,6.638,8.022,10.859,10.324,13.699\n                    c2.303,2.84,4.951,10.016,5.373,15.58c0.423,5.602,6.755,12.011,10.133,17.191c3.377,5.181,6.025,12.126,7.714,16.424\n                    c1.688,4.298,12.665,12.855,26.021,12.855c13.356,0,31.624,0.192,44.366,15.58c0,0,10.861,9.9,18.959,15.58\n                    c0,0,2.226,1.727,11.629,9.862c9.403,8.135,9.403,11.205,17.156,18.496c7.752,7.253,14.545,13.277,16.426,19.455\n                    c1.881,6.179,3.646,11.704,3.339,17.691c-0.307,6.024,2.379,16.193,5.22,21.873c2.84,5.679,10.324,20.453,16.349,27.936\n                    c6.026,7.483,19.919,23.523,23.91,28.55c3.992,5.065,14.738,20.031,19.19,27.706c4.413,7.713,17.539,26.708,24.831,48.849\n                    c7.254,22.142,7.1,22.602,9.787,32.234c2.686,9.632,21.339,45.051,26.251,52.649c4.913,7.598,8.904,41.331,9.557,51.231\n                    c0.614,9.9-1.267,10.13,5.68,31.39c6.946,21.29,8.443,39.41,7.177,51.65c-1.267,12.24-2.534,35.61,6.524,49.73\n                    c9.057,14.12,36.997,61.67,37.957,71.15c0.959,9.47,4.414,25.28,31.624,30.35c27.211,5.06,40.145,8.86,61.023,41.75\n                    s23.411,27.82,37.305,62.59c13.931,34.76,38.878,72.72,85.048,95.16c46.17,22.45,130.604,24.99,202.68,14.85\n                    c72.074-10.13,82.514-19.91,100.554-27.2c18.04-7.25,56.61-30.36,74.95-30.97c18.35-0.61,43.95-2.53,53.12-2.23\n                    c9.17,0.31,33.85,0.62,46.48-4.41c12.66-5.06,11.55-1.57,20.72-2.53l9.18-0.96c0,0,25.59-2.07,40.95-3.8\n                    c15.35-1.73,70.19-6.18,103.7-12.82c33.5-6.63,75.56-12.97,112.56-25.13c37-12.17,68.47-25.6,85.86-29.89\n                    c17.38-4.26,38.41-20.07,43.63-24.33s26.87-15.35,31.32-16.93c4.41-1.57,9.79-4.75,14.09-10.13\n                    c4.26-5.37,62.82-24.13,77.14-27.28c14.31-3.15,59.64-16.12,69.04-17.81c9.37-1.68,33.43-12.66,46.29-19.6\n                    c12.85-6.95,23.72-14.86,30.55-27.4c6.87-12.55,19.3-35.31,35-43.1c0,0,19.11-10.2,29.55-16.38c10.44-6.18,39.99-26.1,55.34-34\n                    c15.36-7.91,46.17-33.35,50.43-38.11s17.7-26.7,26.56-32.5c8.87-5.79,31.63-18.03,20.65-26.017L2107.3,997.777z M987.202,941.252\n                    c-7.907-0.153-22.606-7.099-31.318-13.277c-8.712-6.178-9.172-8.519-14.853-12.817c-5.68-4.259-15.159-12.164-17.232-13.124\n                    c-2.072-0.959-12.473-7.598-8.52-16.616c3.953-9.017,9.326-9.977,19.919-9.977c10.592,0,24.332-0.307,35.731,1.574\n                    c11.398,1.88,16.771,2.225,23.718,2.839c6.943,0.614,18.343,0.461,21.183,1.573l5.84,67.346c0,0-26.562-7.444-34.468-7.598\n                    V941.252z\"/>\n            </g>\n            <g>\n                <path class=\"st1\" d=\"M1114.66,730.964c0,0-19.38,7.253-22.15,19.801c-2.72,12.548-6.21,16.002-1.15,24.674\n                    c5.07,8.634,11.06,14.966,31.32,15.388c20.23,0.422,35.73-1.573,47.63,2.302c11.9,3.915,19.07,9.786,25.83,16.539\n                    c6.75,6.754,12.12,17.077,45.63,18.535c33.5,1.458,37.3,1.804,43.94,2.725c6.64,0.959,13.59,3.261,15.93,8.442\n                    c2.3,5.18,3.38,11.166,10.63,11.166c7.26,0,8.64-3.069,10.86-3.799c2.23-0.729,6.45-1.995,9.91,1.881\n                    c3.49,3.914,4.95,6.101,21.91,3.146c0,0,6.64-0.614,11.59,2.303c0,0,3.57,3.07,10.98,0c0,0,1.26,0.115,1.57-3.569\n                    c0.31-3.684,2.3-8.02,12.55-5.487c10.21,2.532,19.38,3.683,29.63,3.146c10.21-0.537,16.96,0.115,29.51,0\n                    c12.55-0.115,25.95-0.23,25.41-7.483c-0.54-7.291-4.41-7.674-16.43-12.011c-12.01-4.336-18.11-6.101-28.55-8.941\n                    c-10.44-2.839-23.18-7.905-27.52-10.437c-4.34-2.533-21.49-10.438-28.36-12.126c-6.87-1.689-13.09-7.598-16-6.869\n                    c-2.96,0.729-12.86,0.959-15.7,0.192c-2.84-0.73-12.32-4.106-16.77-5.258c-4.42-1.151-15.7-8.442-19.19-10.974\n                    c-3.5-2.533-20.65-14.659-21.8-15.503c-1.15-0.845-3.8-5.603-22.88-3.991c0,0-8.44,0.115-17.8-16.539\n                    c-9.37-16.655-42.91-30.776-51.55-31.083c-8.63-0.307-29.63-1.036-54.27,11.819c-24.67,12.855-11.82,4.758-24.67,11.896\n                    L1114.66,730.964z\"/>\n            </g>\n        </g>\n        <g id=\"beach\">\n            <path class=\"st2\" d=\"M568.445,1262.5c0,0,52.081,23.01,69.16,36.28c17.078,13.27,14.392,8.74,37.611,18.48\n                c19.42,8.17,19.305,11.54,25.599,26.08c6.333,14.53,27.211,48.97,34.157,54.64c6.947,5.68,26.559,15.15,37.305,18.33\n                c10.746,3.15,9.48,5.68,22.145,11.39c12.665,5.68,80.941,5.07,101.167,3.8s37.957-0.61,58.797-3.14\n                c20.878-2.54,25.944-3.15,43.637-5.07c17.697-1.88,28.517-1.88,49.667-5.06c21.14-3.14,21.79-7.59,38.87-10.12\n                c17.08-2.53,31.63-3.8,31.63-3.8s76.33,4.07,86.54,1.27c0,0,10.14,0.42-19.49,4.83c-29.63,4.41-46.14-1.46-72.81,2.34\n                c-26.37,3.76-33.96,7.02-39.95,11.04c-5.99,4.03-52.62,28.38-80.521,34.9c-27.902,6.48-77.986,20.51-138.05,18.1\n                c-57.376-2.3-125.691,1.99-180.957-63.54c-55.266-65.5-17.731-41.23-55.42-94.38C579.614,1265.38,606.479,1293.26,568.445,1262.5z\n                \"/>\n        </g>\n        <g id=\"text-riviere-st-maurice\">\n            <g>\n                <path class=\"st1\" d=\"M175.942,815.638v11.082h-5.45v-27.878h9.096c2.763,0,4.913,0.728,6.486,2.186\n                    c1.574,1.457,2.341,3.451,2.341,6.059c0,1.457-0.307,2.722-0.959,3.758c-0.653,1.035-1.612,1.879-2.84,2.531\n                    c1.42,0.498,2.456,1.303,3.108,2.415c0.614,1.112,0.96,2.531,0.96,4.219v1.955c0,0.767,0.077,1.573,0.269,2.455\n                    c0.191,0.882,0.498,1.495,0.959,1.917v0.383h-5.642c-0.46-0.421-0.729-1.073-0.844-1.994c-0.115-0.92-0.154-1.84-0.154-2.799\n                    v-1.879c0-1.381-0.268-2.454-0.844-3.221c-0.576-0.767-1.382-1.151-2.456-1.151h-3.953L175.942,815.638z M175.942,811.305h3.646\n                    c1.113,0,1.957-0.345,2.533-0.997c0.576-0.691,0.844-1.649,0.844-2.876s-0.307-2.301-0.844-3.03\n                    c-0.576-0.767-1.42-1.112-2.495-1.112h-3.646v8.091L175.942,811.305z\"/>\n            </g>\n            <g>\n                <path class=\"st1\" d=\"M198.47,826.72h-5.411v-27.878h5.411V826.72z\"/>\n            </g>\n            <g>\n                <path class=\"st1\" d=\"M211.402,819.588l0.23,1.074h0.116l0.23-0.997l4.644-20.823h5.718l-7.791,27.878h-5.68l-7.791-27.878h5.719\n                    l4.605,20.784V819.588z\"/>\n            </g>\n            <g>\n                <path class=\"st1\" d=\"M230.365,826.72h-5.412v-27.878h5.412V826.72z\"/>\n            </g>\n            <g>\n                <path class=\"st1\" d=\"M249.704,814.488h-9.364v7.899h11.015v4.333h-16.503v-27.878h16.464v4.333H240.34v6.941h9.364v4.333V814.488\n                    z M245.406,796.848h-4.414l-4.72-4.985v-0.115h5.756l3.339,5.1H245.406z\"/>\n            </g>\n            <g>\n                <path class=\"st1\" d=\"M259.684,815.638v11.082h-5.45v-27.878h9.096c2.764,0,4.913,0.728,6.486,2.186\n                    c1.574,1.457,2.341,3.451,2.341,6.059c0,1.457-0.307,2.722-0.959,3.758c-0.652,1.035-1.612,1.879-2.84,2.531\n                    c1.42,0.498,2.456,1.303,3.109,2.415c0.614,1.112,0.959,2.531,0.959,4.219v1.955c0,0.767,0.077,1.573,0.269,2.455\n                    c0.192,0.882,0.499,1.495,0.959,1.917v0.383h-5.642c-0.46-0.421-0.729-1.073-0.844-1.994c-0.115-0.92-0.153-1.84-0.153-2.799\n                    v-1.879c0-1.381-0.269-2.454-0.845-3.221c-0.575-0.767-1.381-1.151-2.456-1.151h-3.953L259.684,815.638z M259.684,811.305h3.646\n                    c1.113,0,1.958-0.345,2.533-0.997c0.576-0.691,0.845-1.649,0.845-2.876s-0.307-2.301-0.845-3.03\n                    c-0.575-0.767-1.42-1.112-2.494-1.112h-3.646v8.091L259.684,811.305z\"/>\n            </g>\n            <g>\n                <path class=\"st1\" d=\"M291.31,814.488h-9.365v7.899h11.015v4.333h-16.503v-27.878h16.465v4.333h-10.977v6.941h9.365v4.333V814.488\n                    z\"/>\n            </g>\n            <g>\n                <path class=\"st1\" d=\"M120.138,866.525c0-1.074-0.269-1.956-0.844-2.569c-0.576-0.614-1.536-1.266-2.956-1.879\n                    c-2.916-0.997-5.066-2.148-6.524-3.452c-1.459-1.265-2.188-3.067-2.188-5.407c0-2.339,0.845-4.141,2.533-5.598\n                    c1.689-1.419,3.838-2.148,6.448-2.148s4.836,0.805,6.486,2.416c1.65,1.611,2.456,3.643,2.418,6.059v0.115h-5.335\n                    c0-1.265-0.307-2.301-0.959-3.106c-0.653-0.805-1.535-1.189-2.725-1.189c-1.075,0-1.919,0.345-2.533,0.997\n                    c-0.614,0.652-0.921,1.496-0.921,2.493c0,0.92,0.345,1.687,0.998,2.262c0.652,0.575,1.842,1.266,3.53,1.994\n                    c2.649,0.882,4.644,2.033,5.988,3.413c1.343,1.381,1.995,3.221,1.995,5.561c0,2.339-0.806,4.295-2.418,5.675\n                    c-1.612,1.381-3.761,2.032-6.409,2.032s-4.951-0.766-6.908-2.339c-1.957-1.572-2.879-3.758-2.84-6.672v-0.115h5.335\n                    c0,1.725,0.383,2.953,1.113,3.719c0.729,0.767,1.842,1.113,3.3,1.113c1.151,0,1.996-0.307,2.572-0.921\n                    c0.537-0.613,0.844-1.457,0.844-2.492V866.525z\"/>\n            </g>\n            <g>\n                <path class=\"st1\" d=\"M141.553,867.829h-7.369l-1.497,5.944h-5.488l7.868-27.879h5.68l7.829,27.879h-5.488l-1.497-5.944H141.553z\n                    M135.297,863.496h5.143l-2.533-9.856h-0.115L135.297,863.496z\"/>\n            </g>\n            <g>\n                <path class=\"st1\" d=\"M156.443,873.811h-5.412v-27.878h5.412V873.811z\"/>\n            </g>\n            <g>\n                <path class=\"st1\" d=\"M180.508,873.811h-5.411l-8.52-17.831h-0.115v17.831h-5.45v-27.878h5.45l8.52,17.831h0.115v-17.831h5.411\n                    V873.811z\"/>\n            </g>\n            <g>\n                <path class=\"st1\" d=\"M200.656,850.266h-6.294v23.545h-5.45v-23.545h-6.256v-4.333h18V850.266z\"/>\n            </g>\n            <g>\n                <path class=\"st1\" d=\"M208.526,863.994h-9.518v-4.333h9.518V863.994z\"/>\n            </g>\n            <g>\n                <path class=\"st1\" d=\"M220.156,845.894l4.989,20.478h0.115l5.066-20.478h7.1v27.879h-5.411v-8.091l0.46-10.853h-0.115\n                    l-5.335,18.944h-3.607l-5.258-18.829h-0.115l0.46,10.699v8.092h-5.411v-27.879h7.062V845.894z\"/>\n            </g>\n            <g>\n                <path class=\"st1\" d=\"M254.463,867.829h-7.369l-1.496,5.944h-5.489l7.868-27.879h5.68l7.83,27.879h-5.489l-1.496-5.944H254.463z\n                    M248.207,863.496h5.143l-2.533-9.856h-0.115L248.207,863.496z\"/>\n            </g>\n            <g>\n                <path class=\"st1\" d=\"M281.944,845.894v18.982c0,2.991-0.883,5.254-2.61,6.903c-1.766,1.61-4.03,2.416-6.87,2.416\n                    s-5.104-0.806-6.87-2.416c-1.727-1.611-2.61-3.912-2.61-6.865v-18.982h5.45v18.982c0,1.688,0.346,2.953,1.036,3.758\n                    c0.691,0.806,1.689,1.189,2.956,1.189c1.266,0,2.302-0.383,2.993-1.15c0.691-0.767,1.036-2.033,1.036-3.797v-18.982h5.412\n                    L281.944,845.894z\"/>\n            </g>\n            <g>\n                <path class=\"st1\" d=\"M291.309,862.69v11.083h-5.45v-27.879h9.096c2.764,0,4.913,0.729,6.486,2.186\n                    c1.574,1.457,2.341,3.451,2.341,6.059c0,1.457-0.307,2.722-0.959,3.758c-0.652,1.035-1.612,1.879-2.84,2.531\n                    c1.42,0.498,2.456,1.304,3.109,2.416c0.614,1.112,0.959,2.531,0.959,4.218v1.956c0,0.767,0.077,1.572,0.269,2.454\n                    c0.192,0.882,0.499,1.495,0.959,1.917v0.384h-5.641c-0.461-0.422-0.73-1.074-0.845-1.994c-0.115-0.921-0.153-1.841-0.153-2.8\n                    V867.1c0-1.38-0.269-2.454-0.845-3.221c-0.575-0.767-1.381-1.15-2.456-1.15h-3.953L291.309,862.69z M291.309,858.357h3.646\n                    c1.113,0,1.958-0.345,2.533-0.997c0.576-0.69,0.845-1.649,0.845-2.876s-0.307-2.301-0.845-3.03\n                    c-0.575-0.767-1.42-1.112-2.494-1.112h-3.646v8.092L291.309,858.357z\"/>\n            </g>\n            <g>\n                <path class=\"st1\" d=\"M313.837,873.811h-5.411v-27.878h5.411V873.811z\"/>\n            </g>\n            <g>\n                <path class=\"st1\" d=\"M335.868,864.8v0.115c0.077,3.067-0.652,5.368-2.111,6.941c-1.496,1.572-3.684,2.339-6.563,2.339\n                    c-2.878,0-5.181-0.882-6.908-2.646c-1.727-1.764-2.571-4.257-2.571-7.516v-8.322c0-3.221,0.844-5.752,2.494-7.516\n                    c1.651-1.764,3.915-2.684,6.717-2.684c2.955,0,5.219,0.805,6.716,2.377c1.497,1.573,2.303,3.912,2.341,7.018v0.115h-5.296\n                    c0.077-1.841-0.154-3.145-0.729-3.95c-0.576-0.805-1.574-1.227-2.994-1.227c-1.228,0-2.149,0.46-2.801,1.457\n                    c-0.653,0.997-0.96,2.416-0.96,4.333v8.399c0,1.955,0.345,3.451,1.036,4.41c0.691,0.958,1.727,1.418,3.071,1.418\n                    c1.343,0,2.226-0.383,2.763-1.15s0.729-2.071,0.691-3.911h5.258H335.868z\"/>\n            </g>\n            <g>\n                <path class=\"st1\" d=\"M354.06,861.54h-9.365v7.899h11.015v4.334h-16.503v-27.879h16.465v4.333h-10.977v6.941h9.365v4.334V861.54z\"\n                    />\n            </g>\n        </g>\n        <g id=\"buildings\">\n            <g>\n                <path class=\"st3\" d=\"M1498.95,1254.68l9.94,18.02l-24.18,2.69l-13.59-20.71H1498.95z\"/>\n            </g>\n            <g>\n                <path class=\"st3\" d=\"M1818.92,1081.81l35,10.35l6.1-20.44l21.53,5.68l-4.22,15.8l12.43,2.3l-1.07,14.15l-9.06-1.27l-4.22,11.58\n                    l-26.98-6.75l-0.88,2.73l-36.43-9.47L1818.92,1081.81z\"/>\n            </g>\n            <g>\n                <path class=\"st4\" d=\"M1031.53,1238.71l-12.16,56.45l29.26,6.3l12.17-56.46L1031.53,1238.71z\"/>\n            </g>\n            <g>\n                <path class=\"st4\" d=\"M1019.32,1277.11c0,8.09-6.56,14.61-14.62,14.61c-8.059,0-14.622-6.55-14.622-14.61\n                    c0-8.05,6.563-14.61,14.622-14.61C1012.76,1262.5,1019.32,1269.06,1019.32,1277.11z\"/>\n            </g>\n            <g>\n                <path class=\"st3\" d=\"M983.553,1303.48l-7.612,28.88l63.619,16.74l7.61-28.89L983.553,1303.48z\"/>\n            </g>\n        </g>\n        <g id=\"roads\">\n            <g>\n                <path class=\"st5\" d=\"M1240.54,1389.16c-13.13,0-26.94-0.19-41.07-0.38c-22.79-0.31-46.4-0.65-68.23-0.15\n                    c-3.61,0-6.68-2.8-6.76-6.45c-0.07-3.64,2.8-6.67,6.45-6.74c22.07-0.5,45.79-0.16,68.7,0.15c40.03,0.54,77.83,1.07,102.32-2.69\n                    c62.36-9.58,256.22-52.61,284.89-71.05c6.83-4.41,13.66-9.01,20.87-13.89c24.8-16.75,50.43-34.05,79.14-44.48\n                    c11.9-4.33,30.55-8.59,52.16-13.57c41.45-9.51,98.25-22.55,113.79-39.85c6.26-6.98,12.71-14.72,18.92-22.24\n                    c18.85-22.74,38.34-46.24,59.34-55.79c3.3-1.54,7.21-0.04,8.75,3.26c1.5,3.29,0.04,7.21-3.26,8.74\n                    c-18.23,8.28-36.73,30.6-54.66,52.19c-6.29,7.59-12.81,15.45-19.26,22.63c-18.35,20.4-72.69,32.86-120.67,43.86\n                    c-21.18,4.87-39.45,9.05-50.62,13.12c-27.17,9.86-52.12,26.69-76.22,42.99c-7.29,4.94-14.2,9.58-21.15,14.07\n                    c-31.74,20.4-226.51,63.24-290.03,72.98c-16.65,2.57-38.8,3.22-63.44,3.22L1240.54,1389.16z\"/>\n            </g>\n            <g>\n                <path class=\"st5\" d=\"M1794.93,1033.45c-0.35,0-0.65,0-1-0.07c-4.11-0.62-8.44-1.31-13.05-2.04\n                    c-27.52-4.29-65.2-10.16-114.48-14.53c-55.15-4.87-255.68-8.94-326.19-9.74c-14.77-0.15-35.42-0.23-58.6-0.31\n                    c-76.84-0.27-172.44-0.57-190.9-4.41c-7.79-1.61-18.54-4.139-30.97-7.092c-26.1-6.135-58.57-13.805-90.346-19.519\n                    c-61.867-11.082-107.539-17.218-128.609-17.218c-28.4,0-54.92-22.395-56.033-23.353c-2.764-2.378-3.109-6.52-0.73-9.281\n                    c2.38-2.761,6.525-3.106,9.288-0.728c0.23,0.192,24.026,20.209,47.475,20.209c27.94,0,86.622,9.472,130.95,17.41\n                    c32.125,5.752,66.165,13.767,91.035,19.634c12.36,2.914,23.03,5.407,30.63,7.017c17.15,3.567,120.12,3.912,188.28,4.142\n                    c23.22,0.077,43.87,0.153,58.69,0.307c70.65,0.805,271.68,4.87,327.18,9.782c49.7,4.41,87.66,10.31,115.37,14.65\n                    c4.6,0.72,8.94,1.38,13.01,2.03c3.6,0.53,6.06,3.91,5.52,7.51C1800.95,1031.11,1798.15,1033.45,1794.93,1033.45z\"/>\n            </g>\n            <g>\n                <path class=\"st6\" d=\"M1080.39,1225.3c-75.99,1.19-88.966-13.23-89.12-13.34l-2.993,2.3l-3.109,2.19\n                    c1.228,1.76,13.701,16.52,86.472,16.52c2.87,0,5.83,0,8.9-0.07l-0.11-7.6H1080.39z\"/>\n            </g>\n            <g>\n                <path class=\"st6\" d=\"M1085.99,1139.94c-75.99,1.19-88.965-13.23-89.118-13.34l-2.994,2.3l-3.108,2.18\n                    c1.228,1.77,13.7,16.53,86.47,16.53c2.88,0,5.83,0,8.9-0.07l-0.11-7.6H1085.99z\"/>\n            </g>\n            <g>\n                <path class=\"st7\" d=\"M725.491,902.764l-0.729,8.973c0,0,5.718,0.46,11.437,0.882c5.718,0.422,11.475,0.844,11.475,0.844\n                    l0.614-8.974c0,0-5.718-0.422-11.398-0.843C731.171,903.185,725.491,902.764,725.491,902.764z\"/>\n            </g>\n            <g>\n                <path class=\"st7\" d=\"M758.849,907.448l-3.625,8.24c0,0,5.253,2.306,10.518,4.576c5.266,2.27,10.568,4.553,10.568,4.553\n                    l3.516-8.278c0,0-5.265-2.27-10.494-4.528C764.079,909.705,758.849,907.448,758.849,907.448z\"/>\n            </g>\n            <g>\n                <path class=\"st7\" d=\"M691.563,899.811l-0.844,8.935c0,0,5.718,0.537,11.437,1.035c5.718,0.499,11.437,0.997,11.437,0.997\n                    l0.767-8.935c0,0-5.718-0.498-11.398-0.997C697.282,900.31,691.563,899.811,691.563,899.811z\"/>\n            </g>\n            <g>\n                <path class=\"st7\" d=\"M657.753,896.13l-1.151,8.896c0,0,5.718,0.767,11.437,1.381c2.878,0.307,5.718,0.614,7.867,0.844\n                    c2.149,0.23,3.57,0.383,3.57,0.383l0.921-8.935c0,0-1.42-0.153-3.531-0.383c-2.111-0.23-4.951-0.537-7.791-0.844\n                    C663.395,896.858,657.753,896.13,657.753,896.13z\"/>\n            </g>\n            <g>\n                <path class=\"st7\" d=\"M624.862,889.687l-2.264,8.705c3.991,1.035,7.791,1.841,11.552,2.799c1.842,0.499,3.723,0.844,5.603,1.266\n                    c1.881,0.383,3.761,0.652,5.604,0.997l1.458-8.859c-1.766-0.306-3.531-0.575-5.296-0.92c-1.727-0.383-3.493-0.728-5.182-1.189\n                    c-3.914-0.997-7.829-1.802-11.475-2.761V889.687z\"/>\n            </g>\n            <g>\n                <path class=\"st7\" d=\"M609.777,869.478l-9.019,0.345v0.231c0,0,0,0.421,0,0.728c0.038,0.652,0,1.572,0.153,2.761\n                    c0.154,2.339,0.538,5.484,1.612,8.743c0.499,1.611,1.228,3.222,2.073,4.717c0.882,1.457,1.842,2.761,2.801,3.758\n                    c0.96,0.997,1.843,1.726,2.457,2.186c0.307,0.23,0.575,0.422,0.729,0.537c0.192,0.115,0.269,0.192,0.269,0.192l4.989-7.478\n                    c0,0-0.039,0-0.154-0.115c-0.115-0.077-0.268-0.154-0.422-0.307c-0.384-0.268-0.844-0.69-1.382-1.227\n                    c-0.537-0.537-1.036-1.227-1.535-2.071c-0.46-0.844-0.959-1.802-1.266-2.953c-0.729-2.185-1.075-4.716-1.19-6.672\n                    c-0.115-0.959-0.077-1.841-0.115-2.416c0-0.307,0-0.537,0-0.729c0-0.191,0-0.268,0-0.268V869.478z\"/>\n            </g>\n            <g>\n                <path class=\"st7\" d=\"M608.817,834.275l-8.751,2.838c0,0,0.269,1.342,0.614,3.374c0.231,0.997,0.308,2.225,0.461,3.49\n                    c0.077,0.652,0.154,1.304,0.23,1.994c0.077,0.69,0.154,1.342,0.154,2.033c0.077,2.761,0.23,5.522,0,7.592\n                    c-0.115,2.071-0.192,3.452-0.192,3.452l9.019-1.189c0,0,0.077-1.496,0.192-3.72c0.192-2.224,0-5.177-0.077-8.168\n                    c0-0.728-0.115-1.495-0.192-2.186c-0.076-0.728-0.153-1.457-0.23-2.147c-0.192-1.381-0.269-2.684-0.499-3.758\n                    c-0.422-2.186-0.691-3.643-0.691-3.643L608.817,834.275z\"/>\n            </g>\n            <g>\n                <path class=\"st7\" d=\"M594.925,802.025l-7.714,5.1c0,0,0.768,1.151,1.881,2.876c0.575,0.844,1.189,1.918,1.803,3.03\n                    c0.614,1.15,1.382,2.301,1.919,3.566c0.614,1.227,1.228,2.493,1.766,3.643c0.499,1.189,0.959,2.301,1.343,3.26\n                    c0.384,0.958,0.729,1.764,0.921,2.339s0.307,0.882,0.307,0.882l8.482-3.605c0,0-0.115-0.345-0.345-0.959\n                    c-0.192-0.613-0.576-1.457-0.998-2.492c-0.423-1.036-0.921-2.224-1.459-3.528c-0.614-1.266-1.266-2.569-1.919-3.912\n                    c-0.614-1.342-1.42-2.607-2.072-3.834c-0.691-1.228-1.305-2.34-1.958-3.26c-1.228-1.879-2.034-3.106-2.034-3.106H594.925z\"/>\n            </g>\n            <g>\n                <path class=\"st7\" d=\"M568.791,778.863l-6.025,6.787c0,0,1.189,0.691,2.993,1.726c0.921,0.498,1.958,1.112,3.071,1.764\n                    c0.575,0.307,1.151,0.652,1.727,0.997c0.575,0.383,1.113,0.767,1.688,1.189l0.845,0.575c0.268,0.23,0.537,0.422,0.806,0.652\n                    c0.537,0.422,1.036,0.843,1.535,1.265c0.998,0.844,1.842,1.688,2.61,2.378c0.767,0.69,1.343,1.342,1.765,1.802\n                    c0.422,0.46,0.652,0.69,0.652,0.69l7.216-5.752c0,0-0.269-0.268-0.691-0.767c-0.461-0.46-1.036-1.188-1.881-1.917\n                    c-0.806-0.767-1.727-1.687-2.801-2.608c-0.538-0.46-1.075-0.92-1.651-1.38c-0.268-0.23-0.575-0.46-0.844-0.69l-0.921-0.652\n                    c-0.614-0.422-1.228-0.844-1.804-1.266c-0.614-0.383-1.266-0.728-1.842-1.073c-1.19-0.691-2.341-1.343-3.301-1.88\n                    c-1.919-1.112-3.224-1.84-3.224-1.84H568.791z\"/>\n            </g>\n            <g>\n                <path class=\"st7\" d=\"M538.316,761.377l-4.414,7.822c0,0,1.267,0.691,3.109,1.726c1.919,1.074,4.26,2.416,6.678,3.796\n                    c4.797,2.761,9.633,5.484,9.633,5.484l5.373-7.209c0,0-5.143-2.953-10.285-5.906c-2.572-1.457-5.182-2.991-7.024-4.026\n                    c-1.88-1.036-3.147-1.764-3.147-1.764L538.316,761.377z\"/>\n            </g>\n            <g>\n                <path class=\"st7\" d=\"M508.532,744.812l-4.38,7.834l20.003,11.165l4.38-7.834L508.532,744.812z\"/>\n            </g>\n            <g>\n                <path class=\"st7\" d=\"M478.645,728.087l-4.364,7.843l20.026,11.124l4.364-7.843L478.645,728.087z\"/>\n            </g>\n            <g>\n                <path class=\"st7\" d=\"M448.811,711.637l-4.358,7.846l20.034,11.11l4.358-7.846L448.811,711.637z\"/>\n            </g>\n            <g>\n                <path class=\"st7\" d=\"M418.92,695.006l-4.35,7.851l20.046,11.088l4.35-7.85L418.92,695.006z\"/>\n            </g>\n            <g>\n                <path class=\"st7\" d=\"M389.751,677.855l-4.759,7.632l14.507,9.05l5.297,2.914l4.375-7.861l-5.104-2.8L389.751,677.855z\"/>\n            </g>\n            <g>\n                <path class=\"st7\" d=\"M360.624,659.947l-4.683,7.67l19.535,11.964l4.721-7.631L360.624,659.947z\"/>\n            </g>\n            <g>\n                <path class=\"st7\" d=\"M331.34,642.308l-4.606,7.746c0,0,4.913,2.914,9.825,5.867c4.913,2.953,9.787,5.905,9.787,5.905l4.644-7.669\n                    c0,0-4.913-2.953-9.825-5.944c-4.913-2.953-9.863-5.905-9.863-5.905H331.34z\"/>\n            </g>\n            <g>\n                <path class=\"st7\" d=\"M301.48,625.281l-4.183,7.938c0,0,1.228,0.652,3.109,1.649c1.88,0.997,4.336,2.416,6.831,3.796\n                    c4.951,2.838,9.902,5.676,9.902,5.676l4.529-7.746c0,0-4.99-2.877-9.979-5.753c-2.533-1.418-5.028-2.837-6.947-3.873\n                    c-1.919-1.035-3.223-1.725-3.223-1.725L301.48,625.281z\"/>\n            </g>\n            <g>\n                <path class=\"st7\" d=\"M271.008,609.942l-4.145,7.976c0,0,5.105,2.646,10.209,5.292c2.572,1.304,5.143,2.608,7.062,3.566\n                    c1.957,0.959,3.262,1.611,3.262,1.611l3.915-8.091c0,0-1.267-0.614-3.147-1.573c-1.919-0.958-4.452-2.224-6.985-3.528\n                    c-5.066-2.607-10.132-5.253-10.132-5.253H271.008z\"/>\n            </g>\n            <g>\n                <path class=\"st7\" d=\"M240.877,593.951l-4.26,7.9c0,0,5.066,2.722,10.132,5.407c5.066,2.684,10.132,5.368,10.132,5.368\n                    l4.222-7.938l-20.187-10.775L240.877,593.951z\"/>\n            </g>\n            <g>\n                <path class=\"st7\" d=\"M210.981,577.615l-4.376,7.861c0,0,5.028,2.761,10.056,5.522c5.027,2.761,10.055,5.484,10.055,5.484\n                    l4.299-7.9c0,0-5.028-2.722-10.056-5.483c-5.027-2.761-10.017-5.522-10.017-5.522L210.981,577.615z\"/>\n            </g>\n            <g>\n                <path class=\"st7\" d=\"M181.43,560.819l-4.606,7.708c0,0,4.99,2.952,9.979,5.79c4.989,2.838,10.017,5.676,10.017,5.676l4.413-7.823\n                    c0,0-4.951-2.8-9.94-5.637c-4.951-2.838-9.825-5.714-9.825-5.714H181.43z\"/>\n            </g>\n            <g>\n                <path class=\"st7\" d=\"M1381.51,1289.31c-30.67,33.28-74.65,44.63-99.18,51c-4.33,1.11-8.09,2.07-11.05,2.99\n                    c-8.83,2.72-31.05,7.36-54.57,12.31c-30.32,6.37-64.71,13.61-81.75,18.98c-25.37,8.02-42.87,3.72-61.41-0.8\n                    c-2.11-0.5-4.22-1.04-6.37-1.54c-2.07-0.5-4.57-1.11-7.37-1.84c1.65-5.86,5.18-18.33,8.18-28.53\n                    c4.18-14.26,16.92-81.64,19.8-103.19c0.19-1.42,0.35-3.03,0.5-4.72h-12.7c-0.12,1.08-0.23,2.07-0.35,3.03\n                    c-2.76,20.67-15.43,87.78-19.42,101.32c-3.03,10.31-6.6,22.85-8.25,28.76c-28.29-8.06-70.158-21.36-80.175-26.5\n                    c-1.573-0.81-3.492-1.61-5.641-2.46c1.496-3.79,4.145-10.5,8.635-21.82c7.292-18.48,18.192-82.37,23.45-113.08\n                    c0.844-4.91,1.535-8.94,1.995-11.62c2.802-15.88,3.339-52.42,3.685-76.58c0.077-5.41,0.153-10.05,0.23-13.39\n                    c0.341-14.34-0.537-43.56-0.883-55.02c4.874-0.96,8.064-2.31,9.514-3c7.22-2.03,17.47-8.78,24.49-14.03\n                    c-2-3.68-4.07-7.29-6.98-10.58c-6.61,4.98-15.93,11.15-21.34,12.53c-0.54,0.12-1.12,0.39-1.58,0.66\n                    c-0.19,0.11-18.649,9.89-56.683-7.02c-41.872-18.64-93.914-37.658-94.413-37.85c-0.23-0.076-0.422-0.153-0.652-0.192\n                    c-2.111-0.536-52.426-12.616-118.553-5.407c-13.932,1.496-25.254,2.877-35.271,4.065c-36.038,4.295-48.166,5.752-70.963,1.304\n                    c-8.673-1.687-17.386-3.835-26.558-6.135c-22.183-5.484-45.134-11.16-67.509-10.009c-24.448,1.265-47.398,11.197-49.931,74.624\n                    c-1.843,46.06,8.75,100.39,101.129,154.5c17.347,10.16,30.127,17.6,39.799,23.2c19.624,11.4,33.403,20.2,41.334,26.39\n                    c3.531,2.76,8.098,6.32,14.699,11.31l5.642,4.29c33.927,25.77,58.413,44.37,93.875,56.07c29.821,9.85,60.102,11.23,84.396,12.35\n                    c6.179,0.26,11.975,0.53,17.348,0.92c26.059,1.84,68.468,10.92,81.056,17.33c14.584,7.44,81.905,27.88,102.625,32.75\n                    c2.11,0.5,4.18,0.99,6.26,1.53c11.47,2.8,23.14,5.68,36.73,5.68c9.4,0,19.72-1.38,31.51-5.1c16.42-5.18,50.5-12.35,80.55-18.64\n                    c24.87-5.22,46.33-9.74,55.69-12.62c2.69-0.84,6.33-1.76,10.52-2.83c26.36-6.83,74.03-19.18,107.27-56.87\n                    c-3.73-2.42-6.91-5.33-10.71-6.98c-0.19,0.19-0.35,0.42-0.54,0.61L1381.51,1289.31z M958.645,1311.63\n                    c-4.759,12.11-7.484,18.94-8.904,22.54c-20.264-5.79-49.317-10.96-68.238-12.31c-5.527-0.38-11.437-0.65-17.693-0.95\n                    c-23.565-1.08-52.848-2.42-81.018-11.7c-33.467-11.04-57.262-29.11-90.191-54.15l-5.68-4.29c-6.525-4.95-11.053-8.48-14.546-11.2\n                    c-12.55-9.78-13.126-10.12-42.754-27.34c-9.672-5.6-22.414-13.04-39.761-23.16c-86.66-50.74-96.6-100.82-94.912-143.12\n                    c2.034-50.73,15.467-61.314,37.957-62.503c20.533-1.074,42.524,4.372,63.825,9.625c8.942,2.225,18.191,4.487,27.172,6.251\n                    c24.755,4.827,38.418,3.217,74.916-1.15c9.979-1.189,21.262-2.531,35.156-4.027c61.099-6.672,109.495,4.027,113.87,5.062\n                    c4.606,1.692,53.578,19.792,93.262,37.432c19.036,8.47,34.08,10.96,45.134,11c0.383,11.85,1.189,40.07,0.882,53.61\n                    c-0.076,3.41-0.153,8.05-0.23,13.54c-0.307,22.32-0.844,59.67-3.492,74.55c-0.499,2.72-1.152,6.74-2.035,11.69\n                    C976.606,1228.95,965.438,1294.33,958.645,1311.63z\"/>\n            </g>\n            <g class=\"st8\">\n                <path class=\"st1\" d=\"M1899.24,1127.21c-2.53,0-5.06-0.84-7.17-2.57c-4.88-3.95-5.61-11.12-1.62-15.99\n                    c0.31-0.38,7.41-9.09,22.76-25c1.42-1.5,3.8-4.3,3.49-6.29c-0.3-2.07-3.1-8.05-22.75-19.25c-18.43-10.47-26.87-8.4-26.98-8.36\n                    c0.53-0.15-4.61,1.34-4.61,1.34l-11.17-19.71c2.8-1.23,25.49-9.28,54,6.94c15.54,8.86,31.74,20.02,34,35.74\n                    c1.27,8.82-1.95,17.34-9.59,25.31c-14.58,15.19-21.45,23.55-21.53,23.66C1905.8,1125.79,1902.54,1127.21,1899.24,1127.21z\"/>\n            </g>\n            <g>\n                <path class=\"st7\" d=\"M1862.32,1037.75c-3.3-4.34-8.67-6.41-13.51-7.37c-8.56-2.56-37.46-7.59-57.26-10.92\n                    c-1.96,4.44-4.3,8.43-5.76,13.03c16.62,6.02,18.62,15.73,21.65,23.05l0.54,1.3c0.99,2.42,2.26,4.57,3.57,6.45\n                    c-24.18,33.9-61.49,85.55-75.92,102.42c-19.42,22.7-69.5,18.06-72.73,17.76c-3.22-0.54-43.83-7.48-76.45-12.31\n                    c-32.31-4.8-66.82-14.27-69.27-14.96l-93.49-30.94c-1.12-0.35-110.65-35.82-133.83-42.99c-5.45-1.69-11.63-3.99-18.16-6.41\n                    c-21.45-7.9-48.05-17.75-76.48-17.29c-32.97,0.61-66.44-6.1-69.78-6.75c-3.53-1.07-40.8-12.81-63.75-26.77\n                    c-21.22-12.88-20.11-34.931-20.07-35.851c0-0.307,0-0.613,0-0.92l-1.92-24.543c-0.19-2.416-19.46-241.436-20.38-257.005\n                    c-0.96-15.837-5.41-29.988-14.39-45.864c-8.365-14.725-26.979-25.692-28.975-26.843l-39.991-25.232l-142.003-88.008\n                    c-1.228-0.767-123.312-79.111-282.125-177.818c-30.473-21.819-223.52-160.561-259.366-191.469\n                    C214.59,118.863,184.193,64.563,183.771,60h-12.626c0.959,10.392,36.268,68.949,73.38,100.931\n                    c36.96,31.867,231.618,171.682,260.863,192.658l-0.153,0.23c1.113,0.69,2.226,1.38,3.3,2.071\n                    c0.077,0.038,0.154,0.115,0.192,0.153c157.009,97.633,277.251,174.75,278.518,175.555l142.041,88.008l40.068,25.271\n                    c0,0,0.153,0.115,0.268,0.153c0.192,0.115,17.425,9.97,24.333,22.165c8.025,14.073,11.935,26.536,12.785,40.341\n                    c0.95,15.723,19.61,247.419,20.41,257.274l1.88,24.159c-0.07,2.454-0.11,12.311,4.84,23.281c-2.53,2.18-4.3,3.79-8.1,6.67\n                    c2.92,3.3,4.99,6.9,6.99,10.58c3.72-2.76,5.33-4.22,7.75-6.29c3.64,4.57,8.37,8.98,14.62,12.77c3.57,2.15,7.41,4.26,11.4,6.29\n                    c0.31,8.71,1.27,30.56,3.61,50.05c2.76,22.93,4.79,51.23,5.03,70.4c0,0.08,0,0.16,0,0.27c0,0.5,2.53,48.85,0.38,70.98h12.7\n                    c2-23.24-0.27-68.14-0.46-71.52c-0.23-19.55-2.3-48.35-5.1-71.63c-1.81-15.03-2.8-31.98-3.26-42.49\n                    c20.87,9.13,41.37,15.45,42.56,15.8c0.19,0.04,0.34,0.12,0.53,0.12c1.5,0.3,36.85,7.74,72.89,7.09\n                    c25.9-0.5,51.42,8.93,71.88,16.49c6.68,2.45,13.01,4.79,18.81,6.59c23.1,7.18,132.6,42.61,133.63,42.95l5.57,1.84\n                    c0,0.54,0,1-0.04,1.58c-0.96,28.68-3.19,95.9-36.08,139.39c-2.26,2.99-4.68,5.83-7.14,8.55c3.8,1.65,6.99,4.56,10.71,6.98\n                    c1.46-1.65,2.92-3.37,4.34-5.1l19.15,11.08l38,20.29c4.37,2.18,10.78,4.26,17.23,4.26c6.79,0,13.58-2.31,18.07-9.21\n                    c4.34-6.67,5.53-13.3,3.5-19.75c-3.07-9.89-13.63-18.4-32.24-26.07c-20.88-8.59-34.7-19.25-40.07-23.78\n                    c14.43-39,16.27-81.37,17.04-104.07l75.53,25c0,0,0.19,0.04,0.27,0.08c0.38,0.11,36.84,10.27,71,15.33\n                    c33.7,4.99,75.95,12.24,76.38,12.31c0.11,0,0.23,0,0.34,0.04c0.77,0.08,6.76,0.73,15.47,0.73c19.3,0,51.69-3.18,68.47-22.82\n                    c14.66-17.14,51.12-67.6,75.41-101.62c1.88,1.31,3.38,2.11,4.07,2.42c11.82,6.86,23.22,5.64,31.24-3.41\n                    c8.37-9.44,11.59-26.69,6.29-33.6L1862.32,1037.75z M1456.04,1282.83c18.31,7.51,23.68,14.03,24.98,18.13\n                    c0.54,1.73,0.93,4.57-2.03,9.13c-4.72,7.29-18.88,0.61-18.92,0.61l-37.65-20.13l-17.89-10.31c4.3-6.56,8.03-13.5,11.25-20.63\n                    C1423.15,1265.45,1436.77,1274.89,1456.04,1282.83z M1819.68,1052.01l-0.54-1.26c-1.72-4.18-4.03-9.71-8.48-15.19\n                    c6.6,1.19,12.86,2.34,18.27,3.38C1826.55,1042.27,1823.4,1046.72,1819.68,1052.01z M1845.2,1064.32c-2.34,2-6.37,4.1-14.23-0.54\n                    c-0.2-0.11-0.43-0.23-0.62-0.3c0,0-0.96-0.46-2.3-1.38c6.41-9.05,11.4-16.07,14.01-19.79c1.42,0.08,2.95,0.27,4.37,0.58\n                    c0,0,0.08,0,0.12,0c2.38,0.49,4.49,1.26,5.49,2.33C1852.84,1048.02,1851.34,1059.07,1845.2,1064.32z\"/>\n            </g>\n        </g>\n        <g id=\"text\">\n            <g>\n                <path class=\"st5\" d=\"M385.299,358.114l-3.608-2.225l11.437-18.521l3.608,2.224L385.299,358.114z M400.497,339.17l-0.192,0.268\n                    l-2.84-1.725l-0.384-2.608l-2.494,0.805l-2.764-1.687l0.192-0.307l5.028-1.035l2.034,1.265l1.382,5.062L400.497,339.17z\"/>\n            </g>\n            <g>\n                <path class=\"st5\" d=\"M393.704,359.341l6.755,4.18l-1.765,2.876l-10.401-6.404l11.437-18.522l3.608,2.224l-9.672,15.607\n                    L393.704,359.341z\"/>\n            </g>\n            <g>\n                <path class=\"st5\" d=\"M415.35,365.476l-6.218-3.835l-3.224,5.254l7.331,4.525l-1.766,2.876l-10.938-6.749l11.437-18.522\n                    l10.9,6.749l-1.766,2.876l-7.292-4.487l-2.84,4.602l6.218,3.835l-1.766,2.876H415.35z\"/>\n            </g>\n            <g>\n                <path class=\"st5\" d=\"M430.24,379.205c0.461-0.729,0.614-1.419,0.499-2.071c-0.115-0.652-0.499-1.457-1.189-2.454\n                    c-1.497-1.841-2.495-3.528-2.917-4.947c-0.422-1.457-0.192-2.953,0.767-4.487c0.921-1.534,2.265-2.416,3.992-2.684\n                    c1.727-0.268,3.415,0.153,5.181,1.227c1.765,1.074,2.878,2.493,3.301,4.257c0.46,1.764,0.153,3.413-0.883,5.023l-0.077,0.077\n                    l-3.492-2.186c0.537-0.844,0.729-1.649,0.652-2.454c-0.115-0.805-0.537-1.419-1.305-1.879c-0.729-0.46-1.42-0.575-2.072-0.384\n                    c-0.691,0.192-1.228,0.614-1.612,1.266c-0.384,0.613-0.461,1.265-0.269,1.917c0.192,0.652,0.729,1.572,1.535,2.761\n                    c1.382,1.688,2.226,3.26,2.572,4.717c0.307,1.457,0,2.953-0.96,4.525c-0.998,1.611-2.303,2.531-3.915,2.761\n                    c-1.611,0.23-3.339-0.192-5.104-1.265c-1.765-1.074-2.955-2.531-3.646-4.372c-0.652-1.841-0.384-3.681,0.844-5.599l0.077-0.077\n                    l3.531,2.186c-0.691,1.151-0.959,2.109-0.806,2.915c0.192,0.805,0.768,1.495,1.727,2.109c0.768,0.46,1.459,0.613,2.073,0.422\n                    c0.614-0.192,1.151-0.614,1.573-1.304H430.24z\"/>\n            </g>\n            <g>\n                <path class=\"st5\" d=\"M443.904,388.868l-4.874-3.029l-3.454,3.336l-3.646-2.263l16.656-15.3l3.761,2.339l-6.255,21.705\n                    l-3.646-2.263l1.458-4.563V388.868z M441.524,383.423l3.416,2.109l2.38-7.593h-0.077L441.524,383.423z\"/>\n            </g>\n            <g>\n                <path class=\"st5\" d=\"M451.35,398.915l-3.608-2.224l11.437-18.522l3.608,2.225L451.35,398.915z\"/>\n            </g>\n            <g>\n                <path class=\"st5\" d=\"M467.317,408.771l-3.608-2.224l1.65-15.339h-0.077l-7.292,11.772l-3.607-2.224l11.437-18.522l3.607,2.225\n                    l-1.65,15.3h0.077l7.292-11.772l3.608,2.224l-11.437,18.522V408.771z\"/>\n            </g>\n            <g>\n                <path class=\"st5\" d=\"M490.341,401.408l-4.183-2.569l-9.671,15.607l-3.608-2.224l9.671-15.607l-4.145-2.57l1.766-2.876\n                    l11.936,7.363L490.341,401.408z\"/>\n            </g>\n            <g>\n                <path class=\"st5\" d=\"M489.958,413.756l-6.333-3.912l1.765-2.876l6.333,3.912L489.958,413.756z\"/>\n            </g>\n            <g>\n                <path class=\"st5\" d=\"M504.275,423.381v0.115c-1.266,2.033-2.686,3.298-4.298,3.72s-3.378,0.038-5.297-1.151\n                    c-1.919-1.188-3.07-2.722-3.492-4.601s0-3.912,1.381-6.059l3.416-5.522c1.343-2.148,2.917-3.452,4.759-3.95\n                    c1.842-0.499,3.685-0.192,5.527,0.959c1.957,1.227,3.147,2.646,3.492,4.333c0.346,1.687-0.076,3.566-1.343,5.637h-0.077\n                    l-3.492-2.109c0.806-1.189,1.19-2.148,1.113-2.953c-0.039-0.767-0.538-1.457-1.497-2.032c-0.806-0.499-1.612-0.576-2.456-0.192\n                    c-0.845,0.383-1.651,1.189-2.418,2.493l-3.454,5.56c-0.806,1.304-1.19,2.416-1.113,3.336c0.076,0.921,0.537,1.649,1.458,2.224\n                    c0.883,0.537,1.65,0.652,2.303,0.384c0.652-0.307,1.343-1.074,2.072-2.301l3.493,2.147L504.275,423.381z\"/>\n            </g>\n            <g>\n                <path class=\"st5\" d=\"M515.828,438.72l-3.608-2.224l4.759-7.67l-5.757-3.566l-4.759,7.67l-3.608-2.225l11.437-18.521l3.608,2.224\n                    l-4.912,7.976l5.756,3.566l4.913-7.976l3.608,2.224L515.828,438.72z\"/>\n            </g>\n            <g>\n                <path class=\"st5\" d=\"M526.804,435.345l-4.567,7.363l-3.608-2.224L530.066,422l6.025,3.72c1.843,1.112,2.956,2.493,3.416,4.103\n                    c0.461,1.611,0.154,3.26-0.921,4.986c-0.614,0.958-1.343,1.649-2.188,2.109c-0.844,0.422-1.842,0.613-2.916,0.498\n                    c0.767,0.921,1.113,1.879,1.074,2.876c0,0.997-0.422,2.071-1.113,3.183l-0.806,1.304c-0.307,0.498-0.614,1.074-0.844,1.764\n                    c-0.23,0.652-0.307,1.189-0.154,1.649l-0.153,0.268l-3.723-2.301c-0.115-0.46-0.038-0.997,0.269-1.687\n                    c0.307-0.69,0.652-1.304,1.036-1.956l0.768-1.265c0.575-0.92,0.806-1.764,0.767-2.493c-0.077-0.728-0.46-1.342-1.151-1.764\n                    l-2.61-1.61L526.804,435.345z M528.569,432.469l2.418,1.496c0.729,0.46,1.42,0.575,2.111,0.345\n                    c0.691-0.23,1.228-0.729,1.765-1.572c0.538-0.844,0.768-1.649,0.691-2.378c-0.077-0.728-0.46-1.342-1.19-1.764l-2.418-1.495\n                    l-3.3,5.368H528.569z\"/>\n            </g>\n            <g>\n                <path class=\"st5\" d=\"M537.205,451.912l-3.607-2.225l11.437-18.521l3.607,2.224L537.205,451.912z\"/>\n            </g>\n            <g>\n                <path class=\"st5\" d=\"M551.404,454.021c0.46-0.729,0.614-1.419,0.499-2.071c-0.115-0.652-0.499-1.457-1.19-2.454\n                    c-1.497-1.841-2.495-3.528-2.917-4.947c-0.422-1.457-0.192-2.953,0.768-4.487c0.921-1.534,2.264-2.416,3.953-2.684\n                    c1.727-0.269,3.415,0.153,5.181,1.227c1.765,1.074,2.878,2.493,3.301,4.257c0.46,1.725,0.153,3.413-0.883,5.023l-0.077,0.077\n                    l-3.492-2.186c0.537-0.844,0.729-1.649,0.652-2.454c-0.115-0.806-0.537-1.419-1.305-1.879c-0.729-0.46-1.42-0.575-2.072-0.384\n                    c-0.691,0.192-1.228,0.614-1.612,1.266c-0.384,0.613-0.461,1.265-0.269,1.917c0.192,0.652,0.729,1.572,1.535,2.761\n                    c1.382,1.687,2.226,3.26,2.572,4.717c0.307,1.457,0,2.953-0.96,4.525c-0.998,1.61-2.303,2.531-3.915,2.761\n                    c-1.611,0.23-3.339-0.192-5.104-1.266c-1.765-1.073-2.955-2.531-3.646-4.371c-0.652-1.841-0.384-3.682,0.844-5.599l0.077-0.077\n                    l3.531,2.186c-0.691,1.151-0.959,2.109-0.806,2.915c0.192,0.805,0.729,1.495,1.727,2.109c0.768,0.46,1.459,0.613,2.073,0.422\n                    c0.614-0.192,1.151-0.614,1.573-1.304H551.404z\"/>\n            </g>\n            <g>\n                <path class=\"st5\" d=\"M574.892,453.599l-4.183-2.569l-9.672,15.607l-3.607-2.224l9.671-15.607l-4.145-2.57l1.766-2.876\n                    l11.936,7.363L574.892,453.599z\"/>\n            </g>\n            <g>\n                <path class=\"st5\" d=\"M583.182,471.124c-1.344,2.186-2.994,3.49-4.913,3.988c-1.919,0.499-3.876,0.115-5.833-1.074\n                    c-1.958-1.227-3.148-2.799-3.57-4.716c-0.422-1.956,0.039-3.988,1.382-6.174l3.224-5.177c1.343-2.148,2.955-3.49,4.912-3.988\n                    c1.919-0.499,3.877-0.154,5.834,1.035c1.957,1.189,3.147,2.799,3.569,4.755c0.422,1.956,0,4.027-1.381,6.174L583.182,471.124z\n                    M582.798,463.685c0.806-1.343,1.19-2.493,1.113-3.452c-0.077-0.997-0.576-1.764-1.535-2.339c-0.96-0.575-1.881-0.69-2.764-0.307\n                    c-0.882,0.384-1.765,1.227-2.571,2.57l-3.224,5.215c-0.844,1.342-1.228,2.492-1.151,3.451c0.077,0.959,0.576,1.764,1.497,2.339\n                    c0.921,0.576,1.842,0.691,2.763,0.307c0.921-0.383,1.765-1.227,2.61-2.569l3.224-5.215H582.798z\"/>\n            </g>\n            <g>\n                <path class=\"st5\" d=\"M589.167,474.843l-4.106,6.634l-3.608-2.224l11.437-18.522l6.448,3.989c1.842,1.15,2.955,2.607,3.377,4.333\n                    c0.384,1.764,0.039,3.528-1.036,5.292c-1.113,1.764-2.533,2.876-4.26,3.298c-1.766,0.422-3.531,0.076-5.373-1.074l-2.802-1.726\n                    H589.167z M590.933,471.967l2.801,1.726c0.768,0.46,1.536,0.575,2.303,0.23c0.768-0.307,1.42-0.92,1.958-1.802\n                    c0.537-0.882,0.806-1.726,0.767-2.57c-0.038-0.843-0.46-1.495-1.228-1.955l-2.802-1.726l-3.761,6.097H590.933z\"/>\n            </g>\n            <g>\n                <path class=\"st5\" d=\"M609.164,496.356l-3.608-2.224l4.759-7.669l-5.757-3.567l-4.759,7.67l-3.608-2.224l11.437-18.522\n                    l3.608,2.224l-4.912,7.976l5.756,3.567l4.913-7.977l3.608,2.224L609.164,496.356z\"/>\n            </g>\n            <g>\n                <path class=\"st5\" d=\"M626.818,496.05l-6.217-3.835l-3.224,5.254l7.33,4.525l-1.765,2.876l-10.938-6.75l11.437-18.521l10.9,6.749\n                    l-1.766,2.876l-7.292-4.487l-2.84,4.602l6.217,3.835l-1.803,2.876H626.818z\"/>\n            </g>\n            <g>\n                <path class=\"st5\" d=\"M1172.53,765.94l-3.95-1.496l7.67-20.362l3.96,1.495L1172.53,765.94z M1183.81,744.427l-0.11,0.307\n                    l-3.11-1.189l-0.88-2.493l-2.27,1.266l-3.03-1.151l0.12-0.345l4.76-1.994l2.22,0.844l2.3,4.717V744.427z\"/>\n            </g>\n            <g>\n                <path class=\"st5\" d=\"M1181.01,765.518l7.45,2.799l-1.19,3.183l-11.44-4.295l7.68-20.362l3.99,1.495L1181.01,765.518z\"/>\n            </g>\n            <g>\n                <path class=\"st5\" d=\"M1203.47,767.397l-6.84-2.569l-2.18,5.752l8.06,3.029l-1.19,3.183l-12.05-4.525l7.67-20.362l12.01,4.525\n                    l-1.19,3.183l-8.02-3.03l-1.92,5.062l6.84,2.569L1203.47,767.397z\"/>\n            </g>\n            <g>\n                <path class=\"st5\" d=\"M1209.64,779.937l7.68-20.363l5.99,2.263c2.11,0.805,3.57,1.879,4.37,3.259\n                    c0.85,1.381,0.88,2.991,0.19,4.832c-0.34,0.959-0.92,1.764-1.61,2.339c-0.69,0.575-1.57,0.921-2.57,0.959\n                    c0.96,0.652,1.57,1.495,1.77,2.531c0.19,1.035,0.07,2.109-0.35,3.259c-0.73,1.956-1.84,3.222-3.34,3.797s-3.3,0.498-5.37-0.307\n                    l-6.79-2.569H1209.64z M1217.01,772.459l-2.19,5.79l2.81,1.074c0.84,0.307,1.57,0.307,2.15,0c0.57-0.307,1.07-0.92,1.42-1.84\n                    c0.38-0.959,0.46-1.764,0.3-2.455c-0.15-0.652-0.61-1.112-1.42-1.419L1217.01,772.459z M1218.05,769.66l2.19,0.843\n                    c0.8,0.269,1.53,0.269,2.15,0c0.61-0.307,1.07-0.843,1.38-1.725c0.34-0.959,0.38-1.726,0.11-2.34\n                    c-0.27-0.613-0.88-1.073-1.76-1.418l-2.04-0.767L1218.05,769.66z\"/>\n            </g>\n            <g>\n                <path class=\"st5\" d=\"M1230.71,784.27l7.45,2.799l-1.19,3.183l-11.44-4.295l7.68-20.362l3.99,1.495L1230.71,784.27z\"/>\n            </g>\n            <g>\n                <path class=\"st5\" d=\"M1254.51,788.527c-0.92,2.377-2.26,3.988-4.07,4.87c-1.8,0.843-3.8,0.882-5.95,0.076\n                    c-2.15-0.805-3.6-2.147-4.41-3.949c-0.77-1.841-0.73-3.95,0.19-6.328l2.15-5.714c0.88-2.377,2.23-3.988,4.03-4.87\n                    c1.8-0.882,3.76-0.882,5.91-0.076c2.15,0.805,3.61,2.147,4.41,3.988c0.81,1.84,0.73,3.95-0.15,6.327l-2.15,5.714L1254.51,788.527\n                    z M1252.71,781.279c0.53-1.457,0.69-2.646,0.42-3.605c-0.27-0.958-0.92-1.61-1.96-1.994c-1.04-0.383-1.96-0.307-2.76,0.23\n                    c-0.81,0.537-1.5,1.534-2.04,3.03l-2.18,5.752c-0.58,1.457-0.73,2.684-0.46,3.604c0.26,0.921,0.88,1.611,1.91,1.995\n                    c1.04,0.383,1.96,0.306,2.77-0.231c0.8-0.536,1.49-1.533,2.07-3.029l2.19-5.752H1252.71z\"/>\n            </g>\n            <g>\n                <path class=\"st5\" d=\"M1268.59,802.178l-3.95-1.496l-1.3-15.377h-0.08l-4.91,13l-3.99-1.496l7.67-20.362l3.99,1.495l1.31,15.339\n                    h0.11l4.92-12.961l3.95,1.495l-7.68,20.363H1268.59z\"/>\n            </g>\n            <g>\n                <path class=\"st5\" d=\"M1279.84,800.453l-0.15,0.843h0.07l0.43-0.652l9.13-13.92l4.18,1.572l-13.39,18.215l-4.15-1.572l2-22.51\n                    l4.18,1.572l-2.34,16.413L1279.84,800.453z\"/>\n            </g>\n            <g>\n                <path class=\"st5\" d=\"M1291.7,810.883l-3.95-1.496l7.67-20.362l3.95,1.495L1291.7,810.883z\"/>\n            </g>\n            <g>\n                <path class=\"st5\" d=\"M1300.18,810.461l7.45,2.8l-1.19,3.183l-11.44-4.295l7.68-20.363l3.99,1.496L1300.18,810.461z\"/>\n            </g>\n            <g>\n                <path class=\"st5\" d=\"M1313.58,815.523l7.44,2.8l-1.19,3.183l-11.44-4.295l7.68-20.363l3.99,1.496L1313.58,815.523z\"/>\n            </g>\n            <g>\n                <path class=\"st5\" d=\"M1336.02,817.402l-6.83-2.569l-2.18,5.752l8.06,3.029l-1.19,3.183l-12.06-4.525l7.68-20.362l12.01,4.525\n                    l-1.19,3.183l-8.02-3.03l-1.92,5.062l6.83,2.569L1336.02,817.402z\"/>\n            </g>\n            <g id=\"text-fleuve\">\n                <defs>\n                    <rect id=\"SVGID_1_\" x=\"1294.44\" y=\"1433.58\" width=\"390\" height=\"29.979\"/>\n                </defs>\n                <clipPath id=\"SVGID_2_\">\n                    <use xlink:href=\"#SVGID_1_\"  style=\"overflow:visible;\"/>\n                </clipPath>\n                <g class=\"st9\">\n                    <g>\n                        <path class=\"st1\" d=\"M1309.81,1451.05h-9.76v12.11h-5.61v-29.18h17.11v4.53h-11.5v7.94h9.76v4.52V1451.05z\"/>\n                    </g>\n                    <g>\n                        <path class=\"st1\" d=\"M1320.13,1458.59h10.51v4.53h-16.13v-29.14h5.62V1458.59z\"/>\n                    </g>\n                    <g>\n                        <path class=\"st1\" d=\"M1348.7,1450.37h-9.64v8.26h11.34v4.53h-16.99v-29.18h16.95v4.53h-11.3v7.25h9.64v4.53V1450.37z\"/>\n                    </g>\n                    <g>\n                        <path class=\"st1\" d=\"M1372.53,1433.98v19.84c0,3.13-0.91,5.53-2.69,7.21c-1.81,1.69-4.15,2.53-7.07,2.53\n                            c-2.92,0-5.26-0.84-7.07-2.53c-1.78-1.68-2.69-4.08-2.69-7.17v-19.88h5.61v19.84c0,1.76,0.36,3.09,1.07,3.93\n                            c0.71,0.84,1.74,1.24,3.04,1.24c1.3,0,2.37-0.4,3.08-1.2c0.71-0.8,1.07-2.13,1.07-3.97v-19.84h5.57H1372.53z\"/>\n                    </g>\n                    <g>\n                        <path class=\"st1\" d=\"M1385.22,1455.7l0.24,1.13h0.12l0.23-1.09l4.75-21.76h5.88l-8.02,29.14h-5.85l-8.02-29.14h5.89l4.74,21.72\n                            H1385.22z\"/>\n                    </g>\n                    <g>\n                        <path class=\"st1\" d=\"M1414.11,1450.37h-9.64v8.26h11.34v4.53h-17v-29.18h16.96v4.53h-11.3v7.25h9.64v4.53V1450.37z\"/>\n                    </g>\n                    <g>\n                        <path class=\"st1\" d=\"M1440.39,1455.54c0-1.12-0.28-2.04-0.87-2.68s-1.58-1.32-3.04-1.97c-3.01-1.04-5.22-2.24-6.72-3.6\n                            c-1.5-1.33-2.25-3.21-2.25-5.65c0-2.45,0.87-4.33,2.61-5.86c1.73-1.48,3.95-2.24,6.64-2.24c2.68,0,4.97,0.84,6.67,2.53\n                            c1.7,1.68,2.53,3.76,2.49,6.33v0.12h-5.49c0-1.32-0.32-2.41-0.99-3.25c-0.67-0.84-1.58-1.24-2.8-1.24\n                            c-1.11,0-1.98,0.32-2.61,1.04c-0.63,0.72-0.95,1.56-0.95,2.61c0,0.96,0.36,1.76,1.03,2.36c0.71,0.6,1.89,1.32,3.63,2.09\n                            c2.73,0.92,4.79,2.12,6.17,3.56c1.38,1.44,2.05,3.37,2.05,5.81c0,2.45-0.83,4.49-2.49,5.94c-1.66,1.44-3.87,2.12-6.6,2.12\n                            c-2.72,0-5.09-0.8-7.11-2.45c-2.02-1.64-2.96-3.96-2.92-6.97v-0.12h5.49c0,1.8,0.39,3.09,1.14,3.89c0.76,0.8,1.9,1.16,3.4,1.16\n                            c1.19,0,2.06-0.32,2.65-0.96c0.55-0.64,0.87-1.52,0.87-2.61V1455.54z\"/>\n                    </g>\n                    <g>\n                        <path class=\"st1\" d=\"M1462.4,1456.91h-7.58l-1.55,6.21h-5.65l8.11-29.14h5.84l8.07,29.14h-5.65l-1.55-6.21H1462.4z\n                            M1455.96,1452.38h5.3l-2.61-10.3h-0.12L1455.96,1452.38z\"/>\n                    </g>\n                    <g>\n                        <path class=\"st1\" d=\"M1477.78,1463.16h-5.57v-29.18h5.57v29.14V1463.16z\"/>\n                    </g>\n                    <g>\n                        <path class=\"st1\" d=\"M1502.56,1463.16h-5.57l-8.78-18.64h-0.12v18.64h-5.61v-29.18h5.61l8.78,18.64h0.12v-18.64h5.57v29.14\n                            V1463.16z\"/>\n                    </g>\n                    <g>\n                        <path class=\"st1\" d=\"M1523.27,1438.55h-6.48v24.61h-5.62v-24.61h-6.44v-4.57h18.54v4.53V1438.55z\"/>\n                    </g>\n                    <g>\n                        <path class=\"st1\" d=\"M1531.41,1452.9h-9.8v-4.53h9.8V1452.9z\"/>\n                    </g>\n                    <g>\n                        <path class=\"st1\" d=\"M1541.8,1458.59h10.52v4.53h-16.13v-29.14h5.61V1458.59z\"/>\n                    </g>\n                    <g>\n                        <path class=\"st1\" d=\"M1568.4,1456.91h-7.59l-1.54,6.21h-5.65l8.1-29.14h5.85l8.06,29.14h-5.65l-1.54-6.21H1568.4z\n                            M1561.96,1452.38h5.3l-2.61-10.3h-0.12L1561.96,1452.38z\"/>\n                    </g>\n                    <g>\n                        <path class=\"st1\" d=\"M1596.7,1433.98v19.84c0,3.13-0.91,5.53-2.69,7.21c-1.82,1.69-4.15,2.53-7.07,2.53\n                            c-2.93,0-5.26-0.84-7.08-2.53c-1.78-1.68-2.68-4.08-2.68-7.17v-19.88h5.61v19.84c0,1.76,0.35,3.09,1.06,3.93\n                            c0.72,0.84,1.74,1.24,3.05,1.24c1.3,0,2.37-0.4,3.08-1.2c0.71-0.8,1.07-2.13,1.07-3.97v-19.84h5.57H1596.7z\"/>\n                    </g>\n                    <g>\n                        <path class=\"st1\" d=\"M1606.38,1451.58v11.58h-5.61v-29.14h9.37c2.84,0,5.05,0.76,6.68,2.29c1.62,1.52,2.41,3.6,2.41,6.33\n                            c0,1.52-0.32,2.84-0.99,3.93c-0.67,1.08-1.66,1.96-2.93,2.64c1.47,0.52,2.53,1.36,3.2,2.53c0.64,1.16,0.99,2.64,0.99,4.4v2.05\n                            c0,0.8,0.08,1.64,0.28,2.56c0.2,0.93,0.51,1.57,0.99,2.01v0.4h-5.81c-0.48-0.44-0.75-1.12-0.87-2.09\n                            c-0.12-0.96-0.16-1.92-0.16-2.92v-1.96c0-1.45-0.28-2.57-0.87-3.37c-0.59-0.8-1.42-1.2-2.53-1.2h-4.07L1606.38,1451.58z\n                            M1606.38,1447.05h3.76c1.14,0,2.01-0.36,2.6-1.05c0.6-0.72,0.87-1.72,0.87-3s-0.31-2.41-0.87-3.17\n                            c-0.59-0.8-1.46-1.16-2.56-1.16h-3.76v8.46L1606.38,1447.05z\"/>\n                    </g>\n                    <g>\n                        <path class=\"st1\" d=\"M1638.95,1450.37h-9.65v8.26h11.35v4.53h-17v-29.18h16.96v4.53h-11.31v7.25h9.65v4.53V1450.37z\"/>\n                    </g>\n                    <g>\n                        <path class=\"st1\" d=\"M1663.69,1463.16h-5.57l-8.78-18.64h-0.12v18.64h-5.61v-29.18h5.61l8.78,18.64h0.12v-18.64h5.57v29.14\n                            V1463.16z\"/>\n                    </g>\n                    <g>\n                        <path class=\"st1\" d=\"M1684.44,1438.55h-6.48v24.61h-5.62v-24.61h-6.44v-4.57h18.54v4.53V1438.55z\"/>\n                    </g>\n                </g>\n            </g>\n        </g>\n        <g v-if=\"title.includes(50)\" id=\"hotzone-list\">\n            <g id=\"hotzone-1\">\n                <g>\n                    <path class=\"st2\" d=\"M1032.44,1157L1032.44,1157c13.255,0,24,10.745,24,24l0,0c0,13.255-10.745,24-24,24l0,0\n                        c-13.255,0-24-10.745-24-24l0,0C1008.44,1167.745,1019.185,1157,1032.44,1157z\"/>\n                </g>\n                <g>\n                    <path class=\"st10\" d=\"M1032.5,1188.28c-3.981,0-7.22-3.238-7.22-7.22s3.239-7.221,7.22-7.221c3.976,0,7.21,3.239,7.21,7.221\n                        S1036.476,1188.28,1032.5,1188.28z M1032.5,1174.84c-3.43,0-6.22,2.791-6.22,6.221s2.79,6.22,6.22,6.22\n                        c3.424,0,6.21-2.79,6.21-6.22S1035.924,1174.84,1032.5,1174.84z\"/>\n                </g>\n                <g>\n                    <path class=\"st10\" d=\"M1032.5,1170.189c-0.276,0-0.5-0.224-0.5-0.5v-2.069c0-0.276,0.224-0.5,0.5-0.5s0.5,0.224,0.5,0.5v2.069\n                        C1033,1169.966,1032.776,1170.189,1032.5,1170.189z\"/>\n                </g>\n                <g>\n                    <path class=\"st10\" d=\"M1032.5,1194.99c-0.276,0-0.5-0.224-0.5-0.5v-2.061c0-0.276,0.224-0.5,0.5-0.5s0.5,0.224,0.5,0.5v2.061\n                        C1033,1194.767,1032.776,1194.99,1032.5,1194.99z\"/>\n                </g>\n                <g>\n                    <path class=\"st10\" d=\"M1045.93,1181.561h-2.06c-0.276,0-0.5-0.224-0.5-0.5s0.224-0.5,0.5-0.5h2.06c0.276,0,0.5,0.224,0.5,0.5\n                        S1046.207,1181.561,1045.93,1181.561z\"/>\n                </g>\n                <g>\n                    <path class=\"st10\" d=\"M1021.13,1181.561h-2.07c-0.276,0-0.5-0.224-0.5-0.5s0.224-0.5,0.5-0.5h2.07c0.276,0,0.5,0.224,0.5,0.5\n                        S1021.406,1181.561,1021.13,1181.561z\"/>\n                </g>\n                <g>\n                    <path class=\"st10\" d=\"M1040.54,1173.52c-0.127,0-0.255-0.049-0.353-0.146c-0.196-0.194-0.197-0.511-0.002-0.707l1.46-1.47\n                        c0.195-0.196,0.511-0.195,0.707-0.002c0.196,0.194,0.197,0.511,0.002,0.707l-1.46,1.47\n                        C1040.797,1173.471,1040.668,1173.52,1040.54,1173.52z\"/>\n                </g>\n                <g>\n                    <path class=\"st10\" d=\"M1022.99,1191.07c-0.127,0-0.255-0.049-0.352-0.146c-0.196-0.194-0.197-0.511-0.003-0.707l1.46-1.471\n                        c0.195-0.196,0.512-0.196,0.707-0.002c0.196,0.194,0.197,0.511,0.003,0.707l-1.46,1.471\n                        C1023.248,1191.021,1023.119,1191.07,1022.99,1191.07z\"/>\n                </g>\n                <g>\n                    <path class=\"st10\" d=\"M1042,1191.07c-0.128,0-0.257-0.049-0.355-0.147l-1.46-1.471c-0.194-0.196-0.193-0.513,0.003-0.707\n                        c0.194-0.195,0.512-0.195,0.707,0.002l1.46,1.471c0.194,0.196,0.193,0.513-0.003,0.707\n                        C1042.255,1191.021,1042.127,1191.07,1042,1191.07z\"/>\n                </g>\n                <g>\n                    <path class=\"st10\" d=\"M1024.45,1173.52c-0.128,0-0.257-0.049-0.354-0.147l-1.46-1.47c-0.195-0.196-0.194-0.513,0.002-0.707\n                        c0.195-0.194,0.512-0.195,0.707,0.002l1.46,1.47c0.195,0.196,0.194,0.513-0.002,0.707\n                        C1024.705,1173.471,1024.578,1173.52,1024.45,1173.52z\"/>\n                </g>\n                <g>\n                    <g class=\"st11\">\n                        <rect x=\"1008.44\" y=\"1157\" class=\"st2\" width=\"48\" height=\"48\"/>\n                    </g>\n                </g>\n            </g>\n            <g id=\"hotzone-2_1_\">\n                <g>\n                    <path class=\"st2\" d=\"M1181.06,1301L1181.06,1301c13.255,0,24,10.745,24,24l0,0c0,13.255-10.745,24-24,24l0,0\n                        c-13.255,0-24-10.745-24-24l0,0C1157.06,1311.745,1167.805,1301,1181.06,1301z\"/>\n                </g>\n                <g>\n                    <path class=\"st10\" d=\"M1181.12,1332.28c-3.981,0-7.22-3.238-7.22-7.22s3.238-7.221,7.22-7.221c3.976,0,7.21,3.239,7.21,7.221\n                        S1185.096,1332.28,1181.12,1332.28z M1181.12,1318.84c-3.43,0-6.22,2.791-6.22,6.221s2.79,6.22,6.22,6.22\n                        c3.424,0,6.21-2.79,6.21-6.22S1184.544,1318.84,1181.12,1318.84z\"/>\n                </g>\n                <g>\n                    <path class=\"st10\" d=\"M1181.12,1314.189c-0.276,0-0.5-0.224-0.5-0.5v-2.069c0-0.276,0.224-0.5,0.5-0.5s0.5,0.224,0.5,0.5v2.069\n                        C1181.62,1313.966,1181.396,1314.189,1181.12,1314.189z\"/>\n                </g>\n                <g>\n                    <path class=\"st10\" d=\"M1181.12,1338.99c-0.276,0-0.5-0.224-0.5-0.5v-2.061c0-0.276,0.224-0.5,0.5-0.5s0.5,0.224,0.5,0.5v2.061\n                        C1181.62,1338.767,1181.396,1338.99,1181.12,1338.99z\"/>\n                </g>\n                <g>\n                    <path class=\"st10\" d=\"M1194.55,1325.561h-2.06c-0.276,0-0.5-0.224-0.5-0.5s0.224-0.5,0.5-0.5h2.06c0.276,0,0.5,0.224,0.5,0.5\n                        S1194.826,1325.561,1194.55,1325.561z\"/>\n                </g>\n                <g>\n                    <path class=\"st10\" d=\"M1169.75,1325.561h-2.07c-0.276,0-0.5-0.224-0.5-0.5s0.224-0.5,0.5-0.5h2.07c0.276,0,0.5,0.224,0.5,0.5\n                        S1170.026,1325.561,1169.75,1325.561z\"/>\n                </g>\n                <g>\n                    <path class=\"st10\" d=\"M1189.16,1317.52c-0.127,0-0.255-0.049-0.353-0.146c-0.195-0.194-0.197-0.511-0.002-0.707l1.46-1.47\n                        c0.193-0.196,0.51-0.196,0.707-0.002c0.195,0.194,0.197,0.511,0.002,0.707l-1.46,1.47\n                        C1189.417,1317.471,1189.289,1317.52,1189.16,1317.52z\"/>\n                </g>\n                <g>\n                    <path class=\"st10\" d=\"M1171.61,1335.07c-0.127,0-0.255-0.049-0.353-0.146c-0.195-0.194-0.197-0.511-0.002-0.707l1.46-1.471\n                        c0.194-0.195,0.511-0.197,0.707-0.002c0.195,0.194,0.197,0.511,0.002,0.707l-1.46,1.471\n                        C1171.867,1335.021,1171.739,1335.07,1171.61,1335.07z\"/>\n                </g>\n                <g>\n                    <path class=\"st10\" d=\"M1190.62,1335.07c-0.129,0-0.257-0.049-0.354-0.147l-1.46-1.471c-0.195-0.196-0.193-0.513,0.002-0.707\n                        c0.196-0.195,0.513-0.193,0.707,0.002l1.46,1.471c0.195,0.196,0.193,0.513-0.002,0.707\n                        C1190.875,1335.021,1190.747,1335.07,1190.62,1335.07z\"/>\n                </g>\n                <g>\n                    <path class=\"st10\" d=\"M1173.07,1317.52c-0.129,0-0.257-0.049-0.354-0.147l-1.46-1.47c-0.195-0.196-0.193-0.513,0.002-0.707\n                        c0.197-0.194,0.514-0.194,0.707,0.002l1.46,1.47c0.195,0.196,0.193,0.513-0.002,0.707\n                        C1173.325,1317.471,1173.197,1317.52,1173.07,1317.52z\"/>\n                </g>\n                <g class=\"st11\">\n                    <rect x=\"1157.06\" y=\"1301\" class=\"st2\" width=\"48\" height=\"48\"/>\n                </g>\n            </g>\n        </g>\n        <g v-if=\"title.includes(51)\" id=\"vestiaire\">\n            <g id=\"vestiaire-patin\">\n                <path class=\"st0\" d=\"M1140.06,1222L1140.06,1222c13.255,0,24,10.745,24,24l0,0c0,13.255-10.745,24-24,24l0,0\n                    c-13.255,0-24-10.745-24-24l0,0C1116.06,1232.745,1126.805,1222,1140.06,1222z\"/>\n            </g>\n            <g>\n                <g>\n                    <polygon class=\"st12\" points=\"1136.124,1243.393 1136.743,1242.575 1135.87,1242.575 1135.251,1243.393 \t\t\t\t\"/>\n                </g>\n                <g>\n                    <path class=\"st12\" d=\"M1127.956,1238.939c-0.618-0.312-1.24-0.425-1.602-0.466l-0.243,0.97\n                        c-0.018,0.067-0.364,1.358-0.093,2.373h3.779C1129.702,1240.475,1129.083,1239.507,1127.956,1238.939z\"/>\n                </g>\n                <g>\n                    <polygon class=\"st12\" points=\"1127.186,1233.281 1127.125,1234.177 1127.654,1234.115 1127.654,1233.281 \t\t\t\t\"/>\n                </g>\n                <g>\n                    <polygon class=\"st12\" points=\"1128.818,1243.393 1129.438,1242.575 1128.565,1242.575 1127.945,1243.393 \t\t\t\t\"/>\n                </g>\n                <g>\n                    <path class=\"st12\" d=\"M1151.135,1239.137c0.407-0.399,0.628-0.93,0.628-1.5c0-0.578-0.221-1.111-0.62-1.503\n                        c-0.399-0.4-0.945-0.628-1.5-0.628c-0.561,0-1.11,0.228-1.507,0.624c-0.396,0.396-0.623,0.945-0.623,1.507\n                        c0,0.563,0.222,1.094,0.623,1.496C1148.917,1239.93,1150.355,1239.935,1151.135,1239.137z\"/>\n                </g>\n                <g>\n                    <path class=\"st12\" d=\"M1137.914,1238.647c-0.009-0.002-0.019-0.003-0.028-0.005v3.174h3.843\n                        C1141.573,1240.102,1140.324,1239.065,1137.914,1238.647z\"/>\n                </g>\n                <g>\n                    <path class=\"st12\" d=\"M1132.738,1235.64l-0.614-1.285l-5.067,0.595l-0.152,1.305c-0.001,0.014-0.004,0.03-0.009,0.048\n                        l-0.356,1.428c0.46,0.062,1.106,0.203,1.759,0.532c0.965,0.485,2.132,1.496,2.26,3.554h6.57l0.001-1.831l-0.001-0.042v-1.56\n                        c-0.462-0.201-1.05-0.517-1.749-0.938l-0.71,0.708c-0.138,0.143-0.395,0.144-0.536,0c-0.147-0.148-0.147-0.389,0.001-0.536\n                        l0.583-0.583c-0.123-0.077-0.242-0.154-0.357-0.229l-0.722,0.72c-0.143,0.144-0.394,0.145-0.536,0\n                        c-0.072-0.071-0.111-0.167-0.111-0.268c0-0.102,0.039-0.197,0.111-0.269l0.612-0.612c-0.455-0.307-0.776-0.534-0.845-0.583\n                        C1132.808,1235.749,1132.766,1235.698,1132.738,1235.64z\"/>\n                </g>\n                <g>\n                    <path class=\"st12\" d=\"M1150.393,1242.637h-1.5c-0.674,0-1.301,0.259-1.764,0.729c-0.477,0.469-0.736,1.096-0.736,1.771v4.5\n                        c0,0.266,0.104,0.517,0.294,0.706s0.439,0.294,0.706,0.294c0.276,0,0.5,0.224,0.5,0.5v3.75c0,0.466,0.183,0.905,0.514,1.236\n                        c0.662,0.662,1.811,0.662,2.473,0c0.331-0.331,0.514-0.771,0.514-1.236v-3.75c0-0.276,0.224-0.5,0.5-0.5\n                        c0.267,0,0.517-0.104,0.705-0.293c0.19-0.19,0.295-0.441,0.295-0.707v-4.5c0-0.666-0.261-1.294-0.733-1.768\n                        C1151.7,1242.903,1151.057,1242.637,1150.393,1242.637z\"/>\n                </g>\n                <g>\n                    <polygon class=\"st12\" points=\"1134.298,1243.393 1134.917,1242.575 1130.391,1242.575 1129.771,1243.393 \t\t\t\t\"/>\n                </g>\n                <g>\n                    <path class=\"st1\" d=\"M1149.643,1240.756c0.83,0,1.635-0.335,2.199-0.912c0.594-0.582,0.921-1.366,0.921-2.207\n                        c0-0.849-0.327-1.637-0.917-2.214c-1.167-1.171-3.255-1.162-4.417,0c-0.582,0.582-0.916,1.389-0.916,2.214\n                        c0,0.829,0.325,1.611,0.912,2.199C1148.007,1240.43,1148.794,1240.756,1149.643,1240.756z M1148.136,1236.13\n                        c0.396-0.396,0.946-0.624,1.507-0.624c0.555,0,1.101,0.228,1.5,0.628c0.399,0.392,0.62,0.925,0.62,1.503\n                        c0,0.57-0.221,1.101-0.628,1.5c-0.779,0.798-2.218,0.793-2.999-0.004c-0.401-0.402-0.623-0.934-0.623-1.496\n                        C1147.513,1237.076,1147.74,1236.527,1148.136,1236.13z\"/>\n                </g>\n                <g>\n                    <path class=\"st1\" d=\"M1152.869,1242.666c-0.644-0.653-1.546-1.028-2.477-1.028h-1.5c-0.944,0-1.823,0.365-2.471,1.022\n                        c-0.664,0.652-1.029,1.532-1.029,2.478v4.5c0,0.533,0.208,1.035,0.586,1.412c0.257,0.258,0.571,0.437,0.914,0.525v3.313\n                        c0,0.733,0.286,1.423,0.807,1.943s1.21,0.807,1.943,0.807s1.423-0.286,1.943-0.807s0.807-1.21,0.807-1.943v-3.313\n                        c0.343-0.089,0.657-0.268,0.913-0.524c0.379-0.378,0.587-0.88,0.587-1.413v-4.5\n                        C1153.893,1244.205,1153.528,1243.326,1152.869,1242.666z M1152.893,1249.637c0,0.266-0.104,0.517-0.295,0.707\n                        c-0.188,0.188-0.438,0.293-0.705,0.293c-0.276,0-0.5,0.224-0.5,0.5v3.75c0,0.466-0.183,0.905-0.514,1.236\n                        c-0.662,0.662-1.811,0.662-2.473,0c-0.331-0.331-0.514-0.771-0.514-1.236v-3.75c0-0.276-0.224-0.5-0.5-0.5\n                        c-0.267,0-0.517-0.104-0.706-0.294s-0.294-0.44-0.294-0.706v-4.5c0-0.675,0.26-1.302,0.736-1.771\n                        c0.463-0.471,1.09-0.729,1.764-0.729h1.5c0.664,0,1.308,0.266,1.767,0.732c0.473,0.474,0.733,1.102,0.733,1.768V1249.637z\n                        M1142.126,1242.575c0.209,0,0.379-0.17,0.378-0.4c-0.005-1.442-0.595-2.559-1.755-3.316c-0.913-0.598-1.981-0.834-2.704-0.959\n                        c-0.104-0.019-0.232-0.057-0.382-0.112l-0.028-0.011c-1.146-0.444-3.271-1.854-4.254-2.552l-0.688-1.44\n                        c-0.07-0.146-0.231-0.228-0.387-0.214l-3.894,0.456v-1.125c0-0.209-0.17-0.379-0.379-0.379h-1.203\n                        c-0.199,0-0.366,0.155-0.379,0.354l-0.114,1.694l-0.182,1.565l-0.778,3.116c-0.051,0.183-0.483,1.816,0.014,3.082\n                        c0.057,0.146,0.196,0.241,0.354,0.241h1.868l-0.619,0.818h-0.855c-0.147,0-0.283,0.087-0.345,0.221\n                        c-0.062,0.135-0.039,0.294,0.057,0.406l1.529,1.775c0.072,0.083,0.177,0.131,0.288,0.131h1.572c0.209,0,0.379-0.17,0.379-0.379\n                        c0-0.21-0.17-0.38-0.379-0.38h-1.398l-0.875-1.016h14.685c-0.04,0.127-0.087,0.244-0.141,0.353\n                        c-0.217,0.439-0.521,0.663-0.905,0.663h-9.777c-0.209,0-0.379,0.17-0.379,0.38c0,0.209,0.17,0.379,0.379,0.379h9.777\n                        c1.305,0,1.812-1.38,1.897-2.109c0.013-0.107-0.021-0.216-0.093-0.297c-0.072-0.081-0.176-0.127-0.284-0.127h-5.049l0.619-0.818\n                        H1142.126z M1141.729,1241.816h-3.843v-3.174c0.01,0.002,0.02,0.003,0.028,0.005\n                        C1140.324,1239.065,1141.573,1240.102,1141.729,1241.816z M1127.125,1234.177l0.061-0.896h0.469v0.834L1127.125,1234.177z\n                        M1136.743,1242.575l-0.619,0.818h-0.873l0.619-0.818H1136.743z M1129.438,1242.575l-0.62,0.818h-0.873l0.62-0.818H1129.438z\n                        M1126.019,1241.816c-0.271-1.015,0.075-2.306,0.093-2.373l0.243-0.97c0.361,0.041,0.983,0.154,1.602,0.466\n                        c1.127,0.568,1.746,1.536,1.842,2.877H1126.019z M1133.102,1236.988c-0.072,0.071-0.111,0.167-0.111,0.269\n                        c0,0.101,0.039,0.196,0.111,0.268c0.143,0.145,0.394,0.144,0.536,0l0.722-0.72c0.115,0.075,0.234,0.152,0.357,0.229\n                        l-0.583,0.583c-0.148,0.147-0.148,0.388-0.001,0.536c0.142,0.144,0.398,0.143,0.536,0l0.71-0.708\n                        c0.699,0.422,1.287,0.737,1.749,0.938v1.56l0.001,0.042l-0.001,1.831h-6.57c-0.128-2.058-1.295-3.068-2.26-3.554\n                        c-0.652-0.329-1.299-0.471-1.759-0.532l0.356-1.428c0.005-0.018,0.008-0.034,0.009-0.048l0.152-1.305l5.067-0.595l0.614,1.285\n                        c0.027,0.058,0.069,0.108,0.131,0.152c0.068,0.049,0.39,0.276,0.845,0.583L1133.102,1236.988z M1134.917,1242.575l-0.619,0.818\n                        h-4.526l0.619-0.818H1134.917z\"/>\n                </g>\n            </g>\n        </g>\n        <g v-if=\"title.includes(52)\" id=\"debut-sentiers\">\n            <g>\n                <path class=\"st0\" d=\"M1098.257,1174.34L1098.257,1174.34c13.255,0,24,10.745,24,24l0,0c0,13.255-10.745,24-24,24l0,0\n                    c-13.255,0-24-10.745-24-24l0,0C1074.257,1185.085,1085.002,1174.34,1098.257,1174.34z\"/>\n            </g>\n            <g>\n            </g>\n            <g>\n                <g>\n                    <path class=\"st1\" d=\"M1104.262,1191.479h-6.896c-0.163,0-0.316-0.079-0.409-0.213c-0.094-0.134-0.116-0.305-0.061-0.458\n                        l3.448-9.483c0.143-0.395,0.797-0.395,0.939,0l3.448,9.483c0.056,0.153,0.033,0.324-0.061,0.458\n                        C1104.578,1191.4,1104.425,1191.479,1104.262,1191.479z M1098.079,1190.479h5.469l-2.734-7.521L1098.079,1190.479z\"/>\n                </g>\n                <g>\n                    <path class=\"st1\" d=\"M1100.813,1194.928c-0.276,0-0.5-0.224-0.5-0.5v-3.448c0-0.276,0.224-0.5,0.5-0.5s0.5,0.224,0.5,0.5v3.448\n                        C1101.313,1194.704,1101.09,1194.928,1100.813,1194.928z\"/>\n                </g>\n            </g>\n            <g>\n                <g>\n                    <path class=\"st1\" d=\"M1094.029,1207.177h-5.079c-0.163,0-0.316-0.079-0.409-0.213c-0.094-0.134-0.116-0.305-0.061-0.458\n                        l2.539-6.983c0.143-0.395,0.797-0.395,0.939,0l2.54,6.983c0.056,0.153,0.033,0.324-0.061,0.458\n                        C1094.346,1207.098,1094.192,1207.177,1094.029,1207.177z M1089.664,1206.177h3.651l-1.826-5.021L1089.664,1206.177z\"/>\n                </g>\n                <g>\n                    <path class=\"st1\" d=\"M1091.489,1209.716c-0.276,0-0.5-0.224-0.5-0.5v-2.539c0-0.276,0.224-0.5,0.5-0.5s0.5,0.224,0.5,0.5v2.539\n                        C1091.989,1209.492,1091.766,1209.716,1091.489,1209.716z\"/>\n                </g>\n            </g>\n            <g>\n                <g>\n                    <path class=\"st1\" d=\"M1113.707,1201.911h-5.078c-0.163,0-0.316-0.079-0.409-0.213c-0.094-0.134-0.116-0.305-0.061-0.458\n                        l2.539-6.983c0.143-0.395,0.797-0.395,0.939,0l2.539,6.983c0.056,0.153,0.033,0.324-0.061,0.458\n                        C1114.023,1201.832,1113.87,1201.911,1113.707,1201.911z M1109.343,1200.911h3.65l-1.825-5.021L1109.343,1200.911z\"/>\n                </g>\n                <g>\n                    <path class=\"st1\" d=\"M1111.168,1204.45c-0.276,0-0.5-0.224-0.5-0.5v-2.539c0-0.276,0.224-0.5,0.5-0.5s0.5,0.224,0.5,0.5v2.539\n                        C1111.668,1204.227,1111.444,1204.45,1111.168,1204.45z\"/>\n                </g>\n            </g>\n            <g>\n                <path class=\"st1\" d=\"M1104.054,1206.249c-0.102,0-0.203-0.03-0.292-0.094c-0.447-0.321-0.924-0.606-1.416-0.847\n                    c-0.278-0.136-0.539-0.276-0.787-0.423c-0.237-0.14-0.317-0.446-0.177-0.685c0.14-0.238,0.447-0.316,0.685-0.177\n                    c0.227,0.133,0.466,0.262,0.719,0.386c0.541,0.265,1.066,0.578,1.561,0.933c0.224,0.161,0.275,0.474,0.114,0.698\n                    C1104.362,1206.177,1104.209,1206.249,1104.054,1206.249z\"/>\n            </g>\n            <g>\n                <path class=\"st1\" d=\"M1098.73,1203.161c-0.119,0-0.238-0.042-0.334-0.128c-0.647-0.581-1.174-1.27-1.564-2.047\n                    c-0.124-0.247-0.025-0.547,0.222-0.671c0.244-0.127,0.548-0.027,0.671,0.222c0.335,0.665,0.785,1.255,1.34,1.752\n                    c0.205,0.185,0.223,0.5,0.038,0.706C1099.004,1203.105,1098.867,1203.161,1098.73,1203.161z\"/>\n            </g>\n            <g>\n                <path class=\"st1\" d=\"M1093.679,1193.757c-0.098,0-0.196-0.028-0.282-0.088c-0.612-0.419-1.292-0.716-2.02-0.884\n                    c-0.269-0.063-0.437-0.33-0.375-0.6c0.063-0.269,0.33-0.435,0.6-0.375c0.851,0.196,1.645,0.544,2.359,1.034\n                    c0.229,0.155,0.286,0.467,0.13,0.694C1093.994,1193.681,1093.838,1193.757,1093.679,1193.757z\"/>\n            </g>\n            <g>\n                <path class=\"st1\" d=\"M1096.323,1197.909c-0.224,0-0.427-0.15-0.484-0.376c-0.156-0.611-0.348-1.223-0.569-1.818\n                    c-0.096-0.259,0.036-0.546,0.295-0.643c0.255-0.097,0.546,0.035,0.643,0.295c0.233,0.628,0.436,1.272,0.601,1.918\n                    c0.068,0.268-0.093,0.54-0.36,0.608C1096.405,1197.904,1096.364,1197.909,1096.323,1197.909z\"/>\n            </g>\n            <g>\n                <g>\n                    <path class=\"st1\" d=\"M1107.972,1210.856c-0.233,0-0.443-0.165-0.489-0.404l-0.892-4.557c-0.054-0.271,0.123-0.533,0.395-0.586\n                        c0.265-0.057,0.533,0.122,0.586,0.395l0.892,4.557c0.054,0.271-0.123,0.533-0.395,0.586\n                        C1108.036,1210.854,1108.004,1210.856,1107.972,1210.856z\"/>\n                </g>\n                <g>\n                    <path class=\"st1\" d=\"M1105.248,1209.023c-0.233,0-0.443-0.165-0.489-0.404c-0.054-0.271,0.123-0.533,0.395-0.586l4.557-0.892\n                        c0.265-0.058,0.533,0.122,0.586,0.395c0.054,0.271-0.123,0.533-0.395,0.586l-4.557,0.892\n                        C1105.313,1209.021,1105.28,1209.023,1105.248,1209.023z\"/>\n                </g>\n            </g>\n            <g>\n                <path class=\"st1\" d=\"M1086.9,1193.053c-1.406,0-2.549-1.144-2.549-2.55s1.144-2.55,2.549-2.55c1.406,0,2.55,1.144,2.55,2.55\n                    S1088.307,1193.053,1086.9,1193.053z M1086.9,1188.953c-0.854,0-1.549,0.695-1.549,1.55s0.695,1.55,1.549,1.55\n                    s1.55-0.695,1.55-1.55S1087.755,1188.953,1086.9,1188.953z\"/>\n            </g>\n        </g>\n        <g v-if=\"title.includes(20)\" id=\"toilette-list_2_\">\n            <!-- <g id=\"toilette-2_2_\">\n                <g>\n                    <path class=\"st0\" d=\"M1028.699,1309.835L1028.699,1309.835c13.255,0,24,10.745,24,24l0,0c0,13.255-10.745,24-24,24l0,0\n                        c-13.255,0-24-10.745-24-24l0,0C1004.699,1320.58,1015.444,1309.835,1028.699,1309.835z\"/>\n                </g>\n                <g>\n                    <path class=\"st1\" d=\"M1037.659,1345.577h-4.42c-0.168,0-0.313-0.118-0.346-0.283l-0.683-3.427h-2.081\n                        c-0.559,0-1.017-0.424-1.09-1.009c-0.003-0.118-0.003-0.22,0.035-0.334c0.099-0.487,0.197-1.045,0.299-1.616\n                        c0.565-3.185,1.249-7.038,4.351-8.059c-1.106-0.617-1.858-1.809-1.858-3.175c0-1.997,1.607-3.622,3.583-3.622\n                        s3.583,1.625,3.583,3.622c0,1.366-0.751,2.558-1.858,3.175c3.102,1.021,3.786,4.874,4.351,8.059\n                        c0.102,0.571,0.2,1.129,0.31,1.655c0.016,0.093,0.027,0.172,0.027,0.251c-0.076,0.629-0.534,1.053-1.093,1.053h-2.081\n                        l-0.683,3.427C1037.972,1345.459,1037.828,1345.577,1037.659,1345.577z M1033.528,1344.872h3.841l0.683-3.427\n                        c0.033-0.165,0.178-0.283,0.346-0.283h2.37c0.198,0,0.361-0.165,0.39-0.392c0,0.001,0,0.001,0,0.001\n                        c-0.003,0-0.011-0.039-0.018-0.078c-0.108-0.52-0.208-1.084-0.311-1.662c-0.643-3.625-1.372-7.733-5.38-7.733\n                        c-4.009,0-4.738,4.108-5.381,7.733c-0.103,0.579-0.203,1.143-0.313,1.675c0.013,0.291,0.176,0.456,0.374,0.456h2.37\n                        c0.168,0,0.313,0.118,0.346,0.283L1033.528,1344.872z M1035.449,1324.758c-1.586,0-2.877,1.309-2.877,2.917\n                        s1.291,2.918,2.877,2.918s2.877-1.31,2.877-2.918S1037.036,1324.758,1035.449,1324.758z M1024.069,1345.577h-4.84\n                        c-0.178,0-0.329-0.133-0.35-0.31l-0.764-6.23h-2.107c-0.195,0-0.353-0.157-0.353-0.353v-2.449c0-1.622,0.624-3.146,1.755-4.288\n                        c0.701-0.715,1.573-1.238,2.519-1.527c-1.104-0.616-1.855-1.809-1.855-3.175c0-1.998,1.604-3.623,3.575-3.623\n                        c1.976,0,3.583,1.625,3.583,3.623c0,1.363-0.749,2.553-1.852,3.171c0.944,0.285,1.808,0.806,2.521,1.532\n                        c1.128,1.139,1.751,2.661,1.751,4.287v2.449c0,0.195-0.158,0.353-0.353,0.353h-2.108l-0.772,6.23\n                        C1024.397,1345.444,1024.247,1345.577,1024.069,1345.577z M1019.542,1344.872h4.215l0.772-6.23\n                        c0.022-0.177,0.172-0.31,0.35-0.31h2.067v-2.097c0-1.438-0.549-2.785-1.547-3.792c-0.998-1.017-2.329-1.576-3.75-1.576\n                        c-1.394,0-2.755,0.574-3.736,1.575c-1.001,1.012-1.552,2.357-1.552,3.793v2.097h2.066c0.178,0,0.329,0.133,0.35,0.31\n                        L1019.542,1344.872z M1021.649,1324.327c-1.582,0-2.869,1.31-2.869,2.918s1.287,2.917,2.869,2.917\n                        c1.586,0,2.877-1.309,2.877-2.917S1023.235,1324.327,1021.649,1324.327z\"/>\n                </g>\n            </g> -->\n            <g id=\"toilette-1_2_\">\n                <g>\n                    <path class=\"st0\" d=\"M1860,1076L1860,1076c13.255,0,24,10.745,24,24l0,0c0,13.255-10.745,24-24,24l0,0\n                        c-13.255,0-24-10.745-24-24l0,0C1836,1086.745,1846.745,1076,1860,1076z\"/>\n                </g>\n                <g>\n                    <path class=\"st1\" d=\"M1868.96,1111.742h-4.42c-0.168,0-0.313-0.118-0.346-0.283l-0.684-3.427h-2.081\n                        c-0.558,0-1.017-0.424-1.091-1.007c-0.002-0.12-0.002-0.224,0.037-0.339c0.098-0.484,0.196-1.043,0.298-1.614\n                        c0.565-3.185,1.25-7.037,4.352-8.057c-1.107-0.618-1.858-1.81-1.858-3.176c0-1.997,1.607-3.622,3.583-3.622\n                        s3.583,1.625,3.583,3.622c0,1.366-0.751,2.558-1.858,3.176c3.102,1.02,3.786,4.872,4.352,8.057c0.102,0.571,0.2,1.13,0.31,1.656\n                        c0.018,0.105,0.027,0.178,0.027,0.252c-0.076,0.628-0.535,1.052-1.093,1.052h-2.081l-0.684,3.427\n                        C1869.273,1111.624,1869.128,1111.742,1868.96,1111.742z M1864.829,1111.037h3.842l0.684-3.427\n                        c0.032-0.165,0.178-0.283,0.346-0.283h2.37c0.197,0,0.361-0.165,0.39-0.392c0.001,0.004-0.01-0.021-0.016-0.062\n                        c-0.11-0.535-0.211-1.1-0.313-1.679c-0.644-3.624-1.373-7.732-5.381-7.732s-4.737,4.108-5.381,7.732\n                        c-0.103,0.579-0.203,1.144-0.313,1.676c0.013,0.291,0.177,0.456,0.374,0.456h2.37c0.168,0,0.313,0.118,0.346,0.283\n                        L1864.829,1111.037z M1866.75,1090.923c-1.587,0-2.878,1.309-2.878,2.917s1.291,2.918,2.878,2.918s2.878-1.31,2.878-2.918\n                        S1868.337,1090.923,1866.75,1090.923z M1855.37,1111.742h-4.84c-0.179,0-0.329-0.133-0.351-0.31l-0.762-6.23h-2.107\n                        c-0.195,0-0.353-0.157-0.353-0.353v-2.449c0-1.625,0.622-3.148,1.751-4.288c0.702-0.716,1.575-1.238,2.522-1.527\n                        c-1.104-0.617-1.854-1.809-1.854-3.175c0-1.998,1.603-3.623,3.572-3.623c1.976,0,3.582,1.625,3.582,3.623\n                        c0,1.363-0.748,2.553-1.851,3.171c0.944,0.285,1.808,0.806,2.521,1.532c1.128,1.139,1.75,2.662,1.75,4.287v2.449\n                        c0,0.195-0.157,0.353-0.353,0.353h-2.108l-0.771,6.23C1855.698,1111.609,1855.548,1111.742,1855.37,1111.742z\n                        M1850.843,1111.037h4.216l0.771-6.23c0.022-0.177,0.173-0.31,0.351-0.31h2.067v-2.097c0-1.438-0.55-2.785-1.548-3.792\n                        c-0.998-1.017-2.329-1.576-3.749-1.576c-1.394,0-2.757,0.574-3.738,1.575c-0.999,1.008-1.549,2.354-1.549,3.793v2.097h2.067\n                        c0.179,0,0.329,0.133,0.351,0.31L1850.843,1111.037z M1852.95,1090.492c-1.581,0-2.867,1.31-2.867,2.918\n                        s1.286,2.917,2.867,2.917c1.586,0,2.877-1.309,2.877-2.917S1854.536,1090.492,1852.95,1090.492z\"/>\n                </g>\n            </g>\n        </g>\n        <g v-if=\"title.includes(23)\" id=\"parking-list_1_\">\n            <g id=\"parking-3_1_\">\n                <g>\n                    <path class=\"st0\" d=\"M900,1043L900,1043c13.255,0,24,10.745,24,24l0,0c0,13.255-10.745,24-24,24l0,0c-13.255,0-24-10.745-24-24\n                        l0,0C876,1053.745,886.745,1043,900,1043z\"/>\n                </g>\n                <g>\n                    <path class=\"st1\" d=\"M905.978,1078.55h-11.84c-3.074,0-5.574-2.498-5.574-5.569v-11.841c0-3.076,2.5-5.579,5.574-5.579h11.84\n                        c3.073,0,5.574,2.503,5.574,5.579v11.841C911.552,1076.052,909.051,1078.55,905.978,1078.55z M894.138,1056.561\n                        c-2.522,0-4.574,2.054-4.574,4.579v11.841c0,2.52,2.052,4.569,4.574,4.569h11.84c2.522,0,4.574-2.05,4.574-4.569v-11.841\n                        c0-2.525-2.052-4.579-4.574-4.579H894.138z M897.029,1073.5c-0.276,0-0.5-0.224-0.5-0.5v-11.88c0-0.276,0.224-0.5,0.5-0.5h5.387\n                        c1.675,0,3.037,1.359,3.037,3.03v1.859c0,1.677-1.362,3.04-3.037,3.04h-4.887v4.45\n                        C897.529,1073.276,897.305,1073.5,897.029,1073.5z M897.529,1067.55h4.887c1.123,0,2.037-0.915,2.037-2.04v-1.859\n                        c0-1.119-0.914-2.03-2.037-2.03h-4.887V1067.55z\"/>\n                </g>\n            </g>\n            <g id=\"parking-2_1_\">\n                <g>\n                    <path class=\"st0\" d=\"M1965,1009L1965,1009c13.255,0,24,10.745,24,24l0,0c0,13.255-10.745,24-24,24l0,0\n                        c-13.255,0-24-10.745-24-24l0,0C1941,1019.745,1951.745,1009,1965,1009z\"/>\n                </g>\n                <g>\n                    <path class=\"st1\" d=\"M1970.98,1044.55h-11.841c-3.076,0-5.579-2.498-5.579-5.569v-11.841c0-3.077,2.503-5.58,5.579-5.58h11.841\n                        c3.071,0,5.569,2.503,5.569,5.58v11.841C1976.55,1042.052,1974.052,1044.55,1970.98,1044.55z M1959.14,1022.56\n                        c-2.525,0-4.579,2.055-4.579,4.58v11.841c0,2.52,2.054,4.569,4.579,4.569h11.841c2.52,0,4.569-2.05,4.569-4.569v-11.841\n                        c0-2.525-2.05-4.58-4.569-4.58H1959.14z M1962.03,1039.5c-0.276,0-0.5-0.224-0.5-0.5v-11.88c0-0.276,0.224-0.5,0.5-0.5h5.39\n                        c1.671,0,3.03,1.359,3.03,3.03v1.859c0,1.677-1.359,3.04-3.03,3.04h-4.89v4.45C1962.53,1039.276,1962.307,1039.5,1962.03,1039.5\n                        z M1962.53,1033.55h4.89c1.119,0,2.03-0.915,2.03-2.04v-1.859c0-1.119-0.911-2.03-2.03-2.03h-4.89V1033.55z\"/>\n                </g>\n            </g>\n            <g id=\"parking-1_1_\">\n                <g>\n                    <path class=\"st0\" d=\"M788,550L788,550c13.255,0,24,10.745,24,24l0,0c0,13.255-10.745,24-24,24l0,0c-13.255,0-24-10.745-24-24\n                        l0,0C764,560.745,774.745,550,788,550z\"/>\n                </g>\n                <g>\n                    <path class=\"st1\" d=\"M793.978,585.552h-11.84c-3.074,0-5.574-2.5-5.574-5.574v-11.839c0-3.074,2.5-5.574,5.574-5.574h11.84\n                        c3.073,0,5.574,2.5,5.574,5.574v11.839C799.552,583.051,797.051,585.552,793.978,585.552z M782.138,563.565\n                        c-2.522,0-4.574,2.052-4.574,4.574v11.839c0,2.522,2.052,4.574,4.574,4.574h11.84c2.522,0,4.574-2.052,4.574-4.574v-11.839\n                        c0-2.522-2.052-4.574-4.574-4.574H782.138z M785.029,580.501c-0.276,0-0.5-0.224-0.5-0.5v-11.885c0-0.276,0.224-0.5,0.5-0.5\n                        h5.387c1.675,0,3.037,1.362,3.037,3.037v1.859c0,1.674-1.362,3.037-3.037,3.037h-4.887v4.452\n                        C785.529,580.277,785.305,580.501,785.029,580.501z M785.529,574.549h4.887c1.123,0,2.037-0.914,2.037-2.037v-1.859\n                        c0-1.123-0.914-2.037-2.037-2.037h-4.887V574.549z\"/>\n                </g>\n            </g>\n            <g id=\"parking-4_2_\">\n                <g>\n                    <path class=\"st0\" d=\"M1812,1124L1812,1124c13.255,0,24,10.745,24,24l0,0c0,13.255-10.745,24-24,24l0,0\n                        c-13.255,0-24-10.745-24-24l0,0C1788,1134.745,1798.745,1124,1812,1124z\"/>\n                </g>\n                <g>\n                    <path class=\"st1\" d=\"M1817.98,1159.55h-11.841c-3.076,0-5.579-2.498-5.579-5.569v-11.841c0-3.076,2.503-5.579,5.579-5.579\n                        h11.841c3.071,0,5.569,2.503,5.569,5.579v11.841C1823.55,1157.052,1821.052,1159.55,1817.98,1159.55z M1806.14,1137.561\n                        c-2.525,0-4.579,2.054-4.579,4.579v11.841c0,2.52,2.054,4.569,4.579,4.569h11.841c2.52,0,4.569-2.05,4.569-4.569v-11.841\n                        c0-2.525-2.05-4.579-4.569-4.579H1806.14z M1809.03,1154.5c-0.276,0-0.5-0.224-0.5-0.5v-11.88c0-0.276,0.224-0.5,0.5-0.5h5.39\n                        c1.671,0,3.03,1.359,3.03,3.03v1.859c0,1.677-1.359,3.04-3.03,3.04h-4.89v4.45C1809.53,1154.276,1809.307,1154.5,1809.03,1154.5\n                        z M1809.53,1148.55h4.89c1.119,0,2.03-0.915,2.03-2.04v-1.859c0-1.119-0.911-2.03-2.03-2.03h-4.89V1148.55z\"/>\n                </g>\n            </g>\n            <g id=\"parking-5_1_\">\n                <g>\n                    <path class=\"st0\" d=\"M1445.214,1266.21L1445.214,1266.21c13.255,0,24,10.745,24,24l0,0c0,13.255-10.745,24-24,24l0,0\n                        c-13.255,0-24-10.745-24-24l0,0C1421.214,1276.955,1431.959,1266.21,1445.214,1266.21z\"/>\n                </g>\n                <g>\n                    <path class=\"st1\" d=\"M1451.193,1301.76h-11.84c-3.077,0-5.58-2.498-5.58-5.569v-11.841c0-3.071,2.503-5.569,5.58-5.569h11.84\n                        c3.071,0,5.57,2.498,5.57,5.569v11.841C1456.764,1299.262,1454.265,1301.76,1451.193,1301.76z M1439.354,1279.78\n                        c-2.525,0-4.58,2.05-4.58,4.569v11.841c0,2.52,2.055,4.569,4.58,4.569h11.84c2.521,0,4.57-2.05,4.57-4.569v-11.841\n                        c0-2.52-2.05-4.569-4.57-4.569H1439.354z M1442.243,1296.71c-0.276,0-0.5-0.224-0.5-0.5v-11.88c0-0.276,0.224-0.5,0.5-0.5h5.391\n                        c1.67,0,3.029,1.359,3.029,3.03v1.859c0,1.677-1.359,3.04-3.029,3.04h-4.891v4.45\n                        C1442.743,1296.486,1442.52,1296.71,1442.243,1296.71z M1442.743,1290.76h4.891c1.119,0,2.029-0.915,2.029-2.04v-1.859\n                        c0-1.119-0.91-2.03-2.029-2.03h-4.891V1290.76z\"/>\n                </g>\n            </g>\n        </g>\n        <g v-if=\"title.includes(57)\" id=\"rouge-vin_\">\n            <g id=\"rouge-vin\">\n              <path class=\"st0\" d=\"M1814.493,1049.7h0c13.255,0,24,10.745,24,24h0c0,13.255-10.745,24-24,24h0c-13.255,0-24-10.745-24-24h0c0-13.255,10.745-24,24-24Z\"/>\n              <path class=\"st1\" d=\"M1820.64,1085.25c-.276,0-.5-.224-.5-.5v-11.373c-2.28-.306-4.059-2.672-4.059-5.537,0-3.071,2.045-5.569,4.559-5.569s4.559,2.498,4.559,5.569c0,2.865-1.779,5.231-4.059,5.537v11.373c0,.276-.224.5-.5.5ZM1820.64,1063.27c-1.962,0-3.559,2.05-3.559,4.569s1.597,4.57,3.559,4.57,3.559-2.05,3.559-4.57-1.597-4.569-3.559-4.569ZM1808.631,1085.25c-.276,0-.5-.224-.5-.5v-13.056c-1.079-.112-2.075-.586-2.844-1.362-.878-.875-1.384-2.094-1.384-3.342v-4.22c0-.276.224-.5.5-.5s.5.224.5.5v4.22c0,.984.398,1.944,1.092,2.636.582.587,1.327.954,2.136,1.061v-7.916c0-.276.224-.5.5-.5s.5.224.5.5v7.916c.317-.043.628-.126.929-.249.456-.187.861-.458,1.204-.808.344-.342.624-.759.812-1.212.188-.453.284-.934.284-1.428v-4.22c0-.276.224-.5.5-.5s.5.224.5.5v4.22c0,.627-.121,1.236-.36,1.812-.24.573-.595,1.104-1.026,1.532-.435.442-.952.79-1.534,1.028-.422.173-.86.283-1.308.33v13.057c0,.276-.224.5-.5.5Z\"/>\n            </g>\n        </g>\n        <g v-if=\"title.includes(21)\" id=\"food-truck-1_1_\">\n            <g\n               id=\"food-truck-1-2-3\"\n               data-name=\"food-truck-1\"\n               transform=\"translate(-941.10798,211.68029)\">\n              <path\n                 class=\"cls-11\"\n                 d=\"m 1814.69,1049.755 v 0 c 13.255,0 24,10.745 24,24 v 0 c 0,13.255 -10.745,24 -24,24 v 0 c -13.255,0 -24,-10.745 -24,-24 v 0 c 0,-13.255 10.745,-24 24,-24 z\"\n                 id=\"path999-6\"\n                 style=\"fill:#4d80d6;stroke-width:0px\" />\n              <g\n                 id=\"g2139\"\n                 transform=\"matrix(-1.0125265,0,0,0.9677929,1838.8362,1050.5053)\">\n                <path\n                   d=\"m 11.517382,24.490647 h 7.175901\"\n                   fill=\"none\"\n                   stroke=\"#000000\"\n                   stroke-linecap=\"round\"\n                   stroke-linejoin=\"round\"\n                   stroke-width=\"1\"\n                   id=\"path259\"\n                   style=\"stroke:#ffffff;stroke-opacity:1\" />\n                <path\n                   d=\"m 12.115374,33.682138 a 2.3919672,2.4510641 0 1 0 4.783934,0 2.3919672,2.4510641 0 1 0 -4.783934,0\"\n                   fill=\"none\"\n                   stroke=\"#000000\"\n                   stroke-linecap=\"round\"\n                   stroke-linejoin=\"round\"\n                   stroke-width=\"1\"\n                   id=\"path261\"\n                   style=\"stroke:#ffffff;stroke-opacity:1\" />\n                <path\n                   d=\"m 28.859144,33.682138 a 2.3919672,2.4510641 0 1 0 4.783934,0 2.3919672,2.4510641 0 1 0 -4.783934,0\"\n                   fill=\"none\"\n                   stroke=\"#000000\"\n                   stroke-linecap=\"round\"\n                   stroke-linejoin=\"round\"\n                   stroke-width=\"1\"\n                   id=\"path263\"\n                   style=\"stroke:#ffffff;stroke-opacity:1\" />\n                <path\n                   d=\"M 12.115374,33.682138 H 9.7234061 A 0.59799179,0.61276604 0 0 1 9.1254145,33.069372 v -5.873975 a 0.59799179,0.61276604 0 0 1 0.1746138,-0.432614 l 2.2173537,-2.272136 2.647908,-4.88497 a 1.1959835,1.2255321 0 0 1 1.04529,-0.629924 h 3.482703 v -5.514894 a 0.59799179,0.61276604 0 0 1 0.597992,-0.612766 h 16.743771 a 0.59799179,0.61276604 0 0 1 0.597991,0.612766 v 19.608513 a 0.59799179,0.61276604 0 0 1 -0.597991,0.612766 h -2.391968\"\n                   fill=\"none\"\n                   stroke=\"#000000\"\n                   stroke-linecap=\"round\"\n                   stroke-linejoin=\"round\"\n                   stroke-width=\"1\"\n                   id=\"path265\"\n                   style=\"stroke:#ffffff;stroke-opacity:1\" />\n                <path\n                   d=\"M 16.899308,33.682138 H 28.859144\"\n                   fill=\"none\"\n                   stroke=\"#000000\"\n                   stroke-linecap=\"round\"\n                   stroke-linejoin=\"round\"\n                   stroke-width=\"1\"\n                   id=\"path267\"\n                   style=\"stroke:#ffffff;stroke-opacity:1\" />\n                <path\n                   d=\"m 18.693283,18.975753 v 12.25532\"\n                   fill=\"none\"\n                   stroke=\"#000000\"\n                   stroke-linecap=\"round\"\n                   stroke-linejoin=\"round\"\n                   stroke-width=\"1\"\n                   id=\"path269\"\n                   style=\"stroke:#ffffff;stroke-opacity:1\" />\n                <path\n                   d=\"M 9.1254145,31.231073 H 36.633037\"\n                   fill=\"none\"\n                   stroke=\"#000000\"\n                   stroke-linecap=\"round\"\n                   stroke-linejoin=\"round\"\n                   stroke-width=\"1\"\n                   id=\"path271\"\n                   style=\"stroke:#ffffff;stroke-opacity:1\" />\n                <path\n                   d=\"M 21.085251,20.201285 H 34.24107 l -2.391967,-3.676597 h -8.371885 z\"\n                   fill=\"none\"\n                   stroke=\"#000000\"\n                   stroke-linecap=\"round\"\n                   stroke-linejoin=\"round\"\n                   stroke-width=\"1\"\n                   id=\"path273\"\n                   style=\"stroke:#ffffff;stroke-opacity:1\" />\n                <path\n                   d=\"M 21.085251,25.103413 H 34.24107\"\n                   fill=\"none\"\n                   stroke=\"#000000\"\n                   stroke-linecap=\"round\"\n                   stroke-linejoin=\"round\"\n                   stroke-width=\"1\"\n                   id=\"path275\"\n                   style=\"stroke:#ffffff;stroke-opacity:1\" />\n                <path\n                   d=\"m 22.281234,20.201285 h 10.763852 v 7.353193 H 22.281234 Z\"\n                   fill=\"none\"\n                   stroke=\"#000000\"\n                   stroke-linecap=\"round\"\n                   stroke-linejoin=\"round\"\n                   stroke-width=\"1\"\n                   id=\"path277-5\"\n                   style=\"stroke:#ffffff;stroke-opacity:1\" />\n              </g>\n            </g>\n        </g>\n        <g v-if=\"title.includes(28)\" id=\"paserelle_1_\">\n            <g>\n                <path class=\"st6\" d=\"M774,901L774,901c12.703,0,23,10.297,23,23l0,0c0,12.703-10.297,23-23,23l0,0c-12.703,0-23-10.297-23-23l0,0\n                    C751,911.297,761.297,901,774,901z\"/>\n            </g>\n            <g>\n                <path class=\"st1\" d=\"M774,948c-13.233,0-24-10.767-24-24s10.767-24,24-24s24,10.767,24,24S787.233,948,774,948z M774,902\n                    c-12.131,0-22,9.869-22,22s9.869,22,22,22s22-9.869,22-22S786.131,902,774,902z\"/>\n            </g>\n            <g>\n                <path class=\"st1\" d=\"M786.809,934.476h-25.5c-0.276,0-0.5-0.224-0.5-0.5s0.224-0.5,0.5-0.5h25.5c0.276,0,0.5,0.224,0.5,0.5\n                    S787.085,934.476,786.809,934.476z\"/>\n            </g>\n            <g>\n                <path class=\"st1\" d=\"M783.976,928.809h-19.833c-0.276,0-0.5-0.224-0.5-0.5s0.224-0.5,0.5-0.5h19.833c0.276,0,0.5,0.224,0.5,0.5\n                    S784.252,928.809,783.976,928.809z\"/>\n            </g>\n            <g>\n                <path class=\"st1\" d=\"M786.809,934.475c-0.276,0-0.5-0.224-0.5-0.5v-11.333c0-0.276,0.224-0.5,0.5-0.5s0.5,0.224,0.5,0.5v11.333\n                    C787.309,934.251,787.085,934.475,786.809,934.475z\"/>\n            </g>\n            <g>\n                \n                    <rect x=\"778.265\" y=\"927.1\" transform=\"matrix(0.4961 0.8683 -0.8683 0.4961 1200.47 -213.2738)\" class=\"st1\" width=\"11.421\" height=\"1\"/>\n            </g>\n            <g>\n                <path class=\"st1\" d=\"M781.141,923.142h-14.166c-0.276,0-0.5-0.224-0.5-0.5s0.224-0.5,0.5-0.5h14.166c0.276,0,0.5,0.224,0.5,0.5\n                    S781.417,923.142,781.141,923.142z\"/>\n            </g>\n            <g>\n                <path class=\"st1\" d=\"M761.309,934.475c-0.276,0-0.5-0.224-0.5-0.5v-11.333c0-0.276,0.224-0.5,0.5-0.5s0.5,0.224,0.5,0.5v11.333\n                    C761.809,934.251,761.585,934.475,761.309,934.475z\"/>\n            </g>\n            <g>\n                \n                    <rect x=\"763.642\" y=\"921.889\" transform=\"matrix(0.8682 0.4961 -0.4961 0.8682 560.8995 -256.903)\" class=\"st1\" width=\"1\" height=\"11.421\"/>\n            </g>\n            <g>\n                <path class=\"st1\" d=\"M781.143,923.142c-0.276,0-0.5-0.224-0.5-0.5v-8.5c0-0.276,0.224-0.5,0.5-0.5s0.5,0.224,0.5,0.5v8.5\n                    C781.643,922.918,781.419,923.142,781.143,923.142z\"/>\n            </g>\n            <g>\n                \n                    <rect x=\"778.868\" y=\"917.892\" transform=\"matrix(0.5547 0.8321 -0.8321 0.5547 1113.314 -243.3305)\" class=\"st1\" width=\"10.215\" height=\"1\"/>\n            </g>\n            <g>\n                <path class=\"st1\" d=\"M766.975,923.142c-0.276,0-0.5-0.224-0.5-0.5v-8.5c0-0.276,0.224-0.5,0.5-0.5s0.5,0.224,0.5,0.5v8.5\n                    C767.475,922.918,767.251,923.142,766.975,923.142z\"/>\n            </g>\n            <g>\n                <path class=\"st1\" d=\"M761.309,923.142c-0.095,0-0.191-0.027-0.277-0.084c-0.23-0.153-0.292-0.464-0.139-0.693l5.666-8.5\n                    c0.153-0.229,0.462-0.293,0.693-0.139c0.23,0.153,0.292,0.464,0.139,0.693l-5.666,8.5\n                    C761.629,923.063,761.47,923.142,761.309,923.142z\"/>\n            </g>\n        </g>\n        <g v-if=\"title.includes(22)\" id=\"belvedere_1_\">\n            <g>\n                <path class=\"st1\" d=\"M177.04,555.987c0,5.676-4.606,10.277-10.286,10.277c-5.68,0-10.285-4.601-10.285-10.277\n                    c0-5.675,4.605-10.277,10.285-10.277C172.434,545.71,177.04,550.312,177.04,555.987z\"/>\n                <path class=\"st13\" d=\"M166.754,566.949c-6.049,0-10.97-4.918-10.97-10.962s4.921-10.962,10.97-10.962\n                    c6.049,0,10.971,4.917,10.971,10.962S172.803,566.949,166.754,566.949z M166.754,546.395c-5.293,0-9.6,4.303-9.6,9.592\n                    s4.307,9.592,9.6,9.592c5.294,0,9.601-4.303,9.601-9.592S172.048,546.395,166.754,546.395z\"/>\n            </g>\n            <g>\n                <path class=\"st0\" d=\"M162,531L162,531c12.703,0,23,10.297,23,23l0,0c0,12.703-10.297,23-23,23l0,0c-12.703,0-23-10.297-23-23l0,0\n                    C139,541.297,149.297,531,162,531z\"/>\n            </g>\n            <g>\n                <path class=\"st1\" d=\"M162,578c-13.233,0-24-10.767-24-24s10.767-24,24-24s24,10.767,24,24S175.233,578,162,578z M162,532\n                    c-12.131,0-22,9.869-22,22s9.869,22,22,22s22-9.869,22-22S174.131,532,162,532z\"/>\n            </g>\n            <g>\n                <path class=\"st1\" d=\"M168.823,565.552c-2.607,0-4.728-2.121-4.728-4.728v-5.074c0-0.276,0.224-0.5,0.5-0.5s0.5,0.224,0.5,0.5\n                    v2.169c0.866-1.109,2.215-1.823,3.728-1.823c1.207,0,2.31,0.455,3.146,1.201l-2.487-12.767c-0.053-0.275-0.202-0.524-0.42-0.7\n                    c-0.217-0.176-0.503-0.275-0.771-0.266h-2.005c-0.317,0-0.617,0.124-0.843,0.35c-0.225,0.224-0.348,0.523-0.348,0.842v2.537\n                    c0,0.276-0.224,0.5-0.5,0.5s-0.5-0.224-0.5-0.5v-2.537c0-0.586,0.228-1.136,0.641-1.549c0.415-0.415,0.965-0.643,1.55-0.643\n                    h1.996c0.517,0.011,1.011,0.165,1.41,0.489c0.401,0.324,0.675,0.781,0.772,1.287l3.027,15.542c0.013,0.065,0.012,0.129,0,0.19\n                    c0.039,0.245,0.06,0.496,0.06,0.751C173.552,563.431,171.431,565.552,168.823,565.552z M168.823,557.096\n                    c-2.056,0-3.728,1.672-3.728,3.728c0,2.055,1.672,3.728,3.728,3.728c2.056,0,3.729-1.672,3.729-3.728\n                    C172.552,558.769,170.879,557.096,168.823,557.096z M155.293,565.552c-2.607,0-4.729-2.121-4.729-4.728\n                    c0-0.326,0.033-0.645,0.097-0.953l2.991-15.531c0.097-0.504,0.371-0.961,0.772-1.287c0.399-0.324,0.905-0.493,1.419-0.489h1.987\n                    c0.578,0,1.143,0.234,1.55,0.643c0.413,0.413,0.641,0.963,0.641,1.549v2.537c0,0.276-0.224,0.5-0.5,0.5s-0.5-0.224-0.5-0.5\n                    v-2.537c0-0.318-0.124-0.617-0.349-0.842c-0.222-0.222-0.528-0.35-0.842-0.35h-1.996c-0.295-0.002-0.563,0.089-0.78,0.265\n                    c-0.218,0.177-0.367,0.425-0.419,0.699l-2.454,12.739c0.833-0.729,1.922-1.171,3.113-1.171c1.513,0,2.862,0.714,3.728,1.823\n                    v-2.169c0-0.276,0.224-0.5,0.5-0.5s0.5,0.224,0.5,0.5v5.074C160.021,563.431,157.9,565.552,155.293,565.552z M151.638,560.083\n                    c-0.049,0.24-0.074,0.488-0.074,0.742c0,2.055,1.673,3.728,3.729,3.728c2.056,0,3.728-1.672,3.728-3.728\n                    c0-2.056-1.672-3.728-3.728-3.728c-1.8,0-3.306,1.281-3.653,2.979C151.639,560.078,151.639,560.08,151.638,560.083z\n                    M166.286,552.022h-8.456c-0.276,0-0.5-0.224-0.5-0.5s0.224-0.5,0.5-0.5h8.456c0.276,0,0.5,0.224,0.5,0.5\n                    S166.563,552.022,166.286,552.022z\"/>\n            </g>\n        </g>\n        <g v-if=\"title.includes(26)\" id=\"admin_1_\">\n            <g>\n                <path class=\"st0\" d=\"M1493.836,1231L1493.836,1231c13.255,0,24,10.745,24,24l0,0c0,13.255-10.745,24-24,24l0,0\n                    c-13.255,0-24-10.745-24-24l0,0C1469.836,1241.745,1480.581,1231,1493.836,1231z\"/>\n            </g>\n            <g>\n                <path class=\"st1\" d=\"M1503.196,1266.55h-18.6c-0.578,0-1.128-0.224-1.548-0.63c-0.423-0.423-0.652-0.975-0.652-1.56v-9.4\n                    c0-0.296,0.06-0.591,0.177-0.879c0.151-0.317,0.324-0.552,0.54-0.744l10.444-9.634c0.191-0.178,0.486-0.178,0.678,0l10.45,9.64\n                    c0.229,0.215,0.406,0.466,0.52,0.729c0.121,0.264,0.182,0.558,0.182,0.888v9.4c0,0.577-0.224,1.127-0.631,1.548\n                    C1504.324,1266.326,1503.774,1266.55,1503.196,1266.55z M1493.896,1244.751l-10.111,9.326c-0.122,0.109-0.218,0.241-0.299,0.409\n                    c-0.057,0.142-0.09,0.306-0.09,0.474v9.4c0,0.318,0.126,0.618,0.354,0.847c0.227,0.219,0.529,0.343,0.847,0.343h18.6\n                    c0.317,0,0.62-0.124,0.853-0.349c0.214-0.222,0.338-0.524,0.338-0.841v-9.4c0-0.184-0.031-0.342-0.096-0.483\n                    c-0.064-0.148-0.162-0.284-0.287-0.402L1493.896,1244.751z M1496.816,1261.99h-5.84c-0.885,0-2.2-0.583-2.2-2.19v-4.16\n                    c0-0.88,0.586-2.189,2.2-2.189h0.3v-0.46c0-1.213,0.982-2.2,2.19-2.2h0.859c1.208,0,2.19,0.987,2.19,2.2v0.46h0.3\n                    c0.881,0,2.19,0.583,2.19,2.189v4.16C1499.007,1260.681,1498.424,1261.99,1496.816,1261.99z M1490.977,1254.45\n                    c-1.127,0-1.197,0.993-1.2,1.192v4.157c0,1.157,1.077,1.19,1.2,1.19h5.84c1.117,0,1.188-0.994,1.19-1.193v-4.157\n                    c0-1.156-1.068-1.189-1.19-1.189H1490.977z M1492.276,1253.45h3.24v-0.46c0-0.662-0.534-1.2-1.19-1.2h-0.859\n                    c-0.656,0-1.19,0.538-1.19,1.2V1253.45z\"/>\n            </g>\n        </g>\n        <g v-if=\"title.includes(56)\" id=\"go-van\">\n          <g id=\"go-van-1\">\n            <path class=\"st6\" d=\"M1788,1171.891h0c13.255,0,24,10.745,24,24h0c0,13.255-10.745,24-24,24h0c-13.255,0-24-10.745-24-24h0c0-13.255,10.745-24,24-24Z\"/>\n            <g>\n              <path class=\"st1\" d=\"M1792.371,1203.857h-8.53c-.276,0-.5-.224-.5-.5s.224-.5.5-.5h8.53c.276,0,.5.224.5.5s-.224.5-.5.5Z\"/>\n              <g>\n                <path class=\"st1\" d=\"M1780.997,1206.701c-1.844,0-3.344-1.5-3.344-3.344s1.5-3.345,3.345-3.345c1.844,0,3.343,1.502,3.343,3.345s-1.5,3.344-3.344,3.344ZM1780.998,1201.013c-1.293,0-2.345,1.051-2.345,2.343v.002c0,1.292,1.052,2.344,2.344,2.344s2.344-1.052,2.344-2.344-1.051-2.344-2.343-2.345Z\"/>\n                <path class=\"st1\" d=\"M1795.215,1206.701c-1.844,0-3.344-1.5-3.344-3.344h0c0-1.845,1.502-3.345,3.345-3.345.894,0,1.733.349,2.364.98.632.632.979,1.472.979,2.364,0,1.844-1.5,3.344-3.344,3.344ZM1792.371,1203.355l.5.002c0,1.292,1.052,2.344,2.344,2.344s2.344-1.052,2.344-2.344c0-.626-.243-1.215-.686-1.657-.442-.443-1.031-.688-1.657-.688-1.292,0-2.344,1.051-2.345,2.343h-.5Z\"/>\n                <path class=\"st1\" d=\"M1799.48,1203.857h-1.422c-.276,0-.5-.224-.5-.5s.224-.5.5-.5h1.422c.509,0,.922-.413.922-.922v-6.438c0-.362-.085-.725-.247-1.048l-1.365-2.729c-.642-1.283-1.932-2.081-3.367-2.081h-15.848c-2.076,0-3.766,1.688-3.766,3.765v8.531c0,.509.413.922.922.922h1.422c.276,0,.5.224.5.5s-.224.5-.5.5h-1.422c-1.06,0-1.922-.862-1.922-1.922v-8.531c0-2.627,2.138-4.765,4.766-4.765h15.848c1.816,0,3.449,1.009,4.262,2.634l1.365,2.729c.23.461.353.979.353,1.495v6.438c0,1.06-.862,1.922-1.922,1.922Z\"/>\n                <path class=\"st1\" d=\"M1800.902,1196.748h-25.593c-.276,0-.5-.224-.5-.5s.224-.5.5-.5h25.593c.276,0,.5.224.5.5s-.224.5-.5.5Z\"/>\n                <path class=\"st1\" d=\"M1792.371,1196.748c-.276,0-.5-.224-.5-.5v-7.108c0-.276.224-.5.5-.5s.5.224.5.5v7.108c0,.276-.224.5-.5.5Z\"/>\n                <path class=\"st1\" d=\"M1791.66,1189.64h-9.952c-1.452,0-2.633-1.181-2.633-2.633s1.181-2.633,2.633-2.633h9.952c1.452,0,2.633,1.181,2.633,2.633s-1.181,2.633-2.633,2.633ZM1781.708,1185.374c-.9,0-1.633.732-1.633,1.633s.732,1.633,1.633,1.633h9.952c.9,0,1.633-.732,1.633-1.633s-.732-1.633-1.633-1.633h-9.952Z\"/>\n              </g>\n            </g>\n          </g>\n        </g>\n        <g v-if=\"title.includes(49)\" id=\"parking-accessible\">\n            <path class=\"st0\" d=\"M1113.707,1105.543L1113.707,1105.543c13.255,0,24,10.745,24,24l0,0c0,13.255-10.745,24-24,24l0,0\n                c-13.255,0-24-10.745-24-24l0,0C1089.707,1116.288,1100.453,1105.543,1113.707,1105.543z\"/>\n            <g>\n                <g>\n                    <path stroke-color=\"#fff\" d=\"M1111.975,1120.67v-3.234 M1111.975,1117.436v-4.527h3.519c0.915,0,1.657,0.738,1.657,1.653v1.215\n                    c0,0.915-0.742,1.659-1.657,1.659H1111.975z M1117.821,1109.603h-7.735c-1.831,0-3.315,1.49-3.315,3.319v7.735\n                    c0,1.829,1.484,3.312,3.315,3.312h7.735c1.831,0,3.315-1.483,3.315-3.312v-7.735\n                    C1121.136,1111.093,1119.651,1109.603,1117.821,1109.603z\"/>\n                    <path class=\"st1\" d=\"M1099.205,1129.975c1.126,0,2.043-0.916,2.043-2.042s-0.916-2.043-2.043-2.043\n                        c-1.126,0-2.042,0.916-2.042,2.043S1098.078,1129.975,1099.205,1129.975z M1099.205,1126.564c0.754,0,1.368,0.614,1.368,1.368\n                        c0,0.754-0.613,1.368-1.368,1.368c-0.754,0-1.368-0.613-1.368-1.368S1098.451,1126.564,1099.205,1126.564z\"/>\n                    <path class=\"st1\" d=\"M1097.238,1138.302v6.079c0,0.186,0.151,0.338,0.337,0.338c0.186,0,0.338-0.151,0.338-0.338v-6.253\n                        c0-0.005-0.001-0.01-0.001-0.015c0.001-0.121-0.064-0.239-0.179-0.3c-0.432-0.23-0.7-0.675-0.7-1.161v-3.71\n                        c0-0.724,0.589-1.313,1.313-1.313h1.73c0.724,0,1.313,0.589,1.313,1.313v3.71c0,0.486-0.268,0.931-0.7,1.161\n                        c-0.117,0.062-0.182,0.183-0.178,0.307c0,0.003,0,0.005,0,0.008v6.253c0,0.186,0.151,0.338,0.337,0.338\n                        c0.187,0,0.338-0.151,0.338-0.338v-6.079c0.547-0.368,0.879-0.983,0.879-1.649v-3.71c0-1.096-0.892-1.988-1.988-1.988h-1.73\n                        c-1.096,0-1.988,0.892-1.988,1.988v3.71C1096.359,1137.319,1096.691,1137.934,1097.238,1138.302z\"/>\n                    <path class=\"st1\" d=\"M1105.67,1134.586c1.126,0,2.043-0.917,2.043-2.043c0-1.126-0.916-2.043-2.043-2.043\n                        c-1.126,0-2.042,0.916-2.042,2.043C1103.628,1133.669,1104.544,1134.586,1105.67,1134.586z M1105.67,1131.175\n                        c0.754,0,1.368,0.614,1.368,1.368c0,0.754-0.614,1.368-1.368,1.368c-0.754,0-1.368-0.614-1.368-1.368\n                        C1104.303,1131.789,1104.916,1131.175,1105.67,1131.175z\"/>\n                    <path class=\"st1\" d=\"M1104.236,1141.139v3.242c0,0.186,0.151,0.338,0.338,0.338c0.186,0,0.337-0.151,0.337-0.338v-3.415\n                        c0-0.005,0-0.01-0.001-0.016c0-0.121-0.064-0.239-0.179-0.3c-0.432-0.23-0.7-0.675-0.7-1.161v-1.937\n                        c0-0.724,0.589-1.313,1.313-1.313h0.666c0.724,0,1.313,0.589,1.313,1.313v1.937c0,0.486-0.268,0.93-0.7,1.161\n                        c-0.117,0.062-0.182,0.183-0.178,0.307c0,0.003,0,0.005,0,0.008v3.415c0,0.186,0.151,0.338,0.338,0.338s0.338-0.151,0.338-0.338\n                        v-3.242c0.547-0.369,0.879-0.983,0.879-1.649v-1.937c0-1.096-0.892-1.988-1.988-1.988h-0.666c-1.096,0-1.988,0.892-1.988,1.988\n                        v1.937C1103.356,1140.156,1103.689,1140.771,1104.236,1141.139z\"/>\n                    <path class=\"st1\" d=\"M1112.505,1131.039c1.126,0,2.042-0.916,2.042-2.042c0-1.127-0.916-2.043-2.042-2.043\n                        c-1.126,0-2.043,0.917-2.043,2.043C1110.462,1130.123,1111.378,1131.039,1112.505,1131.039z M1112.505,1127.628\n                        c0.754,0,1.367,0.614,1.367,1.368c0,0.754-0.614,1.367-1.367,1.367c-0.754,0-1.368-0.613-1.368-1.367\n                        C1111.137,1128.242,1111.75,1127.628,1112.505,1127.628z\"/>\n                    <path class=\"st1\" d=\"M1109.095,1139.513h1.975v4.868c0,0.186,0.151,0.338,0.338,0.338s0.338-0.151,0.338-0.338v-5.206\n                        c0-0.023-0.002-0.046-0.007-0.068c-0.002-0.011-0.005-0.022-0.008-0.032c-0.043-0.137-0.171-0.237-0.322-0.237c0,0,0,0,0,0\n                        h-1.766l1.529-3.059c0.023-0.047,0.036-0.099,0.036-0.151v-1.636c0-0.716,0.583-1.298,1.299-1.298s1.298,0.582,1.298,1.298\n                        v1.636c0,0.052,0.012,0.104,0.036,0.151l1.529,3.059h-1.753c0,0,0,0,0,0c-0.151,0-0.28,0.1-0.322,0.237\n                        c-0.003,0.011-0.006,0.021-0.008,0.032c-0.005,0.022-0.007,0.045-0.007,0.068v5.206c0,0.186,0.151,0.338,0.337,0.338\n                        s0.338-0.151,0.338-0.338v-4.868h1.961c0.117,0,0.226-0.061,0.287-0.16c0.061-0.099,0.067-0.224,0.015-0.328l-1.738-3.476\n                        v-1.557c0-1.088-0.885-1.973-1.973-1.973c-1.088,0-1.974,0.885-1.974,1.973v1.557l-1.738,3.476\n                        c-0.052,0.105-0.047,0.229,0.015,0.328C1108.87,1139.452,1108.978,1139.513,1109.095,1139.513z\"/>\n                </g>\n                <g>\n                    <g>\n                        <g>\n                            <path class=\"st1\" d=\"M1121.46,1139.351c-0.522,0-0.922,0.399-0.922,0.922s0.399,0.922,0.922,0.922\n                                c0.522,0,0.921-0.399,0.921-0.922S1121.982,1139.351,1121.46,1139.351z M1121.46,1140.58c-0.184,0-0.307-0.123-0.307-0.307\n                                s0.123-0.307,0.307-0.307c0.184,0,0.307,0.123,0.307,0.307S1121.644,1140.58,1121.46,1140.58z\"/>\n                        </g>\n                    </g>\n                    <g>\n                        <g>\n                            <path class=\"st1\" d=\"M1126.067,1134.437h-4.331l-0.215-1.935c-0.061-0.491-0.461-0.829-0.922-0.829h-1.29\n                                c-0.184,0-0.307,0.123-0.307,0.307c0,0.184,0.123,0.307,0.307,0.307h1.29c0.154,0,0.276,0.123,0.307,0.276l0.246,2.212v0.584\n                                c0,0.184,0.123,0.307,0.307,0.307c0.184,0,0.307-0.123,0.307-0.307v-0.307h4.3c0.184,0,0.307,0.123,0.307,0.307\n                                s-0.123,0.307-0.307,0.307h-1.843c-0.184,0-0.307,0.123-0.307,0.307c0,0.184,0.123,0.307,0.307,0.307h1.843\n                                c0.522,0,0.922-0.399,0.922-0.922S1126.589,1134.437,1126.067,1134.437z\"/>\n                        </g>\n                    </g>\n                    <g>\n                        <g>\n                            <path class=\"st1\" d=\"M1129.446,1142.116c-0.184,0-0.307,0.123-0.307,0.307c0,0.184,0.123,0.307,0.307,0.307\n                                c0.338,0,0.614,0.276,0.614,0.614s-0.276,0.614-0.614,0.614s-0.614-0.276-0.614-0.614v-4.3c0-0.522-0.399-0.922-0.922-0.922\n                                h-1.843c-0.184,0-0.307,0.123-0.307,0.307s0.123,0.307,0.307,0.307h1.843c0.184,0,0.307,0.123,0.307,0.307v0.922h-2.764\n                                c-0.184,0-0.307,0.123-0.307,0.307c0,2.027-1.659,3.686-3.686,3.686c-2.027,0-3.686-1.659-3.686-3.686\n                                s1.659-3.686,3.686-3.686c1.72,0,3.194,1.167,3.594,2.826c0.031,0.154,0.215,0.276,0.369,0.215\n                                c0.154-0.031,0.276-0.215,0.215-0.369c-0.461-1.935-2.181-3.287-4.177-3.287c-2.365,0-4.3,1.935-4.3,4.3s1.935,4.3,4.3,4.3\n                                c2.273,0,4.116-1.751,4.3-3.993h2.457v2.765c0,0.676,0.553,1.229,1.229,1.229c0.676,0,1.229-0.553,1.229-1.229\n                                S1130.122,1142.116,1129.446,1142.116z\"/>\n                        </g>\n                    </g>\n                </g>\n            </g>\n        </g>\n        <g v-if=\"title.includes(49)\" id=\"parking-accessible\">\n            <path class=\"st0\" d=\"M1113.707,1105.543L1113.707,1105.543c13.255,0,24,10.745,24,24l0,0c0,13.255-10.745,24-24,24l0,0\n                c-13.255,0-24-10.745-24-24l0,0C1089.707,1116.288,1100.453,1105.543,1113.707,1105.543z\"/>\n            <g>\n                <g>\n                    <path stroke=\"#fff\" d=\"M1111.975,1120.67v-3.234 M1111.975,1117.436v-4.527h3.519c0.915,0,1.657,0.738,1.657,1.653v1.215\n                    c0,0.915-0.742,1.659-1.657,1.659H1111.975z M1117.821,1109.603h-7.735c-1.831,0-3.315,1.49-3.315,3.319v7.735\n                    c0,1.829,1.484,3.312,3.315,3.312h7.735c1.831,0,3.315-1.483,3.315-3.312v-7.735\n                    C1121.136,1111.093,1119.651,1109.603,1117.821,1109.603z\"/>\n                    <path class=\"st1\" d=\"M1099.205,1129.975c1.126,0,2.043-0.916,2.043-2.042s-0.916-2.043-2.043-2.043\n                        c-1.126,0-2.042,0.916-2.042,2.043S1098.078,1129.975,1099.205,1129.975z M1099.205,1126.564c0.754,0,1.368,0.614,1.368,1.368\n                        c0,0.754-0.613,1.368-1.368,1.368c-0.754,0-1.368-0.613-1.368-1.368S1098.451,1126.564,1099.205,1126.564z\"/>\n                    <path class=\"st1\" d=\"M1097.238,1138.302v6.079c0,0.186,0.151,0.338,0.337,0.338c0.186,0,0.338-0.151,0.338-0.338v-6.253\n                        c0-0.005-0.001-0.01-0.001-0.015c0.001-0.121-0.064-0.239-0.179-0.3c-0.432-0.23-0.7-0.675-0.7-1.161v-3.71\n                        c0-0.724,0.589-1.313,1.313-1.313h1.73c0.724,0,1.313,0.589,1.313,1.313v3.71c0,0.486-0.268,0.931-0.7,1.161\n                        c-0.117,0.062-0.182,0.183-0.178,0.307c0,0.003,0,0.005,0,0.008v6.253c0,0.186,0.151,0.338,0.337,0.338\n                        c0.187,0,0.338-0.151,0.338-0.338v-6.079c0.547-0.368,0.879-0.983,0.879-1.649v-3.71c0-1.096-0.892-1.988-1.988-1.988h-1.73\n                        c-1.096,0-1.988,0.892-1.988,1.988v3.71C1096.359,1137.319,1096.691,1137.934,1097.238,1138.302z\"/>\n                    <path class=\"st1\" d=\"M1105.67,1134.586c1.126,0,2.043-0.917,2.043-2.043c0-1.126-0.916-2.043-2.043-2.043\n                        c-1.126,0-2.042,0.916-2.042,2.043C1103.628,1133.669,1104.544,1134.586,1105.67,1134.586z M1105.67,1131.175\n                        c0.754,0,1.368,0.614,1.368,1.368c0,0.754-0.614,1.368-1.368,1.368c-0.754,0-1.368-0.614-1.368-1.368\n                        C1104.303,1131.789,1104.916,1131.175,1105.67,1131.175z\"/>\n                    <path class=\"st1\" d=\"M1104.236,1141.139v3.242c0,0.186,0.151,0.338,0.338,0.338c0.186,0,0.337-0.151,0.337-0.338v-3.415\n                        c0-0.005,0-0.01-0.001-0.016c0-0.121-0.064-0.239-0.179-0.3c-0.432-0.23-0.7-0.675-0.7-1.161v-1.937\n                        c0-0.724,0.589-1.313,1.313-1.313h0.666c0.724,0,1.313,0.589,1.313,1.313v1.937c0,0.486-0.268,0.93-0.7,1.161\n                        c-0.117,0.062-0.182,0.183-0.178,0.307c0,0.003,0,0.005,0,0.008v3.415c0,0.186,0.151,0.338,0.338,0.338s0.338-0.151,0.338-0.338\n                        v-3.242c0.547-0.369,0.879-0.983,0.879-1.649v-1.937c0-1.096-0.892-1.988-1.988-1.988h-0.666c-1.096,0-1.988,0.892-1.988,1.988\n                        v1.937C1103.356,1140.156,1103.689,1140.771,1104.236,1141.139z\"/>\n                    <path class=\"st1\" d=\"M1112.505,1131.039c1.126,0,2.042-0.916,2.042-2.042c0-1.127-0.916-2.043-2.042-2.043\n                        c-1.126,0-2.043,0.917-2.043,2.043C1110.462,1130.123,1111.378,1131.039,1112.505,1131.039z M1112.505,1127.628\n                        c0.754,0,1.367,0.614,1.367,1.368c0,0.754-0.614,1.367-1.367,1.367c-0.754,0-1.368-0.613-1.368-1.367\n                        C1111.137,1128.242,1111.75,1127.628,1112.505,1127.628z\"/>\n                    <path class=\"st1\" d=\"M1109.095,1139.513h1.975v4.868c0,0.186,0.151,0.338,0.338,0.338s0.338-0.151,0.338-0.338v-5.206\n                        c0-0.023-0.002-0.046-0.007-0.068c-0.002-0.011-0.005-0.022-0.008-0.032c-0.043-0.137-0.171-0.237-0.322-0.237c0,0,0,0,0,0\n                        h-1.766l1.529-3.059c0.023-0.047,0.036-0.099,0.036-0.151v-1.636c0-0.716,0.583-1.298,1.299-1.298s1.298,0.582,1.298,1.298\n                        v1.636c0,0.052,0.012,0.104,0.036,0.151l1.529,3.059h-1.753c0,0,0,0,0,0c-0.151,0-0.28,0.1-0.322,0.237\n                        c-0.003,0.011-0.006,0.021-0.008,0.032c-0.005,0.022-0.007,0.045-0.007,0.068v5.206c0,0.186,0.151,0.338,0.337,0.338\n                        s0.338-0.151,0.338-0.338v-4.868h1.961c0.117,0,0.226-0.061,0.287-0.16c0.061-0.099,0.067-0.224,0.015-0.328l-1.738-3.476\n                        v-1.557c0-1.088-0.885-1.973-1.973-1.973c-1.088,0-1.974,0.885-1.974,1.973v1.557l-1.738,3.476\n                        c-0.052,0.105-0.047,0.229,0.015,0.328C1108.87,1139.452,1108.978,1139.513,1109.095,1139.513z\"/>\n                </g>\n                <g>\n                    <g>\n                        <g>\n                            <path class=\"st1\" d=\"M1121.46,1139.351c-0.522,0-0.922,0.399-0.922,0.922s0.399,0.922,0.922,0.922\n                                c0.522,0,0.921-0.399,0.921-0.922S1121.982,1139.351,1121.46,1139.351z M1121.46,1140.58c-0.184,0-0.307-0.123-0.307-0.307\n                                s0.123-0.307,0.307-0.307c0.184,0,0.307,0.123,0.307,0.307S1121.644,1140.58,1121.46,1140.58z\"/>\n                        </g>\n                    </g>\n                    <g>\n                        <g>\n                            <path class=\"st1\" d=\"M1126.067,1134.437h-4.331l-0.215-1.935c-0.061-0.491-0.461-0.829-0.922-0.829h-1.29\n                                c-0.184,0-0.307,0.123-0.307,0.307c0,0.184,0.123,0.307,0.307,0.307h1.29c0.154,0,0.276,0.123,0.307,0.276l0.246,2.212v0.584\n                                c0,0.184,0.123,0.307,0.307,0.307c0.184,0,0.307-0.123,0.307-0.307v-0.307h4.3c0.184,0,0.307,0.123,0.307,0.307\n                                s-0.123,0.307-0.307,0.307h-1.843c-0.184,0-0.307,0.123-0.307,0.307c0,0.184,0.123,0.307,0.307,0.307h1.843\n                                c0.522,0,0.922-0.399,0.922-0.922S1126.589,1134.437,1126.067,1134.437z\"/>\n                        </g>\n                    </g>\n                    <g>\n                        <g>\n                            <path class=\"st1\" d=\"M1129.446,1142.116c-0.184,0-0.307,0.123-0.307,0.307c0,0.184,0.123,0.307,0.307,0.307\n                                c0.338,0,0.614,0.276,0.614,0.614s-0.276,0.614-0.614,0.614s-0.614-0.276-0.614-0.614v-4.3c0-0.522-0.399-0.922-0.922-0.922\n                                h-1.843c-0.184,0-0.307,0.123-0.307,0.307s0.123,0.307,0.307,0.307h1.843c0.184,0,0.307,0.123,0.307,0.307v0.922h-2.764\n                                c-0.184,0-0.307,0.123-0.307,0.307c0,2.027-1.659,3.686-3.686,3.686c-2.027,0-3.686-1.659-3.686-3.686\n                                s1.659-3.686,3.686-3.686c1.72,0,3.194,1.167,3.594,2.826c0.031,0.154,0.215,0.276,0.369,0.215\n                                c0.154-0.031,0.276-0.215,0.215-0.369c-0.461-1.935-2.181-3.287-4.177-3.287c-2.365,0-4.3,1.935-4.3,4.3s1.935,4.3,4.3,4.3\n                                c2.273,0,4.116-1.751,4.3-3.993h2.457v2.765c0,0.676,0.553,1.229,1.229,1.229c0.676,0,1.229-0.553,1.229-1.229\n                                S1130.122,1142.116,1129.446,1142.116z\"/>\n                        </g>\n                    </g>\n                </g>\n            </g>\n        </g>\n        <g v-if=\"title.includes(54)\" id=\"test-shop_2_\">\n            <g>\n                <path class=\"st0\" d=\"M1065.269,1215.19L1065.269,1215.19c13.255,0,24,10.745,24,24l0,0c0,13.255-10.745,24-24,24l0,0\n                    c-13.255,0-24-10.745-24-24l0,0C1041.269,1225.935,1052.014,1215.19,1065.269,1215.19z\"/>\n            </g>\n            <g>\n                <path class=\"st1\" d=\"M1078.078,1243.229c-0.132,0-0.264-0.052-0.362-0.155l-12.388-13.019l-12.388,13.019\n                    c-0.19,0.201-0.507,0.208-0.707,0.018s-0.208-0.507-0.018-0.707l12.75-13.399c0.188-0.199,0.536-0.199,0.725,0l12.75,13.399\n                    c0.19,0.2,0.183,0.517-0.018,0.707C1078.326,1243.184,1078.202,1243.229,1078.078,1243.229z\"/>\n            </g>\n            <g>\n                <path class=\"st1\" d=\"M1063.264,1243.457c0-0.292-0.236-0.528-0.528-0.528s-0.528,0.236-0.528,0.528\n                    c0.002,1.457,1.183,2.638,2.64,2.64v0.528c0,0.292,0.236,0.528,0.528,0.528s0.528-0.236,0.528-0.528v-0.528\n                    c1.458,0,2.64-1.182,2.64-2.64c0-1.458-1.182-2.64-2.64-2.64v-3.168c0.875,0,1.584,0.709,1.584,1.584\n                    c0,0.292,0.236,0.528,0.528,0.528c0.292,0,0.528-0.236,0.528-0.528c-0.002-1.457-1.183-2.638-2.64-2.64v-0.528\n                    c0-0.292-0.236-0.528-0.528-0.528s-0.528,0.236-0.528,0.528v0.528c-1.458,0-2.64,1.182-2.64,2.64c0,1.458,1.182,2.64,2.64,2.64\n                    v3.168C1063.973,1245.042,1063.264,1244.332,1063.264,1243.457z M1065.904,1241.873c0.875,0,1.584,0.709,1.584,1.584\n                    c0,0.875-0.709,1.584-1.584,1.584V1241.873z M1063.264,1239.233c0-0.875,0.709-1.584,1.584-1.584v3.168\n                    C1063.973,1240.817,1063.264,1240.108,1063.264,1239.233z\"/>\n            </g>\n            <g>\n                <path class=\"st1\" d=\"M1073.328,1249.17c0,0.27,0.223,0.5,0.5,0.5c0.276,0,0.5-0.23,0.5-0.5H1073.328z M1073.328,1237.83v11.34h1\n                    v-10.813L1073.328,1237.83z\"/>\n            </g>\n            <g>\n                <path class=\"st1\" d=\"M1073.828,1249.917c0.27,0,0.5-0.223,0.5-0.5c0-0.276-0.23-0.5-0.5-0.5V1249.917z M1062.488,1249.917h11.34\n                    v-1h-10.813L1062.488,1249.917z\"/>\n            </g>\n            <g>\n                <path class=\"st1\" d=\"M1056.828,1248.917c-0.27,0-0.5,0.223-0.5,0.5c0,0.276,0.23,0.5,0.5,0.5V1248.917z M1068.168,1248.917\n                    h-11.34v1h10.813L1068.168,1248.917z\"/>\n            </g>\n            <g>\n                <path class=\"st1\" d=\"M1056.328,1249.17c0,0.27,0.223,0.5,0.5,0.5c0.276,0,0.5-0.23,0.5-0.5H1056.328z M1056.328,1238.145v11.025\n                    h1v-11.34L1056.328,1238.145z\"/>\n            </g>\n            <g>\n            </g>\n        </g>\n    </g>\n    <g v-if=\"season=='ete'\" id=\"ete\">\n        <g id=\"bg\">\n            <g>\n                <rect x=\"0.563\" y=\"0.483\" class=\"st0\" width=\"2170.15\" height=\"1537.06\"/>\n            </g>\n            <g>\n                <g>\n                    <path class=\"st14\" d=\"M2107.86,998.26c-10.98-8.021-18.12-5.91-30.36-6.754c-12.2-0.844-10.98,0-27.4,0\n                        c-16.43,0-45.1,2.11-75.45-5.066c-30.36-7.175-50.17-7.175-65.79-8.864c-15.58-1.688-44.25-5.909-63.25-15.158\n                        c-18.95-9.286-28.36-1.803-38.03-0.537c0,0-6.95,1.036-13.7-2.839c-6.76-3.915-21.07,2.647-25.6,5.909\n                        c-4.53,3.262-17.62,4.643-30.36,2.226c-12.74-2.418-18.96-2.303-26.36,0.959c-7.37,3.262-17.39,2.648-20.34-0.192\n                        c-2.96-2.839-17.08-5.065-29.21-2.532c-12.13,2.532-36.58-5.142-44.9-7.522c-8.33-2.379-33.43-3.223-42.26-3.223\n                        c-8.83,0-44.48,0.883-59.64,0c-15.16-0.883-26.1,1.151-33.05,4.95c-6.94,3.799-14.7,6.639-19.3-0.614\n                        c-4.57-7.291-0.15-6.178-4.41-10.13c-4.26-3.953-13.13-5.833-27.83-5.68c-14.7,0.154-45.86,4.106-55.5,1.881\n                        c0,0-2.57-0.96-0.46-3.377c2.11-2.418,9.91-11.973,10.48-14.813c0.58-2.839,0.96-8.212,1.23-11.128\n                        c0.23-2.916-1.57-2.533-2.23-2.302c-0.61,0.23-3.14,4.911-4.41,9.171c-1.27,4.259-4.26,9.478-6.64,11.474\n                        c-2.38,1.957-8.14,8.212-9.48,13.047s-0.81,9.977-1.96,13.929c-1.19,3.953-3.64,4.989-4.49,6.332\n                        c-0.88,1.343-1.57,4.413-1.19,7.828c0.39,3.416-6.71,5.526-10.67,2.61c-3.95-2.917-10.36-5.833-10.67-8.634\n                        c-0.3-2.763-2.99-7.982-4.26-11.935c-1.26-3.952,0.39-6.101,0.23-8.135c-0.15-2.072,0.54-6.869-2.84-7.176\n                        c-3.41-0.307-15.08,4.567-25.06,9.095c-9.98,4.49-20.22,9.094-28.55,8.787c-8.29-0.307-20.19,1.113-25.14-8.365\n                        c-4.95-9.478-6.41-6.217-13.74-5.372c-7.33,0.844-7.1,0-13.74,1.88s-15.81,1.88-21.3,1.995c-5.49,0.116-10.32,0.538-14.43-2.417\n                        c-4.11-2.955-17.08-13.393-18.65-14.429c-1.58-1.036-13.28-8.097-24.26,2.955c0,0-10.21,12.011-19.07,12.97\n                        c-8.87,0.96-28.36-0.115-36.46-0.422c-8.1-0.307-24.45,5.488-32.47,6.025s-7.6-0.115-7.6-0.115l-5.83-77.822l-14.09-169.19\n                        c0,0-1.11-23.331-6.33-28.243c0,0,18.34-3.799,45.36-6.024c27.02-2.226,36.04-7.445,42.22-10.131\n                        c6.18-2.686,37-9.018,57.88-10.591c0,0,6.17-0.806,13.12-4.759c0,0,3.49-1.88-1.99-13.929c-5.45-12.011-9.02-17.614-11.4-19.763\n                        c-2.38-2.149-5.61-4.106-5.61-4.106s-3.07-1.88-1.42,2.993c1.65,4.912,1.27,6.332,3.15,10.515c1.88,4.183,1.96,5.756,1.8,8.941\n                        c-0.15,3.147,1.04,8.634-6.48,1.113c0,0-3.49-2.533-6.87-4.183c-3.42-1.65-10.13-5.526-13.05-11.474\n                        c-2.92-5.909-5.22-12.318-5.07-19.992c0.16-7.675,1.5-23.715-8.79-28.55c-10.28-4.835-20.37-6.102-22.29-6.179\n                        c-1.88-0.076-12.98-1.112-23.57-18.956c-10.59-17.844-26.48-20.07-37.46-22.372c-10.97-2.302-22.6-3.876-31.54-9.785\n                        c-8.95-5.91-13.36-4.682-21.036-2.917c-7.676,1.727-16.349,4.106-24.409-7.598c-8.059-11.704-16.848-8.135-18.882-8.711\n                        c-2.073-0.537-14.93-4.758-25.676-17.536c-10.746-12.817-32.162-20.07-34.695-22.219c-2.533-2.149-19.995-14.39-28.631-22.679\n                        c-8.635-8.288-27.287-12.663-39.07-18.035c-11.782-5.373-31.624-20.146-36.114-27.361c-4.491-7.176-11.552-11.857-17.847-19.762\n                        c-6.332-7.905-10.746-20.223-46.016-26.401c-35.271-6.178-47.897-18.189-54.69-28.627\n                        c-6.794-10.438-18.346-26.401-34.465-31.773c-16.119-5.373-37.611-6.486-55.496-21.989c-2.687-2.34-7.1-4.566-12.665-6.715\n                        l-30.205-24.943c0,0-22.144-26.977-36.191-31.505c-14.085-4.528-29.092-6.293-35.654-16.846\n                        c-6.563-10.553-20.61-16.692-29.859-21.105c-9.25-4.413-11.015-17.575-23.335-24.636c-12.32-7.023-20.226-11.436-23.296-14.966\n                        c-3.07-3.53-37.88-55.258-37.88-55.258H60.563c0,0,68.738,114.469,87.811,132.811c19.113,18.305,22.221,41.175,29.015,46.471\n                        c6.793,5.257,7.675,9.67,16.464,25.518c8.789,15.81,14.891,26.171,21.07,31.544c6.179,5.372,20.265,13.315,26.405,17.69\n                        c6.141,4.374,29.898,11.972,33.659,16.692c4.337,5.104,8.021,10.438,10.477,16.041c13.932,31.62,20.878,28.473,28.478,44.244\n                        c7.599,15.81,22.144,21.49,34.771,39.832c12.665,18.343,28.439,15.81,41.757,27.207c13.279,11.397,15.812,17.691,22.758,24.022\n                        c6.947,6.332,22.145,15.158,31.625,18.343c9.479,3.147,28.439,13.93,28.439,13.93s9.172,4.413,33.428,1.458\n                        s28.477-1.574,31.509-2.648c3.071-1.036,4.337-0.422,4.337-0.422s-1.689,6.946,9.365,14.121\n                        c11.053,7.176,26.136,9.479,45.747,11.167c19.612,1.689,34.35,10.745,50.814,19.609c16.427,8.864,27.825,12.97,45.864,17.69\n                        c18.038,4.759,29.091,15.158,38.264,18.957c9.172,3.799,10.439,0.959,20.571,6.025c10.132,5.065,28.784,8.519,37.304,11.051\n                        c8.52,2.533,17.079,5.373,36.038,9.786c18.96,4.413,34.465,9.171,42.064,14.85c7.599,5.68,19.612,12.011,30.972,17.384\n                        c11.398,5.372,31.624,9.785,44.596,9.478c12.972-0.307,13.587,2.839,24.333,7.291c10.746,4.413,16.771,6.945,24.025,7.598\n                        c0,0,2.149,0.307,3.646,0.806c0,0,4.491,6.638,5.221,16.615c0.73,9.978,13.51,162.014,13.51,162.014s0.31,1.305-13.09-2.456\n                        c-13.394-3.799-20.455,0.538-33.197-1.573c-12.742-2.111-21.608,0.23-26.443-2.302c-4.836-2.533-17.271-8.634-20.572-13.086\n                        c-3.262-4.413-8.75-11.819-22.029-12.318c-13.279-0.537-24.256,8.212-35.002,10.745c-10.746,2.533-29.514,2.724-53.961,0.537\n                        c-24.448-2.226-34.695-1.88-40.49-2.418c-5.795-0.537-16.004-1.573-22.03-2.724c-6.025-1.151-11.82-1.995-19.074-1.688\n                        c-7.254,0.307-22.644-1.152-28.784-3.262c-6.103-2.111-16.772-0.192-28.9,2.11c-12.128,2.303-9.173,0.845-17.194,2.533\n                        c-8.021,1.688-8.75,0.422-12.435,0.959c-3.684,0.538-13.087-0.614-12.972-10.744c0.115-10.131,12.972-7.598,14.239-7.79\n                        c1.266-0.23,5.68,1.88,11.706,0c6.025-1.88,7.675-7.176,13.471-9.709c5.795-2.532,10.439-5.372,14.967-10.629\n                        c4.529-5.257,12.666-11.167,22.452-11.704c9.787-0.537,17.079,1.573,31.202-0.307c14.124-1.881,21.186-5.181,31.51-4.221\n                        c10.324,0.959,26.443,5.794,34.042,6.869c7.599,1.036,19.727,1.266,22.989-6.217c3.262-7.483-7.062-8.02-16.656-11.704\n                        c-9.595-3.684-26.559-11.052-31.394-14.313c-4.836-3.262-17.386-5.181-29.399-7.598c-12.013-2.418-7.292-3.147-15.505-6.524\n                        c-8.213-3.377-15.812-12.855-27.211-17.268c-11.399-4.413-3.147-8.864-21.723-13.699c-18.537-4.836-16.848-8.443-27.633-8.212\n                        c-10.746,0.23-17.078-3.799-22.144-5.488c-5.066-1.688-19.382-10.322-40.682-10.975c-21.301-0.614-40.912-3.568-49.317-14.313\n                        c-8.444-10.745-8.444-15.158-32.047-22.756c-23.603-7.598-23.411-22.755-34.771-29.509\n                        c-11.399-6.754-17.271-13.086-44.482-11.397c0,0-9.71,1.036-23.411-6.524c-13.701-7.598-27.403-3.568-34.58-2.724\n                        c-7.177,0.844-15.582,2.533-17.923-8.02c-2.303-10.553-6.524-15.81-15.39-18.957c-8.865-3.147-22.336-2.533-33.083-2.11\n                        c-10.746,0.422-17.27,0.614-26.136-5.066c-8.865-5.679-13.548-6.447-17.808-6.754c-4.26-0.307-9.71,1.19-15.735,2.418\n                        c-6.026,1.228-9.864,1.42-11.514-4.106c-1.612-5.526-5.565-9.555-8.942-9.133c-3.378,0.422-1.881,3.07-4.951,2.725\n                        c-3.07-0.307-6.64,0.23-10.861-1.574c-4.222-1.803-7.791-4.106-13.395-4.528c-5.603-0.422-5.373-0.422-6.025,1.881\n                        c-0.614,2.302,0.959,2.302-3.263,0.613c-4.221-1.688-4.835-3.261-8.097-3.914c-3.263-0.614-9.442-2.302-14.546-4.221\n                        c0,0-12.013-6.945-18.115,3.377c-6.102,10.323-3.378,15.273,0,21.912c3.377,6.638,8.021,10.859,10.324,13.699\n                        c2.303,2.84,4.951,10.015,5.373,15.58c0.422,5.602,6.755,12.011,10.132,17.191c3.377,5.181,6.026,12.126,7.714,16.424\n                        c1.689,4.298,12.665,12.855,26.021,12.855c13.356,0,31.625,0.192,44.367,15.58c0,0,10.861,9.9,18.959,15.58\n                        c0,0,2.226,1.727,11.629,9.862c9.403,8.135,9.403,11.205,17.155,18.496c7.753,7.253,14.546,13.277,16.426,19.455\n                        c1.881,6.179,3.646,11.704,3.339,17.691c-0.307,6.024,2.38,16.193,5.22,21.873c2.84,5.679,10.324,20.453,16.35,27.936\n                        c6.025,7.483,19.918,23.523,23.91,28.55c3.991,5.065,14.737,20.031,19.189,27.706c4.414,7.713,17.54,26.708,24.832,48.849\n                        c7.253,22.142,7.1,22.602,9.786,32.234c2.687,9.632,21.339,45.051,26.252,52.649c4.912,7.598,8.904,41.328,9.556,51.228\n                        c0.614,9.9-1.267,10.13,5.68,31.39c6.947,21.3,8.444,39.41,7.177,51.65c-1.266,12.24-2.533,35.61,6.524,49.73\n                        c9.058,14.13,36.998,61.67,37.957,71.15c0.96,9.48,4.414,25.29,31.625,30.35c27.211,5.07,40.144,8.87,61.023,41.75\n                        c20.878,32.89,23.411,27.82,37.304,62.59c13.932,34.77,38.878,72.72,85.048,95.17c46.17,22.45,130.605,24.98,202.681,14.85\n                        c72.071-10.13,82.511-19.92,100.551-27.21c18.04-7.25,56.61-30.35,74.96-30.97c18.34-0.61,43.94-2.53,53.11-2.22\n                        c9.18,0.3,33.85,0.61,46.48-4.42c12.67-5.06,11.55-1.57,20.72-2.53l9.18-0.96c0,0,25.6-2.07,40.95-3.8\n                        c15.35-1.72,70.19-6.17,103.7-12.81c33.5-6.64,75.57-12.97,112.56-25.14c37-12.16,68.47-25.59,85.86-29.89\n                        c17.38-4.26,38.42-20.07,43.64-24.33c5.22-4.26,26.86-15.35,31.31-16.92c4.42-1.58,9.79-4.76,14.09-10.13\n                        c4.26-5.38,62.82-24.14,77.14-27.29c14.32-3.14,59.64-16.11,69.04-17.8c9.37-1.69,33.43-12.67,46.29-19.61\n                        c12.86-6.95,23.72-14.85,30.55-27.4c6.87-12.55,19.3-35.3,35-43.09c0,0,19.11-10.21,29.55-16.39\n                        c10.44-6.18,39.99-26.09,55.35-34c15.35-7.9,46.17-33.35,50.43-38.1c4.26-4.76,17.69-26.71,26.55-32.51\n                        c8.87-5.79,31.63-18.03,20.65-26.014L2107.86,998.26z M987.764,941.735c-7.906-0.153-22.605-7.099-31.317-13.277\n                        c-8.712-6.178-9.173-8.519-14.853-12.817c-5.68-4.26-15.16-12.165-17.232-13.124c-2.073-0.959-12.474-7.598-8.52-16.616\n                        c3.953-9.018,9.326-9.977,19.918-9.977c10.593,0,24.333-0.307,35.731,1.573c11.399,1.881,16.772,2.226,23.719,2.84\n                        c6.95,0.614,18.34,0.461,21.18,1.573l5.84,67.346c0,0-26.56-7.444-34.466-7.598V941.735z\"/>\n                </g>\n                <g>\n                    <path class=\"st14\" d=\"M1115.22,731.447c0,0-19.38,7.253-22.14,19.801c-2.73,12.548-6.22,16.002-1.16,24.674\n                        c5.07,8.634,11.06,14.966,31.32,15.388c20.23,0.422,35.73-1.573,47.63,2.302c11.9,3.914,19.07,9.786,25.83,16.539\n                        c6.75,6.754,12.13,17.077,45.63,18.535c33.51,1.458,37.31,1.803,43.95,2.724c6.64,0.96,13.58,3.262,15.92,8.443\n                        c2.31,5.18,3.38,11.166,10.63,11.166c7.26,0,8.64-3.07,10.87-3.799c2.22-0.729,6.44-1.995,9.9,1.881\n                        c3.49,3.914,4.95,6.101,21.91,3.146c0,0,6.64-0.614,11.59,2.303c0,0,3.57,3.07,10.98,0c0,0,1.27,0.115,1.57-3.569\n                        c0.31-3.684,2.31-8.02,12.55-5.487c10.21,2.532,19.38,3.683,29.63,3.146c10.21-0.537,16.97,0.115,29.52,0\n                        c12.55-0.115,25.94-0.23,25.4-7.483c-0.54-7.291-4.41-7.674-16.42-12.011c-12.02-4.336-18.12-6.101-28.56-8.941\n                        c-10.44-2.839-23.18-7.905-27.52-10.437c-4.33-2.533-21.49-10.438-28.36-12.126c-6.87-1.689-13.09-7.598-16-6.869\n                        c-2.96,0.729-12.86,0.959-15.7,0.192c-2.84-0.73-12.32-4.106-16.77-5.258c-4.41-1.151-15.7-8.442-19.19-10.975\n                        c-3.49-2.532-20.65-14.658-21.8-15.503c-1.15-0.844-3.8-5.602-22.87-3.99c0,0-8.45,0.115-17.81-16.539\n                        c-9.37-16.655-42.91-30.776-51.55-31.083c-8.63-0.307-29.62-1.036-54.26,11.819c-24.68,12.855-11.82,4.758-24.68,11.896\n                        L1115.22,731.447z\"/>\n                </g>\n            </g>\n            <g>\n                <path class=\"st2\" d=\"M569.008,1262.98c0,0,52.08,23.01,69.159,36.28s14.392,8.74,37.612,18.49\n                    c19.419,8.16,19.304,11.54,25.598,26.07c6.333,14.54,27.211,48.97,34.158,54.65c6.946,5.67,26.558,15.14,37.304,18.33\n                    c10.747,3.14,9.48,5.67,22.145,11.39c12.665,5.67,80.942,5.06,101.168,3.79c20.225-1.26,37.956-0.61,58.796-3.14\n                    c20.879-2.53,25.945-3.15,43.637-5.06c17.695-1.88,28.515-1.88,49.665-5.07c21.14-3.14,21.8-7.59,38.88-10.12\n                    c17.07-2.53,31.62-3.8,31.62-3.8s76.34,4.07,86.55,1.27c0,0,10.13,0.42-19.5,4.83s-46.13-1.46-72.81,2.34\n                    c-26.36,3.76-33.96,7.02-39.95,11.04c-5.99,4.03-52.62,28.38-80.518,34.9c-27.902,6.48-77.987,20.52-138.05,18.1\n                    c-57.377-2.3-125.692,1.99-180.958-63.54c-55.266-65.5-17.731-41.22-55.419-94.37\n                    C580.176,1265.86,607.042,1293.74,569.008,1262.98z\"/>\n            </g>\n            <g>\n                <path class=\"st1\" d=\"M176.505,816.121v11.082h-5.45v-27.878h9.096c2.763,0,4.912,0.728,6.486,2.186\n                    c1.573,1.457,2.341,3.451,2.341,6.058c0,1.458-0.307,2.723-0.96,3.759c-0.652,1.035-1.612,1.879-2.84,2.53\n                    c1.42,0.499,2.456,1.304,3.109,2.416c0.614,1.112,0.959,2.531,0.959,4.219v1.955c0,0.767,0.077,1.573,0.269,2.455\n                    c0.192,0.882,0.499,1.495,0.96,1.917v0.383h-5.642c-0.461-0.421-0.729-1.073-0.845-1.994c-0.115-0.92-0.153-1.84-0.153-2.799\n                    v-1.879c0-1.381-0.269-2.454-0.844-3.221c-0.576-0.767-1.382-1.151-2.457-1.151h-3.953L176.505,816.121z M176.505,811.788h3.646\n                    c1.113,0,1.957-0.345,2.533-0.997c0.575-0.691,0.844-1.649,0.844-2.876c0-1.228-0.307-2.301-0.844-3.03\n                    c-0.576-0.767-1.42-1.112-2.495-1.112h-3.646v8.091L176.505,811.788z\"/>\n            </g>\n            <g>\n                <path class=\"st1\" d=\"M199.033,827.203h-5.412v-27.878h5.412V827.203z\"/>\n            </g>\n            <g>\n                <path class=\"st1\" d=\"M211.965,820.071l0.23,1.073h0.115l0.23-0.997l4.644-20.822h5.719l-7.791,27.878h-5.68l-7.791-27.878h5.718\n                    l4.606,20.784V820.071z\"/>\n            </g>\n            <g>\n                <path class=\"st1\" d=\"M230.927,827.203h-5.411v-27.878h5.411V827.203z\"/>\n            </g>\n            <g>\n                <path class=\"st1\" d=\"M250.267,814.971h-9.365v7.899h11.015v4.333h-16.503v-27.878h16.465v4.333h-10.977v6.941h9.365v4.333\n                    V814.971z M245.968,797.331h-4.413l-4.721-4.985v-0.116h5.757l3.339,5.101H245.968z\"/>\n            </g>\n            <g>\n                <path class=\"st1\" d=\"M260.247,816.121v11.082h-5.45v-27.878h9.096c2.763,0,4.912,0.728,6.486,2.186\n                    c1.573,1.457,2.341,3.451,2.341,6.058c0,1.458-0.307,2.723-0.96,3.759c-0.652,1.035-1.611,1.879-2.84,2.53\n                    c1.42,0.499,2.457,1.304,3.109,2.416c0.614,1.112,0.96,2.531,0.96,4.219v1.955c0,0.767,0.076,1.573,0.268,2.455\n                    c0.192,0.882,0.499,1.495,0.96,1.917v0.383h-5.642c-0.461-0.421-0.729-1.073-0.844-1.994c-0.115-0.92-0.154-1.84-0.154-2.799\n                    v-1.879c0-1.381-0.269-2.454-0.844-3.221c-0.576-0.767-1.382-1.151-2.456-1.151h-3.954L260.247,816.121z M260.247,811.788h3.646\n                    c1.113,0,1.957-0.345,2.533-0.997c0.575-0.691,0.844-1.649,0.844-2.876c0-1.228-0.307-2.301-0.844-3.03\n                    c-0.576-0.767-1.42-1.112-2.495-1.112h-3.646v8.091L260.247,811.788z\"/>\n            </g>\n            <g>\n                <path class=\"st1\" d=\"M291.872,814.971h-9.364v7.899h11.015v4.333H277.02v-27.878h16.464v4.333h-10.976v6.941h9.364v4.333V814.971\n                    z\"/>\n            </g>\n            <g>\n                <path class=\"st1\" d=\"M120.7,867.008c0-1.074-0.268-1.956-0.844-2.569c-0.576-0.614-1.535-1.266-2.955-1.879\n                    c-2.917-0.997-5.066-2.148-6.525-3.452c-1.458-1.265-2.187-3.068-2.187-5.407s0.844-4.141,2.533-5.598\n                    c1.688-1.419,3.838-2.148,6.447-2.148c2.61,0,4.836,0.805,6.487,2.416c1.65,1.611,2.456,3.643,2.417,6.059v0.115h-5.334\n                    c0-1.266-0.307-2.301-0.96-3.106c-0.652-0.805-1.535-1.189-2.725-1.189c-1.074,0-1.919,0.345-2.533,0.997\n                    c-0.614,0.652-0.921,1.496-0.921,2.493c0,0.92,0.346,1.687,0.998,2.262c0.653,0.575,1.842,1.266,3.531,1.994\n                    c2.648,0.882,4.644,2.033,5.987,3.413c1.343,1.381,1.996,3.221,1.996,5.561c0,2.339-0.806,4.294-2.418,5.675\n                    c-1.612,1.38-3.761,2.032-6.409,2.032c-2.649,0-4.951-0.767-6.909-2.339c-1.957-1.572-2.878-3.758-2.84-6.672v-0.115h5.335\n                    c0,1.725,0.384,2.952,1.113,3.719c0.729,0.767,1.842,1.112,3.301,1.112c1.151,0,1.995-0.306,2.571-0.92\n                    c0.537-0.613,0.844-1.457,0.844-2.492V867.008z\"/>\n            </g>\n            <g>\n                <path class=\"st1\" d=\"M142.116,868.312h-7.369l-1.497,5.944h-5.488l7.867-27.879h5.681l7.829,27.879h-5.488l-1.497-5.944H142.116z\n                    M135.86,863.978h5.143l-2.533-9.855h-0.116L135.86,863.978z\"/>\n            </g>\n            <g>\n                <path class=\"st1\" d=\"M157.005,874.294h-5.411v-27.878h5.411V874.294z\"/>\n            </g>\n            <g>\n                <path class=\"st1\" d=\"M181.071,874.294h-5.412l-8.52-17.831h-0.115v17.831h-5.45v-27.878h5.45l8.52,17.831h0.115v-17.831h5.412\n                    V874.294z\"/>\n            </g>\n            <g>\n                <path class=\"st1\" d=\"M201.219,850.749h-6.295v23.545h-5.449v-23.545h-6.256v-4.333h18V850.749z\"/>\n            </g>\n            <g>\n                <path class=\"st1\" d=\"M209.088,864.477h-9.518v-4.333h9.518V864.477z\"/>\n            </g>\n            <g>\n                <path class=\"st1\" d=\"M220.718,846.377l4.989,20.478h0.115l5.066-20.478h7.101v27.879h-5.412v-8.091l0.461-10.853h-0.115\n                    l-5.335,18.944h-3.608l-5.258-18.829h-0.115l0.461,10.699v8.091h-5.412v-27.878h7.062V846.377z\"/>\n            </g>\n            <g>\n                <path class=\"st1\" d=\"M255.026,868.312h-7.369l-1.497,5.944h-5.488l7.868-27.879h5.68l7.829,27.879h-5.488l-1.497-5.944H255.026z\n                    M248.77,863.978h5.143l-2.533-9.855h-0.115L248.77,863.978z\"/>\n            </g>\n            <g>\n                <path class=\"st1\" d=\"M282.506,846.377v18.982c0,2.991-0.883,5.254-2.61,6.903c-1.765,1.61-4.029,2.415-6.869,2.415\n                    c-2.841,0-5.105-0.805-6.87-2.415c-1.727-1.611-2.61-3.912-2.61-6.865v-18.982h5.45v18.982c0,1.688,0.345,2.953,1.036,3.758\n                    c0.691,0.806,1.689,1.189,2.955,1.189c1.267,0,2.303-0.383,2.994-1.15c0.691-0.767,1.036-2.033,1.036-3.797v-18.982h5.411\n                    L282.506,846.377z\"/>\n            </g>\n            <g>\n                <path class=\"st1\" d=\"M291.872,863.173v11.083h-5.45v-27.879h9.096c2.763,0,4.912,0.729,6.486,2.186\n                    c1.573,1.457,2.341,3.451,2.341,6.059c0,1.457-0.307,2.722-0.96,3.758c-0.652,1.035-1.611,1.879-2.84,2.531\n                    c1.42,0.498,2.457,1.303,3.109,2.416c0.614,1.112,0.96,2.531,0.96,4.218v1.956c0,0.766,0.076,1.572,0.268,2.454\n                    c0.192,0.882,0.499,1.495,0.96,1.917v0.384H300.2c-0.461-0.422-0.729-1.074-0.844-1.994c-0.115-0.921-0.154-1.841-0.154-2.8\n                    v-1.879c0-1.38-0.269-2.454-0.844-3.221c-0.576-0.767-1.382-1.15-2.456-1.15h-3.954L291.872,863.173z M291.872,858.84h3.646\n                    c1.113,0,1.957-0.345,2.533-0.997c0.575-0.69,0.844-1.649,0.844-2.876s-0.307-2.301-0.844-3.03\n                    c-0.576-0.767-1.42-1.112-2.495-1.112h-3.646v8.092L291.872,858.84z\"/>\n            </g>\n            <g>\n                <path class=\"st1\" d=\"M314.4,874.294h-5.412v-27.878h5.412V874.294z\"/>\n            </g>\n            <g>\n                <path class=\"st1\" d=\"M336.431,865.283v0.115c0.076,3.067-0.653,5.368-2.111,6.94c-1.497,1.573-3.685,2.34-6.563,2.34\n                    c-2.878,0-5.181-0.882-6.908-2.646c-1.727-1.764-2.572-4.257-2.572-7.516v-8.322c0-3.221,0.845-5.752,2.495-7.516\n                    c1.65-1.764,3.915-2.684,6.716-2.684c2.956,0,5.22,0.805,6.717,2.377c1.496,1.572,2.302,3.912,2.341,7.018v0.115h-5.297\n                    c0.077-1.841-0.153-3.145-0.729-3.95c-0.575-0.805-1.573-1.227-2.993-1.227c-1.228,0-2.15,0.46-2.802,1.457\n                    s-0.959,2.416-0.959,4.333v8.399c0,1.955,0.345,3.451,1.036,4.41c0.691,0.958,1.727,1.418,3.07,1.418\n                    c1.343,0,2.226-0.383,2.763-1.15c0.538-0.767,0.73-2.071,0.691-3.911h5.258H336.431z\"/>\n            </g>\n            <g>\n                <path class=\"st1\" d=\"M354.622,862.023h-9.364v7.899h11.015v4.334H339.77v-27.879h16.464v4.333h-10.976v6.941h9.364v4.333V862.023\n                    z\"/>\n            </g>\n            <g>\n                <path class=\"st6\" d=\"M1080.95,1225.79c-75.99,1.19-88.964-13.23-89.117-13.35l-2.994,2.3l-3.109,2.19\n                    c1.229,1.76,13.702,16.53,86.47,16.53c2.88,0,5.83,0,8.9-0.08l-0.11-7.59H1080.95z\"/>\n            </g>\n            <g>\n                <path class=\"st6\" d=\"M1086.55,1140.43c-75.99,1.19-88.962-13.23-89.116-13.35l-2.993,2.3l-3.109,2.19\n                    c1.228,1.76,13.698,16.53,86.468,16.53c2.88,0,5.83,0,8.9-0.08l-0.11-7.59H1086.55z\"/>\n            </g>\n            <g>\n                <path class=\"st3\" d=\"M1499.51,1255.16l9.94,18.03l-24.18,2.68l-13.59-20.71H1499.51z\"/>\n            </g>\n            <g>\n                <path class=\"st3\" d=\"M1819.48,1082.29l35,10.36l6.1-20.44l21.53,5.67l-4.22,15.8l12.44,2.3l-1.08,14.15l-9.06-1.26l-4.22,11.58\n                    l-26.98-6.75l-0.88,2.72l-36.42-9.47L1819.48,1082.29z\"/>\n            </g>\n            <g class=\"st8\">\n                <path class=\"st1\" d=\"M1899.8,1127.69c-2.53,0-5.06-0.84-7.17-2.56c-4.88-3.95-5.61-11.13-1.61-16c0.3-0.38,7.4-9.08,22.75-25\n                    c1.42-1.49,3.8-4.29,3.5-6.29c-0.31-2.07-3.11-8.05-22.76-19.25c-18.42-10.47-26.87-8.4-26.98-8.36\n                    c0.54-0.15-4.61,1.34-4.61,1.34l-11.17-19.71c2.81-1.22,25.49-9.28,54,6.95c15.55,8.85,31.74,20.01,34.01,35.74\n                    c1.26,8.82-1.96,17.33-9.6,25.3c-14.58,15.19-21.45,23.55-21.53,23.66C1906.37,1126.28,1903.11,1127.69,1899.8,1127.69z\"/>\n            </g>\n            <g>\n                <path class=\"st4\" d=\"M1032.09,1239.19l-12.16,56.46l29.26,6.29l12.17-56.46L1032.09,1239.19z\"/>\n            </g>\n            <g>\n                <path class=\"st4\" d=\"M1019.89,1277.6c0,8.09-6.57,14.61-14.63,14.61c-8.057,0-14.619-6.56-14.619-14.61\n                    c0-8.06,6.562-14.62,14.619-14.62C1013.32,1262.98,1019.89,1269.54,1019.89,1277.6z\"/>\n            </g>\n            <g>\n                <path class=\"st1\" d=\"M177.04,556.47c0,5.675-4.606,10.277-10.286,10.277c-5.68,0-10.285-4.602-10.285-10.277\n                    c0-5.675,4.605-10.277,10.285-10.277C172.434,546.193,177.04,550.795,177.04,556.47z\"/>\n                <path class=\"st13\" d=\"M166.754,567.432c-6.049,0-10.97-4.918-10.97-10.962s4.921-10.962,10.97-10.962\n                    c6.049,0,10.971,4.917,10.971,10.962S172.803,567.432,166.754,567.432z M166.754,546.878c-5.293,0-9.6,4.303-9.6,9.592\n                    s4.307,9.592,9.6,9.592c5.294,0,9.601-4.303,9.601-9.592S172.048,546.878,166.754,546.878z\"/>\n            </g>\n            <g>\n                <path class=\"st1\" d=\"M726.053,903.247l-0.729,8.973c0,0,5.719,0.46,11.437,0.882c5.719,0.422,11.476,0.844,11.476,0.844\n                    l0.614-8.974c0,0-5.719-0.422-11.399-0.843C731.734,903.668,726.053,903.247,726.053,903.247z\"/>\n            </g>\n            <g>\n                <path class=\"st1\" d=\"M759.412,907.93l-3.626,8.241c0,0,5.253,2.306,10.519,4.576c5.265,2.27,10.567,4.552,10.567,4.552\n                    l3.517-8.278c0,0-5.266-2.27-10.495-4.527C764.641,910.187,759.412,907.93,759.412,907.93z\"/>\n            </g>\n            <g>\n                <path class=\"st1\" d=\"M692.126,900.294l-0.845,8.935c0,0,5.719,0.537,11.437,1.035c5.719,0.499,11.437,0.997,11.437,0.997\n                    l0.768-8.935c0,0-5.719-0.498-11.399-0.997C697.844,900.792,692.126,900.294,692.126,900.294z\"/>\n            </g>\n            <g>\n                <path class=\"st1\" d=\"M658.315,896.613l-1.151,8.896c0,0,5.719,0.767,11.437,1.381c2.878,0.307,5.719,0.613,7.868,0.844\n                    c2.149,0.23,3.569,0.383,3.569,0.383l0.921-8.935c0,0-1.42-0.153-3.531-0.383c-2.111-0.231-4.951-0.537-7.791-0.844\n                    C663.957,897.341,658.315,896.613,658.315,896.613z\"/>\n            </g>\n            <g>\n                <path class=\"st1\" d=\"M625.425,890.17l-2.265,8.705c3.992,1.035,7.791,1.84,11.552,2.799c1.843,0.499,3.723,0.844,5.604,1.266\n                    c1.88,0.383,3.761,0.652,5.603,0.997l1.458-8.859c-1.765-0.306-3.53-0.575-5.296-0.92c-1.727-0.383-3.492-0.729-5.181-1.189\n                    c-3.915-0.997-7.829-1.802-11.475-2.761V890.17z\"/>\n            </g>\n            <g>\n                <path class=\"st1\" d=\"M610.339,869.961l-9.019,0.345v0.23c0,0,0,0.422,0,0.729c0.039,0.652,0,1.572,0.154,2.761\n                    c0.153,2.339,0.537,5.484,1.612,8.743c0.499,1.611,1.228,3.221,2.072,4.717c0.883,1.457,1.842,2.761,2.802,3.758\n                    c0.959,0.997,1.842,1.726,2.456,2.186c0.307,0.23,0.576,0.422,0.729,0.537c0.192,0.115,0.269,0.192,0.269,0.192l4.989-7.478\n                    c0,0-0.038,0-0.153-0.115c-0.115-0.077-0.269-0.154-0.422-0.307c-0.384-0.269-0.845-0.69-1.382-1.227s-1.036-1.227-1.535-2.071\n                    c-0.461-0.844-0.96-1.802-1.267-2.953c-0.729-2.186-1.074-4.716-1.189-6.672c-0.116-0.959-0.077-1.841-0.116-2.416\n                    c0-0.307,0-0.537,0-0.729c0-0.191,0-0.268,0-0.268V869.961z\"/>\n            </g>\n            <g>\n                <path class=\"st1\" d=\"M609.379,834.758l-8.75,2.838c0,0,0.269,1.342,0.614,3.374c0.23,0.997,0.307,2.225,0.461,3.49\n                    c0.076,0.652,0.153,1.304,0.23,1.994c0.077,0.69,0.153,1.342,0.153,2.032c0.077,2.761,0.231,5.523,0,7.593\n                    c-0.115,2.071-0.192,3.452-0.192,3.452l9.019-1.189c0,0,0.077-1.496,0.192-3.72c0.192-2.224,0-5.177-0.076-8.168\n                    c0-0.729-0.115-1.496-0.192-2.186c-0.077-0.728-0.154-1.457-0.231-2.147c-0.191-1.381-0.268-2.685-0.498-3.758\n                    c-0.423-2.186-0.691-3.643-0.691-3.643L609.379,834.758z\"/>\n            </g>\n            <g>\n                <path class=\"st1\" d=\"M595.488,802.508l-7.715,5.1c0,0,0.768,1.15,1.881,2.876c0.576,0.844,1.19,1.918,1.804,3.03\n                    c0.614,1.15,1.382,2.3,1.919,3.566c0.614,1.227,1.228,2.492,1.765,3.643c0.499,1.189,0.96,2.301,1.344,3.259\n                    c0.383,0.959,0.729,1.764,0.921,2.34c0.192,0.575,0.307,0.882,0.307,0.882l8.481-3.605c0,0-0.115-0.345-0.345-0.959\n                    c-0.192-0.613-0.576-1.457-0.998-2.492c-0.422-1.036-0.921-2.224-1.458-3.528c-0.614-1.266-1.267-2.57-1.919-3.912\n                    c-0.614-1.342-1.42-2.607-2.073-3.834c-0.691-1.228-1.305-2.34-1.957-3.26c-1.228-1.879-2.034-3.106-2.034-3.106H595.488z\"/>\n            </g>\n            <g>\n                <path class=\"st1\" d=\"M569.354,779.346l-6.026,6.787c0,0,1.19,0.69,2.994,1.726c0.921,0.498,1.957,1.112,3.07,1.764\n                    c0.576,0.307,1.151,0.652,1.727,0.997c0.576,0.383,1.113,0.767,1.689,1.189l0.844,0.575c0.269,0.23,0.537,0.422,0.806,0.652\n                    c0.537,0.422,1.036,0.843,1.535,1.265c0.998,0.844,1.842,1.687,2.61,2.378c0.768,0.69,1.343,1.342,1.765,1.802\n                    c0.423,0.46,0.653,0.69,0.653,0.69l7.215-5.752c0,0-0.268-0.268-0.691-0.767c-0.46-0.46-1.036-1.188-1.88-1.917\n                    c-0.806-0.767-1.727-1.687-2.802-2.608c-0.537-0.46-1.074-0.92-1.65-1.38c-0.269-0.23-0.576-0.46-0.845-0.69l-0.921-0.652\n                    c-0.614-0.422-1.228-0.844-1.803-1.266c-0.615-0.383-1.267-0.728-1.843-1.074c-1.189-0.69-2.341-1.342-3.3-1.879\n                    c-1.919-1.112-3.224-1.84-3.224-1.84H569.354z\"/>\n            </g>\n            <g>\n                <path class=\"st1\" d=\"M538.878,761.859l-4.413,7.823c0,0,1.266,0.691,3.109,1.726c1.919,1.074,4.26,2.416,6.678,3.796\n                    c4.797,2.761,9.633,5.484,9.633,5.484l5.373-7.209c0,0-5.143-2.953-10.286-5.906c-2.571-1.457-5.181-2.991-7.023-4.026\n                    c-1.881-1.036-3.147-1.764-3.147-1.764L538.878,761.859z\"/>\n            </g>\n            <g>\n                <path class=\"st1\" d=\"M509.095,745.295l-4.38,7.833l20.002,11.166l4.38-7.834L509.095,745.295z\"/>\n            </g>\n            <g>\n                <path class=\"st1\" d=\"M479.207,728.57l-4.363,7.843l20.026,11.124l4.363-7.843L479.207,728.57z\"/>\n            </g>\n            <g>\n                <path class=\"st1\" d=\"M449.374,712.12l-4.358,7.846l20.033,11.11l4.358-7.846L449.374,712.12z\"/>\n            </g>\n            <g>\n                <path class=\"st1\" d=\"M419.483,695.489l-4.35,7.851l20.045,11.088l4.35-7.85L419.483,695.489z\"/>\n            </g>\n            <g>\n                <path class=\"st1\" d=\"M390.314,678.338l-4.759,7.632l14.507,9.05l5.296,2.914l4.376-7.861l-5.105-2.8L390.314,678.338z\"/>\n            </g>\n            <g>\n                <path class=\"st1\" d=\"M361.186,660.43l-4.682,7.67l19.535,11.964l4.721-7.631L361.186,660.43z\"/>\n            </g>\n            <g>\n                <path class=\"st1\" d=\"M331.902,642.791l-4.605,7.746c0,0,4.912,2.914,9.825,5.867c4.912,2.953,9.787,5.905,9.787,5.905\n                    l4.643-7.669c0,0-4.912-2.953-9.825-5.944c-4.912-2.953-9.863-5.905-9.863-5.905H331.902z\"/>\n            </g>\n            <g>\n                <path class=\"st1\" d=\"M302.043,625.764l-4.184,7.938c0,0,1.229,0.652,3.109,1.649c1.881,0.997,4.337,2.416,6.832,3.796\n                    c4.95,2.838,9.901,5.676,9.901,5.676l4.529-7.747c0,0-4.989-2.876-9.978-5.752c-2.533-1.419-5.028-2.837-6.947-3.873\n                    c-1.919-1.035-3.224-1.725-3.224-1.725L302.043,625.764z\"/>\n            </g>\n            <g>\n                <path class=\"st1\" d=\"M271.571,610.425l-4.145,7.976c0,0,5.104,2.646,10.209,5.292c2.571,1.304,5.142,2.608,7.061,3.566\n                    c1.958,0.959,3.263,1.611,3.263,1.611l3.914-8.091c0,0-1.266-0.614-3.147-1.573c-1.919-0.958-4.452-2.224-6.985-3.528\n                    c-5.066-2.607-10.132-5.253-10.132-5.253H271.571z\"/>\n            </g>\n            <g>\n                <path class=\"st1\" d=\"M241.44,594.434l-4.26,7.899c0,0,5.066,2.723,10.132,5.407c5.066,2.685,10.132,5.369,10.132,5.369\n                    l4.222-7.938l-20.188-10.775L241.44,594.434z\"/>\n            </g>\n            <g>\n                <path class=\"st1\" d=\"M211.543,578.098l-4.375,7.861c0,0,5.028,2.761,10.055,5.522c5.028,2.761,10.056,5.484,10.056,5.484\n                    l4.298-7.9c0,0-5.028-2.722-10.055-5.483c-5.028-2.761-10.017-5.522-10.017-5.522L211.543,578.098z\"/>\n            </g>\n            <g>\n                <path class=\"st1\" d=\"M181.992,561.302l-4.605,7.708c0,0,4.989,2.952,9.978,5.79c4.99,2.838,10.017,5.676,10.017,5.676\n                    l4.414-7.823c0,0-4.951-2.8-9.94-5.637c-4.951-2.838-9.825-5.714-9.825-5.714H181.992z\"/>\n            </g>\n            <g>\n                <path class=\"st6\" d=\"M1241.1,1389.65c-13.12,0-26.94-0.19-41.06-0.39c-22.8-0.3-46.4-0.65-68.24-0.15c-3.61,0-6.68-2.8-6.76-6.44\n                    c-0.07-3.65,2.81-6.67,6.45-6.75c22.07-0.5,45.79-0.15,68.7,0.15c40.03,0.54,77.83,1.08,102.32-2.68\n                    c62.37-9.59,256.22-52.62,284.89-71.06c6.83-4.41,13.66-9.01,20.88-13.88c24.79-16.76,50.43-34.05,79.13-44.49\n                    c11.9-4.33,30.55-8.59,52.16-13.57c41.45-9.51,98.25-22.55,113.8-39.84c6.25-6.98,12.7-14.73,18.92-22.24\n                    c18.84-22.75,38.34-46.25,59.33-55.8c3.3-1.53,7.22-0.04,8.75,3.26c1.5,3.3,0.04,7.21-3.26,8.74\n                    c-18.23,8.29-36.73,30.6-54.65,52.19c-6.3,7.6-12.82,15.46-19.27,22.63c-18.34,20.4-72.69,32.86-120.66,43.87\n                    c-21.19,4.87-39.46,9.05-50.63,13.11c-27.17,9.86-52.11,26.69-76.22,42.99c-7.29,4.95-14.2,9.59-21.14,14.07\n                    c-31.74,20.4-226.52,63.24-290.03,72.98c-16.66,2.57-38.81,3.22-63.45,3.22L1241.1,1389.65z\"/>\n            </g>\n            <g>\n                <path class=\"st1\" d=\"M1382.07,1289.79c-30.67,33.29-74.65,44.64-99.17,51c-4.34,1.11-8.1,2.07-11.06,2.99\n                    c-8.82,2.73-31.04,7.37-54.57,12.31c-30.32,6.37-64.71,13.62-81.75,18.98c-25.37,8.02-42.87,3.72-61.41-0.8\n                    c-2.11-0.5-4.22-1.04-6.37-1.53c-2.07-0.5-4.56-1.12-7.36-1.84c1.65-5.87,5.18-18.34,8.17-28.54\n                    c4.18-14.26,16.92-81.64,19.8-103.19c0.2-1.42,0.35-3.03,0.5-4.72h-12.7c-0.12,1.08-0.23,2.08-0.35,3.03\n                    c-2.76,20.67-15.43,87.78-19.42,101.32c-3.03,10.31-6.6,22.85-8.25,28.76c-28.28-8.05-70.155-21.36-80.172-26.5\n                    c-1.574-0.8-3.493-1.61-5.642-2.45c1.497-3.8,4.145-10.51,8.636-21.82c7.292-18.49,18.191-82.37,23.449-113.09\n                    c0.845-4.91,1.535-8.94,1.996-11.62c2.802-15.88,3.339-52.42,3.683-76.58c0.08-5.41,0.15-10.05,0.23-13.38\n                    c0.35-14.34-0.536-43.57-0.881-55.03c4.871-0.96,8.061-2.3,9.521-2.99c7.21-2.04,17.46-8.78,24.48-14.04\n                    c-1.99-3.68-4.07-7.28-6.98-10.58c-6.6,4.98-15.93,11.16-21.34,12.54c-0.54,0.11-1.11,0.38-1.57,0.65\n                    c-0.2,0.11-18.657,9.89-56.691-7.02c-41.871-18.63-93.913-37.655-94.412-37.847c-0.231-0.077-0.422-0.153-0.653-0.192\n                    c-2.111-0.536-52.426-12.616-118.553-5.407c-13.931,1.496-25.253,2.876-35.27,4.065c-36.038,4.295-48.166,5.752-70.963,1.304\n                    c-8.674-1.687-17.386-3.835-26.559-6.136c-22.183-5.483-45.134-11.159-67.509-10.008c-24.447,1.265-47.398,11.197-49.931,74.621\n                    c-1.842,46.06,8.751,100.4,101.129,154.51c17.348,10.16,30.128,17.6,39.799,23.2c19.625,11.4,33.403,20.19,41.335,26.38\n                    c3.531,2.76,8.098,6.33,14.699,11.31l5.642,4.3c33.927,25.77,58.413,44.36,93.875,56.06c29.821,9.86,60.102,11.24,84.396,12.35\n                    c6.179,0.27,11.974,0.53,17.347,0.92c26.06,1.84,68.468,10.93,81.057,17.33c14.584,7.44,81.902,27.88,102.622,32.75\n                    c2.11,0.5,4.19,1,6.26,1.53c11.47,2.8,23.14,5.68,36.73,5.68c9.4,0,19.73-1.38,31.51-5.1c16.42-5.18,50.5-12.35,80.56-18.64\n                    c24.87-5.21,46.32-9.74,55.68-12.61c2.69-0.85,6.34-1.77,10.52-2.84c26.37-6.83,74.03-19.18,107.27-56.87\n                    c-3.72-2.42-6.91-5.33-10.71-6.98c-0.19,0.19-0.34,0.42-0.54,0.61L1382.07,1289.79z M959.207,1312.11\n                    c-4.759,12.12-7.483,18.94-8.903,22.55c-20.265-5.79-49.318-10.97-68.239-12.31c-5.526-0.39-11.437-0.65-17.692-0.96\n                    c-23.565-1.08-52.848-2.42-81.019-11.7c-33.466-11.04-57.261-29.1-90.191-54.14l-5.68-4.3c-6.524-4.95-11.053-8.47-14.545-11.2\n                    c-12.55-9.78-13.126-10.12-42.755-27.34c-9.671-5.6-22.413-13.04-39.761-23.16c-86.66-50.73-96.6-100.82-94.911-143.11\n                    c2.034-50.737,15.467-61.321,37.957-62.51c20.533-1.074,42.524,4.372,63.824,9.625c8.943,2.224,18.192,4.487,27.173,6.251\n                    c24.754,4.834,38.417,3.224,74.916-1.15c9.978-1.189,21.262-2.531,35.155-4.027c61.1-6.672,109.496,4.026,113.871,5.062\n                    c4.605,1.689,53.577,19.789,93.261,37.429c19.036,8.47,34.081,10.97,45.134,11c0.384,11.85,1.19,40.08,0.883,53.61\n                    c-0.077,3.42-0.154,8.06-0.23,13.54c-0.307,22.32-0.845,59.67-3.493,74.55c-0.499,2.72-1.151,6.75-2.034,11.69\n                    C977.169,1229.43,966.001,1294.81,959.207,1312.11z\"/>\n            </g>\n            <g>\n                <path class=\"st1\" d=\"M385.862,358.596l-3.608-2.224l11.437-18.522l3.608,2.225L385.862,358.596z M401.06,339.653l-0.192,0.268\n                    l-2.84-1.725l-0.384-2.608l-2.495,0.805l-2.763-1.687l0.192-0.307l5.028-1.035l2.034,1.265l1.381,5.062L401.06,339.653z\"/>\n            </g>\n            <g>\n                <path class=\"st1\" d=\"M394.267,359.824l6.755,4.179l-1.766,2.877l-10.401-6.405l11.437-18.521l3.608,2.224l-9.671,15.607\n                    L394.267,359.824z\"/>\n            </g>\n            <g>\n                <path class=\"st1\" d=\"M415.912,365.959l-6.217-3.835l-3.224,5.254l7.33,4.525l-1.765,2.876l-10.938-6.749l11.437-18.522\n                    l10.899,6.749l-1.765,2.876l-7.292-4.487l-2.84,4.602l6.217,3.835l-1.765,2.876H415.912z\"/>\n            </g>\n            <g>\n                <path class=\"st1\" d=\"M430.803,379.688c0.46-0.729,0.614-1.419,0.499-2.071s-0.499-1.457-1.19-2.454\n                    c-1.497-1.841-2.495-3.528-2.917-4.947c-0.422-1.457-0.192-2.953,0.768-4.487c0.921-1.534,2.264-2.416,3.991-2.684\n                    c1.727-0.269,3.416,0.153,5.181,1.227c1.766,1.074,2.879,2.493,3.301,4.257c0.461,1.764,0.154,3.413-0.883,5.023l-0.076,0.077\n                    l-3.493-2.186c0.537-0.844,0.729-1.649,0.653-2.454c-0.116-0.806-0.538-1.419-1.305-1.879c-0.73-0.46-1.42-0.575-2.073-0.384\n                    c-0.691,0.192-1.228,0.614-1.612,1.266c-0.384,0.613-0.46,1.265-0.268,1.917c0.191,0.652,0.729,1.572,1.535,2.761\n                    c1.381,1.687,2.226,3.26,2.571,4.717c0.307,1.457,0,2.953-0.959,4.525c-0.998,1.61-2.303,2.531-3.915,2.761\n                    s-3.339-0.192-5.104-1.266c-1.766-1.073-2.956-2.531-3.646-4.371c-0.653-1.841-0.384-3.682,0.844-5.599l0.077-0.077l3.531,2.186\n                    c-0.691,1.151-0.96,2.109-0.806,2.915c0.191,0.805,0.767,1.495,1.727,2.109c0.767,0.46,1.458,0.613,2.072,0.422\n                    c0.614-0.192,1.151-0.614,1.574-1.304H430.803z\"/>\n            </g>\n            <g>\n                <path class=\"st1\" d=\"M444.466,389.351l-4.874-3.029l-3.454,3.336l-3.646-2.263l16.657-15.3l3.761,2.339l-6.256,21.705\n                    l-3.646-2.263l1.458-4.563V389.351z M442.087,383.906l3.416,2.109l2.379-7.593h-0.077L442.087,383.906z\"/>\n            </g>\n            <g>\n                <path class=\"st1\" d=\"M451.912,399.398l-3.607-2.224l11.437-18.522l3.607,2.225L451.912,399.398z\"/>\n            </g>\n            <g>\n                <path class=\"st1\" d=\"M467.879,409.254l-3.608-2.224l1.651-15.339h-0.077l-7.292,11.772l-3.608-2.224l11.437-18.522l3.608,2.224\n                    l-1.65,15.301h0.076l7.292-11.773l3.608,2.225l-11.437,18.521V409.254z\"/>\n            </g>\n            <g>\n                <path class=\"st1\" d=\"M490.904,401.891l-4.183-2.569l-9.672,15.607l-3.608-2.224l9.672-15.607l-4.145-2.57l1.765-2.876\n                    l11.936,7.363L490.904,401.891z\"/>\n            </g>\n            <g>\n                <path class=\"st1\" d=\"M490.52,414.239l-6.332-3.912l1.765-2.876l6.333,3.912L490.52,414.239z\"/>\n            </g>\n            <g>\n                <path class=\"st1\" d=\"M504.838,423.864v0.115c-1.267,2.032-2.687,3.298-4.299,3.72s-3.377,0.038-5.296-1.151\n                    c-1.919-1.188-3.071-2.722-3.493-4.601s0-3.912,1.382-6.059l3.416-5.522c1.343-2.148,2.917-3.452,4.759-3.95\n                    c1.842-0.499,3.684-0.192,5.526,0.959c1.958,1.227,3.147,2.646,3.493,4.333c0.345,1.687-0.077,3.566-1.343,5.637h-0.077\n                    l-3.493-2.109c0.806-1.189,1.19-2.148,1.113-2.953c-0.038-0.767-0.537-1.457-1.497-2.032c-0.805-0.499-1.611-0.576-2.456-0.192\n                    c-0.844,0.383-1.65,1.189-2.418,2.492l-3.454,5.561c-0.806,1.304-1.19,2.416-1.113,3.336c0.077,0.92,0.538,1.649,1.459,2.224\n                    c0.882,0.537,1.65,0.652,2.302,0.384c0.653-0.307,1.344-1.074,2.073-2.301l3.492,2.147L504.838,423.864z\"/>\n            </g>\n            <g>\n                <path class=\"st1\" d=\"M516.39,439.203l-3.608-2.224l4.759-7.67l-5.756-3.566l-4.759,7.67l-3.608-2.225l11.437-18.521l3.608,2.224\n                    l-4.913,7.976l5.757,3.566l4.912-7.976l3.608,2.224L516.39,439.203z\"/>\n            </g>\n            <g>\n                <path class=\"st1\" d=\"M527.366,435.828l-4.567,7.363l-3.608-2.224l11.437-18.484l6.026,3.72c1.842,1.112,2.955,2.493,3.416,4.103\n                    c0.46,1.611,0.153,3.26-0.921,4.985c-0.615,0.959-1.344,1.649-2.188,2.11c-0.844,0.421-1.842,0.613-2.917,0.498\n                    c0.768,0.92,1.113,1.879,1.075,2.876c0,0.997-0.422,2.071-1.113,3.183l-0.806,1.304c-0.307,0.498-0.614,1.074-0.845,1.764\n                    c-0.23,0.652-0.307,1.189-0.153,1.649l-0.154,0.268l-3.722-2.301c-0.116-0.46-0.039-0.997,0.268-1.687\n                    c0.307-0.69,0.653-1.304,1.037-1.956l0.767-1.265c0.576-0.92,0.806-1.764,0.768-2.493c-0.077-0.728-0.461-1.342-1.152-1.764\n                    l-2.609-1.61L527.366,435.828z M529.132,432.952l2.417,1.496c0.73,0.46,1.421,0.575,2.111,0.345\n                    c0.691-0.23,1.228-0.729,1.766-1.572c0.537-0.844,0.767-1.649,0.691-2.378c-0.077-0.728-0.461-1.342-1.19-1.764l-2.418-1.495\n                    l-3.301,5.368H529.132z\"/>\n            </g>\n            <g>\n                <path class=\"st1\" d=\"M537.768,452.394l-3.608-2.224l11.437-18.522l3.608,2.225L537.768,452.394z\"/>\n            </g>\n            <g>\n                <path class=\"st1\" d=\"M551.966,454.504c0.461-0.729,0.614-1.419,0.499-2.071c-0.115-0.652-0.499-1.457-1.19-2.454\n                    c-1.496-1.841-2.494-3.528-2.916-4.947c-0.423-1.457-0.192-2.953,0.767-4.487c0.921-1.534,2.265-2.416,3.953-2.684\n                    c1.727-0.269,3.416,0.153,5.181,1.227c1.766,1.074,2.879,2.493,3.301,4.257c0.461,1.725,0.154,3.412-0.883,5.023l-0.076,0.077\n                    l-3.493-2.186c0.537-0.844,0.729-1.649,0.653-2.454c-0.116-0.806-0.538-1.419-1.305-1.879c-0.73-0.461-1.42-0.576-2.073-0.384\n                    c-0.691,0.192-1.228,0.614-1.612,1.266c-0.384,0.613-0.46,1.265-0.268,1.917c0.191,0.652,0.729,1.572,1.535,2.761\n                    c1.381,1.687,2.226,3.26,2.571,4.717c0.307,1.457,0,2.953-0.959,4.525c-0.998,1.61-2.303,2.531-3.915,2.761\n                    c-1.612,0.23-3.339-0.192-5.104-1.266c-1.766-1.073-2.956-2.531-3.646-4.371c-0.653-1.841-0.384-3.682,0.844-5.599l0.077-0.077\n                    l3.531,2.186c-0.691,1.151-0.96,2.109-0.806,2.915c0.191,0.805,0.729,1.495,1.727,2.109c0.767,0.46,1.458,0.613,2.072,0.421\n                    c0.614-0.191,1.152-0.613,1.574-1.303H551.966z\"/>\n            </g>\n            <g>\n                <path class=\"st1\" d=\"M575.455,454.082l-4.184-2.569L561.6,467.12l-3.608-2.224l9.672-15.607l-4.145-2.57l1.765-2.876\n                    l11.936,7.363L575.455,454.082z\"/>\n            </g>\n            <g>\n                <path class=\"st1\" d=\"M583.744,471.607c-1.343,2.186-2.993,3.49-4.912,3.988c-1.919,0.499-3.877,0.115-5.834-1.074\n                    c-1.957-1.227-3.147-2.799-3.569-4.716c-0.422-1.956,0.038-3.989,1.381-6.174l3.224-5.177c1.344-2.148,2.955-3.49,4.913-3.988\n                    c1.919-0.499,3.876-0.154,5.833,1.035c1.958,1.189,3.148,2.799,3.57,4.755c0.422,1.956,0,4.027-1.382,6.174L583.744,471.607z\n                    M583.36,464.167c0.806-1.342,1.19-2.492,1.113-3.451c-0.076-0.997-0.575-1.764-1.535-2.339c-0.959-0.575-1.88-0.69-2.763-0.307\n                    c-0.883,0.384-1.765,1.227-2.571,2.57l-3.224,5.215c-0.845,1.342-1.228,2.492-1.152,3.451c0.077,0.959,0.576,1.764,1.497,2.339\n                    c0.921,0.575,1.842,0.691,2.763,0.307c0.922-0.383,1.766-1.227,2.61-2.569l3.224-5.216H583.36z\"/>\n            </g>\n            <g>\n                <path class=\"st1\" d=\"M589.73,475.326l-4.107,6.634l-3.607-2.224l11.437-18.522l6.447,3.989c1.843,1.15,2.956,2.607,3.378,4.333\n                    c0.383,1.764,0.038,3.528-1.037,5.292c-1.113,1.764-2.533,2.876-4.26,3.298c-1.765,0.421-3.53,0.076-5.373-1.074l-2.801-1.726\n                    H589.73z M591.495,472.45l2.802,1.726c0.768,0.46,1.535,0.575,2.303,0.23c0.767-0.307,1.42-0.92,1.957-1.802\n                    c0.537-0.882,0.806-1.726,0.768-2.57c-0.039-0.843-0.461-1.495-1.229-1.955l-2.801-1.726l-3.761,6.097H591.495z\"/>\n            </g>\n            <g>\n                <path class=\"st1\" d=\"M609.726,496.839l-3.608-2.224l4.759-7.669l-5.756-3.567l-4.759,7.67l-3.608-2.224l11.437-18.522\n                    l3.608,2.224l-4.913,7.976l5.757,3.567l4.912-7.977l3.608,2.224L609.726,496.839z\"/>\n            </g>\n            <g>\n                <path class=\"st1\" d=\"M627.381,496.533l-6.218-3.835l-3.224,5.253l7.331,4.525l-1.766,2.877l-10.938-6.75l11.437-18.521\n                    l10.9,6.749l-1.765,2.876l-7.292-4.487l-2.84,4.602l6.217,3.835l-1.804,2.876H627.381z\"/>\n            </g>\n            <g>\n                <path class=\"st1\" d=\"M1173.09,766.422l-3.95-1.495l7.68-20.363l3.95,1.496L1173.09,766.422z M1184.38,744.909l-0.12,0.307\n                    l-3.11-1.189l-0.88-2.492l-2.26,1.265l-3.04-1.15l0.12-0.345l4.76-1.994l2.22,0.843l2.31,4.717V744.909z\"/>\n            </g>\n            <g>\n                <path class=\"st1\" d=\"M1181.58,766l7.44,2.8l-1.19,3.183l-11.44-4.295l7.68-20.363l3.99,1.496L1181.58,766z\"/>\n            </g>\n            <g>\n                <path class=\"st1\" d=\"M1204.03,767.88l-6.83-2.57l-2.19,5.752l8.06,3.03l-1.19,3.183l-12.05-4.525l7.67-20.363l12.02,4.525\n                    l-1.19,3.183l-8.02-3.029l-1.92,5.061l6.83,2.57L1204.03,767.88z\"/>\n            </g>\n            <g>\n                <path class=\"st1\" d=\"M1210.21,780.419l7.67-20.362l5.99,2.262c2.11,0.805,3.57,1.879,4.37,3.26c0.85,1.38,0.89,2.991,0.2,4.831\n                    c-0.35,0.959-0.92,1.764-1.62,2.34c-0.69,0.575-1.57,0.92-2.57,0.958c0.96,0.652,1.58,1.496,1.77,2.531\n                    c0.19,1.036,0.08,2.109-0.35,3.26c-0.73,1.956-1.84,3.221-3.34,3.796c-1.49,0.575-3.3,0.499-5.37-0.307l-6.79-2.569H1210.21z\n                    M1217.58,772.941l-2.19,5.791l2.8,1.074c0.84,0.306,1.57,0.306,2.15,0c0.57-0.307,1.07-0.921,1.42-1.841\n                    c0.38-0.959,0.46-1.764,0.31-2.454c-0.16-0.652-0.62-1.112-1.42-1.419L1217.58,772.941z M1218.61,770.142l2.19,0.844\n                    c0.8,0.268,1.53,0.268,2.15,0c0.61-0.307,1.07-0.844,1.38-1.726c0.35-0.959,0.38-1.726,0.12-2.339\n                    c-0.27-0.614-0.89-1.074-1.77-1.419l-2.03-0.767L1218.61,770.142z\"/>\n            </g>\n            <g>\n                <path class=\"st1\" d=\"M1231.27,784.752l7.45,2.8l-1.19,3.183l-11.44-4.295l7.68-20.363l3.99,1.496L1231.27,784.752z\"/>\n            </g>\n            <g>\n                <path class=\"st1\" d=\"M1255.07,789.009c-0.92,2.378-2.26,3.988-4.07,4.87c-1.8,0.844-3.8,0.882-5.94,0.077\n                    c-2.15-0.805-3.61-2.148-4.42-3.95c-0.77-1.841-0.73-3.95,0.19-6.327l2.15-5.714c0.89-2.378,2.23-3.988,4.03-4.87\n                    c1.81-0.882,3.76-0.882,5.91-0.077c2.15,0.805,3.61,2.148,4.42,3.988c0.8,1.841,0.73,3.95-0.16,6.328l-2.15,5.713\n                    L1255.07,789.009z M1253.27,781.761c0.54-1.457,0.69-2.646,0.42-3.604c-0.27-0.959-0.92-1.611-1.96-1.994\n                    c-1.03-0.384-1.95-0.307-2.76,0.23c-0.81,0.537-1.5,1.534-2.03,3.029l-2.19,5.752c-0.58,1.457-0.73,2.685-0.46,3.605\n                    s0.88,1.61,1.92,1.994c1.03,0.383,1.95,0.307,2.76-0.23c0.81-0.537,1.5-1.534,2.07-3.03l2.19-5.752H1253.27z\"/>\n            </g>\n            <g>\n                <path class=\"st1\" d=\"M1269.16,802.66l-3.96-1.495l-1.3-15.378h-0.08l-4.91,13l-3.99-1.495l7.67-20.363l4,1.496l1.3,15.339h0.12\n                    l4.91-12.962l3.95,1.496l-7.67,20.362H1269.16z\"/>\n            </g>\n            <g>\n                <path class=\"st1\" d=\"M1280.4,800.935l-0.15,0.844h0.08l0.42-0.652l9.13-13.92l4.19,1.572l-13.4,18.215l-4.14-1.572l1.99-22.51\n                    l4.19,1.572l-2.34,16.413L1280.4,800.935z\"/>\n            </g>\n            <g>\n                <path class=\"st1\" d=\"M1292.26,811.365l-3.95-1.495l7.67-20.363l3.96,1.496L1292.26,811.365z\"/>\n            </g>\n            <g>\n                <path class=\"st1\" d=\"M1300.74,810.944l7.45,2.799l-1.19,3.183l-11.44-4.295l7.68-20.362l3.99,1.495L1300.74,810.944z\"/>\n            </g>\n            <g>\n                <path class=\"st1\" d=\"M1314.14,816.006l7.44,2.799l-1.19,3.183l-11.43-4.295l7.67-20.362l3.99,1.495L1314.14,816.006z\"/>\n            </g>\n            <g>\n                <path class=\"st1\" d=\"M1336.59,817.885l-6.83-2.57l-2.19,5.752l8.06,3.03l-1.19,3.183l-12.05-4.525l7.67-20.363l12.02,4.525\n                    l-1.19,3.183l-8.03-3.03l-1.91,5.062l6.83,2.57L1336.59,817.885z\"/>\n            </g>\n            <g>\n                <path class=\"st6\" d=\"M1795.49,1033.94c-0.34,0-0.65,0-1-0.08c-4.1-0.62-8.44-1.31-13.05-2.03c-27.51-4.3-65.2-10.17-114.48-14.54\n                    c-55.15-4.87-255.68-8.93-326.18-9.74c-14.78-0.15-35.43-0.23-58.61-0.3c-76.83-0.27-172.44-0.58-190.9-4.41\n                    c-7.79-1.62-18.53-4.146-30.97-7.099c-26.1-6.136-58.57-13.805-90.344-19.519c-61.867-11.082-107.538-17.218-128.608-17.218\n                    c-28.401,0-54.921-22.395-56.034-23.354c-2.763-2.377-3.109-6.519-0.729-9.28c2.379-2.761,6.524-3.106,9.288-0.728\n                    c0.23,0.191,24.025,20.209,47.475,20.209c27.94,0,86.621,9.472,130.949,17.41c32.123,5.752,66.163,13.766,91.033,19.634\n                    c12.36,2.914,23.03,5.407,30.63,7.017c17.15,3.567,120.13,3.912,188.29,4.142c23.22,0.076,43.86,0.153,58.68,0.307\n                    c70.65,0.805,271.68,4.87,327.18,9.779c49.7,4.41,87.66,10.31,115.37,14.65c4.6,0.73,8.94,1.38,13.01,2.03\n                    c3.61,0.54,6.06,3.91,5.53,7.52C1801.52,1031.6,1798.72,1033.94,1795.49,1033.94z\"/>\n            </g>\n            <g>\n                <path class=\"st1\" d=\"M1862.88,1038.23c-3.3-4.33-8.67-6.4-13.51-7.36c-8.55-2.57-37.45-7.6-57.26-10.93\n                    c-1.95,4.45-4.3,8.43-5.75,13.04c16.61,6.02,18.61,15.72,21.64,23.04l0.54,1.31c1,2.41,2.26,4.56,3.57,6.44\n                    c-24.18,33.9-61.49,85.55-75.92,102.43c-19.42,22.7-69.5,18.06-72.72,17.75c-3.23-0.54-43.83-7.48-76.46-12.31\n                    c-32.31-4.79-66.81-14.26-69.27-14.95l-93.49-30.95c-1.11-0.35-110.65-35.82-133.83-42.99c-5.45-1.69-11.63-3.99-18.15-6.4\n                    c-21.46-7.9-48.05-17.76-76.49-17.3c-32.97,0.62-66.44-6.09-69.78-6.75c-3.53-1.07-40.79-12.8-63.74-26.76\n                    c-21.23-12.89-20.11-34.938-20.08-35.858c0-0.307,0-0.614,0-0.92l-1.91-24.543c-0.2-2.416-19.46-241.436-20.38-257.005\n                    c-0.96-15.837-5.42-29.988-14.4-45.864c-8.363-14.725-26.977-25.692-28.972-26.843l-39.992-25.233l-142.002-88.007\n                    c-1.229-0.767-123.313-79.111-282.125-177.818c-30.473-21.819-223.52-160.561-259.367-191.469\n                    c-37.88-32.634-68.276-86.934-68.698-91.497h-12.627c0.96,10.392,36.268,68.949,73.381,100.931\n                    c36.959,31.866,231.618,171.682,260.863,192.658l-0.154,0.23c1.113,0.69,2.226,1.38,3.301,2.07\n                    c0.077,0.039,0.154,0.116,0.192,0.154c157.009,97.633,277.251,174.75,278.517,175.555l142.042,88.008l40.067,25.27\n                    c0,0,0.154,0.115,0.269,0.154c0.192,0.115,17.424,9.97,24.332,22.165c8.023,14.073,11.933,26.536,12.783,40.341\n                    c0.96,15.723,19.61,247.419,20.42,257.274l1.88,24.159c-0.08,2.454-0.12,12.308,4.83,23.278c-2.53,2.18-4.3,3.8-8.1,6.67\n                    c2.92,3.3,4.99,6.9,6.99,10.59c3.72-2.77,5.33-4.22,7.75-6.29c3.65,4.56,8.37,8.97,14.62,12.77c3.57,2.14,7.41,4.25,11.4,6.28\n                    c0.31,8.71,1.27,30.57,3.61,50.05c2.76,22.93,4.8,51.23,5.03,70.4c0,0.08,0,0.16,0,0.27c0,0.5,2.53,48.86,0.38,70.98h12.7\n                    c2-23.23-0.26-68.14-0.46-71.51c-0.23-19.56-2.3-48.36-5.1-71.64c-1.8-15.03-2.8-31.98-3.26-42.49\n                    c20.88,9.13,41.37,15.46,42.56,15.8c0.19,0.04,0.35,0.12,0.54,0.12c1.49,0.3,36.84,7.74,72.88,7.09\n                    c25.91-0.5,51.43,8.94,71.88,16.49c6.68,2.46,13.01,4.8,18.81,6.6c23.1,7.17,132.6,42.6,133.64,42.95l5.56,1.84\n                    c0,0.53,0,0.99-0.04,1.57c-0.96,28.68-3.18,95.91-36.07,139.39c-2.27,2.99-4.69,5.83-7.14,8.55c3.8,1.65,6.98,4.57,10.7,6.98\n                    c1.46-1.65,2.92-3.37,4.34-5.1l19.15,11.09l38,20.28c4.37,2.19,10.78,4.26,17.23,4.26c6.79,0,13.59-2.3,18.08-9.2\n                    c4.33-6.68,5.52-13.31,3.49-19.75c-3.07-9.9-13.63-18.41-32.24-26.08c-20.88-8.59-34.69-19.25-40.07-23.78\n                    c14.43-39,16.28-81.37,17.04-104.07l75.53,25c0,0,0.2,0.04,0.27,0.08c0.39,0.11,36.85,10.28,71,15.34\n                    c33.7,4.98,75.96,12.23,76.38,12.31c0.11,0,0.23,0,0.34,0.04c0.77,0.07,6.76,0.72,15.47,0.72c19.31,0,51.7-3.18,68.47-22.81\n                    c14.66-17.14,51.12-67.61,75.41-101.62c1.88,1.3,3.38,2.11,4.07,2.41c11.82,6.87,23.22,5.64,31.24-3.41\n                    c8.37-9.43,11.59-26.69,6.3-33.59L1862.88,1038.23z M1456.6,1283.31c18.31,7.52,23.68,14.03,24.99,18.14\n                    c0.53,1.72,0.92,4.56-2.04,9.12c-4.72,7.29-18.88,0.62-18.92,0.62l-37.65-20.13l-17.88-10.32c4.3-6.56,8.02-13.5,11.24-20.63\n                    C1423.71,1265.94,1437.34,1275.37,1456.6,1283.31z M1820.24,1052.5l-0.53-1.27c-1.73-4.18-4.03-9.7-8.48-15.19\n                    c6.6,1.19,12.85,2.34,18.26,3.38C1827.11,1042.76,1823.97,1047.2,1820.24,1052.5z M1845.77,1064.8c-2.34,2-6.37,4.11-14.24-0.53\n                    c-0.19-0.12-0.42-0.23-0.62-0.31c0,0-0.96-0.46-2.3-1.38c6.41-9.05,11.4-16.07,14.01-19.79c1.42,0.08,2.95,0.27,4.37,0.58\n                    c0,0,0.08,0,0.12,0c2.38,0.5,4.49,1.26,5.49,2.34C1853.4,1048.51,1851.91,1059.55,1845.77,1064.8z\"/>\n            </g>\n            <g>\n                <path class=\"st3\" d=\"M984.116,1303.96l-7.612,28.89l63.616,16.73l7.61-28.89L984.116,1303.96z\"/>\n            </g>\n            <g>\n                <path class=\"st1\" d=\"M795.687,984.451c-0.151-0.38-15.203-38.157-22.918-51.507l2.979-1.721\n                    c7.841,13.565,22.516,50.395,23.136,51.956L795.687,984.451z\"/>\n            </g>\n            <g>\n                <defs>\n                    <rect id=\"SVGID_4_\" x=\"1295\" y=\"1434.06\" width=\"390\" height=\"29.979\"/>\n                </defs>\n                <clipPath id=\"SVGID_6_\">\n                    <use xlink:href=\"#SVGID_4_\"  style=\"overflow:visible;\"/>\n                </clipPath>\n                <g class=\"st15\">\n                    <g>\n                        <path class=\"st1\" d=\"M1310.37,1451.54h-9.76v12.1H1295v-29.18h17.11v4.53h-11.5v7.94h9.76v4.53V1451.54z\"/>\n                    </g>\n                    <g>\n                        <path class=\"st1\" d=\"M1320.69,1459.07h10.51v4.53h-16.12v-29.14h5.61V1459.07z\"/>\n                    </g>\n                    <g>\n                        <path class=\"st1\" d=\"M1349.26,1450.86h-9.64v8.25h11.34v4.53h-16.99v-29.18h16.95v4.53h-11.3v7.26h9.64v4.53V1450.86z\"/>\n                    </g>\n                    <g>\n                        <path class=\"st1\" d=\"M1373.09,1434.46v19.84c0,3.13-0.9,5.53-2.68,7.22c-1.82,1.68-4.15,2.52-7.08,2.52\n                            c-2.92,0-5.25-0.84-7.07-2.52c-1.78-1.69-2.69-4.09-2.69-7.18v-19.88h5.61v19.84c0,1.77,0.36,3.09,1.07,3.93\n                            s1.74,1.24,3.04,1.24c1.31,0,2.37-0.4,3.09-1.2c0.71-0.8,1.06-2.12,1.06-3.97v-19.84h5.57H1373.09z\"/>\n                    </g>\n                    <g>\n                        <path class=\"st1\" d=\"M1385.78,1456.19l0.24,1.12h0.12l0.24-1.08l4.74-21.77h5.89l-8.03,29.14h-5.85l-8.02-29.14h5.89\n                            l4.74,21.73H1385.78z\"/>\n                    </g>\n                    <g>\n                        <path class=\"st1\" d=\"M1414.67,1450.86h-9.64v8.25h11.34v4.53h-16.99v-29.18h16.95v4.53h-11.3v7.26h9.64v4.53V1450.86z\"/>\n                    </g>\n                    <g>\n                        <path class=\"st1\" d=\"M1440.95,1456.03c0-1.13-0.27-2.05-0.87-2.69c-0.59-0.64-1.58-1.32-3.04-1.96c-3-1.04-5.22-2.25-6.72-3.61\n                            c-1.5-1.32-2.25-3.21-2.25-5.65c0-2.45,0.87-4.33,2.61-5.85c1.74-1.49,3.95-2.25,6.64-2.25c2.69,0,4.98,0.84,6.68,2.53\n                            c1.7,1.68,2.53,3.77,2.49,6.33v0.12h-5.5c0-1.32-0.31-2.4-0.98-3.25c-0.68-0.84-1.59-1.24-2.81-1.24\n                            c-1.11,0-1.98,0.32-2.61,1.04c-0.63,0.73-0.95,1.57-0.95,2.61c0,0.96,0.36,1.76,1.03,2.36c0.71,0.6,1.9,1.33,3.64,2.09\n                            c2.72,0.92,4.78,2.12,6.16,3.57c1.38,1.44,2.06,3.36,2.06,5.81c0,2.44-0.83,4.49-2.49,5.93c-1.66,1.44-3.88,2.12-6.6,2.12\n                            c-2.73,0-5.1-0.8-7.12-2.44c-2.01-1.65-2.96-3.97-2.92-6.98v-0.12h5.49c0,1.81,0.4,3.09,1.15,3.89c0.75,0.8,1.89,1.16,3.4,1.16\n                            c1.18,0,2.05-0.32,2.64-0.96c0.56-0.64,0.87-1.52,0.87-2.6V1456.03z\"/>\n                    </g>\n                    <g>\n                        <path class=\"st1\" d=\"M1462.97,1457.39h-7.59l-1.54,6.21h-5.65l8.1-29.14h5.85l8.06,29.14h-5.65l-1.54-6.21H1462.97z\n                            M1456.52,1452.86h5.3l-2.61-10.3h-0.12L1456.52,1452.86z\"/>\n                    </g>\n                    <g>\n                        <path class=\"st1\" d=\"M1478.34,1463.64h-5.57v-29.18h5.57v29.14V1463.64z\"/>\n                    </g>\n                    <g>\n                        <path class=\"st1\" d=\"M1503.12,1463.64h-5.57l-8.77-18.64h-0.12v18.64h-5.62v-29.18h5.62l8.77,18.64h0.12v-18.64h5.57v29.14\n                            V1463.64z\"/>\n                    </g>\n                    <g>\n                        <path class=\"st1\" d=\"M1523.83,1439.03h-6.48v24.61h-5.61v-24.61h-6.45v-4.57h18.54v4.53V1439.03z\"/>\n                    </g>\n                    <g>\n                        <path class=\"st1\" d=\"M1531.97,1453.38h-9.8v-4.53h9.8V1453.38z\"/>\n                    </g>\n                    <g>\n                        <path class=\"st1\" d=\"M1542.37,1459.07h10.51v4.53h-16.13v-29.14h5.62V1459.07z\"/>\n                    </g>\n                    <g>\n                        <path class=\"st1\" d=\"M1568.96,1457.39h-7.58l-1.54,6.21h-5.66l8.11-29.14h5.84l8.07,29.14h-5.65l-1.55-6.21H1568.96z\n                            M1562.52,1452.86h5.3l-2.61-10.3h-0.12L1562.52,1452.86z\"/>\n                    </g>\n                    <g>\n                        <path class=\"st1\" d=\"M1597.26,1434.46v19.84c0,3.13-0.91,5.53-2.69,7.22c-1.81,1.68-4.15,2.52-7.07,2.52s-5.26-0.84-7.07-2.52\n                            c-1.78-1.69-2.69-4.09-2.69-7.18v-19.88h5.61v19.84c0,1.77,0.36,3.09,1.07,3.93c0.71,0.84,1.74,1.24,3.04,1.24\n                            c1.3,0,2.37-0.4,3.08-1.2c0.71-0.8,1.07-2.12,1.07-3.97v-19.84h5.57H1597.26z\"/>\n                    </g>\n                    <g>\n                        <path class=\"st1\" d=\"M1606.94,1452.06v11.58h-5.61v-29.14h9.37c2.84,0,5.06,0.77,6.68,2.29s2.41,3.61,2.41,6.33\n                            c0,1.52-0.32,2.85-0.99,3.93c-0.67,1.08-1.66,1.96-2.92,2.64c1.46,0.53,2.53,1.37,3.2,2.53c0.63,1.16,0.99,2.64,0.99,4.41v2.04\n                            c0,0.8,0.07,1.65,0.27,2.57c0.2,0.92,0.52,1.56,0.99,2v0.4h-5.81c-0.47-0.44-0.75-1.12-0.87-2.08\n                            c-0.12-0.96-0.16-1.93-0.16-2.93v-1.96c0-1.44-0.27-2.57-0.87-3.37c-0.59-0.8-1.42-1.2-2.53-1.2h-4.07L1606.94,1452.06z\n                            M1606.94,1447.53h3.76c1.14,0,2.01-0.36,2.61-1.04c0.59-0.72,0.87-1.73,0.87-3.01s-0.32-2.4-0.87-3.16\n                            c-0.6-0.81-1.47-1.17-2.57-1.17h-3.76v8.46L1606.94,1447.53z\"/>\n                    </g>\n                    <g>\n                        <path class=\"st1\" d=\"M1639.51,1450.86h-9.64v8.25h11.34v4.53h-17v-29.18h16.96v4.53h-11.3v7.26h9.64v4.53V1450.86z\"/>\n                    </g>\n                    <g>\n                        <path class=\"st1\" d=\"M1664.25,1463.64h-5.57l-8.78-18.64h-0.11v18.64h-5.62v-29.18h5.62l8.77,18.64h0.12v-18.64h5.57v29.14\n                            V1463.64z\"/>\n                    </g>\n                    <g>\n                        <path class=\"st1\" d=\"M1685,1439.03h-6.48v24.61h-5.61v-24.61h-6.45v-4.57H1685v4.53V1439.03z\"/>\n                    </g>\n                </g>\n            </g>\n        </g>\n        <g  id=\"preaux-list\">\n            <g v-if=\"attractions.includes(2214)\" id=\"pavillon-rosalie\">\n                <g>\n                    <path class=\"st16\" d=\"M1140,1222L1140,1222c13.255,0,24,10.745,24,24l0,0c0,13.255-10.745,24-24,24l0,0\n                        c-13.255,0-24-10.745-24-24l0,0C1116,1232.745,1126.745,1222,1140,1222z\"/>\n                </g>\n                <g>\n                    <path class=\"st1\" d=\"M1146.77,1256.48c-0.276,0-0.5-0.224-0.5-0.5v-11.83c0-0.201,0.119-0.375,0.291-0.454l-6.5-6.831\n                        l-6.503,6.835c0.167,0.081,0.282,0.252,0.282,0.45v11.83c0,0.276-0.224,0.5-0.5,0.5s-0.5-0.224-0.5-0.5v-11.526l-5.167,5.431\n                        c-0.191,0.201-0.507,0.208-0.707,0.018s-0.208-0.507-0.018-0.707l12.75-13.4c0.189-0.199,0.535-0.199,0.725,0l12.75,13.4\n                        c0.19,0.2,0.183,0.517-0.018,0.707c-0.199,0.189-0.516,0.184-0.707-0.018l-5.179-5.443v11.539\n                        C1147.27,1256.257,1147.046,1256.48,1146.77,1256.48z\"/>\n                </g>\n            </g>\n            <g v-if=\"attractions.includes(1602)\" id=\"preaux-1\">\n                <g id=\"num_1_\">\n                    <g>\n                        <path class=\"st10\" d=\"M925.067,1175.714L925.067,1175.714c6.033,0,10.924,4.891,10.924,10.924l0,0\n                            c0,6.033-4.891,10.924-10.924,10.924l0,0c-6.033,0-10.924-4.891-10.924-10.924l0,0\n                            C914.143,1180.604,919.034,1175.714,925.067,1175.714z\"/>\n                    </g>\n                </g>\n                <g>\n                    <path class=\"st10\" d=\"M906,1181L906,1181c13.255,0,24,10.745,24,24l0,0c0,13.255-10.745,24-24,24l0,0c-13.255,0-24-10.745-24-24\n                        l0,0C882,1191.745,892.745,1181,906,1181z\"/>\n                </g>\n                <g>\n                    <path class=\"st1\" d=\"M918.809,1209.04c-0.132,0-0.264-0.052-0.362-0.155l-12.388-13.02l-12.388,13.02\n                        c-0.189,0.201-0.507,0.208-0.707,0.018c-0.2-0.19-0.208-0.507-0.018-0.707l12.75-13.4c0.188-0.197,0.536-0.197,0.725,0\n                        l12.75,13.4c0.19,0.2,0.183,0.517-0.018,0.707C919.057,1208.994,918.933,1209.04,918.809,1209.04z\"/>\n                </g>\n                <g>\n                    <path class=\"st1\" d=\"M908.893,1215.48c-0.276,0-0.5-0.224-0.5-0.5v-6.591h-4.667v6.591c0,0.276-0.224,0.5-0.5,0.5\n                        s-0.5-0.224-0.5-0.5v-7.091c0-0.276,0.224-0.5,0.5-0.5h5.667c0.276,0,0.5,0.224,0.5,0.5v7.091\n                        C909.393,1215.257,909.169,1215.48,908.893,1215.48z\"/>\n                </g>\n                <g>\n                    <path class=\"st1\" d=\"M914.059,1214.98c0,0.27,0.223,0.5,0.5,0.5c0.276,0,0.5-0.23,0.5-0.5H914.059z M914.059,1203.64v11.34h1\n                        v-11.34H914.059z\"/>\n                </g>\n                <g>\n                    <path class=\"st1\" d=\"M897.059,1214.98c0,0.27,0.223,0.5,0.5,0.5c0.276,0,0.5-0.23,0.5-0.5H897.059z M897.059,1203.64v11.34h1\n                        v-11.34H897.059z\"/>\n                </g>\n                <g>\n                    <g>\n                        <path class=\"st1\" d=\"M924.819,1183.189h-0.024l-1.355,0.731l-0.204-0.803l1.703-0.912h0.9v7.796h-1.02V1183.189z\"/>\n                    </g>\n                </g>\n            </g>\n            <g v-if=\"attractions.includes(2051)\" id=\"preaux-2\">\n                <g>\n                    <path class=\"st10\" d=\"M938.06,1236L938.06,1236c13.255,0,24,10.745,24,24l0,0c0,13.255-10.745,24-24,24l0,0\n                        c-13.255,0-24-10.745-24-24l0,0C914.06,1246.745,924.805,1236,938.06,1236z\"/>\n                </g>\n                <g id=\"num_2_\">\n                    <g>\n                        <path class=\"st10\" d=\"M955.87,1230.849L955.87,1230.849c6.033,0,10.924,4.891,10.924,10.924l0,0\n                            c0,6.033-4.891,10.924-10.924,10.924l0,0c-6.033,0-10.924-4.891-10.924-10.924l0,0\n                            C944.946,1235.74,949.837,1230.849,955.87,1230.849z\"/>\n                    </g>\n                </g>\n                <g>\n                    <g>\n                        <path class=\"st1\" d=\"M953.332,1245.138v-0.647l0.828-0.804c1.991-1.895,2.891-2.902,2.902-4.078\n                            c0-0.791-0.384-1.522-1.547-1.522c-0.708,0-1.295,0.359-1.655,0.659l-0.336-0.743c0.54-0.456,1.308-0.792,2.207-0.792\n                            c1.679,0,2.387,1.151,2.387,2.267c0,1.439-1.043,2.603-2.687,4.186l-0.624,0.576v0.023h3.502v0.876H953.332z\"/>\n                    </g>\n                </g>\n                <g>\n                    <path class=\"st1\" d=\"M950.869,1264.04c-0.132,0-0.264-0.052-0.362-0.155l-12.388-13.02l-12.388,13.02\n                        c-0.19,0.201-0.507,0.208-0.707,0.018s-0.208-0.507-0.018-0.707l12.75-13.4c0.188-0.197,0.536-0.197,0.725,0l12.75,13.4\n                        c0.19,0.2,0.183,0.517-0.018,0.707C951.117,1263.994,950.993,1264.04,950.869,1264.04z\"/>\n                </g>\n                <g>\n                    <path class=\"st1\" d=\"M940.953,1270.48c-0.276,0-0.5-0.224-0.5-0.5v-6.591h-4.667v6.591c0,0.276-0.224,0.5-0.5,0.5\n                        s-0.5-0.224-0.5-0.5v-7.091c0-0.276,0.224-0.5,0.5-0.5h5.667c0.276,0,0.5,0.224,0.5,0.5v7.091\n                        C941.453,1270.257,941.229,1270.48,940.953,1270.48z\"/>\n                </g>\n                <g>\n                    <path class=\"st1\" d=\"M946.119,1269.98c0,0.27,0.223,0.5,0.5,0.5c0.276,0,0.5-0.23,0.5-0.5H946.119z M946.119,1258.64v11.34h1\n                        v-11.34H946.119z\"/>\n                </g>\n                <g>\n                    <path class=\"st1\" d=\"M929.119,1269.98c0,0.27,0.223,0.5,0.5,0.5c0.276,0,0.5-0.23,0.5-0.5H929.119z M929.119,1258.64v11.34h1\n                        v-11.34H929.119z\"/>\n                </g>\n            </g>\n            <g v-if=\"attractions.includes(2213)\" id=\"preaux-3\">\n                <g>\n                    <path class=\"st10\" d=\"M1181.06,1301L1181.06,1301c13.255,0,24,10.745,24,24l0,0c0,13.255-10.745,24-24,24l0,0\n                        c-13.255,0-24-10.745-24-24l0,0C1157.06,1311.745,1167.805,1301,1181.06,1301z\"/>\n                </g>\n                <g id=\"num_3_\">\n                    <g>\n                        <path class=\"st10\" d=\"M1198.87,1295.849L1198.87,1295.849c6.033,0,10.924,4.891,10.924,10.924l0,0\n                            c0,6.033-4.891,10.924-10.924,10.924l0,0c-6.033,0-10.924-4.891-10.924-10.924l0,0\n                            C1187.946,1300.74,1192.837,1295.849,1198.87,1295.849z\"/>\n                    </g>\n                </g>\n                <g>\n                    <g>\n                        <path class=\"st1\" d=\"M1196.584,1308.927c0.3,0.191,0.996,0.491,1.728,0.491c1.355,0,1.774-0.863,1.763-1.511\n                            c-0.012-1.092-0.995-1.56-2.015-1.56h-0.588v-0.791h0.588c0.768,0,1.739-0.396,1.739-1.319c0-0.624-0.396-1.176-1.367-1.176\n                            c-0.624,0-1.224,0.276-1.56,0.516l-0.275-0.768c0.407-0.3,1.199-0.6,2.038-0.6c1.535,0,2.231,0.911,2.231,1.859\n                            c0,0.804-0.48,1.487-1.439,1.835v0.023c0.959,0.192,1.739,0.912,1.739,2.003c0,1.247-0.972,2.339-2.843,2.339\n                            c-0.875,0-1.643-0.275-2.026-0.527L1196.584,1308.927z\"/>\n                    </g>\n                </g>\n                <g>\n                    <path class=\"st1\" d=\"M1193.869,1329.04c-0.132,0-0.264-0.052-0.362-0.155l-12.388-13.02l-12.388,13.02\n                        c-0.191,0.202-0.508,0.207-0.707,0.018c-0.2-0.19-0.208-0.507-0.018-0.707l12.75-13.4c0.189-0.197,0.535-0.197,0.725,0\n                        l12.75,13.4c0.19,0.2,0.183,0.517-0.018,0.707C1194.117,1328.994,1193.993,1329.04,1193.869,1329.04z\"/>\n                </g>\n                <g>\n                    <path class=\"st1\" d=\"M1183.953,1335.48c-0.276,0-0.5-0.224-0.5-0.5v-6.591h-4.667v6.591c0,0.276-0.224,0.5-0.5,0.5\n                        s-0.5-0.224-0.5-0.5v-7.091c0-0.276,0.224-0.5,0.5-0.5h5.667c0.276,0,0.5,0.224,0.5,0.5v7.091\n                        C1184.453,1335.257,1184.229,1335.48,1183.953,1335.48z\"/>\n                </g>\n                <g>\n                    <path class=\"st1\" d=\"M1189.119,1334.98c0,0.27,0.223,0.5,0.5,0.5c0.276,0,0.5-0.23,0.5-0.5H1189.119z M1189.119,1323.64v11.34h1\n                        v-11.34H1189.119z\"/>\n                </g>\n                <g>\n                    <path class=\"st1\" d=\"M1172.119,1334.98c0,0.27,0.223,0.5,0.5,0.5c0.276,0,0.5-0.23,0.5-0.5H1172.119z M1172.119,1323.64v11.34h1\n                        v-11.34H1172.119z\"/>\n                </g>\n            </g>\n            <g v-if=\"attractions.includes(2212)\" id=\"preaux-4\">\n                <g>\n                    <path class=\"st10\" d=\"M1377,1331L1377,1331c13.255,0,24,10.745,24,24l0,0c0,13.255-10.745,24-24,24l0,0\n                        c-13.255,0-24-10.745-24-24l0,0C1353,1341.745,1363.745,1331,1377,1331z\"/>\n                </g>\n                <g id=\"num\">\n                    <g>\n                        <path class=\"st10\" d=\"M1394.81,1325.849L1394.81,1325.849c6.033,0,10.924,4.891,10.924,10.924l0,0\n                            c0,6.033-4.891,10.924-10.924,10.924l0,0c-6.033,0-10.924-4.891-10.924-10.924l0,0\n                            C1383.886,1330.74,1388.777,1325.849,1394.81,1325.849z\"/>\n                    </g>\n                </g>\n                <g>\n                    <g>\n                        <path class=\"st1\" d=\"M1395.534,1340.138v-2.123h-3.622v-0.695l3.479-4.978h1.139v4.846h1.092v0.827h-1.092v2.123H1395.534z\n                            M1395.534,1337.188v-2.603c0-0.408,0.013-0.815,0.036-1.224h-0.036c-0.239,0.456-0.432,0.792-0.647,1.151l-1.907,2.65v0.024\n                            H1395.534z\"/>\n                    </g>\n                </g>\n                <g>\n                    <path class=\"st1\" d=\"M1389.809,1359.04c-0.132,0-0.264-0.052-0.362-0.155l-12.388-13.02l-12.388,13.02\n                        c-0.19,0.202-0.507,0.207-0.707,0.018c-0.2-0.19-0.208-0.507-0.018-0.707l12.75-13.4c0.189-0.197,0.535-0.197,0.725,0\n                        l12.75,13.4c0.19,0.2,0.183,0.517-0.018,0.707C1390.057,1358.994,1389.933,1359.04,1389.809,1359.04z\"/>\n                </g>\n                <g>\n                    <path class=\"st1\" d=\"M1379.893,1365.48c-0.276,0-0.5-0.224-0.5-0.5v-6.591h-4.667v6.591c0,0.276-0.224,0.5-0.5,0.5\n                        s-0.5-0.224-0.5-0.5v-7.091c0-0.276,0.224-0.5,0.5-0.5h5.667c0.276,0,0.5,0.224,0.5,0.5v7.091\n                        C1380.393,1365.257,1380.169,1365.48,1379.893,1365.48z\"/>\n                </g>\n                <g>\n                    <path class=\"st1\" d=\"M1385.059,1364.98c0,0.27,0.223,0.5,0.5,0.5c0.276,0,0.5-0.23,0.5-0.5H1385.059z M1385.059,1353.64v11.34h1\n                        v-11.34H1385.059z\"/>\n                </g>\n                <g>\n                    <path class=\"st1\" d=\"M1368.059,1364.98c0,0.27,0.223,0.5,0.5,0.5c0.276,0,0.5-0.23,0.5-0.5H1368.059z M1368.059,1353.64v11.34h1\n                        v-11.34H1368.059z\"/>\n                </g>\n            </g>\n            <g v-if=\"attractions.includes(1592)\" id=\"preaux-5\">\n                <g>\n                    <path class=\"st10\" d=\"M843,1405L843,1405c13.255,0,24,10.745,24,24l0,0c0,13.255-10.745,24-24,24l0,0c-13.255,0-24-10.745-24-24\n                        l0,0C819,1415.745,829.745,1405,843,1405z\"/>\n                </g>\n                <g id=\"num_4_\">\n                    <g>\n                        <path class=\"st10\" d=\"M860.81,1399.849L860.81,1399.849c6.033,0,10.924,4.891,10.924,10.924l0,0\n                            c0,6.033-4.891,10.924-10.924,10.924l0,0c-6.033,0-10.924-4.891-10.924-10.924l0,0\n                            C849.886,1404.74,854.777,1399.849,860.81,1399.849z\"/>\n                    </g>\n                </g>\n                <g>\n                    <g>\n                        <path class=\"st1\" d=\"M862.926,1407.229h-2.975l-0.3,2.003c0.18-0.024,0.348-0.048,0.636-0.048c0.6,0,1.199,0.132,1.679,0.42\n                            c0.611,0.348,1.115,1.02,1.115,2.003c0,1.522-1.211,2.662-2.902,2.662c-0.852,0-1.571-0.24-1.943-0.479l0.264-0.804\n                            c0.324,0.191,0.959,0.432,1.667,0.432c0.996,0,1.847-0.647,1.847-1.691c-0.012-1.007-0.684-1.727-2.243-1.727\n                            c-0.444,0-0.792,0.048-1.08,0.084l0.504-3.742h3.73V1407.229z\"/>\n                    </g>\n                </g>\n                <g>\n                    <path class=\"st1\" d=\"M855.809,1433.04c-0.132,0-0.264-0.052-0.362-0.155l-12.388-13.02l-12.388,13.02\n                        c-0.19,0.201-0.507,0.208-0.707,0.018c-0.2-0.19-0.208-0.507-0.018-0.707l12.75-13.4c0.188-0.197,0.536-0.197,0.725,0\n                        l12.75,13.4c0.19,0.2,0.183,0.517-0.018,0.707C856.057,1432.994,855.933,1433.04,855.809,1433.04z\"/>\n                </g>\n                <g>\n                    <path class=\"st1\" d=\"M845.893,1439.48c-0.276,0-0.5-0.224-0.5-0.5v-6.591h-4.667v6.591c0,0.276-0.224,0.5-0.5,0.5\n                        s-0.5-0.224-0.5-0.5v-7.091c0-0.276,0.224-0.5,0.5-0.5h5.667c0.276,0,0.5,0.224,0.5,0.5v7.091\n                        C846.393,1439.257,846.169,1439.48,845.893,1439.48z\"/>\n                </g>\n                <g>\n                    <path class=\"st1\" d=\"M851.059,1438.98c0,0.27,0.223,0.5,0.5,0.5c0.276,0,0.5-0.23,0.5-0.5H851.059z M851.059,1427.64v11.34h1\n                        v-11.34H851.059z\"/>\n                </g>\n                <g>\n                    <path class=\"st1\" d=\"M834.059,1438.98c0,0.27,0.223,0.5,0.5,0.5c0.276,0,0.5-0.23,0.5-0.5H834.059z M834.059,1427.64v11.34h1\n                        v-11.34H834.059z\"/>\n                </g>\n            </g>\n        </g>\n        <g v-if=\"title.includes(20)\" id=\"toilette-list\">\n            <g id=\"toilette-1\">\n                <g>\n                    <path class=\"st0\" d=\"M1860,1076L1860,1076c13.255,0,24,10.745,24,24l0,0c0,13.255-10.745,24-24,24l0,0\n                        c-13.255,0-24-10.745-24-24l0,0C1836,1086.745,1846.745,1076,1860,1076z\"/>\n                </g>\n                <g>\n                    <path class=\"st1\" d=\"M1868.96,1111.742h-4.42c-0.168,0-0.313-0.118-0.346-0.283l-0.684-3.427h-2.081\n                        c-0.558,0-1.017-0.424-1.091-1.007c-0.002-0.12-0.002-0.224,0.037-0.339c0.098-0.484,0.196-1.043,0.298-1.614\n                        c0.565-3.185,1.25-7.037,4.352-8.057c-1.107-0.618-1.858-1.81-1.858-3.176c0-1.997,1.607-3.622,3.583-3.622\n                        s3.583,1.625,3.583,3.622c0,1.366-0.751,2.558-1.858,3.176c3.102,1.02,3.786,4.872,4.352,8.057c0.102,0.571,0.2,1.13,0.31,1.656\n                        c0.018,0.105,0.027,0.178,0.027,0.252c-0.076,0.628-0.535,1.052-1.093,1.052h-2.081l-0.684,3.427\n                        C1869.273,1111.624,1869.128,1111.742,1868.96,1111.742z M1864.829,1111.037h3.842l0.684-3.427\n                        c0.032-0.165,0.178-0.283,0.346-0.283h2.37c0.197,0,0.361-0.165,0.39-0.392c0.001,0.004-0.01-0.021-0.016-0.062\n                        c-0.11-0.535-0.211-1.1-0.313-1.679c-0.644-3.624-1.373-7.732-5.381-7.732s-4.737,4.108-5.381,7.732\n                        c-0.103,0.579-0.203,1.144-0.313,1.676c0.013,0.291,0.177,0.456,0.374,0.456h2.37c0.168,0,0.313,0.118,0.346,0.283\n                        L1864.829,1111.037z M1866.75,1090.923c-1.587,0-2.878,1.309-2.878,2.917s1.291,2.918,2.878,2.918s2.878-1.31,2.878-2.918\n                        S1868.337,1090.923,1866.75,1090.923z M1855.37,1111.742h-4.84c-0.179,0-0.329-0.133-0.351-0.31l-0.762-6.23h-2.107\n                        c-0.195,0-0.353-0.157-0.353-0.353v-2.449c0-1.625,0.622-3.148,1.751-4.288c0.702-0.716,1.575-1.238,2.522-1.527\n                        c-1.104-0.617-1.854-1.809-1.854-3.175c0-1.998,1.603-3.623,3.572-3.623c1.976,0,3.582,1.625,3.582,3.623\n                        c0,1.363-0.748,2.553-1.851,3.171c0.944,0.285,1.808,0.806,2.521,1.532c1.128,1.139,1.75,2.662,1.75,4.287v2.449\n                        c0,0.195-0.157,0.353-0.353,0.353h-2.108l-0.771,6.23C1855.698,1111.609,1855.548,1111.742,1855.37,1111.742z\n                        M1850.843,1111.037h4.216l0.771-6.23c0.022-0.177,0.173-0.31,0.351-0.31h2.067v-2.097c0-1.438-0.55-2.785-1.548-3.792\n                        c-0.998-1.017-2.329-1.576-3.749-1.576c-1.394,0-2.757,0.574-3.738,1.575c-0.999,1.008-1.549,2.354-1.549,3.793v2.097h2.067\n                        c0.179,0,0.329,0.133,0.351,0.31L1850.843,1111.037z M1852.95,1090.492c-1.581,0-2.867,1.31-2.867,2.918\n                        s1.286,2.917,2.867,2.917c1.586,0,2.877-1.309,2.877-2.917S1854.536,1090.492,1852.95,1090.492z\"/>\n                </g>\n            </g>\n            <!-- <g id=\"toilette-2_1_\">\n                <g>\n                    <path class=\"st0\" d=\"M1028.699,1309.835L1028.699,1309.835c13.255,0,24,10.745,24,24l0,0c0,13.255-10.745,24-24,24l0,0\n                        c-13.255,0-24-10.745-24-24l0,0C1004.699,1320.58,1015.444,1309.835,1028.699,1309.835z\"/>\n                </g>\n                <g>\n                    <path class=\"st1\" d=\"M1037.659,1345.577h-4.42c-0.168,0-0.313-0.118-0.346-0.283l-0.683-3.427h-2.081\n                        c-0.559,0-1.017-0.424-1.09-1.009c-0.003-0.118-0.003-0.22,0.035-0.334c0.099-0.487,0.197-1.045,0.299-1.616\n                        c0.565-3.185,1.249-7.038,4.351-8.059c-1.106-0.617-1.858-1.809-1.858-3.175c0-1.997,1.607-3.622,3.583-3.622\n                        s3.583,1.625,3.583,3.622c0,1.366-0.751,2.558-1.858,3.175c3.102,1.021,3.786,4.874,4.351,8.059\n                        c0.102,0.571,0.2,1.129,0.31,1.655c0.016,0.093,0.027,0.172,0.027,0.251c-0.076,0.629-0.534,1.053-1.093,1.053h-2.081\n                        l-0.683,3.427C1037.972,1345.459,1037.828,1345.577,1037.659,1345.577z M1033.528,1344.872h3.841l0.683-3.427\n                        c0.033-0.165,0.178-0.283,0.346-0.283h2.37c0.198,0,0.361-0.165,0.39-0.392c0,0.001,0,0.001,0,0.001\n                        c-0.003,0-0.011-0.039-0.018-0.078c-0.108-0.52-0.208-1.084-0.311-1.662c-0.643-3.625-1.372-7.733-5.38-7.733\n                        c-4.009,0-4.738,4.108-5.381,7.733c-0.103,0.579-0.203,1.143-0.313,1.675c0.013,0.291,0.176,0.456,0.374,0.456h2.37\n                        c0.168,0,0.313,0.118,0.346,0.283L1033.528,1344.872z M1035.449,1324.758c-1.586,0-2.877,1.309-2.877,2.917\n                        s1.291,2.918,2.877,2.918s2.877-1.31,2.877-2.918S1037.036,1324.758,1035.449,1324.758z M1024.069,1345.577h-4.84\n                        c-0.178,0-0.329-0.133-0.35-0.31l-0.764-6.23h-2.107c-0.195,0-0.353-0.157-0.353-0.353v-2.449c0-1.622,0.624-3.146,1.755-4.288\n                        c0.701-0.715,1.573-1.238,2.519-1.527c-1.104-0.616-1.855-1.809-1.855-3.175c0-1.998,1.604-3.623,3.575-3.623\n                        c1.976,0,3.583,1.625,3.583,3.623c0,1.363-0.749,2.553-1.852,3.171c0.944,0.285,1.808,0.806,2.521,1.532\n                        c1.128,1.139,1.751,2.661,1.751,4.287v2.449c0,0.195-0.158,0.353-0.353,0.353h-2.108l-0.772,6.23\n                        C1024.397,1345.444,1024.247,1345.577,1024.069,1345.577z M1019.542,1344.872h4.215l0.772-6.23\n                        c0.022-0.177,0.172-0.31,0.35-0.31h2.067v-2.097c0-1.438-0.549-2.785-1.547-3.792c-0.998-1.017-2.329-1.576-3.75-1.576\n                        c-1.394,0-2.755,0.574-3.736,1.575c-1.001,1.012-1.552,2.357-1.552,3.793v2.097h2.066c0.178,0,0.329,0.133,0.35,0.31\n                        L1019.542,1344.872z M1021.649,1324.327c-1.582,0-2.869,1.31-2.869,2.918s1.287,2.917,2.869,2.917\n                        c1.586,0,2.877-1.309,2.877-2.917S1023.235,1324.327,1021.649,1324.327z\"/>\n                </g> -->\n            </g>\n        </g>\n        <g v-if=\"title.includes(49)\" id=\"parking-accessible\">\n            <path class=\"st0\" d=\"M1113.707,1105.543L1113.707,1105.543c13.255,0,24,10.745,24,24l0,0c0,13.255-10.745,24-24,24l0,0\n                c-13.255,0-24-10.745-24-24l0,0C1089.707,1116.288,1100.453,1105.543,1113.707,1105.543z\"/>\n            <g>\n                <g>\n                    <path stroke=\"#fff\" d=\"M1111.975,1120.67v-3.234 M1111.975,1117.436v-4.527h3.519c0.915,0,1.657,0.738,1.657,1.653v1.215\n                    c0,0.915-0.742,1.659-1.657,1.659H1111.975z M1117.821,1109.603h-7.735c-1.831,0-3.315,1.49-3.315,3.319v7.735\n                    c0,1.829,1.484,3.312,3.315,3.312h7.735c1.831,0,3.315-1.483,3.315-3.312v-7.735\n                    C1121.136,1111.093,1119.651,1109.603,1117.821,1109.603z\"/>\n                    <path class=\"st1\" d=\"M1099.205,1129.975c1.126,0,2.043-0.916,2.043-2.042s-0.916-2.043-2.043-2.043\n                        c-1.126,0-2.042,0.916-2.042,2.043S1098.078,1129.975,1099.205,1129.975z M1099.205,1126.564c0.754,0,1.368,0.614,1.368,1.368\n                        c0,0.754-0.613,1.368-1.368,1.368c-0.754,0-1.368-0.613-1.368-1.368S1098.451,1126.564,1099.205,1126.564z\"/>\n                    <path class=\"st1\" d=\"M1097.238,1138.302v6.079c0,0.186,0.151,0.338,0.337,0.338c0.186,0,0.338-0.151,0.338-0.338v-6.253\n                        c0-0.005-0.001-0.01-0.001-0.015c0.001-0.121-0.064-0.239-0.179-0.3c-0.432-0.23-0.7-0.675-0.7-1.161v-3.71\n                        c0-0.724,0.589-1.313,1.313-1.313h1.73c0.724,0,1.313,0.589,1.313,1.313v3.71c0,0.486-0.268,0.931-0.7,1.161\n                        c-0.117,0.062-0.182,0.183-0.178,0.307c0,0.003,0,0.005,0,0.008v6.253c0,0.186,0.151,0.338,0.337,0.338\n                        c0.187,0,0.338-0.151,0.338-0.338v-6.079c0.547-0.368,0.879-0.983,0.879-1.649v-3.71c0-1.096-0.892-1.988-1.988-1.988h-1.73\n                        c-1.096,0-1.988,0.892-1.988,1.988v3.71C1096.359,1137.319,1096.691,1137.934,1097.238,1138.302z\"/>\n                    <path class=\"st1\" d=\"M1105.67,1134.586c1.126,0,2.043-0.917,2.043-2.043c0-1.126-0.916-2.043-2.043-2.043\n                        c-1.126,0-2.042,0.916-2.042,2.043C1103.628,1133.669,1104.544,1134.586,1105.67,1134.586z M1105.67,1131.175\n                        c0.754,0,1.368,0.614,1.368,1.368c0,0.754-0.614,1.368-1.368,1.368c-0.754,0-1.368-0.614-1.368-1.368\n                        C1104.303,1131.789,1104.916,1131.175,1105.67,1131.175z\"/>\n                    <path class=\"st1\" d=\"M1104.236,1141.139v3.242c0,0.186,0.151,0.338,0.338,0.338c0.186,0,0.337-0.151,0.337-0.338v-3.415\n                        c0-0.005,0-0.01-0.001-0.016c0-0.121-0.064-0.239-0.179-0.3c-0.432-0.23-0.7-0.675-0.7-1.161v-1.937\n                        c0-0.724,0.589-1.313,1.313-1.313h0.666c0.724,0,1.313,0.589,1.313,1.313v1.937c0,0.486-0.268,0.93-0.7,1.161\n                        c-0.117,0.062-0.182,0.183-0.178,0.307c0,0.003,0,0.005,0,0.008v3.415c0,0.186,0.151,0.338,0.338,0.338s0.338-0.151,0.338-0.338\n                        v-3.242c0.547-0.369,0.879-0.983,0.879-1.649v-1.937c0-1.096-0.892-1.988-1.988-1.988h-0.666c-1.096,0-1.988,0.892-1.988,1.988\n                        v1.937C1103.356,1140.156,1103.689,1140.771,1104.236,1141.139z\"/>\n                    <path class=\"st1\" d=\"M1112.505,1131.039c1.126,0,2.042-0.916,2.042-2.042c0-1.127-0.916-2.043-2.042-2.043\n                        c-1.126,0-2.043,0.917-2.043,2.043C1110.462,1130.123,1111.378,1131.039,1112.505,1131.039z M1112.505,1127.628\n                        c0.754,0,1.367,0.614,1.367,1.368c0,0.754-0.614,1.367-1.367,1.367c-0.754,0-1.368-0.613-1.368-1.367\n                        C1111.137,1128.242,1111.75,1127.628,1112.505,1127.628z\"/>\n                    <path class=\"st1\" d=\"M1109.095,1139.513h1.975v4.868c0,0.186,0.151,0.338,0.338,0.338s0.338-0.151,0.338-0.338v-5.206\n                        c0-0.023-0.002-0.046-0.007-0.068c-0.002-0.011-0.005-0.022-0.008-0.032c-0.043-0.137-0.171-0.237-0.322-0.237c0,0,0,0,0,0\n                        h-1.766l1.529-3.059c0.023-0.047,0.036-0.099,0.036-0.151v-1.636c0-0.716,0.583-1.298,1.299-1.298s1.298,0.582,1.298,1.298\n                        v1.636c0,0.052,0.012,0.104,0.036,0.151l1.529,3.059h-1.753c0,0,0,0,0,0c-0.151,0-0.28,0.1-0.322,0.237\n                        c-0.003,0.011-0.006,0.021-0.008,0.032c-0.005,0.022-0.007,0.045-0.007,0.068v5.206c0,0.186,0.151,0.338,0.337,0.338\n                        s0.338-0.151,0.338-0.338v-4.868h1.961c0.117,0,0.226-0.061,0.287-0.16c0.061-0.099,0.067-0.224,0.015-0.328l-1.738-3.476\n                        v-1.557c0-1.088-0.885-1.973-1.973-1.973c-1.088,0-1.974,0.885-1.974,1.973v1.557l-1.738,3.476\n                        c-0.052,0.105-0.047,0.229,0.015,0.328C1108.87,1139.452,1108.978,1139.513,1109.095,1139.513z\"/>\n                </g>\n                <g>\n                    <g>\n                        <g>\n                            <path class=\"st1\" d=\"M1121.46,1139.351c-0.522,0-0.922,0.399-0.922,0.922s0.399,0.922,0.922,0.922\n                                c0.522,0,0.921-0.399,0.921-0.922S1121.982,1139.351,1121.46,1139.351z M1121.46,1140.58c-0.184,0-0.307-0.123-0.307-0.307\n                                s0.123-0.307,0.307-0.307c0.184,0,0.307,0.123,0.307,0.307S1121.644,1140.58,1121.46,1140.58z\"/>\n                        </g>\n                    </g>\n                    <g>\n                        <g>\n                            <path class=\"st1\" d=\"M1126.067,1134.437h-4.331l-0.215-1.935c-0.061-0.491-0.461-0.829-0.922-0.829h-1.29\n                                c-0.184,0-0.307,0.123-0.307,0.307c0,0.184,0.123,0.307,0.307,0.307h1.29c0.154,0,0.276,0.123,0.307,0.276l0.246,2.212v0.584\n                                c0,0.184,0.123,0.307,0.307,0.307c0.184,0,0.307-0.123,0.307-0.307v-0.307h4.3c0.184,0,0.307,0.123,0.307,0.307\n                                s-0.123,0.307-0.307,0.307h-1.843c-0.184,0-0.307,0.123-0.307,0.307c0,0.184,0.123,0.307,0.307,0.307h1.843\n                                c0.522,0,0.922-0.399,0.922-0.922S1126.589,1134.437,1126.067,1134.437z\"/>\n                        </g>\n                    </g>\n                    <g>\n                        <g>\n                            <path class=\"st1\" d=\"M1129.446,1142.116c-0.184,0-0.307,0.123-0.307,0.307c0,0.184,0.123,0.307,0.307,0.307\n                                c0.338,0,0.614,0.276,0.614,0.614s-0.276,0.614-0.614,0.614s-0.614-0.276-0.614-0.614v-4.3c0-0.522-0.399-0.922-0.922-0.922\n                                h-1.843c-0.184,0-0.307,0.123-0.307,0.307s0.123,0.307,0.307,0.307h1.843c0.184,0,0.307,0.123,0.307,0.307v0.922h-2.764\n                                c-0.184,0-0.307,0.123-0.307,0.307c0,2.027-1.659,3.686-3.686,3.686c-2.027,0-3.686-1.659-3.686-3.686\n                                s1.659-3.686,3.686-3.686c1.72,0,3.194,1.167,3.594,2.826c0.031,0.154,0.215,0.276,0.369,0.215\n                                c0.154-0.031,0.276-0.215,0.215-0.369c-0.461-1.935-2.181-3.287-4.177-3.287c-2.365,0-4.3,1.935-4.3,4.3s1.935,4.3,4.3,4.3\n                                c2.273,0,4.116-1.751,4.3-3.993h2.457v2.765c0,0.676,0.553,1.229,1.229,1.229c0.676,0,1.229-0.553,1.229-1.229\n                                S1130.122,1142.116,1129.446,1142.116z\"/>\n                        </g>\n                    </g>\n                </g>\n            </g>\n        </g>\n        <g v-if=\"title.includes(57)\" id=\"rouge-vin_\">\n            <g id=\"rouge-vin\">\n              <path class=\"st0\" d=\"M1814.493,1049.7h0c13.255,0,24,10.745,24,24h0c0,13.255-10.745,24-24,24h0c-13.255,0-24-10.745-24-24h0c0-13.255,10.745-24,24-24Z\"/>\n              <path class=\"st1\" d=\"M1820.64,1085.25c-.276,0-.5-.224-.5-.5v-11.373c-2.28-.306-4.059-2.672-4.059-5.537,0-3.071,2.045-5.569,4.559-5.569s4.559,2.498,4.559,5.569c0,2.865-1.779,5.231-4.059,5.537v11.373c0,.276-.224.5-.5.5ZM1820.64,1063.27c-1.962,0-3.559,2.05-3.559,4.569s1.597,4.57,3.559,4.57,3.559-2.05,3.559-4.57-1.597-4.569-3.559-4.569ZM1808.631,1085.25c-.276,0-.5-.224-.5-.5v-13.056c-1.079-.112-2.075-.586-2.844-1.362-.878-.875-1.384-2.094-1.384-3.342v-4.22c0-.276.224-.5.5-.5s.5.224.5.5v4.22c0,.984.398,1.944,1.092,2.636.582.587,1.327.954,2.136,1.061v-7.916c0-.276.224-.5.5-.5s.5.224.5.5v7.916c.317-.043.628-.126.929-.249.456-.187.861-.458,1.204-.808.344-.342.624-.759.812-1.212.188-.453.284-.934.284-1.428v-4.22c0-.276.224-.5.5-.5s.5.224.5.5v4.22c0,.627-.121,1.236-.36,1.812-.24.573-.595,1.104-1.026,1.532-.435.442-.952.79-1.534,1.028-.422.173-.86.283-1.308.33v13.057c0,.276-.224.5-.5.5Z\"/>\n            </g>\n        </g>\n        <g v-if=\"title.includes(21)\" id=\"food-truck-1\">\n            <g\n               id=\"food-truck-1-2-3\"\n               data-name=\"food-truck-1\"\n               transform=\"translate(-941.10798,211.68029)\">\n              <path\n                 class=\"cls-11\"\n                 d=\"m 1814.69,1049.755 v 0 c 13.255,0 24,10.745 24,24 v 0 c 0,13.255 -10.745,24 -24,24 v 0 c -13.255,0 -24,-10.745 -24,-24 v 0 c 0,-13.255 10.745,-24 24,-24 z\"\n                 id=\"path999-6\"\n                 style=\"fill:#4d80d6;stroke-width:0px\" />\n              <g\n                 id=\"g2139\"\n                 transform=\"matrix(-1.0125265,0,0,0.9677929,1838.8362,1050.5053)\">\n                <path\n                   d=\"m 11.517382,24.490647 h 7.175901\"\n                   fill=\"none\"\n                   stroke=\"#000000\"\n                   stroke-linecap=\"round\"\n                   stroke-linejoin=\"round\"\n                   stroke-width=\"1\"\n                   id=\"path259\"\n                   style=\"stroke:#ffffff;stroke-opacity:1\" />\n                <path\n                   d=\"m 12.115374,33.682138 a 2.3919672,2.4510641 0 1 0 4.783934,0 2.3919672,2.4510641 0 1 0 -4.783934,0\"\n                   fill=\"none\"\n                   stroke=\"#000000\"\n                   stroke-linecap=\"round\"\n                   stroke-linejoin=\"round\"\n                   stroke-width=\"1\"\n                   id=\"path261\"\n                   style=\"stroke:#ffffff;stroke-opacity:1\" />\n                <path\n                   d=\"m 28.859144,33.682138 a 2.3919672,2.4510641 0 1 0 4.783934,0 2.3919672,2.4510641 0 1 0 -4.783934,0\"\n                   fill=\"none\"\n                   stroke=\"#000000\"\n                   stroke-linecap=\"round\"\n                   stroke-linejoin=\"round\"\n                   stroke-width=\"1\"\n                   id=\"path263\"\n                   style=\"stroke:#ffffff;stroke-opacity:1\" />\n                <path\n                   d=\"M 12.115374,33.682138 H 9.7234061 A 0.59799179,0.61276604 0 0 1 9.1254145,33.069372 v -5.873975 a 0.59799179,0.61276604 0 0 1 0.1746138,-0.432614 l 2.2173537,-2.272136 2.647908,-4.88497 a 1.1959835,1.2255321 0 0 1 1.04529,-0.629924 h 3.482703 v -5.514894 a 0.59799179,0.61276604 0 0 1 0.597992,-0.612766 h 16.743771 a 0.59799179,0.61276604 0 0 1 0.597991,0.612766 v 19.608513 a 0.59799179,0.61276604 0 0 1 -0.597991,0.612766 h -2.391968\"\n                   fill=\"none\"\n                   stroke=\"#000000\"\n                   stroke-linecap=\"round\"\n                   stroke-linejoin=\"round\"\n                   stroke-width=\"1\"\n                   id=\"path265\"\n                   style=\"stroke:#ffffff;stroke-opacity:1\" />\n                <path\n                   d=\"M 16.899308,33.682138 H 28.859144\"\n                   fill=\"none\"\n                   stroke=\"#000000\"\n                   stroke-linecap=\"round\"\n                   stroke-linejoin=\"round\"\n                   stroke-width=\"1\"\n                   id=\"path267\"\n                   style=\"stroke:#ffffff;stroke-opacity:1\" />\n                <path\n                   d=\"m 18.693283,18.975753 v 12.25532\"\n                   fill=\"none\"\n                   stroke=\"#000000\"\n                   stroke-linecap=\"round\"\n                   stroke-linejoin=\"round\"\n                   stroke-width=\"1\"\n                   id=\"path269\"\n                   style=\"stroke:#ffffff;stroke-opacity:1\" />\n                <path\n                   d=\"M 9.1254145,31.231073 H 36.633037\"\n                   fill=\"none\"\n                   stroke=\"#000000\"\n                   stroke-linecap=\"round\"\n                   stroke-linejoin=\"round\"\n                   stroke-width=\"1\"\n                   id=\"path271\"\n                   style=\"stroke:#ffffff;stroke-opacity:1\" />\n                <path\n                   d=\"M 21.085251,20.201285 H 34.24107 l -2.391967,-3.676597 h -8.371885 z\"\n                   fill=\"none\"\n                   stroke=\"#000000\"\n                   stroke-linecap=\"round\"\n                   stroke-linejoin=\"round\"\n                   stroke-width=\"1\"\n                   id=\"path273\"\n                   style=\"stroke:#ffffff;stroke-opacity:1\" />\n                <path\n                   d=\"M 21.085251,25.103413 H 34.24107\"\n                   fill=\"none\"\n                   stroke=\"#000000\"\n                   stroke-linecap=\"round\"\n                   stroke-linejoin=\"round\"\n                   stroke-width=\"1\"\n                   id=\"path275\"\n                   style=\"stroke:#ffffff;stroke-opacity:1\" />\n                <path\n                   d=\"m 22.281234,20.201285 h 10.763852 v 7.353193 H 22.281234 Z\"\n                   fill=\"none\"\n                   stroke=\"#000000\"\n                   stroke-linecap=\"round\"\n                   stroke-linejoin=\"round\"\n                   stroke-width=\"1\"\n                   id=\"path277-5\"\n                   style=\"stroke:#ffffff;stroke-opacity:1\" />\n              </g>\n            </g>\n        </g>\n        <g v-if=\"title.includes(20)\" id=\"toilette-list_1_\">\n            <g id=\"toilette-1_1_\">\n                <g>\n                    <path class=\"st0\" d=\"M1860,1076L1860,1076c13.255,0,24,10.745,24,24l0,0c0,13.255-10.745,24-24,24l0,0\n                        c-13.255,0-24-10.745-24-24l0,0C1836,1086.745,1846.745,1076,1860,1076z\"/>\n                </g>\n                <g>\n                    <path class=\"st1\" d=\"M1868.96,1111.742h-4.42c-0.168,0-0.313-0.118-0.346-0.283l-0.684-3.427h-2.081\n                        c-0.558,0-1.017-0.424-1.091-1.007c-0.002-0.12-0.002-0.224,0.037-0.339c0.098-0.484,0.196-1.043,0.298-1.614\n                        c0.565-3.185,1.25-7.037,4.352-8.057c-1.107-0.618-1.858-1.81-1.858-3.176c0-1.997,1.607-3.622,3.583-3.622\n                        s3.583,1.625,3.583,3.622c0,1.366-0.751,2.558-1.858,3.176c3.102,1.02,3.786,4.872,4.352,8.057c0.102,0.571,0.2,1.13,0.31,1.656\n                        c0.018,0.105,0.027,0.178,0.027,0.252c-0.076,0.628-0.535,1.052-1.093,1.052h-2.081l-0.684,3.427\n                        C1869.273,1111.624,1869.128,1111.742,1868.96,1111.742z M1864.829,1111.037h3.842l0.684-3.427\n                        c0.032-0.165,0.178-0.283,0.346-0.283h2.37c0.197,0,0.361-0.165,0.39-0.392c0.001,0.004-0.01-0.021-0.016-0.062\n                        c-0.11-0.535-0.211-1.1-0.313-1.679c-0.644-3.624-1.373-7.732-5.381-7.732s-4.737,4.108-5.381,7.732\n                        c-0.103,0.579-0.203,1.144-0.313,1.676c0.013,0.291,0.177,0.456,0.374,0.456h2.37c0.168,0,0.313,0.118,0.346,0.283\n                        L1864.829,1111.037z M1866.75,1090.923c-1.587,0-2.878,1.309-2.878,2.917s1.291,2.918,2.878,2.918s2.878-1.31,2.878-2.918\n                        S1868.337,1090.923,1866.75,1090.923z M1855.37,1111.742h-4.84c-0.179,0-0.329-0.133-0.351-0.31l-0.762-6.23h-2.107\n                        c-0.195,0-0.353-0.157-0.353-0.353v-2.449c0-1.625,0.622-3.148,1.751-4.288c0.702-0.716,1.575-1.238,2.522-1.527\n                        c-1.104-0.617-1.854-1.809-1.854-3.175c0-1.998,1.603-3.623,3.572-3.623c1.976,0,3.582,1.625,3.582,3.623\n                        c0,1.363-0.748,2.553-1.851,3.171c0.944,0.285,1.808,0.806,2.521,1.532c1.128,1.139,1.75,2.662,1.75,4.287v2.449\n                        c0,0.195-0.157,0.353-0.353,0.353h-2.108l-0.771,6.23C1855.698,1111.609,1855.548,1111.742,1855.37,1111.742z\n                        M1850.843,1111.037h4.216l0.771-6.23c0.022-0.177,0.173-0.31,0.351-0.31h2.067v-2.097c0-1.438-0.55-2.785-1.548-3.792\n                        c-0.998-1.017-2.329-1.576-3.749-1.576c-1.394,0-2.757,0.574-3.738,1.575c-0.999,1.008-1.549,2.354-1.549,3.793v2.097h2.067\n                        c0.179,0,0.329,0.133,0.351,0.31L1850.843,1111.037z M1852.95,1090.492c-1.581,0-2.867,1.31-2.867,2.918\n                        s1.286,2.917,2.867,2.917c1.586,0,2.877-1.309,2.877-2.917S1854.536,1090.492,1852.95,1090.492z\"/>\n                </g>\n            </g>\n        </g>\n        <g v-if=\"title.includes(28)\" id=\"paserelle\">\n            <g>\n                <path class=\"st6\" d=\"M774,901L774,901c12.703,0,23,10.297,23,23l0,0c0,12.703-10.297,23-23,23l0,0c-12.703,0-23-10.297-23-23l0,0\n                    C751,911.297,761.297,901,774,901z\"/>\n            </g>\n            <g>\n                <path class=\"st1\" d=\"M774,948c-13.233,0-24-10.767-24-24s10.767-24,24-24s24,10.767,24,24S787.233,948,774,948z M774,902\n                    c-12.131,0-22,9.869-22,22s9.869,22,22,22s22-9.869,22-22S786.131,902,774,902z\"/>\n            </g>\n            <g>\n                <path class=\"st1\" d=\"M786.809,934.476h-25.5c-0.276,0-0.5-0.224-0.5-0.5s0.224-0.5,0.5-0.5h25.5c0.276,0,0.5,0.224,0.5,0.5\n                    S787.085,934.476,786.809,934.476z\"/>\n            </g>\n            <g>\n                <path class=\"st1\" d=\"M783.976,928.809h-19.833c-0.276,0-0.5-0.224-0.5-0.5s0.224-0.5,0.5-0.5h19.833c0.276,0,0.5,0.224,0.5,0.5\n                    S784.252,928.809,783.976,928.809z\"/>\n            </g>\n            <g>\n                <path class=\"st1\" d=\"M786.809,934.475c-0.276,0-0.5-0.224-0.5-0.5v-11.333c0-0.276,0.224-0.5,0.5-0.5s0.5,0.224,0.5,0.5v11.333\n                    C787.309,934.251,787.085,934.475,786.809,934.475z\"/>\n            </g>\n            <g>\n                \n                    <rect x=\"778.265\" y=\"927.1\" transform=\"matrix(0.4961 0.8683 -0.8683 0.4961 1200.47 -213.2738)\" class=\"st1\" width=\"11.421\" height=\"1\"/>\n            </g>\n            <g>\n                <path class=\"st1\" d=\"M781.141,923.142h-14.166c-0.276,0-0.5-0.224-0.5-0.5s0.224-0.5,0.5-0.5h14.166c0.276,0,0.5,0.224,0.5,0.5\n                    S781.417,923.142,781.141,923.142z\"/>\n            </g>\n            <g>\n                <path class=\"st1\" d=\"M761.309,934.475c-0.276,0-0.5-0.224-0.5-0.5v-11.333c0-0.276,0.224-0.5,0.5-0.5s0.5,0.224,0.5,0.5v11.333\n                    C761.809,934.251,761.585,934.475,761.309,934.475z\"/>\n            </g>\n            <g>\n                \n                    <rect x=\"763.642\" y=\"921.889\" transform=\"matrix(0.8682 0.4961 -0.4961 0.8682 560.8995 -256.903)\" class=\"st1\" width=\"1\" height=\"11.421\"/>\n            </g>\n            <g>\n                <path class=\"st1\" d=\"M781.143,923.142c-0.276,0-0.5-0.224-0.5-0.5v-8.5c0-0.276,0.224-0.5,0.5-0.5s0.5,0.224,0.5,0.5v8.5\n                    C781.643,922.918,781.419,923.142,781.143,923.142z\"/>\n            </g>\n            <g>\n                \n                    <rect x=\"778.868\" y=\"917.892\" transform=\"matrix(0.5547 0.8321 -0.8321 0.5547 1113.314 -243.3305)\" class=\"st1\" width=\"10.215\" height=\"1\"/>\n            </g>\n            <g>\n                <path class=\"st1\" d=\"M766.975,923.142c-0.276,0-0.5-0.224-0.5-0.5v-8.5c0-0.276,0.224-0.5,0.5-0.5s0.5,0.224,0.5,0.5v8.5\n                    C767.475,922.918,767.251,923.142,766.975,923.142z\"/>\n            </g>\n            <g>\n                <path class=\"st1\" d=\"M761.309,923.142c-0.095,0-0.191-0.027-0.277-0.084c-0.23-0.153-0.292-0.464-0.139-0.693l5.666-8.5\n                    c0.153-0.229,0.462-0.293,0.693-0.139c0.23,0.153,0.292,0.464,0.139,0.693l-5.666,8.5\n                    C761.629,923.063,761.47,923.142,761.309,923.142z\"/>\n            </g>\n        </g>\n        <g v-if=\"title.includes(25)\" id=\"camping-1\">\n            <g>\n                <path class=\"st6\" d=\"M783,1191L783,1191c13.255,0,24,10.745,24,24l0,0c0,13.255-10.745,24-24,24l0,0c-13.255,0-24-10.745-24-24\n                    l0,0C759,1201.745,769.745,1191,783,1191z\"/>\n            </g>\n            <g>\n                <path class=\"st1\" d=\"M778.384,1228.311c-0.004,0-0.008,0-0.012,0h-7.8c-0.421,0-0.763-0.341-0.763-0.761v-7.72\n                    c0-0.178,0.065-0.353,0.183-0.492l12.381-14.036l-2.642-2.638c-0.196-0.194-0.196-0.512-0.001-0.707\n                    c0.195-0.195,0.513-0.195,0.707,0l2.622,2.617l2.622-2.617c0.194-0.195,0.512-0.195,0.707,0c0.195,0.195,0.195,0.513-0.001,0.707\n                    l-2.642,2.638l12.373,14.027c0.125,0.149,0.191,0.324,0.191,0.501v7.72c0,0.42-0.343,0.761-0.764,0.761h-7.799\n                    c-0.008,0-0.016,0-0.023,0h-9.327C778.392,1228.311,778.388,1228.311,778.384,1228.311z M788.087,1227.311h7.222v-7.387\n                    l-11.75-13.321v7.941L788.087,1227.311z M779.092,1227.311h7.934l-3.967-11.185L779.092,1227.311z M770.809,1227.311h7.222\n                    l4.528-12.767v-7.941l-11.75,13.32V1227.311z\"/>\n            </g>\n        </g>\n        <g v-if=\"title.includes(24)\" id=\"playground\">\n            <g>\n                <path class=\"st16\" d=\"M1125,1315L1125,1315c13.255,0,24,10.745,24,24l0,0c0,13.255-10.745,24-24,24l0,0\n                    c-13.255,0-24-10.745-24-24l0,0C1101,1325.745,1111.745,1315,1125,1315z\"/>\n            </g>\n            <g>\n                <path class=\"st1\" d=\"M1114.062,1350.55c-0.02,0-0.039-0.001-0.059-0.003c-0.274-0.032-0.471-0.28-0.439-0.555l2.279-19.739\n                    c0.18-1.529,1.478-2.683,3.018-2.683h12.39c1.553,0,2.85,1.154,3.017,2.686l2.28,19.736c0.031,0.274-0.165,0.522-0.439,0.555\n                    c-0.272,0.025-0.522-0.165-0.555-0.439l-2.28-19.739c-0.111-1.026-0.981-1.798-2.022-1.798h-1.46v15.968\n                    c0.968,0.227,1.69,1.097,1.69,2.132c0,1.208-0.982,2.19-2.19,2.19h-8.46c-1.208,0-2.19-0.982-2.19-2.19\n                    c0-1.035,0.723-1.905,1.69-2.132v-15.968h-1.47c-1.033,0-1.903,0.773-2.023,1.799l-2.279,19.738\n                    C1114.527,1350.362,1114.312,1350.55,1114.062,1350.55z M1120.83,1345.48c-0.656,0-1.19,0.533-1.19,1.189s0.534,1.19,1.19,1.19\n                    h8.46c0.656,0,1.19-0.534,1.19-1.19s-0.534-1.189-1.19-1.189H1120.83z M1121.33,1344.48h7.46v-15.91h-7.46V1344.48z\"/>\n            </g>\n        </g>\n        <g v-if=\"title.includes(56)\" id=\"go-van\">\n          <g id=\"go-van-1\">\n            <path class=\"st6\" d=\"M1788,1171.891h0c13.255,0,24,10.745,24,24h0c0,13.255-10.745,24-24,24h0c-13.255,0-24-10.745-24-24h0c0-13.255,10.745-24,24-24Z\"/>\n            <g>\n              <path class=\"st1\" d=\"M1792.371,1203.857h-8.53c-.276,0-.5-.224-.5-.5s.224-.5.5-.5h8.53c.276,0,.5.224.5.5s-.224.5-.5.5Z\"/>\n              <g>\n                <path class=\"st1\" d=\"M1780.997,1206.701c-1.844,0-3.344-1.5-3.344-3.344s1.5-3.345,3.345-3.345c1.844,0,3.343,1.502,3.343,3.345s-1.5,3.344-3.344,3.344ZM1780.998,1201.013c-1.293,0-2.345,1.051-2.345,2.343v.002c0,1.292,1.052,2.344,2.344,2.344s2.344-1.052,2.344-2.344-1.051-2.344-2.343-2.345Z\"/>\n                <path class=\"st1\" d=\"M1795.215,1206.701c-1.844,0-3.344-1.5-3.344-3.344h0c0-1.845,1.502-3.345,3.345-3.345.894,0,1.733.349,2.364.98.632.632.979,1.472.979,2.364,0,1.844-1.5,3.344-3.344,3.344ZM1792.371,1203.355l.5.002c0,1.292,1.052,2.344,2.344,2.344s2.344-1.052,2.344-2.344c0-.626-.243-1.215-.686-1.657-.442-.443-1.031-.688-1.657-.688-1.292,0-2.344,1.051-2.345,2.343h-.5Z\"/>\n                <path class=\"st1\" d=\"M1799.48,1203.857h-1.422c-.276,0-.5-.224-.5-.5s.224-.5.5-.5h1.422c.509,0,.922-.413.922-.922v-6.438c0-.362-.085-.725-.247-1.048l-1.365-2.729c-.642-1.283-1.932-2.081-3.367-2.081h-15.848c-2.076,0-3.766,1.688-3.766,3.765v8.531c0,.509.413.922.922.922h1.422c.276,0,.5.224.5.5s-.224.5-.5.5h-1.422c-1.06,0-1.922-.862-1.922-1.922v-8.531c0-2.627,2.138-4.765,4.766-4.765h15.848c1.816,0,3.449,1.009,4.262,2.634l1.365,2.729c.23.461.353.979.353,1.495v6.438c0,1.06-.862,1.922-1.922,1.922Z\"/>\n                <path class=\"st1\" d=\"M1800.902,1196.748h-25.593c-.276,0-.5-.224-.5-.5s.224-.5.5-.5h25.593c.276,0,.5.224.5.5s-.224.5-.5.5Z\"/>\n                <path class=\"st1\" d=\"M1792.371,1196.748c-.276,0-.5-.224-.5-.5v-7.108c0-.276.224-.5.5-.5s.5.224.5.5v7.108c0,.276-.224.5-.5.5Z\"/>\n                <path class=\"st1\" d=\"M1791.66,1189.64h-9.952c-1.452,0-2.633-1.181-2.633-2.633s1.181-2.633,2.633-2.633h9.952c1.452,0,2.633,1.181,2.633,2.633s-1.181,2.633-2.633,2.633ZM1781.708,1185.374c-.9,0-1.633.732-1.633,1.633s.732,1.633,1.633,1.633h9.952c.9,0,1.633-.732,1.633-1.633s-.732-1.633-1.633-1.633h-9.952Z\"/>\n              </g>\n            </g>\n          </g>\n        </g>\n        <g v-if=\"title.includes(22)\" id=\"belvedere\">\n            <g>\n                <path class=\"st1\" d=\"M177.04,555.987c0,5.676-4.606,10.277-10.286,10.277c-5.68,0-10.285-4.601-10.285-10.277\n                    c0-5.675,4.605-10.277,10.285-10.277C172.434,545.71,177.04,550.312,177.04,555.987z\"/>\n                <path class=\"st13\" d=\"M166.754,566.949c-6.049,0-10.97-4.918-10.97-10.962s4.921-10.962,10.97-10.962\n                    c6.049,0,10.971,4.917,10.971,10.962S172.803,566.949,166.754,566.949z M166.754,546.395c-5.293,0-9.6,4.303-9.6,9.592\n                    s4.307,9.592,9.6,9.592c5.294,0,9.601-4.303,9.601-9.592S172.048,546.395,166.754,546.395z\"/>\n            </g>\n            <g>\n                <path class=\"st0\" d=\"M162,531L162,531c12.703,0,23,10.297,23,23l0,0c0,12.703-10.297,23-23,23l0,0c-12.703,0-23-10.297-23-23l0,0\n                    C139,541.297,149.297,531,162,531z\"/>\n            </g>\n            <g>\n                <path class=\"st1\" d=\"M162,578c-13.233,0-24-10.767-24-24s10.767-24,24-24s24,10.767,24,24S175.233,578,162,578z M162,532\n                    c-12.131,0-22,9.869-22,22s9.869,22,22,22s22-9.869,22-22S174.131,532,162,532z\"/>\n            </g>\n            <g>\n                <path class=\"st1\" d=\"M168.823,565.552c-2.607,0-4.728-2.121-4.728-4.728v-5.074c0-0.276,0.224-0.5,0.5-0.5s0.5,0.224,0.5,0.5\n                    v2.169c0.866-1.109,2.215-1.823,3.728-1.823c1.207,0,2.31,0.455,3.146,1.201l-2.487-12.767c-0.053-0.275-0.202-0.524-0.42-0.7\n                    c-0.217-0.176-0.503-0.275-0.771-0.266h-2.005c-0.317,0-0.617,0.124-0.843,0.35c-0.225,0.224-0.348,0.523-0.348,0.842v2.537\n                    c0,0.276-0.224,0.5-0.5,0.5s-0.5-0.224-0.5-0.5v-2.537c0-0.586,0.228-1.136,0.641-1.549c0.415-0.415,0.965-0.643,1.55-0.643\n                    h1.996c0.517,0.011,1.011,0.165,1.41,0.489c0.401,0.324,0.675,0.781,0.772,1.287l3.027,15.542c0.013,0.065,0.012,0.129,0,0.19\n                    c0.039,0.245,0.06,0.496,0.06,0.751C173.552,563.431,171.431,565.552,168.823,565.552z M168.823,557.096\n                    c-2.056,0-3.728,1.672-3.728,3.728c0,2.055,1.672,3.728,3.728,3.728c2.056,0,3.729-1.672,3.729-3.728\n                    C172.552,558.769,170.879,557.096,168.823,557.096z M155.293,565.552c-2.607,0-4.729-2.121-4.729-4.728\n                    c0-0.326,0.033-0.645,0.097-0.953l2.991-15.531c0.097-0.504,0.371-0.961,0.772-1.287c0.399-0.324,0.905-0.493,1.419-0.489h1.987\n                    c0.578,0,1.143,0.234,1.55,0.643c0.413,0.413,0.641,0.963,0.641,1.549v2.537c0,0.276-0.224,0.5-0.5,0.5s-0.5-0.224-0.5-0.5\n                    v-2.537c0-0.318-0.124-0.617-0.349-0.842c-0.222-0.222-0.528-0.35-0.842-0.35h-1.996c-0.295-0.002-0.563,0.089-0.78,0.265\n                    c-0.218,0.177-0.367,0.425-0.419,0.699l-2.454,12.739c0.833-0.729,1.922-1.171,3.113-1.171c1.513,0,2.862,0.714,3.728,1.823\n                    v-2.169c0-0.276,0.224-0.5,0.5-0.5s0.5,0.224,0.5,0.5v5.074C160.021,563.431,157.9,565.552,155.293,565.552z M151.638,560.083\n                    c-0.049,0.24-0.074,0.488-0.074,0.742c0,2.055,1.673,3.728,3.729,3.728c2.056,0,3.728-1.672,3.728-3.728\n                    c0-2.056-1.672-3.728-3.728-3.728c-1.8,0-3.306,1.281-3.653,2.979C151.639,560.078,151.639,560.08,151.638,560.083z\n                    M166.286,552.022h-8.456c-0.276,0-0.5-0.224-0.5-0.5s0.224-0.5,0.5-0.5h8.456c0.276,0,0.5,0.224,0.5,0.5\n                    S166.563,552.022,166.286,552.022z\"/>\n            </g>\n        </g>\n        <g v-if=\"title.includes(27)\" id=\"vestiaire-1\">\n            <g>\n                <path class=\"st0\" d=\"M737,1368L737,1368c13.255,0,24,10.745,24,24l0,0c0,13.255-10.745,24-24,24l0,0c-13.255,0-24-10.745-24-24\n                    l0,0C713,1378.745,723.745,1368,737,1368z\"/>\n            </g>\n            <g>\n                <defs>\n                    <rect id=\"SVGID_8_\" x=\"725.059\" y=\"1380.06\" width=\"24\" height=\"24\"/>\n                </defs>\n                <clipPath id=\"SVGID_9_\">\n                    <use xlink:href=\"#SVGID_8_\"  style=\"overflow:visible;\"/>\n                </clipPath>\n                <g class=\"st17\">\n                    <g>\n                        <defs>\n                            <rect id=\"SVGID_10_\" x=\"725.059\" y=\"1380.06\" width=\"24\" height=\"24\"/>\n                        </defs>\n                        <clipPath id=\"SVGID_11_\">\n                            <use xlink:href=\"#SVGID_10_\"  style=\"overflow:visible;\"/>\n                        </clipPath>\n                        <g class=\"st18\">\n                            <g>\n                                <path class=\"st1\" d=\"M744.559,1386.93c-0.843,0-1.629-0.326-2.213-0.919c-0.587-0.584-0.912-1.367-0.912-2.2\n                                    c0-0.829,0.333-1.637,0.916-2.215c1.178-1.173,3.238-1.173,4.418,0c0.583,0.579,0.917,1.386,0.917,2.215\n                                    c0,0.833-0.325,1.615-0.916,2.204C746.187,1386.604,745.401,1386.93,744.559,1386.93z M744.559,1381.68\n                                    c-0.557,0-1.105,0.228-1.504,0.625c-0.395,0.393-0.621,0.941-0.621,1.506c0,0.565,0.221,1.097,0.621,1.495\n                                    c0.795,0.807,2.214,0.805,3.004,0.003c0.404-0.402,0.625-0.934,0.625-1.498s-0.227-1.113-0.622-1.506\n                                    C745.663,1381.907,745.115,1381.68,744.559,1381.68z\"/>\n                            </g>\n                            <g>\n                                <path class=\"st1\" d=\"M744.559,1403.811c-0.72,0-1.429-0.294-1.944-0.806c-0.52-0.518-0.806-1.208-0.806-1.944v-3.314\n                                    c-0.343-0.09-0.661-0.27-0.914-0.522c-0.378-0.376-0.586-0.878-0.586-1.413v-4.5c0-0.937,0.364-1.816,1.025-2.476\n                                    c0.653-0.659,1.533-1.024,2.475-1.024h1.5c0.942,0,1.821,0.365,2.477,1.027c0.659,0.656,1.023,1.535,1.023,2.473v4.5\n                                    c0,0.535-0.208,1.037-0.587,1.414c-0.253,0.252-0.571,0.432-0.913,0.521v3.314c0,0.736-0.287,1.427-0.807,1.944\n                                    C745.988,1403.517,745.28,1403.811,744.559,1403.811z M743.809,1388.811c-0.673,0-1.301,0.26-1.767,0.73\n                                    c-0.474,0.473-0.733,1.101-0.733,1.77v4.5c0,0.268,0.104,0.518,0.292,0.705c0.188,0.188,0.446,0.295,0.708,0.295\n                                    c0.276,0,0.5,0.224,0.5,0.5v3.75c0,0.469,0.182,0.907,0.511,1.235c0.659,0.655,1.82,0.653,2.477,0\n                                    c0.33-0.328,0.512-0.767,0.512-1.235v-3.75c0-0.276,0.224-0.5,0.5-0.5c0.262,0,0.519-0.107,0.707-0.295\n                                    c0.189-0.188,0.293-0.438,0.293-0.705v-4.5c0-0.67-0.26-1.297-0.732-1.767c-0.468-0.474-1.095-0.733-1.768-0.733H743.809z\"/>\n                            </g>\n                            <g>\n                                <path class=\"st1\" d=\"M733.309,1385.811c-0.276,0-0.5-0.224-0.5-0.5v-1.5c0-0.276,0.224-0.5,0.5-0.5\n                                    c0.195,0,0.389-0.059,0.562-0.17c0.16-0.111,0.286-0.265,0.359-0.447c0.079-0.187,0.098-0.383,0.06-0.577\n                                    c-0.039-0.191-0.136-0.375-0.274-0.513c-0.138-0.138-0.316-0.232-0.517-0.274c-0.189-0.036-0.391-0.019-0.579,0.055\n                                    c-0.176,0.077-0.334,0.208-0.442,0.372c-0.113,0.164-0.169,0.354-0.169,0.555c0,0.276-0.224,0.5-0.5,0.5s-0.5-0.224-0.5-0.5\n                                    c0-0.404,0.117-0.789,0.339-1.113c0.21-0.317,0.518-0.575,0.886-0.735c0.384-0.153,0.782-0.19,1.167-0.112\n                                    c0.393,0.082,0.746,0.271,1.021,0.547c0.28,0.28,0.469,0.634,0.548,1.024c0.078,0.393,0.038,0.791-0.116,1.154\n                                    c-0.143,0.354-0.395,0.667-0.728,0.896c-0.197,0.127-0.405,0.219-0.618,0.274v1.064\n                                    C733.809,1385.587,733.585,1385.811,733.309,1385.811z\"/>\n                            </g>\n                            <g>\n                                <path class=\"st1\" d=\"M736.309,1391.811h-10.5c-0.276,0-0.5-0.224-0.5-0.5v-1.5c0-0.176,0.092-0.339,0.243-0.429l7.5-4.5\n                                    c0.147-0.089,0.328-0.095,0.481-0.019l4.5,2.25c0.247,0.124,0.347,0.424,0.224,0.671c-0.124,0.247-0.423,0.349-0.671,0.224\n                                    l-4.254-2.127l-7.022,4.213v0.717h10c0.276,0,0.5,0.224,0.5,0.5S736.585,1391.811,736.309,1391.811z\"/>\n                            </g>\n                        </g>\n                    </g>\n                </g>\n            </g>\n        </g>\n        <g v-if=\"title.includes(23)\" id=\"parking-list\">\n            <g id=\"parking-5\">\n                <g>\n                    <path class=\"st0\" d=\"M1445.214,1266.21L1445.214,1266.21c13.255,0,24,10.745,24,24l0,0c0,13.255-10.745,24-24,24l0,0\n                        c-13.255,0-24-10.745-24-24l0,0C1421.214,1276.955,1431.959,1266.21,1445.214,1266.21z\"/>\n                </g>\n                <g>\n                    <path class=\"st1\" d=\"M1451.193,1301.76h-11.84c-3.077,0-5.58-2.498-5.58-5.569v-11.841c0-3.071,2.503-5.569,5.58-5.569h11.84\n                        c3.071,0,5.57,2.498,5.57,5.569v11.841C1456.764,1299.262,1454.265,1301.76,1451.193,1301.76z M1439.354,1279.78\n                        c-2.525,0-4.58,2.05-4.58,4.569v11.841c0,2.52,2.055,4.569,4.58,4.569h11.84c2.521,0,4.57-2.05,4.57-4.569v-11.841\n                        c0-2.52-2.05-4.569-4.57-4.569H1439.354z M1442.243,1296.71c-0.276,0-0.5-0.224-0.5-0.5v-11.88c0-0.276,0.224-0.5,0.5-0.5h5.391\n                        c1.67,0,3.029,1.359,3.029,3.03v1.859c0,1.677-1.359,3.04-3.029,3.04h-4.891v4.45\n                        C1442.743,1296.486,1442.52,1296.71,1442.243,1296.71z M1442.743,1290.76h4.891c1.119,0,2.029-0.915,2.029-2.04v-1.859\n                        c0-1.119-0.91-2.03-2.029-2.03h-4.891V1290.76z\"/>\n                </g>\n            </g>\n            <g id=\"parking-3\">\n                <g>\n                    <path class=\"st0\" d=\"M900,1043L900,1043c13.255,0,24,10.745,24,24l0,0c0,13.255-10.745,24-24,24l0,0c-13.255,0-24-10.745-24-24\n                        l0,0C876,1053.745,886.745,1043,900,1043z\"/>\n                </g>\n                <g>\n                    <path class=\"st1\" d=\"M905.978,1078.55h-11.84c-3.074,0-5.574-2.498-5.574-5.569v-11.841c0-3.076,2.5-5.579,5.574-5.579h11.84\n                        c3.073,0,5.574,2.503,5.574,5.579v11.841C911.552,1076.052,909.051,1078.55,905.978,1078.55z M894.138,1056.561\n                        c-2.522,0-4.574,2.054-4.574,4.579v11.841c0,2.52,2.052,4.569,4.574,4.569h11.84c2.522,0,4.574-2.05,4.574-4.569v-11.841\n                        c0-2.525-2.052-4.579-4.574-4.579H894.138z M897.029,1073.5c-0.276,0-0.5-0.224-0.5-0.5v-11.88c0-0.276,0.224-0.5,0.5-0.5h5.387\n                        c1.675,0,3.037,1.359,3.037,3.03v1.859c0,1.677-1.362,3.04-3.037,3.04h-4.887v4.45\n                        C897.529,1073.276,897.305,1073.5,897.029,1073.5z M897.529,1067.55h4.887c1.123,0,2.037-0.915,2.037-2.04v-1.859\n                        c0-1.119-0.914-2.03-2.037-2.03h-4.887V1067.55z\"/>\n                </g>\n            </g>\n            <g id=\"parking-2\">\n                <g>\n                    <path class=\"st0\" d=\"M1965,1009L1965,1009c13.255,0,24,10.745,24,24l0,0c0,13.255-10.745,24-24,24l0,0\n                        c-13.255,0-24-10.745-24-24l0,0C1941,1019.745,1951.745,1009,1965,1009z\"/>\n                </g>\n                <g>\n                    <path class=\"st1\" d=\"M1970.98,1044.55h-11.841c-3.076,0-5.579-2.498-5.579-5.569v-11.841c0-3.077,2.503-5.58,5.579-5.58h11.841\n                        c3.071,0,5.569,2.503,5.569,5.58v11.841C1976.55,1042.052,1974.052,1044.55,1970.98,1044.55z M1959.14,1022.56\n                        c-2.525,0-4.579,2.055-4.579,4.58v11.841c0,2.52,2.054,4.569,4.579,4.569h11.841c2.52,0,4.569-2.05,4.569-4.569v-11.841\n                        c0-2.525-2.05-4.58-4.569-4.58H1959.14z M1962.03,1039.5c-0.276,0-0.5-0.224-0.5-0.5v-11.88c0-0.276,0.224-0.5,0.5-0.5h5.39\n                        c1.671,0,3.03,1.359,3.03,3.03v1.859c0,1.677-1.359,3.04-3.03,3.04h-4.89v4.45C1962.53,1039.276,1962.307,1039.5,1962.03,1039.5\n                        z M1962.53,1033.55h4.89c1.119,0,2.03-0.915,2.03-2.04v-1.859c0-1.119-0.911-2.03-2.03-2.03h-4.89V1033.55z\"/>\n                </g>\n            </g>\n            <g id=\"parking-1\">\n                <g>\n                    <path class=\"st0\" d=\"M788,550L788,550c13.255,0,24,10.745,24,24l0,0c0,13.255-10.745,24-24,24l0,0c-13.255,0-24-10.745-24-24\n                        l0,0C764,560.745,774.745,550,788,550z\"/>\n                </g>\n                <g>\n                    <path class=\"st1\" d=\"M793.978,585.552h-11.84c-3.074,0-5.574-2.5-5.574-5.574v-11.839c0-3.074,2.5-5.574,5.574-5.574h11.84\n                        c3.073,0,5.574,2.5,5.574,5.574v11.839C799.552,583.051,797.051,585.552,793.978,585.552z M782.138,563.565\n                        c-2.522,0-4.574,2.052-4.574,4.574v11.839c0,2.522,2.052,4.574,4.574,4.574h11.84c2.522,0,4.574-2.052,4.574-4.574v-11.839\n                        c0-2.522-2.052-4.574-4.574-4.574H782.138z M785.029,580.501c-0.276,0-0.5-0.224-0.5-0.5v-11.885c0-0.276,0.224-0.5,0.5-0.5\n                        h5.387c1.675,0,3.037,1.362,3.037,3.037v1.859c0,1.674-1.362,3.037-3.037,3.037h-4.887v4.452\n                        C785.529,580.277,785.305,580.501,785.029,580.501z M785.529,574.549h4.887c1.123,0,2.037-0.914,2.037-2.037v-1.859\n                        c0-1.123-0.914-2.037-2.037-2.037h-4.887V574.549z\"/>\n                </g>\n            </g>\n            <g id=\"parking-4_1_\">\n                <g>\n                    <path class=\"st0\" d=\"M1812,1124L1812,1124c13.255,0,24,10.745,24,24l0,0c0,13.255-10.745,24-24,24l0,0\n                        c-13.255,0-24-10.745-24-24l0,0C1788,1134.745,1798.745,1124,1812,1124z\"/>\n                </g>\n                <g>\n                    <path class=\"st1\" d=\"M1817.98,1159.55h-11.841c-3.076,0-5.579-2.498-5.579-5.569v-11.841c0-3.076,2.503-5.579,5.579-5.579\n                        h11.841c3.071,0,5.569,2.503,5.569,5.579v11.841C1823.55,1157.052,1821.052,1159.55,1817.98,1159.55z M1806.14,1137.561\n                        c-2.525,0-4.579,2.054-4.579,4.579v11.841c0,2.52,2.054,4.569,4.579,4.569h11.841c2.52,0,4.569-2.05,4.569-4.569v-11.841\n                        c0-2.525-2.05-4.579-4.569-4.579H1806.14z M1809.03,1154.5c-0.276,0-0.5-0.224-0.5-0.5v-11.88c0-0.276,0.224-0.5,0.5-0.5h5.39\n                        c1.671,0,3.03,1.359,3.03,3.03v1.859c0,1.677-1.359,3.04-3.03,3.04h-4.89v4.45C1809.53,1154.276,1809.307,1154.5,1809.03,1154.5\n                        z M1809.53,1148.55h4.89c1.119,0,2.03-0.915,2.03-2.04v-1.859c0-1.119-0.911-2.03-2.03-2.03h-4.89V1148.55z\"/>\n                </g>\n            </g>\n        </g>\n        <g id=\"pool-list\">\n            <g v-if=\"title.includes(53)\" id=\"pool-wip\">\n                <g>\n                    <path class=\"st16\" d=\"M1022.81,1242.435L1022.81,1242.435c13.255,0,24,10.745,24,24l0,0c0,13.255-10.745,24-24,24l0,0\n                        c-13.255,0-24-10.745-24-24l0,0C998.81,1253.18,1009.555,1242.435,1022.81,1242.435z\"/>\n                </g>\n                <g>\n                    <path class=\"st1\" d=\"M1038.178,1278.737h-30.616c-0.78,0-1.504-0.421-1.89-1.1c-0.385-0.678-0.377-1.516,0.021-2.187\n                        l15.308-25.737c0.396-0.665,1.095-1.063,1.869-1.063c0.774,0,1.473,0.397,1.868,1.063l15.308,25.737\n                        c0.398,0.671,0.407,1.509,0.021,2.187C1039.682,1278.316,1038.958,1278.737,1038.178,1278.737z M1022.87,1249.651\n                        c-0.418,0-0.795,0.215-1.009,0.574l-15.308,25.737c-0.215,0.362-0.22,0.814-0.012,1.181s0.599,0.594,1.021,0.594h30.616\n                        c0.421,0,0.812-0.228,1.021-0.594c0.208-0.366,0.204-0.818-0.012-1.181l-15.308-25.737\n                        C1023.665,1249.866,1023.288,1249.651,1022.87,1249.651z\"/>\n                </g>\n                <g>\n                    <path class=\"st1\" d=\"M1023.571,1260.209c0.781,0,1.414,0.633,1.414,1.414s-0.633,1.414-1.414,1.414s-1.414-0.633-1.414-1.414\n                        S1022.79,1260.209,1023.571,1260.209z M1018.383,1268.779l-0.013-0.013l0,0c-0.059-0.039-0.111-0.072-0.156-0.124l0.156,1.792\n                        l-1.968,2.789c-0.28,0.404-0.182,0.951,0.208,1.232c0.404,0.28,0.952,0.182,1.232-0.208l2.125-3.063\n                        c0.111-0.156,0.182-0.365,0.156-0.573l-0.072-0.867L1018.383,1268.779z M1024.229,1274.612h8.433l-1.577-4.92\n                        c0,0-0.893,0.222-2.659,2.099c-0.039,0.039-0.085,0.085-0.124,0.124l-4.262-2.464c0.072-0.137,0.085-0.293,0.059-0.463\n                        l-1.512-5.605c-0.124-0.547-0.613-0.965-1.186-0.965h-2.822c-0.208,0-0.417,0.111-0.534,0.293l-1.408,2.444\n                        c-0.182,0.293-0.072,0.671,0.222,0.841l1.577,0.906l-0.208,0.352c-0.254,0.417-0.111,0.952,0.319,1.186l3.539,2.04v3.233\n                        c0,0.489,0.391,0.88,0.88,0.88s0.88-0.391,0.88-0.88v-3.689l3.917,2.268c-0.808,0.463-1.734,0.547-2.392,0.938\n                        C1024.562,1273.713,1024.229,1274.612,1024.229,1274.612z M1018.735,1266.387l-1.036-0.6l0,0l1.232-2.125h1.382\n                        L1018.735,1266.387z M1021.01,1267.704l0.977-1.707l0.73,2.685L1021.01,1267.704z M1007.759,1276.68L1007.759,1276.68\n                        C1007.759,1276.68,1007.759,1276.68,1007.759,1276.68L1007.759,1276.68z\"/>\n                </g>\n            </g>\n            <g id=\"pool-ready_1_\" class=\"st19\">\n                <g id=\"pool-ready\" class=\"st20\">\n                    <g>\n                        <path class=\"st0\" d=\"M1022.81,1242.435L1022.81,1242.435c13.255,0,24,10.745,24,24l0,0c0,13.255-10.745,24-24,24l0,0\n                            c-13.255,0-24-10.745-24-24l0,0C998.81,1253.18,1009.555,1242.435,1022.81,1242.435z\"/>\n                    </g>\n                </g>\n                <g class=\"st20\">\n                    <path class=\"st1\" d=\"M1014.367,1275.197c0.015-0.232,0.197-0.422,0.43-0.445c0.245-0.024,0.469,0.142,0.518,0.384\n                        c0.364,1.831,1.553,3.627,3.397,3.263c0.313-0.061,0.619-0.239,0.859-0.467c0.755-0.72,1.154-1.76,1.404-2.813\n                        c0.057-0.237,0.281-0.394,0.523-0.365c0.234,0.027,0.412,0.22,0.423,0.454c0.375,1.817,1.559,3.582,3.389,3.22\n                        c0.313-0.061,0.618-0.239,0.859-0.467c0.755-0.72,1.154-1.76,1.403-2.813c0.053-0.22,0.25-0.373,0.476-0.368\n                        c0.225,0.004,0.417,0.164,0.461,0.385c0.365,1.831,1.553,3.626,3.398,3.263c0.313-0.061,0.619-0.239,0.859-0.467\n                        c0.755-0.72,1.154-1.76,1.404-2.813c0.06-0.257,0.319-0.417,0.577-0.356c0.257,0.06,0.416,0.319,0.356,0.577\n                        c-0.292,1.234-0.789,2.441-1.675,3.286c-0.372,0.354-0.851,0.617-1.336,0.713c-1.854,0.366-3.291-0.862-4.052-2.542\n                        c-0.291,0.691-0.681,1.324-1.21,1.828c-0.371,0.354-0.85,0.617-1.335,0.713c-1.86,0.367-3.299-0.869-4.059-2.556\n                        c-0.29,0.686-0.678,1.313-1.203,1.813c-0.371,0.354-0.851,0.618-1.335,0.713c-1.849,0.365-3.284-0.855-4.046-2.527\n                        c-0.291,0.697-0.683,1.336-1.216,1.844c-0.372,0.354-0.851,0.617-1.336,0.713c-2.367,0.467-4.055-1.663-4.523-4.016\n                        c-0.052-0.259,0.117-0.512,0.376-0.564c0.26-0.052,0.512,0.117,0.564,0.377c0.365,1.831,1.553,3.626,3.398,3.263\n                        c0.313-0.061,0.619-0.239,0.859-0.467C1013.718,1277.253,1014.116,1276.233,1014.367,1275.197L1014.367,1275.197z\"/>\n                </g>\n                <g class=\"st20\">\n                    <path class=\"st1\" d=\"M1014.369,1269.113c0.015-0.232,0.197-0.421,0.43-0.444c0.245-0.024,0.47,0.142,0.518,0.384\n                        c0.361,1.817,1.565,3.256,3.394,2.896c0.313-0.062,0.619-0.239,0.859-0.468c0.755-0.719,1.154-1.759,1.404-2.812\n                        c0.057-0.237,0.281-0.394,0.523-0.365c0.234,0.027,0.412,0.22,0.423,0.454c0.375,1.817,1.559,3.581,3.389,3.22\n                        c0.313-0.062,0.618-0.239,0.859-0.468c0.745-0.709,1.113-1.266,1.359-2.303c0.053-0.219,0.25-0.373,0.475-0.369\n                        c0.225,0.004,0.417,0.165,0.461,0.385c0.362,1.814,1.616,3.114,3.442,2.755c0.313-0.062,0.619-0.239,0.859-0.468\n                        c0.755-0.719,1.154-1.759,1.404-2.812c0.06-0.257,0.319-0.417,0.577-0.356c0.257,0.06,0.416,0.319,0.356,0.576\n                        c-0.292,1.235-0.789,2.442-1.675,3.287c-0.372,0.353-0.851,0.617-1.336,0.713c-1.889,0.373-3.354-0.558-4.116-2.139\n                        c-0.272,0.51-0.634,0.939-1.146,1.426c-0.371,0.353-0.85,0.617-1.335,0.713c-1.86,0.367-3.299-0.869-4.059-2.556\n                        c-0.29,0.686-0.678,1.313-1.203,1.813c-0.371,0.353-0.851,0.617-1.335,0.713c-1.878,0.37-3.311-0.641-4.064-2.244\n                        c-0.289,0.57-0.674,1.06-1.198,1.56c-0.372,0.353-0.851,0.617-1.336,0.713c-2.367,0.467-4.055-1.664-4.523-4.016\n                        c-0.052-0.26,0.117-0.512,0.376-0.564c0.26-0.052,0.512,0.117,0.564,0.377c0.365,1.831,1.553,3.626,3.398,3.263\n                        c0.313-0.062,0.619-0.239,0.859-0.468C1013.712,1270.808,1014.121,1270.129,1014.369,1269.113L1014.369,1269.113z\"/>\n                </g>\n                <g class=\"st20\">\n                    <path class=\"st1\" d=\"M1021.079,1255.543c0-2.023-1.517-3.643-3.356-3.643s-3.356,1.62-3.356,3.643l0.003,14.062\n                        c0.001,0.265,0.216,0.479,0.48,0.479c0.265,0,0.479-0.215,0.478-0.479l-0.003-14.062c0-1.47,1.061-2.685,2.397-2.685\n                        c1.337,0,2.397,1.215,2.397,2.685c0,0.265,0.215,0.479,0.479,0.479S1021.079,1255.808,1021.079,1255.543L1021.079,1255.543z\"/>\n                </g>\n                <g class=\"st20\">\n                    <path class=\"st1\" d=\"M1027.514,1262.191v-6.648c0-2.023,1.517-3.643,3.356-3.643s3.356,1.62,3.356,3.643\n                        c0,0.265-0.215,0.479-0.479,0.479s-0.479-0.215-0.479-0.479c0-1.47-1.061-2.685-2.397-2.685c-1.337,0-2.397,1.215-2.397,2.685\n                        v13.694l-0.001,0.025l-0.002,0.024l-0.003,0.024l-0.004,0.024c-0.002,0.008-0.004,0.015-0.006,0.023l-0.007,0.023l-0.007,0.022\n                        l-0.009,0.022l-0.01,0.021l-0.01,0.02l-0.012,0.02l-0.012,0.02l-0.013,0.018l-0.014,0.018l-0.015,0.017l-0.016,0.017\n                        l-0.016,0.015l-0.017,0.015l-0.018,0.014l-0.019,0.013l-0.019,0.012l-0.02,0.011l-0.02,0.011l-0.021,0.01l-0.022,0.009\n                        l-0.022,0.008l-0.023,0.006l-0.023,0.006l-0.024,0.004l-0.024,0.003l-0.024,0.002l-0.025,0.001l-0.025-0.001l-0.024-0.002\n                        l-0.024-0.003l-0.024-0.004l-0.023-0.006l-0.023-0.006l-0.022-0.008l-0.022-0.009l-0.021-0.01l-0.02-0.011l-0.02-0.011\n                        l-0.02-0.012l-0.018-0.013l-0.018-0.014l-0.017-0.015l-0.017-0.015l-0.015-0.017l-0.015-0.017l-0.014-0.018l-0.013-0.018\n                        l-0.012-0.02l-0.011-0.02l-0.01-0.02l-0.01-0.021l-0.009-0.022l-0.008-0.022l-0.006-0.023l-0.006-0.023l-0.004-0.024\n                        l-0.004-0.024l-0.001-0.024l-0.001-0.025v-6.087h-12.667c-0.265,0-0.479-0.215-0.479-0.479s0.215-0.479,0.479-0.479H1027.514\n                        L1027.514,1262.191z\"/>\n                </g>\n                <g class=\"st20\">\n                    <path class=\"st1\" d=\"M1014.836,1267.949c0.42,0.01,13.156-0.019,13.156-0.019c0.265-0.001,0.478-0.216,0.478-0.48\n                        c-0.001-0.265-0.217-0.479-0.481-0.478c0,0-12.712,0.029-13.131,0.019c-0.265-0.006-0.484,0.203-0.49,0.468\n                        C1014.362,1267.723,1014.572,1267.942,1014.836,1267.949L1014.836,1267.949z\"/>\n                </g>\n                <g class=\"st20\">\n                    <path class=\"st1\" d=\"M1014.858,1258.291c0.42,0.01,13.156-0.019,13.156-0.019c0.265,0,0.479-0.216,0.478-0.48\n                        c0-0.265-0.216-0.478-0.48-0.478c0,0-12.713,0.029-13.132,0.019c-0.264-0.006-0.484,0.204-0.49,0.469\n                        S1014.594,1258.285,1014.858,1258.291L1014.858,1258.291z\"/>\n                </g>\n            </g>\n        </g>\n        <g v-if=\"title.includes(54)\" id=\"test-shop_1_\">\n            <g>\n                <path class=\"st0\" d=\"M1065.269,1215.19L1065.269,1215.19c13.255,0,24,10.745,24,24l0,0c0,13.255-10.745,24-24,24l0,0\n                    c-13.255,0-24-10.745-24-24l0,0C1041.269,1225.935,1052.014,1215.19,1065.269,1215.19z\"/>\n            </g>\n            <g>\n                <path class=\"st1\" d=\"M1078.078,1243.229c-0.132,0-0.264-0.052-0.362-0.155l-12.388-13.019l-12.388,13.019\n                    c-0.19,0.201-0.507,0.208-0.707,0.018s-0.208-0.507-0.018-0.707l12.75-13.399c0.188-0.199,0.536-0.199,0.725,0l12.75,13.399\n                    c0.19,0.2,0.183,0.517-0.018,0.707C1078.326,1243.184,1078.202,1243.229,1078.078,1243.229z\"/>\n            </g>\n            <g>\n                <path class=\"st1\" d=\"M1063.264,1243.457c0-0.292-0.236-0.528-0.528-0.528s-0.528,0.236-0.528,0.528\n                    c0.002,1.457,1.183,2.638,2.64,2.64v0.528c0,0.292,0.236,0.528,0.528,0.528s0.528-0.236,0.528-0.528v-0.528\n                    c1.458,0,2.64-1.182,2.64-2.64c0-1.458-1.182-2.64-2.64-2.64v-3.168c0.875,0,1.584,0.709,1.584,1.584\n                    c0,0.292,0.236,0.528,0.528,0.528c0.292,0,0.528-0.236,0.528-0.528c-0.002-1.457-1.183-2.638-2.64-2.64v-0.528\n                    c0-0.292-0.236-0.528-0.528-0.528s-0.528,0.236-0.528,0.528v0.528c-1.458,0-2.64,1.182-2.64,2.64c0,1.458,1.182,2.64,2.64,2.64\n                    v3.168C1063.973,1245.042,1063.264,1244.332,1063.264,1243.457z M1065.904,1241.873c0.875,0,1.584,0.709,1.584,1.584\n                    c0,0.875-0.709,1.584-1.584,1.584V1241.873z M1063.264,1239.233c0-0.875,0.709-1.584,1.584-1.584v3.168\n                    C1063.973,1240.817,1063.264,1240.108,1063.264,1239.233z\"/>\n            </g>\n            <g>\n                <path class=\"st1\" d=\"M1073.328,1249.17c0,0.27,0.223,0.5,0.5,0.5c0.276,0,0.5-0.23,0.5-0.5H1073.328z M1073.328,1237.83v11.34h1\n                    v-10.813L1073.328,1237.83z\"/>\n            </g>\n            <g>\n                <path class=\"st1\" d=\"M1073.828,1249.917c0.27,0,0.5-0.223,0.5-0.5c0-0.276-0.23-0.5-0.5-0.5V1249.917z M1062.488,1249.917h11.34\n                    v-1h-10.813L1062.488,1249.917z\"/>\n            </g>\n            <g>\n                <path class=\"st1\" d=\"M1056.828,1248.917c-0.27,0-0.5,0.223-0.5,0.5c0,0.276,0.23,0.5,0.5,0.5V1248.917z M1068.168,1248.917\n                    h-11.34v1h10.813L1068.168,1248.917z\"/>\n            </g>\n            <g>\n                <path class=\"st1\" d=\"M1056.328,1249.17c0,0.27,0.223,0.5,0.5,0.5c0.276,0,0.5-0.23,0.5-0.5H1056.328z M1056.328,1238.145v11.025\n                    h1v-11.34L1056.328,1238.145z\"/>\n            </g>\n            <g>\n            </g>\n        </g>\n        <g v-if=\"title.includes(26)\" id=\"admin_2_\">\n            <g>\n                <path class=\"st0\" d=\"M1493.836,1231L1493.836,1231c13.255,0,24,10.745,24,24l0,0c0,13.255-10.745,24-24,24l0,0\n                    c-13.255,0-24-10.745-24-24l0,0C1469.836,1241.745,1480.581,1231,1493.836,1231z\"/>\n            </g>\n            <g>\n                <path class=\"st1\" d=\"M1503.196,1266.55h-18.6c-0.578,0-1.128-0.224-1.548-0.63c-0.423-0.423-0.652-0.975-0.652-1.56v-9.4\n                    c0-0.296,0.06-0.591,0.177-0.879c0.151-0.317,0.324-0.552,0.54-0.744l10.444-9.634c0.191-0.178,0.486-0.178,0.678,0l10.45,9.64\n                    c0.229,0.215,0.406,0.466,0.52,0.729c0.121,0.264,0.182,0.558,0.182,0.888v9.4c0,0.577-0.224,1.127-0.631,1.548\n                    C1504.324,1266.326,1503.774,1266.55,1503.196,1266.55z M1493.896,1244.751l-10.111,9.326c-0.122,0.109-0.218,0.241-0.299,0.409\n                    c-0.057,0.142-0.09,0.306-0.09,0.474v9.4c0,0.318,0.126,0.618,0.354,0.847c0.227,0.219,0.529,0.343,0.847,0.343h18.6\n                    c0.317,0,0.62-0.124,0.853-0.349c0.214-0.222,0.338-0.524,0.338-0.841v-9.4c0-0.184-0.031-0.342-0.096-0.483\n                    c-0.064-0.148-0.162-0.284-0.287-0.402L1493.896,1244.751z M1496.816,1261.99h-5.84c-0.885,0-2.2-0.583-2.2-2.19v-4.16\n                    c0-0.88,0.586-2.189,2.2-2.189h0.3v-0.46c0-1.213,0.982-2.2,2.19-2.2h0.859c1.208,0,2.19,0.987,2.19,2.2v0.46h0.3\n                    c0.881,0,2.19,0.583,2.19,2.189v4.16C1499.007,1260.681,1498.424,1261.99,1496.816,1261.99z M1490.977,1254.45\n                    c-1.127,0-1.197,0.993-1.2,1.192v4.157c0,1.157,1.077,1.19,1.2,1.19h5.84c1.117,0,1.188-0.994,1.19-1.193v-4.157\n                    c0-1.156-1.068-1.189-1.19-1.189H1490.977z M1492.276,1253.45h3.24v-0.46c0-0.662-0.534-1.2-1.19-1.2h-0.859\n                    c-0.656,0-1.19,0.538-1.19,1.2V1253.45z\"/>\n            </g>\n        </g>\n    </g>\n    </svg>\n</template>\n<script>\nexport default {\n    name: 'Card',\n\n    props: {\n        title: {\n            type: Array,\n            default: []\n        },\n        season: {\n            type: String,\n            default: ''\n        },\n        attractions: {\n            type: Array,\n            default: []\n        },\n    },\n}\n</script>\n<style scoped>\n.st0{fill:#4D80D6;}\n.st1{fill:#FFFFFF;}\n.st2{fill:#FFCF70;}\n.st3{fill:#C6E9FA;}\n.st4{fill:#66CDF5;}\n.st5{fill:#254170;}\n.st6{fill:#487264;}\n.st7{fill:#93B8F5;}\n.st8{opacity:0.4;enable-background:new    ;}\n.st9{clip-path:url(#SVGID_2_);}\n.st10{fill:#663108;}\n.st11{opacity:0;}\n.st12{fill:none;}\n.st13{fill:#0389CA;}\n.st14{fill:#9CBEAF;}\n.st15{clip-path:url(#SVGID_6_);}\n.st16{fill:#DB8544;}\n.st17{clip-path:url(#SVGID_9_);}\n.st18{clip-path:url(#SVGID_11_);}\n.st19{display:none;}\n.st20{display:inline;}\n</style>"]}, media: undefined })

  }
  /* scoped */
  const __vue_scope_id__ = "data-v-f4adaed0"
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "src/js/Vue/card.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (true) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  function __vue_create_injector__() {
    const styles = __vue_create_injector__.styles || (__vue_create_injector__.styles = {})
    const isOldIE =
      typeof navigator !== 'undefined' &&
      /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase())

    return function addStyle(id, css) {
      if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) return // SSR styles are present.

      const group = isOldIE ? css.media || 'default' : id
      const style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined })

      if (!style.ids.includes(id)) {
        let code = css.source
        let index = style.ids.length

        style.ids.push(id)

        if (false && css.map) {
          // https://developer.chrome.com/devtools/docs/javascript-debugging
          // this makes source maps inside style tags work properly in Chrome
          code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'
          // http://stackoverflow.com/a/26603875
          code +=
            '\n/*# sourceMappingURL=data:application/json;base64,' +
            btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
            ' */'
        }

        if (isOldIE) {
          style.element = style.element || document.querySelector('style[data-group=' + group + ']')
        }

        if (!style.element) {
          const head = document.head || document.getElementsByTagName('head')[0]
          const el = style.element = document.createElement('style')
          el.type = 'text/css'

          if (css.media) el.setAttribute('media', css.media)
          if (isOldIE) {
            el.setAttribute('data-group', group)
            el.setAttribute('data-next-index', '0')
          }

          head.appendChild(el)
        }

        if (isOldIE) {
          index = parseInt(style.element.getAttribute('data-next-index'))
          style.element.setAttribute('data-next-index', index + 1)
        }

        if (style.element.styleSheet) {
          style.parts.push(code)
          style.element.styleSheet.cssText = style.parts
            .filter(Boolean)
            .join('\n')
        } else {
          const textNode = document.createTextNode(code)
          const nodes = style.element.childNodes
          if (nodes[index]) style.element.removeChild(nodes[index])
          if (nodes.length) style.element.insertBefore(textNode, nodes[index])
          else style.element.appendChild(textNode)
        }
      }
    }
  }
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  )

  export default __vue_component__